"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var fabric = fabric || {
  version: "3.6.3"
};

if (typeof exports !== "undefined") {
  exports.fabric = fabric;
} else if (typeof define === "function" && define.amd) {
  define([], function () {
    return fabric;
  });
}

if (typeof document !== "undefined" && typeof window !== "undefined") {
  if (document instanceof (typeof HTMLDocument !== "undefined" ? HTMLDocument : Document)) {
    fabric.document = document;
  } else {
    fabric.document = document.implementation.createHTMLDocument("");
  }

  fabric.window = window;
} else {}

fabric.isTouchSupported = "ontouchstart" in fabric.window || "ontouchstart" in fabric.document || fabric.window && fabric.window.navigator && fabric.window.navigator.maxTouchPoints > 0;
fabric.isLikelyNode = typeof Buffer !== "undefined" && typeof window === "undefined";
fabric.DPI = 96;
fabric.reNum = "(?:[-+]?(?:\\d+|\\d*\\.\\d+)(?:[eE][-+]?\\d+)?)";
fabric.rePathCommand = /([-+]?((\d+\.\d+)|((\d+)|(\.\d+)))(?:[eE][-+]?\d+)?)/gi;
fabric.reNonWord = /[ \n\.,;!\?\-]/;
fabric.fontPaths = {};
fabric.iMatrix = [1, 0, 0, 1, 0, 0];
fabric.svgNS = "http://www.w3.org/2000/svg";
fabric.perfLimitSizeTotal = 2097152;
fabric.maxCacheSideLimit = 4096;
fabric.minCacheSideLimit = 256;
fabric.charWidthsCache = {};
fabric.textureSize = 2048;
fabric.disableStyleCopyPaste = false;
fabric.enableGLFiltering = true;
fabric.devicePixelRatio = fabric.window.devicePixelRatio || fabric.window.webkitDevicePixelRatio || fabric.window.mozDevicePixelRatio || 1;
fabric.browserShadowBlurConstant = 1;
fabric.arcToSegmentsCache = {};
fabric.boundsOfCurveCache = {};
fabric.cachesBoundsOfCurve = true;
fabric.forceGLPutImageData = false;

fabric.initFilterBackend = function () {
  if (fabric.enableGLFiltering && fabric.isWebglSupported && fabric.isWebglSupported(fabric.textureSize)) {
    console.log("max texture size: " + fabric.maxTextureSize);
    return new fabric.WebglFilterBackend({
      tileSize: fabric.textureSize
    });
  } else if (fabric.Canvas2dFilterBackend) {
    return new fabric.Canvas2dFilterBackend();
  }
};

if (typeof document !== "undefined" && typeof window !== "undefined") {
  window.fabric = fabric;
}

if (typeof eventjs === "undefined") var eventjs = {};

(function (D) {
  D.modifyEventListener = false;
  D.modifySelectors = false;

  D.configure = function (t) {
    if (isFinite(t.modifyEventListener)) D.modifyEventListener = t.modifyEventListener;
    if (isFinite(t.modifySelectors)) D.modifySelectors = t.modifySelectors;

    if (i === false && D.modifyEventListener) {
      r();
    }

    if (n === false && D.modifySelectors) {
      a();
    }
  };

  D.add = function (t, e, i, r) {
    return M(t, e, i, r, "add");
  };

  D.remove = function (t, e, i, r) {
    return M(t, e, i, r, "remove");
  };

  D.returnFalse = function (t) {
    return false;
  };

  D.stop = function (t) {
    if (!t) return;
    if (t.stopPropagation) t.stopPropagation();
    t.cancelBubble = true;
    t.cancelBubbleCount = 0;
  };

  D.prevent = function (t) {
    if (!t) return;

    if (t.preventDefault) {
      t.preventDefault();
    } else if (t.preventManipulation) {
      t.preventManipulation();
    } else {
      t.returnValue = false;
    }
  };

  D.cancel = function (t) {
    D.stop(t);
    D.prevent(t);
  };

  D.blur = function () {
    var t = document.activeElement;
    if (!t) return;
    var e = document.activeElement.nodeName;

    if (e === "INPUT" || e === "TEXTAREA" || t.contentEditable === "true") {
      if (t.blur) t.blur();
    }
  };

  D.getEventSupport = function (t, e) {
    if (typeof t === "string") {
      e = t;
      t = window;
    }

    e = "on" + e;
    if (e in t) return true;
    if (!t.setAttribute) t = document.createElement("div");

    if (t.setAttribute && t.removeAttribute) {
      t.setAttribute(e, "");
      var i = typeof t[e] === "function";
      if (typeof t[e] !== "undefined") t[e] = null;
      t.removeAttribute(e);
      return i;
    }
  };

  var E = function E(t) {
    if (!t || (0, _typeof2["default"])(t) !== "object") return t;
    var e = new t.constructor();

    for (var i in t) {
      if (!t[i] || (0, _typeof2["default"])(t[i]) !== "object") {
        e[i] = t[i];
      } else {
        e[i] = E(t[i]);
      }
    }

    return e;
  };

  var M = function M(r, t, e, i, n, s) {
    i = i || {};

    if (String(r) === "[object Object]") {
      var o = r;
      r = o.target;
      delete o.target;

      if (o.type && o.listener) {
        t = o.type;
        delete o.type;
        e = o.listener;
        delete o.listener;

        for (var a in o) {
          i[a] = o[a];
        }
      } else {
        for (var c in o) {
          var l = o[c];
          if (typeof l === "function") continue;
          i[c] = l;
        }

        var h = {};

        for (var a in o) {
          var c = a.split(",");
          var f = o[a];
          var u = {};

          for (var d in i) {
            u[d] = i[d];
          }

          if (typeof f === "function") {
            var e = f;
          } else if (typeof f.listener === "function") {
            var e = f.listener;

            for (var d in f) {
              if (typeof f[d] === "function") continue;
              u[d] = f[d];
            }
          } else {
            continue;
          }

          for (var g = 0; g < c.length; g++) {
            h[a] = eventjs.add(r, c[g], e, u, n);
          }
        }

        return h;
      }
    }

    if (!r || !t || !e) return;

    if (typeof r === "string" && t === "ready") {
      if (window.eventjs_stallOnReady) {
        t = "load";
        r = window;
      } else {
        var p = new Date().getTime();
        var v = i.timeout;
        var m = i.interval || 1e3 / 60;
        var b = window.setInterval(function () {
          if (new Date().getTime() - p > v) {
            window.clearInterval(b);
          }

          if (document.querySelector(r)) {
            window.clearInterval(b);
            setTimeout(e, 1);
          }
        }, m);
        return;
      }
    }

    if (typeof r === "string") {
      r = document.querySelectorAll(r);
      if (r.length === 0) return A("Missing target on listener!", arguments);

      if (r.length === 1) {
        r = r[0];
      }
    }

    var y;
    var _ = {};

    if (r.length > 0 && r !== window) {
      for (var x = 0, C = r.length; x < C; x++) {
        y = M(r[x], t, e, E(i), n);
        if (y) _[x] = y;
      }

      return F(_);
    }

    if (typeof t === "string") {
      t = t.toLowerCase();

      if (t.indexOf(" ") !== -1) {
        t = t.split(" ");
      } else if (t.indexOf(",") !== -1) {
        t = t.split(",");
      }
    }

    if (typeof t !== "string") {
      if (typeof t.length === "number") {
        for (var w = 0, S = t.length; w < S; w++) {
          y = M(r, t[w], e, E(i), n);
          if (y) _[t[w]] = y;
        }
      } else {
        for (var a in t) {
          if (typeof t[a] === "function") {
            y = M(r, a, t[a], E(i), n);
          } else {
            y = M(r, a, t[a].listener, E(t[a]), n);
          }

          if (y) _[a] = y;
        }
      }

      return F(_);
    } else if (t.indexOf("on") === 0) {
      t = t.substr(2);
    }

    if ((0, _typeof2["default"])(r) !== "object") return A("Target is not defined!", arguments);
    if (typeof e !== "function") return A("Listener is not a function!", arguments);
    var T = i.useCapture || false;
    var O = B(r) + "." + B(e) + "." + (T ? 1 : 0);

    if (D.Gesture && D.Gesture._gestureHandlers[t]) {
      O = t + O;

      if (n === "remove") {
        if (!I[O]) return;
        I[O].remove();
        delete I[O];
      } else if (n === "add") {
        if (I[O]) {
          I[O].add();
          return I[O];
        }

        if (i.useCall && !D.modifyEventListener) {
          var j = e;

          e = function e(t, _e) {
            for (var i in _e) {
              t[i] = _e[i];
            }

            return j.call(r, t);
          };
        }

        i.gesture = t;
        i.target = r;
        i.listener = e;
        i.fromOverwrite = s;
        I[O] = D.proxy[t](i);
      }

      return I[O];
    } else {
      var k = L(t);

      for (var g = 0, P; g < k.length; g++) {
        t = k[g];
        P = t + "." + O;

        if (n === "remove") {
          if (!I[P]) continue;
          r[X](t, e, T);
          delete I[P];
        } else if (n === "add") {
          if (I[P]) return I[P];
          r[R](t, e, T);
          I[P] = {
            id: P,
            type: t,
            target: r,
            listener: e,
            remove: function remove() {
              for (var t = 0; t < k.length; t++) {
                D.remove(r, k[t], e, i);
              }
            }
          };
        }
      }

      return I[P];
    }
  };

  var F = function F(e) {
    return {
      remove: function remove() {
        for (var t in e) {
          e[t].remove();
        }
      },
      add: function add() {
        for (var t in e) {
          e[t].add();
        }
      }
    };
  };

  var A = function A(t, e) {
    if (typeof console === "undefined") return;
    if (typeof console.error === "undefined") return;
    console.error(t, e);
  };

  var s = {
    msPointer: ["MSPointerDown", "MSPointerMove", "MSPointerUp"],
    touch: ["touchstart", "touchmove", "touchend"],
    mouse: ["mousedown", "mousemove", "mouseup"]
  };
  var o = {
    MSPointerDown: 0,
    MSPointerMove: 1,
    MSPointerUp: 2,
    touchstart: 0,
    touchmove: 1,
    touchend: 2,
    mousedown: 0,
    mousemove: 1,
    mouseup: 2
  };

  var t = function () {
    D.supports = {};

    if (window.navigator.msPointerEnabled) {
      D.supports.msPointer = true;
    }

    if (D.getEventSupport("touchstart")) {
      D.supports.touch = true;
    }

    if (D.getEventSupport("mousedown")) {
      D.supports.mouse = true;
    }
  }();

  var L = function () {
    return function (t) {
      var e = document.addEventListener ? "" : "on";
      var i = o[t];

      if (isFinite(i)) {
        var r = [];

        for (var n in D.supports) {
          r.push(e + s[n][i]);
        }

        return r;
      } else {
        return [e + t];
      }
    };
  }();

  var I = {};
  var e = 0;

  var B = function B(t) {
    if (t === window) return "#window";
    if (t === document) return "#document";
    if (!t.uniqueID) t.uniqueID = "e" + e++;
    return t.uniqueID;
  };

  var R = document.addEventListener ? "addEventListener" : "attachEvent";
  var X = document.removeEventListener ? "removeEventListener" : "detachEvent";

  D.createPointerEvent = function (t, e, i) {
    var r = e.gesture;
    var n = e.target;
    var s = t.changedTouches || D.proxy.getCoords(t);

    if (s.length) {
      var o = s[0];
      e.pointers = i ? [] : s;
      e.pageX = o.pageX;
      e.pageY = o.pageY;
      e.x = e.pageX;
      e.y = e.pageY;
    }

    var a = document.createEvent("Event");
    a.initEvent(r, true, true);
    a.originalEvent = t;

    for (var c in e) {
      if (c === "target") continue;
      a[c] = e[c];
    }

    var l = a.type;

    if (D.Gesture && D.Gesture._gestureHandlers[l]) {
      e.oldListener.call(n, a, e, false);
    }
  };

  var i = false;

  var r = function r() {
    if (!window.HTMLElement) return;

    var t = function t(e) {
      var t = function t(o) {
        var t = o + "EventListener";
        var a = e[t];

        e[t] = function (t, e, i) {
          if (D.Gesture && D.Gesture._gestureHandlers[t]) {
            var r = i;

            if ((0, _typeof2["default"])(i) === "object") {
              r.useCall = true;
            } else {
              r = {
                useCall: true,
                useCapture: i
              };
            }

            M(this, t, e, r, o, true);
          } else {
            var n = L(t);

            for (var s = 0; s < n.length; s++) {
              a.call(this, n[s], e, i);
            }
          }
        };
      };

      t("add");
      t("remove");
    };

    if (navigator.userAgent.match(/Firefox/)) {
      t(HTMLDivElement.prototype);
      t(HTMLCanvasElement.prototype);
    } else {
      t(HTMLElement.prototype);
    }

    t(document);
    t(window);
  };

  var n = false;

  var a = function a() {
    var t = NodeList.prototype;

    t.removeEventListener = function (t, e, i) {
      for (var r = 0, n = this.length; r < n; r++) {
        this[r].removeEventListener(t, e, i);
      }
    };

    t.addEventListener = function (t, e, i) {
      for (var r = 0, n = this.length; r < n; r++) {
        this[r].addEventListener(t, e, i);
      }
    };
  };

  return D;
})(eventjs);

if (typeof eventjs === "undefined") var eventjs = {};
if (typeof eventjs.proxy === "undefined") eventjs.proxy = {};

eventjs.proxy = function (p) {
  "use strict";

  p.pointerSetup = function (e, i) {
    e.target = e.target || window;
    e.doc = e.target.ownerDocument || e.target;
    e.minFingers = e.minFingers || e.fingers || 1;
    e.maxFingers = e.maxFingers || e.fingers || Infinity;
    e.position = e.position || "relative";
    delete e.fingers;
    i = i || {};
    i.enabled = true;
    i.gesture = e.gesture;
    i.target = e.target;
    i.env = e.env;

    if (eventjs.modifyEventListener && e.fromOverwrite) {
      e.oldListener = e.listener;
      e.listener = eventjs.createPointerEvent;
    }

    var r = 0;
    var n = i.gesture.indexOf("pointer") === 0 && eventjs.modifyEventListener ? "pointer" : "mouse";
    if (e.oldListener) i.oldListener = e.oldListener;
    i.listener = e.listener;

    i.proxy = function (t) {
      i.defaultListener = e.listener;
      e.listener = t;
      t(e.event, i);
    };

    i.add = function () {
      if (i.enabled === true) return;
      if (e.onPointerDown) eventjs.add(e.target, n + "down", e.onPointerDown);
      if (e.onPointerMove) eventjs.add(e.doc, n + "move", e.onPointerMove);
      if (e.onPointerUp) eventjs.add(e.doc, n + "up", e.onPointerUp);
      i.enabled = true;
    };

    i.remove = function () {
      if (i.enabled === false) return;
      if (e.onPointerDown) eventjs.remove(e.target, n + "down", e.onPointerDown);
      if (e.onPointerMove) eventjs.remove(e.doc, n + "move", e.onPointerMove);
      if (e.onPointerUp) eventjs.remove(e.doc, n + "up", e.onPointerUp);
      i.reset();
      i.enabled = false;
    };

    i.pause = function (t) {
      if (e.onPointerMove && (!t || t.move)) eventjs.remove(e.doc, n + "move", e.onPointerMove);
      if (e.onPointerUp && (!t || t.up)) eventjs.remove(e.doc, n + "up", e.onPointerUp);
      r = e.fingers;
      e.fingers = 0;
    };

    i.resume = function (t) {
      if (e.onPointerMove && (!t || t.move)) eventjs.add(e.doc, n + "move", e.onPointerMove);
      if (e.onPointerUp && (!t || t.up)) eventjs.add(e.doc, n + "up", e.onPointerUp);
      e.fingers = r;
    };

    i.reset = function () {
      e.tracker = {};
      e.fingers = 0;
    };

    return i;
  };

  var t = eventjs.supports;
  eventjs.isMouse = !!t.mouse;
  eventjs.isMSPointer = !!t.touch;
  eventjs.isTouch = !!t.msPointer;

  p.pointerStart = function (t, e, o) {
    var i = (t.type || "mousedown").toUpperCase();

    if (i.indexOf("MOUSE") === 0) {
      eventjs.isMouse = true;
      eventjs.isTouch = false;
      eventjs.isMSPointer = false;
    } else if (i.indexOf("TOUCH") === 0) {
      eventjs.isMouse = false;
      eventjs.isTouch = true;
      eventjs.isMSPointer = false;
    } else if (i.indexOf("MSPOINTER") === 0) {
      eventjs.isMouse = false;
      eventjs.isTouch = false;
      eventjs.isMSPointer = true;
    }

    var r = function r(t, e) {
      var i = o.bbox;
      var r = a[e] = {};

      switch (o.position) {
        case "absolute":
          r.offsetX = 0;
          r.offsetY = 0;
          break;

        case "differenceFromLast":
          r.offsetX = t.pageX;
          r.offsetY = t.pageY;
          break;

        case "difference":
          r.offsetX = t.pageX;
          r.offsetY = t.pageY;
          break;

        case "move":
          r.offsetX = t.pageX - i.x1;
          r.offsetY = t.pageY - i.y1;
          break;

        default:
          r.offsetX = i.x1 - i.scrollLeft;
          r.offsetY = i.y1 - i.scrollTop;
          break;
      }

      var n = t.pageX - r.offsetX;
      var s = t.pageY - r.offsetY;
      r.rotation = 0;
      r.scale = 1;
      r.startTime = r.moveTime = new Date().getTime();
      r.move = {
        x: n,
        y: s
      };
      r.start = {
        x: n,
        y: s
      };
      o.fingers++;
    };

    o.event = t;

    if (e.defaultListener) {
      o.listener = e.defaultListener;
      delete e.defaultListener;
    }

    var n = !o.fingers;
    var a = o.tracker;
    var s = t.changedTouches || p.getCoords(t);
    var c = s.length;

    for (var l = 0; l < c; l++) {
      var h = s[l];
      var f = h.identifier || Infinity;

      if (o.fingers) {
        if (o.fingers >= o.maxFingers) {
          var u = [];

          for (var f in o.tracker) {
            u.push(f);
          }

          e.identifier = u.join(",");
          return n;
        }

        var d = 0;

        for (var g in a) {
          if (a[g].up) {
            delete a[g];
            r(h, f);
            o.cancel = true;
            break;
          }

          d++;
        }

        if (a[f]) continue;
        r(h, f);
      } else {
        a = o.tracker = {};
        e.bbox = o.bbox = p.getBoundingBox(o.target);
        o.fingers = 0;
        o.cancel = false;
        r(h, f);
      }
    }

    var u = [];

    for (var f in o.tracker) {
      u.push(f);
    }

    e.identifier = u.join(",");
    return n;
  };

  p.pointerEnd = function (t, e, i, r) {
    var n = t.touches || [];
    var s = n.length;
    var o = {};

    for (var a = 0; a < s; a++) {
      var c = n[a];
      var l = c.identifier;
      o[l || Infinity] = true;
    }

    for (var l in i.tracker) {
      var h = i.tracker[l];
      if (o[l] || h.up) continue;

      if (r) {
        r({
          pageX: h.pageX,
          pageY: h.pageY,
          changedTouches: [{
            pageX: h.pageX,
            pageY: h.pageY,
            identifier: l === "Infinity" ? Infinity : l
          }]
        }, "up");
      }

      h.up = true;
      i.fingers--;
    }

    if (i.fingers !== 0) return false;
    var f = [];
    i.gestureFingers = 0;

    for (var l in i.tracker) {
      i.gestureFingers++;
      f.push(l);
    }

    e.identifier = f.join(",");
    return true;
  };

  p.getCoords = function (t) {
    if (typeof t.pageX !== "undefined") {
      p.getCoords = function (t) {
        return Array({
          type: "mouse",
          x: t.pageX,
          y: t.pageY,
          pageX: t.pageX,
          pageY: t.pageY,
          identifier: t.pointerId || Infinity
        });
      };
    } else {
      p.getCoords = function (t) {
        var e = document.documentElement;
        t = t || window.event;
        return Array({
          type: "mouse",
          x: t.clientX + e.scrollLeft,
          y: t.clientY + e.scrollTop,
          pageX: t.clientX + e.scrollLeft,
          pageY: t.clientY + e.scrollTop,
          identifier: Infinity
        });
      };
    }

    return p.getCoords(t);
  };

  p.getCoord = function (t) {
    if ("ontouchstart" in window) {
      var i = 0;
      var r = 0;

      p.getCoord = function (t) {
        var e = t.changedTouches;

        if (e && e.length) {
          return {
            x: i = e[0].pageX,
            y: r = e[0].pageY
          };
        } else {
          return {
            x: i,
            y: r
          };
        }
      };
    } else if (typeof t.pageX !== "undefined" && typeof t.pageY !== "undefined") {
      p.getCoord = function (t) {
        return {
          x: t.pageX,
          y: t.pageY
        };
      };
    } else {
      p.getCoord = function (t) {
        var e = document.documentElement;
        t = t || window.event;
        return {
          x: t.clientX + e.scrollLeft,
          y: t.clientY + e.scrollTop
        };
      };
    }

    return p.getCoord(t);
  };

  var f = function f(t, e) {
    var i = parseFloat(t.getPropertyValue(e), 10);
    return isFinite(i) ? i : 0;
  };

  p.getBoundingBox = function (t) {
    if (t === window || t === document) t = document.body;
    var e = {};
    var i = t.getBoundingClientRect();
    e.width = i.width;
    e.height = i.height;
    e.x1 = i.left;
    e.y1 = i.top;
    e.scaleX = i.width / t.offsetWidth || 1;
    e.scaleY = i.height / t.offsetHeight || 1;
    e.scrollLeft = 0;
    e.scrollTop = 0;
    var r = window.getComputedStyle(t);
    var n = r.getPropertyValue("box-sizing") === "border-box";

    if (n === false) {
      var s = f(r, "border-left-width");
      var o = f(r, "border-right-width");
      var a = f(r, "border-bottom-width");
      var c = f(r, "border-top-width");
      e.border = [s, o, c, a];
      e.x1 += s;
      e.y1 += c;
      e.width -= o + s;
      e.height -= a + c;
    }

    e.x2 = e.x1 + e.width;
    e.y2 = e.y1 + e.height;
    var l = r.getPropertyValue("position");
    var h = l === "fixed" ? t : t.parentNode;

    while (h !== null) {
      if (h === document.body) break;
      if (h.scrollTop === undefined) break;
      var r = window.getComputedStyle(h);
      var l = r.getPropertyValue("position");

      if (l === "absolute") {} else if (l === "fixed") {
        e.scrollTop -= h.parentNode.scrollTop;
        e.scrollLeft -= h.parentNode.scrollLeft;
        break;
      } else {
        e.scrollLeft += h.scrollLeft;
        e.scrollTop += h.scrollTop;
      }

      h = h.parentNode;
    }

    e.scrollBodyLeft = window.pageXOffset !== undefined ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft;
    e.scrollBodyTop = window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    e.scrollLeft -= e.scrollBodyLeft;
    e.scrollTop -= e.scrollBodyTop;
    return e;
  };

  (function () {
    var t = navigator.userAgent.toLowerCase();
    var e = t.indexOf("macintosh") !== -1;
    var i;

    if (e && t.indexOf("khtml") !== -1) {
      i = {
        91: true,
        93: true
      };
    } else if (e && t.indexOf("firefox") !== -1) {
      i = {
        224: true
      };
    } else {
      i = {
        17: true
      };
    }

    (p.metaTrackerReset = function () {
      eventjs.fnKey = p.fnKey = false;
      eventjs.metaKey = p.metaKey = false;
      eventjs.escKey = p.escKey = false;
      eventjs.ctrlKey = p.ctrlKey = false;
      eventjs.shiftKey = p.shiftKey = false;
      eventjs.altKey = p.altKey = false;
    })();

    p.metaTracker = function (t) {
      var e = t.type === "keydown";
      if (t.keyCode === 27) eventjs.escKey = p.escKey = e;
      if (i[t.keyCode]) eventjs.metaKey = p.metaKey = e;
      eventjs.ctrlKey = p.ctrlKey = t.ctrlKey;
      eventjs.shiftKey = p.shiftKey = t.shiftKey;
      eventjs.altKey = p.altKey = t.altKey;
    };
  })();

  return p;
}(eventjs.proxy);

if (typeof eventjs === "undefined") var eventjs = {};

eventjs.MutationObserver = function () {
  var n = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;

  var s = !n && function () {
    var t = document.createElement("p");
    var e = false;

    var i = function i() {
      e = true;
    };

    if (t.addEventListener) {
      t.addEventListener("DOMAttrModified", i, false);
    } else if (t.attachEvent) {
      t.attachEvent("onDOMAttrModified", i);
    } else {
      return false;
    }

    t.setAttribute("id", "target");
    return e;
  }();

  return function (e, i) {
    if (n) {
      var t = {
        subtree: false,
        attributes: true
      };
      var r = new n(function (t) {
        t.forEach(function (t) {
          i.call(t.target, t.attributeName);
        });
      });
      r.observe(e, t);
    } else if (s) {
      eventjs.add(e, "DOMAttrModified", function (t) {
        i.call(e, t.attrName);
      });
    } else if ("onpropertychange" in document.body) {
      eventjs.add(e, "propertychange", function (t) {
        i.call(e, window.event.propertyName);
      });
    }
  };
}();

if (typeof eventjs === "undefined") var eventjs = {};
if (typeof eventjs.proxy === "undefined") eventjs.proxy = {};

eventjs.proxy = function (f) {
  "use strict";

  f.click = function (l) {
    l.gesture = l.gesture || "click";
    l.maxFingers = l.maxFingers || l.fingers || 1;

    l.onPointerDown = function (t) {
      if (f.pointerStart(t, h, l)) {
        eventjs.add(l.target, "mouseup", l.onPointerUp);
      }
    };

    l.onPointerUp = function (t) {
      if (f.pointerEnd(t, h, l)) {
        eventjs.remove(l.target, "mouseup", l.onPointerUp);
        var e = t.changedTouches || f.getCoords(t);
        var i = e[0];
        var r = l.bbox;
        var n = f.getBoundingBox(l.target);
        var s = i.pageY - n.scrollBodyTop;
        var o = i.pageX - n.scrollBodyLeft;

        if (o > r.x1 && s > r.y1 && o < r.x2 && s < r.y2 && r.scrollTop === n.scrollTop) {
          for (var a in l.tracker) {
            break;
          }

          var c = l.tracker[a];
          h.x = c.start.x;
          h.y = c.start.y;
          l.listener(t, h);
        }
      }
    };

    var h = f.pointerSetup(l);
    h.state = "click";
    eventjs.add(l.target, "mousedown", l.onPointerDown);
    return h;
  };

  eventjs.Gesture = eventjs.Gesture || {};
  eventjs.Gesture._gestureHandlers = eventjs.Gesture._gestureHandlers || {};
  eventjs.Gesture._gestureHandlers.click = f.click;
  return f;
}(eventjs.proxy);

if (typeof eventjs === "undefined") var eventjs = {};
if (typeof eventjs.proxy === "undefined") eventjs.proxy = {};

eventjs.proxy = function (f) {
  "use strict";

  f.dbltap = f.dblclick = function (s) {
    s.gesture = s.gesture || "dbltap";
    s.maxFingers = s.maxFingers || s.fingers || 1;
    var r = 700;
    var o, a, c;
    var l, h;

    s.onPointerDown = function (t) {
      var e = t.changedTouches || f.getCoords(t);

      if (o && !a) {
        h = e[0];
        a = new Date().getTime() - o;
      } else {
        l = e[0];
        o = new Date().getTime();
        a = 0;
        clearTimeout(c);
        c = setTimeout(function () {
          o = 0;
        }, r);
      }

      if (f.pointerStart(t, n, s)) {
        eventjs.add(s.target, "mousemove", s.onPointerMove).listener(t);
        eventjs.add(s.target, "mouseup", s.onPointerUp);
      }
    };

    s.onPointerMove = function (t) {
      if (o && !a) {
        var e = t.changedTouches || f.getCoords(t);
        h = e[0];
      }

      var i = s.bbox;
      var r = h.pageX - i.x1;
      var n = h.pageY - i.y1;

      if (!(r > 0 && r < i.width && n > 0 && n < i.height && Math.abs(h.pageX - l.pageX) <= 25 && Math.abs(h.pageY - l.pageY) <= 25)) {
        eventjs.remove(s.target, "mousemove", s.onPointerMove);
        clearTimeout(c);
        o = a = 0;
      }
    };

    s.onPointerUp = function (t) {
      if (f.pointerEnd(t, n, s)) {
        eventjs.remove(s.target, "mousemove", s.onPointerMove);
        eventjs.remove(s.target, "mouseup", s.onPointerUp);
      }

      if (o && a) {
        if (a <= r) {
          n.state = s.gesture;

          for (var e in s.tracker) {
            break;
          }

          var i = s.tracker[e];
          n.x = i.start.x;
          n.y = i.start.y;
          s.listener(t, n);
        }

        clearTimeout(c);
        o = a = 0;
      }
    };

    var n = f.pointerSetup(s);
    n.state = "dblclick";
    eventjs.add(s.target, "mousedown", s.onPointerDown);
    return n;
  };

  eventjs.Gesture = eventjs.Gesture || {};
  eventjs.Gesture._gestureHandlers = eventjs.Gesture._gestureHandlers || {};
  eventjs.Gesture._gestureHandlers.dbltap = f.dbltap;
  eventjs.Gesture._gestureHandlers.dblclick = f.dblclick;
  return f;
}(eventjs.proxy);

if (typeof eventjs === "undefined") var eventjs = {};
if (typeof eventjs.proxy === "undefined") eventjs.proxy = {};

eventjs.proxy = function (f) {
  "use strict";

  f.dragElement = function (i, t) {
    f.drag({
      event: t,
      target: i,
      position: "move",
      listener: function listener(t, e) {
        i.style.left = e.x + "px";
        i.style.top = e.y + "px";
        eventjs.prevent(t);
      }
    });
  };

  f.drag = function (l) {
    l.gesture = "drag";

    l.onPointerDown = function (t) {
      if (f.pointerStart(t, h, l)) {
        if (!l.monitor) {
          eventjs.add(l.doc, "mousemove", l.onPointerMove);
          eventjs.add(l.doc, "mouseup", l.onPointerUp);
        }
      }

      l.onPointerMove(t, "down");
    };

    l.onPointerMove = function (t, e) {
      if (!l.tracker) return l.onPointerDown(t);
      var i = l.bbox;
      var r = t.changedTouches || f.getCoords(t);
      var n = r.length;

      for (var s = 0; s < n; s++) {
        var o = r[s];
        var a = o.identifier || Infinity;
        var c = l.tracker[a];
        if (!c) continue;
        c.pageX = o.pageX;
        c.pageY = o.pageY;
        h.state = e || "move";
        h.identifier = a;
        h.start = c.start;
        h.fingers = l.fingers;

        if (l.position === "differenceFromLast") {
          h.x = c.pageX - c.offsetX;
          h.y = c.pageY - c.offsetY;
          c.offsetX = c.pageX;
          c.offsetY = c.pageY;
        } else {
          h.x = c.pageX - c.offsetX;
          h.y = c.pageY - c.offsetY;
        }

        l.listener(t, h);
      }
    };

    l.onPointerUp = function (t) {
      if (f.pointerEnd(t, h, l, l.onPointerMove)) {
        if (!l.monitor) {
          eventjs.remove(l.doc, "mousemove", l.onPointerMove);
          eventjs.remove(l.doc, "mouseup", l.onPointerUp);
        }
      }
    };

    var h = f.pointerSetup(l);

    if (l.event) {
      l.onPointerDown(l.event);
    } else {
      eventjs.add(l.target, "mousedown", l.onPointerDown);

      if (l.monitor) {
        eventjs.add(l.doc, "mousemove", l.onPointerMove);
        eventjs.add(l.doc, "mouseup", l.onPointerUp);
      }
    }

    return h;
  };

  eventjs.Gesture = eventjs.Gesture || {};
  eventjs.Gesture._gestureHandlers = eventjs.Gesture._gestureHandlers || {};
  eventjs.Gesture._gestureHandlers.drag = f.drag;
  return f;
}(eventjs.proxy);

if (typeof eventjs === "undefined") var eventjs = {};
if (typeof eventjs.proxy === "undefined") eventjs.proxy = {};

eventjs.proxy = function (_) {
  "use strict";

  var x = Math.PI / 180;

  var C = function C(t, e) {
    var i = 0;
    var r = 0;
    var n = 0;

    for (var s in e) {
      var o = e[s];
      if (o.up) continue;
      i += o.move.x;
      r += o.move.y;
      n++;
    }

    t.x = i /= n;
    t.y = r /= n;
    return t;
  };

  _.gesture = function (b) {
    b.gesture = b.gesture || "gesture";
    b.minFingers = b.minFingers || b.fingers || 2;

    b.onPointerDown = function (t) {
      var e = b.fingers;

      if (_.pointerStart(t, y, b)) {
        eventjs.add(b.doc, "mousemove", b.onPointerMove);
        eventjs.add(b.doc, "mouseup", b.onPointerUp);
      }

      if (b.fingers === b.minFingers && e !== b.fingers) {
        y.fingers = b.minFingers;
        y.scale = 1;
        y.rotation = 0;
        y.state = "start";
        var i = "";

        for (var r in b.tracker) {
          i += r;
        }

        y.identifier = parseInt(i);
        C(y, b.tracker);
        b.listener(t, y);
      }
    };

    b.onPointerMove = function (t, e) {
      var i = b.bbox;
      var r = b.tracker;

      var n = t.changedTouches || _.getCoords(t);

      var s = n.length;

      for (var o = 0; o < s; o++) {
        var a = n[o];
        var c = a.identifier || Infinity;
        var l = r[c];
        if (!l) continue;
        l.move.x = a.pageX - i.x1;
        l.move.y = a.pageY - i.y1;
      }

      if (b.fingers < b.minFingers) return;
      var n = [];
      var h = 0;
      var f = 0;
      C(y, r);

      for (var c in r) {
        var a = r[c];
        if (a.up) continue;
        var u = a.start;

        if (!u.distance) {
          var d = u.x - y.x;
          var g = u.y - y.y;
          u.distance = Math.sqrt(d * d + g * g);
          u.angle = Math.atan2(d, g) / x;
        }

        var d = a.move.x - y.x;
        var g = a.move.y - y.y;
        var p = Math.sqrt(d * d + g * g);
        h += p / u.distance;
        var v = Math.atan2(d, g) / x;
        var m = (u.angle - v + 360) % 360 - 180;
        a.DEG2 = a.DEG1;
        a.DEG1 = m > 0 ? m : -m;

        if (typeof a.DEG2 !== "undefined") {
          if (m > 0) {
            a.rotation += a.DEG1 - a.DEG2;
          } else {
            a.rotation -= a.DEG1 - a.DEG2;
          }

          f += a.rotation;
        }

        n.push(a.move);
      }

      y.touches = n;
      y.fingers = b.fingers;
      y.scale = h / b.fingers;
      y.rotation = f / b.fingers;
      y.state = "change";
      b.listener(t, y);
    };

    b.onPointerUp = function (t) {
      var e = b.fingers;

      if (_.pointerEnd(t, y, b)) {
        eventjs.remove(b.doc, "mousemove", b.onPointerMove);
        eventjs.remove(b.doc, "mouseup", b.onPointerUp);
      }

      if (e === b.minFingers && b.fingers < b.minFingers) {
        y.fingers = b.fingers;
        y.state = "end";
        b.listener(t, y);
      }
    };

    var y = _.pointerSetup(b);

    eventjs.add(b.target, "mousedown", b.onPointerDown);
    return y;
  };

  eventjs.Gesture = eventjs.Gesture || {};
  eventjs.Gesture._gestureHandlers = eventjs.Gesture._gestureHandlers || {};
  eventjs.Gesture._gestureHandlers.gesture = _.gesture;
  return _;
}(eventjs.proxy);

if (typeof eventjs === "undefined") var eventjs = {};
if (typeof eventjs.proxy === "undefined") eventjs.proxy = {};

eventjs.proxy = function (t) {
  "use strict";

  t.pointerdown = t.pointermove = t.pointerup = function (e) {
    e.gesture = e.gesture || "pointer";
    if (e.target.isPointerEmitter) return;
    var i = true;

    e.onPointerDown = function (t) {
      i = false;
      r.gesture = "pointerdown";
      e.listener(t, r);
    };

    e.onPointerMove = function (t) {
      r.gesture = "pointermove";
      e.listener(t, r, i);
    };

    e.onPointerUp = function (t) {
      i = true;
      r.gesture = "pointerup";
      e.listener(t, r, true);
    };

    var r = t.pointerSetup(e);
    eventjs.add(e.target, "mousedown", e.onPointerDown);
    eventjs.add(e.target, "mousemove", e.onPointerMove);
    eventjs.add(e.doc, "mouseup", e.onPointerUp);
    e.target.isPointerEmitter = true;
    return r;
  };

  eventjs.Gesture = eventjs.Gesture || {};
  eventjs.Gesture._gestureHandlers = eventjs.Gesture._gestureHandlers || {};
  eventjs.Gesture._gestureHandlers.pointerdown = t.pointerdown;
  eventjs.Gesture._gestureHandlers.pointermove = t.pointermove;
  eventjs.Gesture._gestureHandlers.pointerup = t.pointerup;
  return t;
}(eventjs.proxy);

if (typeof eventjs === "undefined") var eventjs = {};
if (typeof eventjs.proxy === "undefined") eventjs.proxy = {};

eventjs.proxy = function (t) {
  "use strict";

  t.shake = function (d) {
    var g = {
      gesture: "devicemotion",
      acceleration: {},
      accelerationIncludingGravity: {},
      target: d.target,
      listener: d.listener,
      remove: function remove() {
        window.removeEventListener("devicemotion", t, false);
      }
    };
    var p = 4;
    var v = 1e3;
    var m = 200;
    var b = 3;
    var y = new Date().getTime();
    var _ = {
      x: 0,
      y: 0,
      z: 0
    };
    var x = {
      x: {
        count: 0,
        value: 0
      },
      y: {
        count: 0,
        value: 0
      },
      z: {
        count: 0,
        value: 0
      }
    };

    var t = function t(_t) {
      var e = .8;
      var i = _t.accelerationIncludingGravity;
      _.x = e * _.x + (1 - e) * i.x;
      _.y = e * _.y + (1 - e) * i.y;
      _.z = e * _.z + (1 - e) * i.z;
      g.accelerationIncludingGravity = _;
      g.acceleration.x = i.x - _.x;
      g.acceleration.y = i.y - _.y;
      g.acceleration.z = i.z - _.z;

      if (d.gesture === "devicemotion") {
        d.listener(_t, g);
        return;
      }

      var r = "xyz";
      var n = new Date().getTime();

      for (var s = 0, o = r.length; s < o; s++) {
        var a = r[s];
        var c = g.acceleration[a];
        var l = x[a];
        var h = Math.abs(c);
        if (n - y < v) continue;

        if (h > p) {
          var f = n * c / h;
          var u = Math.abs(f + l.value);

          if (l.value && u < m) {
            l.value = f;
            l.count++;

            if (l.count === b) {
              d.listener(_t, g);
              y = n;
              l.value = 0;
              l.count = 0;
            }
          } else {
            l.value = f;
            l.count = 1;
          }
        }
      }
    };

    if (!window.addEventListener) return;
    window.addEventListener("devicemotion", t, false);
    return g;
  };

  eventjs.Gesture = eventjs.Gesture || {};
  eventjs.Gesture._gestureHandlers = eventjs.Gesture._gestureHandlers || {};
  eventjs.Gesture._gestureHandlers.shake = t.shake;
  return t;
}(eventjs.proxy);

if (typeof eventjs === "undefined") var eventjs = {};
if (typeof eventjs.proxy === "undefined") eventjs.proxy = {};

eventjs.proxy = function (b) {
  "use strict";

  var y = Math.PI / 180;

  b.swipe = function (v) {
    v.snap = v.snap || 90;
    v.threshold = v.threshold || 1;
    v.gesture = v.gesture || "swipe";

    v.onPointerDown = function (t) {
      if (b.pointerStart(t, m, v)) {
        eventjs.add(v.doc, "mousemove", v.onPointerMove).listener(t);
        eventjs.add(v.doc, "mouseup", v.onPointerUp);
      }
    };

    v.onPointerMove = function (t) {
      var e = t.changedTouches || b.getCoords(t);
      var i = e.length;

      for (var r = 0; r < i; r++) {
        var n = e[r];
        var s = n.identifier || Infinity;
        var o = v.tracker[s];
        if (!o) continue;
        o.move.x = n.pageX;
        o.move.y = n.pageY;
        o.moveTime = new Date().getTime();
      }
    };

    v.onPointerUp = function (t) {
      if (b.pointerEnd(t, m, v)) {
        eventjs.remove(v.doc, "mousemove", v.onPointerMove);
        eventjs.remove(v.doc, "mouseup", v.onPointerUp);
        var e;
        var i;
        var r;
        var n;
        var s = {
          x: 0,
          y: 0
        };
        var o = 0;
        var a = 0;
        var c = 0;

        for (var l in v.tracker) {
          var h = v.tracker[l];
          var f = h.move.x - h.start.x;
          var u = h.move.y - h.start.y;
          o += h.move.x;
          a += h.move.y;
          s.x += h.start.x;
          s.y += h.start.y;
          c++;
          var d = Math.sqrt(f * f + u * u);
          var g = h.moveTime - h.startTime;
          var n = Math.atan2(f, u) / y + 180;
          var i = g ? d / g : 0;

          if (typeof r === "undefined") {
            r = n;
            e = i;
          } else if (Math.abs(n - r) <= 20) {
            r = (r + n) / 2;
            e = (e + i) / 2;
          } else {
            return;
          }
        }

        var p = v.gestureFingers;

        if (v.minFingers <= p && v.maxFingers >= p) {
          if (e > v.threshold) {
            s.x /= c;
            s.y /= c;
            m.start = s;
            m.x = o / c;
            m.y = a / c;
            m.angle = -(((r / v.snap + .5 >> 0) * v.snap || 360) - 360);
            m.velocity = e;
            m.fingers = p;
            m.state = "swipe";
            v.listener(t, m);
          }
        }
      }
    };

    var m = b.pointerSetup(v);
    eventjs.add(v.target, "mousedown", v.onPointerDown);
    return m;
  };

  eventjs.Gesture = eventjs.Gesture || {};
  eventjs.Gesture._gestureHandlers = eventjs.Gesture._gestureHandlers || {};
  eventjs.Gesture._gestureHandlers.swipe = b.swipe;
  return b;
}(eventjs.proxy);

if (typeof eventjs === "undefined") var eventjs = {};
if (typeof eventjs.proxy === "undefined") eventjs.proxy = {};

eventjs.proxy = function (g) {
  "use strict";

  g.longpress = function (t) {
    t.gesture = "longpress";
    return g.tap(t);
  };

  g.tap = function (d) {
    d.delay = d.delay || 500;
    d.timeout = d.timeout || 250;
    d.driftDeviance = d.driftDeviance || 10;
    d.gesture = d.gesture || "tap";
    var i, n;

    d.onPointerDown = function (r) {
      if (g.pointerStart(r, s, d)) {
        i = new Date().getTime();
        eventjs.add(d.doc, "mousemove", d.onPointerMove).listener(r);
        eventjs.add(d.doc, "mouseup", d.onPointerUp);
        if (d.gesture !== "longpress") return;
        n = setTimeout(function () {
          if (r.cancelBubble && ++r.cancelBubbleCount > 1) return;
          var t = 0;

          for (var e in d.tracker) {
            var i = d.tracker[e];
            if (i.end === true) return;
            if (d.cancel) return;
            t++;
          }

          if (d.minFingers <= t && d.maxFingers >= t) {
            s.state = "start";
            s.fingers = t;
            s.x = i.start.x;
            s.y = i.start.y;
            d.listener(r, s);
          }
        }, d.delay);
      }
    };

    d.onPointerMove = function (t) {
      var e = d.bbox;
      var i = t.changedTouches || g.getCoords(t);
      var r = i.length;

      for (var n = 0; n < r; n++) {
        var s = i[n];
        var o = s.identifier || Infinity;
        var a = d.tracker[o];
        if (!a) continue;
        var c = s.pageX - e.x1;
        var l = s.pageY - e.y1;
        var h = c - a.start.x;
        var f = l - a.start.y;
        var u = Math.sqrt(h * h + f * f);

        if (!(c > 0 && c < e.width && l > 0 && l < e.height && u <= d.driftDeviance)) {
          eventjs.remove(d.doc, "mousemove", d.onPointerMove);
          d.cancel = true;
          return;
        }
      }
    };

    d.onPointerUp = function (t) {
      if (g.pointerEnd(t, s, d)) {
        clearTimeout(n);
        eventjs.remove(d.doc, "mousemove", d.onPointerMove);
        eventjs.remove(d.doc, "mouseup", d.onPointerUp);
        if (t.cancelBubble && ++t.cancelBubbleCount > 1) return;

        if (d.gesture === "longpress") {
          if (s.state === "start") {
            s.state = "end";
            d.listener(t, s);
          }

          return;
        }

        if (d.cancel) return;
        if (new Date().getTime() - i > d.timeout) return;
        var e = d.gestureFingers;

        if (d.minFingers <= e && d.maxFingers >= e) {
          s.state = "tap";
          s.fingers = d.gestureFingers;
          d.listener(t, s);
        }
      }
    };

    var s = g.pointerSetup(d);
    eventjs.add(d.target, "mousedown", d.onPointerDown);
    return s;
  };

  eventjs.Gesture = eventjs.Gesture || {};
  eventjs.Gesture._gestureHandlers = eventjs.Gesture._gestureHandlers || {};
  eventjs.Gesture._gestureHandlers.tap = g.tap;
  eventjs.Gesture._gestureHandlers.longpress = g.longpress;
  return g;
}(eventjs.proxy);

if (typeof eventjs === "undefined") var eventjs = {};
if (typeof eventjs.proxy === "undefined") eventjs.proxy = {};

eventjs.proxy = function (t) {
  "use strict";

  t.wheelPreventElasticBounce = function (t) {
    if (!t) return;
    if (typeof t === "string") t = document.querySelector(t);
    eventjs.add(t, "wheel", function (t, e) {
      e.preventElasticBounce();
      eventjs.stop(t);
    });
  };

  t.wheel = function (e) {
    var i;
    var r = e.timeout || 150;
    var n = 0;
    var s = {
      gesture: "wheel",
      state: "start",
      wheelDelta: 0,
      target: e.target,
      listener: e.listener,
      preventElasticBounce: function preventElasticBounce(t) {
        var e = this.target;
        var i = e.scrollTop;
        var r = i + e.offsetHeight;
        var n = e.scrollHeight;
        if (r === n && this.wheelDelta <= 0) eventjs.cancel(t);else if (i === 0 && this.wheelDelta >= 0) eventjs.cancel(t);
        eventjs.stop(t);
      },
      add: function add() {
        e.target[o](c, t, false);
      },
      remove: function remove() {
        e.target[a](c, t, false);
      }
    };

    var t = function t(_t2) {
      _t2 = _t2 || window.event;
      s.state = n++ ? "change" : "start";
      s.wheelDelta = _t2.detail ? _t2.detail * -20 : _t2.wheelDelta;
      e.listener(_t2, s);
      clearTimeout(i);
      i = setTimeout(function () {
        n = 0;
        s.state = "end";
        s.wheelDelta = 0;
        e.listener(_t2, s);
      }, r);
    };

    var o = document.addEventListener ? "addEventListener" : "attachEvent";
    var a = document.removeEventListener ? "removeEventListener" : "detachEvent";
    var c = eventjs.getEventSupport("mousewheel") ? "mousewheel" : "DOMMouseScroll";
    e.target[o](c, t, false);
    return s;
  };

  eventjs.Gesture = eventjs.Gesture || {};
  eventjs.Gesture._gestureHandlers = eventjs.Gesture._gestureHandlers || {};
  eventjs.Gesture._gestureHandlers.wheel = t.wheel;
  return t;
}(eventjs.proxy);

if (typeof Event === "undefined") var Event = {};
if (typeof Event.proxy === "undefined") Event.proxy = {};

Event.proxy = function (t) {
  "use strict";

  t.orientation = function (e) {
    var i = {
      gesture: "orientationchange",
      previous: null,
      current: window.orientation,
      target: e.target,
      listener: e.listener,
      remove: function remove() {
        window.removeEventListener("orientationchange", t, false);
      }
    };

    var t = function t(_t3) {
      i.previous = i.current;
      i.current = window.orientation;

      if (i.previous !== null && i.previous != i.current) {
        e.listener(_t3, i);
        return;
      }
    };

    if (window.DeviceOrientationEvent) {
      window.addEventListener("orientationchange", t, false);
    }

    return i;
  };

  Event.Gesture = Event.Gesture || {};
  Event.Gesture._gestureHandlers = Event.Gesture._gestureHandlers || {};
  Event.Gesture._gestureHandlers.orientation = t.orientation;
  return t;
}(Event.proxy);

(function () {
  function r(t, e) {
    if (!this.__eventListeners[t]) {
      return;
    }

    var i = this.__eventListeners[t];

    if (e) {
      i[i.indexOf(e)] = false;
    } else {
      fabric.util.array.fill(i, false);
    }
  }

  function t(t, e) {
    if (!this.__eventListeners) {
      this.__eventListeners = {};
    }

    if (arguments.length === 1) {
      for (var i in t) {
        this.on(i, t[i]);
      }
    } else {
      if (!this.__eventListeners[t]) {
        this.__eventListeners[t] = [];
      }

      this.__eventListeners[t].push(e);
    }

    return this;
  }

  function e(t, e) {
    if (!this.__eventListeners) {
      return this;
    }

    if (arguments.length === 0) {
      for (t in this.__eventListeners) {
        r.call(this, t);
      }
    } else if (arguments.length === 1 && (0, _typeof2["default"])(arguments[0]) === "object") {
      for (var i in t) {
        r.call(this, i, t[i]);
      }
    } else {
      r.call(this, t, e);
    }

    return this;
  }

  function i(t, e) {
    if (!this.__eventListeners) {
      return this;
    }

    var i = this.__eventListeners[t];

    if (!i) {
      return this;
    }

    for (var r = 0, n = i.length; r < n; r++) {
      i[r] && i[r].call(this, e || {});
    }

    this.__eventListeners[t] = i.filter(function (t) {
      return t !== false;
    });
    return this;
  }

  fabric.Observable = {
    observe: t,
    stopObserving: e,
    fire: i,
    on: t,
    off: e,
    trigger: i
  };
})();

fabric.Collection = {
  _objects: [],
  add: function add() {
    this._objects.push.apply(this._objects, arguments);

    if (this._onObjectAdded) {
      for (var t = 0, e = arguments.length; t < e; t++) {
        this._onObjectAdded(arguments[t]);
      }
    }

    this.renderOnAddRemove && this.requestRenderAll();
    return this;
  },
  insertAt: function insertAt(t, e, i) {
    var r = this._objects;

    if (i) {
      r[e] = t;
    } else {
      r.splice(e, 0, t);
    }

    this._onObjectAdded && this._onObjectAdded(t);
    this.renderOnAddRemove && this.requestRenderAll();
    return this;
  },
  remove: function remove() {
    var t = this._objects,
        e,
        i = false;

    for (var r = 0, n = arguments.length; r < n; r++) {
      e = t.indexOf(arguments[r]);

      if (e !== -1) {
        i = true;
        t.splice(e, 1);
        this._onObjectRemoved && this._onObjectRemoved(arguments[r]);
      }
    }

    this.renderOnAddRemove && i && this.requestRenderAll();
    return this;
  },
  forEachObject: function forEachObject(t, e) {
    var i = this.getObjects();

    for (var r = 0, n = i.length; r < n; r++) {
      t.call(e, i[r], r, i);
    }

    return this;
  },
  getObjects: function getObjects(e) {
    if (typeof e === "undefined") {
      return this._objects.concat();
    }

    return this._objects.filter(function (t) {
      return t.type === e;
    });
  },
  item: function item(t) {
    return this._objects[t];
  },
  isEmpty: function isEmpty() {
    return this._objects.length === 0;
  },
  size: function size() {
    return this._objects.length;
  },
  contains: function contains(t) {
    return this._objects.indexOf(t) > -1;
  },
  complexity: function complexity() {
    return this._objects.reduce(function (t, e) {
      t += e.complexity ? e.complexity() : 0;
      return t;
    }, 0);
  }
};
fabric.CommonMethods = {
  _setOptions: function _setOptions(t) {
    for (var e in t) {
      this.set(e, t[e]);
    }
  },
  _initGradient: function _initGradient(t, e) {
    if (t && t.colorStops && !(t instanceof fabric.Gradient)) {
      this.set(e, new fabric.Gradient(t));
    }
  },
  _initPattern: function _initPattern(t, e, i) {
    if (t && t.source && !(t instanceof fabric.Pattern)) {
      this.set(e, new fabric.Pattern(t, i));
    } else {
      i && i();
    }
  },
  _initClipping: function _initClipping(t) {
    if (!t.clipTo || typeof t.clipTo !== "string") {
      return;
    }

    var e = fabric.util.getFunctionBody(t.clipTo);

    if (typeof e !== "undefined") {
      this.clipTo = new Function("ctx", e);
    }
  },
  _setObject: function _setObject(t) {
    for (var e in t) {
      this._set(e, t[e]);
    }
  },
  set: function set(t, e) {
    if ((0, _typeof2["default"])(t) === "object") {
      this._setObject(t);
    } else {
      if (typeof e === "function" && t !== "clipTo") {
        this._set(t, e(this.get(t)));
      } else {
        this._set(t, e);
      }
    }

    return this;
  },
  _set: function _set(t, e) {
    this[t] = e;
  },
  toggle: function toggle(t) {
    var e = this.get(t);

    if (typeof e === "boolean") {
      this.set(t, !e);
    }

    return this;
  },
  get: function get(t) {
    return this[t];
  }
};

(function (s) {
  var d = Math.sqrt,
      g = Math.atan2,
      o = Math.pow,
      a = Math.PI / 180,
      r = Math.PI / 2;
  fabric.util = {
    cos: function cos(t) {
      if (t === 0) {
        return 1;
      }

      if (t < 0) {
        t = -t;
      }

      var e = t / r;

      switch (e) {
        case 1:
        case 3:
          return 0;

        case 2:
          return -1;
      }

      return Math.cos(t);
    },
    sin: function sin(t) {
      if (t === 0) {
        return 0;
      }

      var e = t / r,
          i = 1;

      if (t < 0) {
        i = -1;
      }

      switch (e) {
        case 1:
          return i;

        case 2:
          return 0;

        case 3:
          return -i;
      }

      return Math.sin(t);
    },
    removeFromArray: function removeFromArray(t, e) {
      var i = t.indexOf(e);

      if (i !== -1) {
        t.splice(i, 1);
      }

      return t;
    },
    getRandomInt: function getRandomInt(t, e) {
      return Math.floor(Math.random() * (e - t + 1)) + t;
    },
    degreesToRadians: function degreesToRadians(t) {
      return t * a;
    },
    radiansToDegrees: function radiansToDegrees(t) {
      return t / a;
    },
    rotatePoint: function rotatePoint(t, e, i) {
      t.subtractEquals(e);
      var r = fabric.util.rotateVector(t, i);
      return new fabric.Point(r.x, r.y).addEquals(e);
    },
    rotateVector: function rotateVector(t, e) {
      var i = fabric.util.sin(e),
          r = fabric.util.cos(e),
          n = t.x * r - t.y * i,
          s = t.x * i + t.y * r;
      return {
        x: n,
        y: s
      };
    },
    transformPoint: function transformPoint(t, e, i) {
      if (i) {
        return new fabric.Point(e[0] * t.x + e[2] * t.y, e[1] * t.x + e[3] * t.y);
      }

      return new fabric.Point(e[0] * t.x + e[2] * t.y + e[4], e[1] * t.x + e[3] * t.y + e[5]);
    },
    makeBoundingBoxFromPoints: function makeBoundingBoxFromPoints(t, e) {
      if (e) {
        for (var i = 0; i < t.length; i++) {
          t[i] = fabric.util.transformPoint(t[i], e);
        }
      }

      var r = [t[0].x, t[1].x, t[2].x, t[3].x],
          n = fabric.util.array.min(r),
          s = fabric.util.array.max(r),
          o = s - n,
          a = [t[0].y, t[1].y, t[2].y, t[3].y],
          c = fabric.util.array.min(a),
          l = fabric.util.array.max(a),
          h = l - c;
      return {
        left: n,
        top: c,
        width: o,
        height: h
      };
    },
    invertTransform: function invertTransform(t) {
      var e = 1 / (t[0] * t[3] - t[1] * t[2]),
          i = [e * t[3], -e * t[1], -e * t[2], e * t[0]],
          r = fabric.util.transformPoint({
        x: t[4],
        y: t[5]
      }, i, true);
      i[4] = -r.x;
      i[5] = -r.y;
      return i;
    },
    toFixed: function toFixed(t, e) {
      return parseFloat(Number(t).toFixed(e));
    },
    parseUnit: function parseUnit(t, e) {
      var i = /\D{0,2}$/.exec(t),
          r = parseFloat(t);

      if (!e) {
        e = fabric.Text.DEFAULT_SVG_FONT_SIZE;
      }

      switch (i[0]) {
        case "mm":
          return r * fabric.DPI / 25.4;

        case "cm":
          return r * fabric.DPI / 2.54;

        case "in":
          return r * fabric.DPI;

        case "pt":
          return r * fabric.DPI / 72;

        case "pc":
          return r * fabric.DPI / 72 * 12;

        case "em":
          return r * e;

        default:
          return r;
      }
    },
    falseFunction: function falseFunction() {
      return false;
    },
    getKlass: function getKlass(t, e) {
      t = fabric.util.string.camelize(t.charAt(0).toUpperCase() + t.slice(1));
      return fabric.util.resolveNamespace(e)[t];
    },
    getSvgAttributes: function getSvgAttributes(t) {
      var e = ["instantiated_by_use", "style", "id", "class"];

      switch (t) {
        case "linearGradient":
          e = e.concat(["x1", "y1", "x2", "y2", "gradientUnits", "gradientTransform"]);
          break;

        case "radialGradient":
          e = e.concat(["gradientUnits", "gradientTransform", "cx", "cy", "r", "fx", "fy", "fr"]);
          break;

        case "stop":
          e = e.concat(["offset", "stop-color", "stop-opacity"]);
          break;
      }

      return e;
    },
    resolveNamespace: function resolveNamespace(t) {
      if (!t) {
        return fabric;
      }

      var e = t.split("."),
          i = e.length,
          r,
          n = s || fabric.window;

      for (r = 0; r < i; ++r) {
        n = n[e[r]];
      }

      return n;
    },
    loadImage: function loadImage(t, e, i, r) {
      if (!t) {
        e && e.call(i, t);
        return;
      }

      var n = fabric.util.createImage();

      var s = function s() {
        e && e.call(i, n);
        n = n.onload = n.onerror = null;
      };

      n.onload = s;

      n.onerror = function () {
        fabric.log("Error loading " + n.src);
        e && e.call(i, null, true);
        n = n.onload = n.onerror = null;
      };

      if (t.indexOf("data") !== 0 && r) {
        n.crossOrigin = r;
      }

      if (t.substring(0, 14) === "data:image/svg") {
        n.onload = null;
        fabric.util.loadImageInDom(n, s);
      }

      n.src = t;
    },
    loadImageInDom: function loadImageInDom(t, e) {
      var i = fabric.document.createElement("div");
      i.style.width = i.style.height = "1px";
      i.style.left = i.style.top = "-100%";
      i.style.position = "absolute";
      i.appendChild(t);
      fabric.document.querySelector("body").appendChild(i);

      t.onload = function () {
        e();
        i.parentNode.removeChild(i);
        i = null;
      };
    },
    enlivenObjects: function enlivenObjects(t, e, n, s) {
      t = t || [];
      var o = [],
          i = 0,
          r = t.length;

      function a() {
        if (++i === r) {
          e && e(o.filter(function (t) {
            return t;
          }));
        }
      }

      if (!r) {
        e && e(o);
        return;
      }

      t.forEach(function (i, r) {
        if (!i || !i.type) {
          a();
          return;
        }

        var t = fabric.util.getKlass(i.type, n);
        t.fromObject(i, function (t, e) {
          e || (o[r] = t);
          s && s(i, t, e);
          a();
        });
      });
    },
    enlivenPatterns: function enlivenPatterns(t, e) {
      t = t || [];

      function i() {
        if (++n === s) {
          e && e(r);
        }
      }

      var r = [],
          n = 0,
          s = t.length;

      if (!s) {
        e && e(r);
        return;
      }

      t.forEach(function (t, e) {
        if (t && t.source) {
          new fabric.Pattern(t, function (t) {
            r[e] = t;
            i();
          });
        } else {
          r[e] = t;
          i();
        }
      });
    },
    groupSVGElements: function groupSVGElements(t, e, i) {
      var r;

      if (t && t.length === 1) {
        return t[0];
      }

      if (e) {
        if (e.width && e.height) {
          e.centerPoint = {
            x: e.width / 2,
            y: e.height / 2
          };
        } else {
          delete e.width;
          delete e.height;
        }
      }

      r = new fabric.Group(t, e);

      if (typeof i !== "undefined") {
        r.sourcePath = i;
      }

      return r;
    },
    populateWithProperties: function populateWithProperties(t, e, i) {
      if (i && Object.prototype.toString.call(i) === "[object Array]") {
        for (var r = 0, n = i.length; r < n; r++) {
          if (i[r] in t) {
            e[i[r]] = t[i[r]];
          }
        }
      }
    },
    drawDashedLine: function drawDashedLine(t, e, i, r, n, s) {
      var o = r - e,
          a = n - i,
          c = d(o * o + a * a),
          l = g(a, o),
          h = s.length,
          f = 0,
          u = true;
      t.save();
      t.translate(e, i);
      t.moveTo(0, 0);
      t.rotate(l);
      e = 0;

      while (c > e) {
        e += s[f++ % h];

        if (e > c) {
          e = c;
        }

        t[u ? "lineTo" : "moveTo"](e, 0);
        u = !u;
      }

      t.restore();
    },
    createCanvasElement: function createCanvasElement() {
      return fabric.document.createElement("canvas");
    },
    copyCanvasElement: function copyCanvasElement(t) {
      var e = fabric.util.createCanvasElement();
      e.width = t.width;
      e.height = t.height;
      e.getContext("2d").drawImage(t, 0, 0);
      return e;
    },
    toDataURL: function toDataURL(t, e, i) {
      return t.toDataURL("image/" + e, i);
    },
    createImage: function createImage() {
      return fabric.document.createElement("img");
    },
    clipContext: function clipContext(t, e) {
      e.save();
      e.beginPath();
      t.clipTo(e);
      e.clip();
    },
    multiplyTransformMatrices: function multiplyTransformMatrices(t, e, i) {
      return [t[0] * e[0] + t[2] * e[1], t[1] * e[0] + t[3] * e[1], t[0] * e[2] + t[2] * e[3], t[1] * e[2] + t[3] * e[3], i ? 0 : t[0] * e[4] + t[2] * e[5] + t[4], i ? 0 : t[1] * e[4] + t[3] * e[5] + t[5]];
    },
    qrDecompose: function qrDecompose(t) {
      var e = g(t[1], t[0]),
          i = o(t[0], 2) + o(t[1], 2),
          r = d(i),
          n = (t[0] * t[3] - t[2] * t[1]) / r,
          s = g(t[0] * t[2] + t[1] * t[3], i);
      return {
        angle: e / a,
        scaleX: r,
        scaleY: n,
        skewX: s / a,
        skewY: 0,
        translateX: t[4],
        translateY: t[5]
      };
    },
    calcRotateMatrix: function calcRotateMatrix(t) {
      if (!t.angle) {
        return fabric.iMatrix.concat();
      }

      var e = fabric.util.degreesToRadians(t.angle),
          i = fabric.util.cos(e),
          r = fabric.util.sin(e);
      return [i, r, -r, i, 0, 0];
    },
    calcDimensionsMatrix: function calcDimensionsMatrix(t) {
      var e = typeof t.scaleX === "undefined" ? 1 : t.scaleX,
          i = typeof t.scaleY === "undefined" ? 1 : t.scaleY,
          r = [t.flipX ? -e : e, 0, 0, t.flipY ? -i : i, 0, 0],
          n = fabric.util.multiplyTransformMatrices,
          s = fabric.util.degreesToRadians;

      if (t.skewX) {
        r = n(r, [1, 0, Math.tan(s(t.skewX)), 1], true);
      }

      if (t.skewY) {
        r = n(r, [1, Math.tan(s(t.skewY)), 0, 1], true);
      }

      return r;
    },
    composeMatrix: function composeMatrix(t) {
      var e = [1, 0, 0, 1, t.translateX || 0, t.translateY || 0],
          i = fabric.util.multiplyTransformMatrices;

      if (t.angle) {
        e = i(e, fabric.util.calcRotateMatrix(t));
      }

      if (t.scaleX || t.scaleY || t.skewX || t.skewY || t.flipX || t.flipY) {
        e = i(e, fabric.util.calcDimensionsMatrix(t));
      }

      return e;
    },
    customTransformMatrix: function customTransformMatrix(t, e, i) {
      return fabric.util.composeMatrix({
        scaleX: t,
        scaleY: e,
        skewX: i
      });
    },
    resetObjectTransform: function resetObjectTransform(t) {
      t.scaleX = 1;
      t.scaleY = 1;
      t.skewX = 0;
      t.skewY = 0;
      t.flipX = false;
      t.flipY = false;
      t.rotate(0);
    },
    saveObjectTransform: function saveObjectTransform(t) {
      return {
        scaleX: t.scaleX,
        scaleY: t.scaleY,
        skewX: t.skewX,
        skewY: t.skewY,
        angle: t.angle,
        left: t.left,
        flipX: t.flipX,
        flipY: t.flipY,
        top: t.top
      };
    },
    getFunctionBody: function getFunctionBody(t) {
      return (String(t).match(/function[^{]*\{([\s\S]*)\}/) || {})[1];
    },
    isTransparent: function isTransparent(t, e, i, r) {
      if (r > 0) {
        if (e > r) {
          e -= r;
        } else {
          e = 0;
        }

        if (i > r) {
          i -= r;
        } else {
          i = 0;
        }
      }

      var n = true,
          s,
          o,
          a = t.getImageData(e, i, r * 2 || 1, r * 2 || 1),
          c = a.data.length;

      for (s = 3; s < c; s += 4) {
        o = a.data[s];
        n = o <= 0;

        if (n === false) {
          break;
        }
      }

      a = null;
      return n;
    },
    parsePreserveAspectRatioAttribute: function parsePreserveAspectRatioAttribute(t) {
      var e = "meet",
          i = "Mid",
          r = "Mid",
          n = t.split(" "),
          s;

      if (n && n.length) {
        e = n.pop();

        if (e !== "meet" && e !== "slice") {
          s = e;
          e = "meet";
        } else if (n.length) {
          s = n.pop();
        }
      }

      i = s !== "none" ? s.slice(1, 4) : "none";
      r = s !== "none" ? s.slice(5, 8) : "none";
      return {
        meetOrSlice: e,
        alignX: i,
        alignY: r
      };
    },
    clearFabricFontCache: function clearFabricFontCache(t) {
      t = (t || "").toLowerCase();

      if (!t) {
        fabric.charWidthsCache = {};
      } else if (fabric.charWidthsCache[t]) {
        delete fabric.charWidthsCache[t];
      }
    },
    limitDimsByArea: function limitDimsByArea(t, e) {
      var i = Math.sqrt(e * t),
          r = Math.floor(e / i);
      return {
        x: Math.floor(i),
        y: r
      };
    },
    capValue: function capValue(t, e, i) {
      return Math.max(t, Math.min(e, i));
    },
    findScaleToFit: function findScaleToFit(t, e) {
      return Math.min(e.width / t.width, e.height / t.height);
    },
    findScaleToCover: function findScaleToCover(t, e) {
      return Math.max(e.width / t.width, e.height / t.height);
    },
    matrixToSVG: function matrixToSVG(t) {
      return "matrix(" + t.map(function (t) {
        return fabric.util.toFixed(t, fabric.Object.NUM_FRACTION_DIGITS);
      }).join(" ") + ")";
    }
  };
})(typeof exports !== "undefined" ? exports : void 0);

(function () {
  fabric.util.createAccessors = function (t) {
    var e = t.prototype,
        i,
        r,
        n,
        s,
        o;

    for (i = e.stateProperties.length; i--;) {
      r = e.stateProperties[i];
      n = r.charAt(0).toUpperCase() + r.slice(1);
      s = "set" + n;
      o = "get" + n;

      if (!e[o]) {
        e[o] = function (t) {
          return new Function('return this.get("' + t + '")');
        }(r);
      }

      if (!e[s]) {
        e[s] = function (t) {
          return new Function("value", 'return this.set("' + t + '", value)');
        }(r);
      }
    }
  };
})(typeof exports !== "undefined" ? exports : void 0);

(function () {
  var L = Array.prototype.join;

  function v(t, e, i, r, n, s, o) {
    var a = L.call(arguments);

    if (fabric.arcToSegmentsCache[a]) {
      return fabric.arcToSegmentsCache[a];
    }

    var c = Math.PI,
        l = o * c / 180,
        h = fabric.util.sin(l),
        f = fabric.util.cos(l),
        u = 0,
        d = 0;
    i = Math.abs(i);
    r = Math.abs(r);

    var g = -f * t * .5 - h * e * .5,
        p = -f * e * .5 + h * t * .5,
        v = i * i,
        m = r * r,
        b = p * p,
        y = g * g,
        _ = v * m - v * b - m * y,
        x = 0;

    if (_ < 0) {
      var C = Math.sqrt(1 - _ / (v * m));
      i *= C;
      r *= C;
    } else {
      x = (n === s ? -1 : 1) * Math.sqrt(_ / (v * b + m * y));
    }

    var w = x * i * p / r,
        S = -x * r * g / i,
        T = f * w - h * S + t * .5,
        O = h * w + f * S + e * .5,
        j = B(1, 0, (g - w) / i, (p - S) / r),
        k = B((g - w) / i, (p - S) / r, (-g - w) / i, (-p - S) / r);

    if (s === 0 && k > 0) {
      k -= 2 * c;
    } else if (s === 1 && k < 0) {
      k += 2 * c;
    }

    var P = Math.ceil(Math.abs(k / c * 2)),
        D = [],
        E = k / P,
        M = 8 / 3 * Math.sin(E / 4) * Math.sin(E / 4) / Math.sin(E / 2),
        F = j + E;

    for (var A = 0; A < P; A++) {
      D[A] = I(j, F, f, h, i, r, T, O, M, u, d);
      u = D[A][4];
      d = D[A][5];
      j = F;
      F += E;
    }

    fabric.arcToSegmentsCache[a] = D;
    return D;
  }

  function I(t, e, i, r, n, s, o, a, c, l, h) {
    var f = fabric.util.cos(t),
        u = fabric.util.sin(t),
        d = fabric.util.cos(e),
        g = fabric.util.sin(e),
        p = i * n * d - r * s * g + o,
        v = r * n * d + i * s * g + a,
        m = l + c * (-i * n * u - r * s * f),
        b = h + c * (-r * n * u + i * s * f),
        y = p + c * (i * n * g + r * s * d),
        _ = v + c * (r * n * g - i * s * d);

    return [m, b, y, _, p, v];
  }

  function B(t, e, i, r) {
    var n = Math.atan2(e, t),
        s = Math.atan2(r, i);

    if (s >= n) {
      return s - n;
    } else {
      return 2 * Math.PI - (n - s);
    }
  }

  fabric.util.drawArc = function (t, e, i, r) {
    var n = r[0],
        s = r[1],
        o = r[2],
        a = r[3],
        c = r[4],
        l = r[5],
        h = r[6],
        f = [[], [], [], []],
        u = v(l - e, h - i, n, s, a, c, o);

    for (var d = 0, g = u.length; d < g; d++) {
      f[d][0] = u[d][0] + e;
      f[d][1] = u[d][1] + i;
      f[d][2] = u[d][2] + e;
      f[d][3] = u[d][3] + i;
      f[d][4] = u[d][4] + e;
      f[d][5] = u[d][5] + i;
      t.bezierCurveTo.apply(t, f[d]);
    }
  };

  fabric.util.getBoundsOfArc = function (t, e, i, r, n, s, o, a, c) {
    var l = 0,
        h = 0,
        f,
        u = [],
        d = v(a - t, c - e, i, r, s, o, n);

    for (var g = 0, p = d.length; g < p; g++) {
      f = m(l, h, d[g][0], d[g][1], d[g][2], d[g][3], d[g][4], d[g][5]);
      u.push({
        x: f[0].x + t,
        y: f[0].y + e
      });
      u.push({
        x: f[1].x + t,
        y: f[1].y + e
      });
      l = d[g][4];
      h = d[g][5];
    }

    return u;
  };

  function m(t, e, i, r, n, s, o, a) {
    var c;

    if (fabric.cachesBoundsOfCurve) {
      c = L.call(arguments);

      if (fabric.boundsOfCurveCache[c]) {
        return fabric.boundsOfCurveCache[c];
      }
    }

    var l = Math.sqrt,
        h = Math.min,
        f = Math.max,
        u = Math.abs,
        d = [],
        g = [[], []],
        p,
        v,
        m,
        b,
        y,
        _,
        x,
        C;

    v = 6 * t - 12 * i + 6 * n;
    p = -3 * t + 9 * i - 9 * n + 3 * o;
    m = 3 * i - 3 * t;

    for (var w = 0; w < 2; ++w) {
      if (w > 0) {
        v = 6 * e - 12 * r + 6 * s;
        p = -3 * e + 9 * r - 9 * s + 3 * a;
        m = 3 * r - 3 * e;
      }

      if (u(p) < 1e-12) {
        if (u(v) < 1e-12) {
          continue;
        }

        b = -m / v;

        if (0 < b && b < 1) {
          d.push(b);
        }

        continue;
      }

      x = v * v - 4 * m * p;

      if (x < 0) {
        continue;
      }

      C = l(x);
      y = (-v + C) / (2 * p);

      if (0 < y && y < 1) {
        d.push(y);
      }

      _ = (-v - C) / (2 * p);

      if (0 < _ && _ < 1) {
        d.push(_);
      }
    }

    var S,
        T,
        O = d.length,
        j = O,
        k;

    while (O--) {
      b = d[O];
      k = 1 - b;
      S = k * k * k * t + 3 * k * k * b * i + 3 * k * b * b * n + b * b * b * o;
      g[0][O] = S;
      T = k * k * k * e + 3 * k * k * b * r + 3 * k * b * b * s + b * b * b * a;
      g[1][O] = T;
    }

    g[0][j] = t;
    g[1][j] = e;
    g[0][j + 1] = o;
    g[1][j + 1] = a;
    var P = [{
      x: h.apply(null, g[0]),
      y: h.apply(null, g[1])
    }, {
      x: f.apply(null, g[0]),
      y: f.apply(null, g[1])
    }];

    if (fabric.cachesBoundsOfCurve) {
      fabric.boundsOfCurveCache[c] = P;
    }

    return P;
  }

  fabric.util.getBoundsOfCurve = m;
})();

(function () {
  var o = Array.prototype.slice;

  function t(t, e) {
    var i = o.call(arguments, 2),
        r = [];

    for (var n = 0, s = t.length; n < s; n++) {
      r[n] = i.length ? t[n][e].apply(t[n], i) : t[n][e].call(t[n]);
    }

    return r;
  }

  function e(t, e) {
    return n(t, e, function (t, e) {
      return t >= e;
    });
  }

  function i(t, e) {
    return n(t, e, function (t, e) {
      return t < e;
    });
  }

  function r(t, e) {
    var i = t.length;

    while (i--) {
      t[i] = e;
    }

    return t;
  }

  function n(t, e, i) {
    if (!t || t.length === 0) {
      return;
    }

    var r = t.length - 1,
        n = e ? t[r][e] : t[r];

    if (e) {
      while (r--) {
        if (i(t[r][e], n)) {
          n = t[r][e];
        }
      }
    } else {
      while (r--) {
        if (i(t[r], n)) {
          n = t[r];
        }
      }
    }

    return n;
  }

  fabric.util.array = {
    fill: r,
    invoke: t,
    min: i,
    max: e
  };
})();

(function () {
  function o(t, e, i) {
    if (i) {
      if (!fabric.isLikelyNode && e instanceof Element) {
        t = e;
      } else if (e instanceof Array) {
        t = [];

        for (var r = 0, n = e.length; r < n; r++) {
          t[r] = o({}, e[r], i);
        }
      } else if (e && (0, _typeof2["default"])(e) === "object") {
        for (var s in e) {
          if (s === "canvas") {
            t[s] = o({}, e[s]);
          } else if (e.hasOwnProperty(s)) {
            t[s] = o({}, e[s], i);
          }
        }
      } else {
        t = e;
      }
    } else {
      for (var s in e) {
        t[s] = e[s];
      }
    }

    return t;
  }

  function t(t, e) {
    return o({}, t, e);
  }

  fabric.util.object = {
    extend: o,
    clone: t
  };
  fabric.util.object.extend(fabric.util, fabric.Observable);
})();

(function () {
  function t(t) {
    return t.replace(/-+(.)?/g, function (t, e) {
      return e ? e.toUpperCase() : "";
    });
  }

  function e(t, e) {
    return t.charAt(0).toUpperCase() + (e ? t.slice(1) : t.slice(1).toLowerCase());
  }

  function i(t) {
    return t.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  }

  function r(t) {
    var e = 0,
        i,
        r = [];

    for (e = 0, i; e < t.length; e++) {
      if ((i = n(t, e)) === false) {
        continue;
      }

      r.push(i);
    }

    return r;
  }

  function n(t, e) {
    var i = t.charCodeAt(e);

    if (isNaN(i)) {
      return "";
    }

    if (i < 55296 || i > 57343) {
      return t.charAt(e);
    }

    if (55296 <= i && i <= 56319) {
      if (t.length <= e + 1) {
        throw "High surrogate without following low surrogate";
      }

      var r = t.charCodeAt(e + 1);

      if (56320 > r || r > 57343) {
        throw "High surrogate without following low surrogate";
      }

      return t.charAt(e) + t.charAt(e + 1);
    }

    if (e === 0) {
      throw "Low surrogate without preceding high surrogate";
    }

    var n = t.charCodeAt(e - 1);

    if (55296 > n || n > 56319) {
      throw "Low surrogate without preceding high surrogate";
    }

    return false;
  }

  fabric.util.string = {
    camelize: t,
    capitalize: e,
    escapeXml: i,
    graphemeSplit: r
  };
})();

(function () {
  var s = Array.prototype.slice,
      o = function o() {},
      i = function () {
    for (var t in {
      toString: 1
    }) {
      if (t === "toString") {
        return false;
      }
    }

    return true;
  }(),
      a = function a(t, r, n) {
    for (var e in r) {
      if (e in t.prototype && typeof t.prototype[e] === "function" && (r[e] + "").indexOf("callSuper") > -1) {
        t.prototype[e] = function (i) {
          return function () {
            var t = this.constructor.superclass;
            this.constructor.superclass = n;
            var e = r[i].apply(this, arguments);
            this.constructor.superclass = t;

            if (i !== "initialize") {
              return e;
            }
          };
        }(e);
      } else {
        t.prototype[e] = r[e];
      }

      if (i) {
        if (r.toString !== Object.prototype.toString) {
          t.prototype.toString = r.toString;
        }

        if (r.valueOf !== Object.prototype.valueOf) {
          t.prototype.valueOf = r.valueOf;
        }
      }
    }
  };

  function c() {}

  function l(t) {
    var e = null,
        i = this;

    while (i.constructor.superclass) {
      var r = i.constructor.superclass.prototype[t];

      if (i[t] !== r) {
        e = r;
        break;
      }

      i = i.constructor.superclass.prototype;
    }

    if (!e) {
      return console.log("tried to callSuper " + t + ", method not found in prototype chain", this);
    }

    return arguments.length > 1 ? e.apply(this, s.call(arguments, 1)) : e.call(this);
  }

  function t() {
    var t = null,
        e = s.call(arguments, 0);

    if (typeof e[0] === "function") {
      t = e.shift();
    }

    function i() {
      this.initialize.apply(this, arguments);
    }

    i.superclass = t;
    i.subclasses = [];

    if (t) {
      c.prototype = t.prototype;
      i.prototype = new c();
      t.subclasses.push(i);
    }

    for (var r = 0, n = e.length; r < n; r++) {
      a(i, e[r], t);
    }

    if (!i.prototype.initialize) {
      i.prototype.initialize = o;
    }

    i.prototype.constructor = i;
    i.prototype.callSuper = l;
    return i;
  }

  fabric.util.createClass = t;
})();

(function () {
  var n = !!fabric.document.createElement("div").attachEvent;

  fabric.util.addListener = function (t, e, i, r) {
    t && t.addEventListener(e, i, n ? false : r);
  };

  fabric.util.removeListener = function (t, e, i, r) {
    t && t.removeEventListener(e, i, n ? false : r);
  };

  function s(t) {
    var e = t.changedTouches;

    if (e && e[0]) {
      return e[0];
    }

    return t;
  }

  fabric.util.getPointer = function (t) {
    var e = t.target,
        i = fabric.util.getScrollLeftTop(e),
        r = s(t);
    return {
      x: r.clientX + i.left,
      y: r.clientY + i.top
    };
  };
})();

(function () {
  function t(t, e) {
    var i = t.style;

    if (!i) {
      return t;
    }

    if (typeof e === "string") {
      t.style.cssText += ";" + e;
      return e.indexOf("opacity") > -1 ? s(t, e.match(/opacity:\s*(\d?\.?\d*)/)[1]) : t;
    }

    for (var r in e) {
      if (r === "opacity") {
        s(t, e[r]);
      } else {
        var n = r === "float" || r === "cssFloat" ? typeof i.styleFloat === "undefined" ? "cssFloat" : "styleFloat" : r;
        i[n] = e[r];
      }
    }

    return t;
  }

  var e = fabric.document.createElement("div"),
      i = typeof e.style.opacity === "string",
      r = typeof e.style.filter === "string",
      n = /alpha\s*\(\s*opacity\s*=\s*([^\)]+)\)/,
      s = function s(t) {
    return t;
  };

  if (i) {
    s = function s(t, e) {
      t.style.opacity = e;
      return t;
    };
  } else if (r) {
    s = function s(t, e) {
      var i = t.style;

      if (t.currentStyle && !t.currentStyle.hasLayout) {
        i.zoom = 1;
      }

      if (n.test(i.filter)) {
        e = e >= .9999 ? "" : "alpha(opacity=" + e * 100 + ")";
        i.filter = i.filter.replace(n, e);
      } else {
        i.filter += " alpha(opacity=" + e * 100 + ")";
      }

      return t;
    };
  }

  fabric.util.setStyle = t;
})();

(function () {
  var e = Array.prototype.slice;

  function t(t) {
    return typeof t === "string" ? fabric.document.getElementById(t) : t;
  }

  var i,
      r = function r(t) {
    return e.call(t, 0);
  };

  try {
    i = r(fabric.document.childNodes) instanceof Array;
  } catch (t) {}

  if (!i) {
    r = function r(t) {
      var e = new Array(t.length),
          i = t.length;

      while (i--) {
        e[i] = t[i];
      }

      return e;
    };
  }

  function n(t, e) {
    var i = fabric.document.createElement(t);

    for (var r in e) {
      if (r === "class") {
        i.className = e[r];
      } else if (r === "for") {
        i.htmlFor = e[r];
      } else {
        i.setAttribute(r, e[r]);
      }
    }

    return i;
  }

  function s(t, e) {
    if (t && (" " + t.className + " ").indexOf(" " + e + " ") === -1) {
      t.className += (t.className ? " " : "") + e;
    }
  }

  function o(t, e, i) {
    if (typeof e === "string") {
      e = n(e, i);
    }

    if (t.parentNode) {
      t.parentNode.replaceChild(e, t);
    }

    e.appendChild(t);
    return e;
  }

  function c(t) {
    var e = 0,
        i = 0,
        r = fabric.document.documentElement,
        n = fabric.document.body || {
      scrollLeft: 0,
      scrollTop: 0
    };

    while (t && (t.parentNode || t.host)) {
      t = t.parentNode || t.host;

      if (t === fabric.document) {
        e = n.scrollLeft || r.scrollLeft || 0;
        i = n.scrollTop || r.scrollTop || 0;
      } else {
        e += t.scrollLeft || 0;
        i += t.scrollTop || 0;
      }

      if (t.nodeType === 1 && t.style.position === "fixed") {
        break;
      }
    }

    return {
      left: e,
      top: i
    };
  }

  function a(t) {
    var e,
        i = t && t.ownerDocument,
        r = {
      left: 0,
      top: 0
    },
        n = {
      left: 0,
      top: 0
    },
        s,
        o = {
      borderLeftWidth: "left",
      borderTopWidth: "top",
      paddingLeft: "left",
      paddingTop: "top"
    };

    if (!i) {
      return n;
    }

    for (var a in o) {
      n[o[a]] += parseInt(l(t, a), 10) || 0;
    }

    e = i.documentElement;

    if (typeof t.getBoundingClientRect !== "undefined") {
      r = t.getBoundingClientRect();
    }

    s = c(t);
    return {
      left: r.left + s.left - (e.clientLeft || 0) + n.left,
      top: r.top + s.top - (e.clientTop || 0) + n.top
    };
  }

  var l;

  if (fabric.document.defaultView && fabric.document.defaultView.getComputedStyle) {
    l = function l(t, e) {
      var i = fabric.document.defaultView.getComputedStyle(t, null);
      return i ? i[e] : undefined;
    };
  } else {
    l = function l(t, e) {
      var i = t.style[e];

      if (!i && t.currentStyle) {
        i = t.currentStyle[e];
      }

      return i;
    };
  }

  (function () {
    var t = fabric.document.documentElement.style,
        e = "userSelect" in t ? "userSelect" : "MozUserSelect" in t ? "MozUserSelect" : "WebkitUserSelect" in t ? "WebkitUserSelect" : "KhtmlUserSelect" in t ? "KhtmlUserSelect" : "";

    function i(t) {
      if (typeof t.onselectstart !== "undefined") {
        t.onselectstart = fabric.util.falseFunction;
      }

      if (e) {
        t.style[e] = "none";
      } else if (typeof t.unselectable === "string") {
        t.unselectable = "on";
      }

      return t;
    }

    function r(t) {
      if (typeof t.onselectstart !== "undefined") {
        t.onselectstart = null;
      }

      if (e) {
        t.style[e] = "";
      } else if (typeof t.unselectable === "string") {
        t.unselectable = "";
      }

      return t;
    }

    fabric.util.makeElementUnselectable = i;
    fabric.util.makeElementSelectable = r;
  })();

  (function () {
    function t(t, e) {
      var i = fabric.document.getElementsByTagName("head")[0],
          r = fabric.document.createElement("script"),
          n = true;

      r.onload = r.onreadystatechange = function (t) {
        if (n) {
          if (typeof this.readyState === "string" && this.readyState !== "loaded" && this.readyState !== "complete") {
            return;
          }

          n = false;
          e(t || fabric.window.event);
          r = r.onload = r.onreadystatechange = null;
        }
      };

      r.src = t;
      i.appendChild(r);
    }

    fabric.util.getScript = t;
  })();

  function h(t) {
    var e = fabric.jsdomImplForWrapper(t);
    return e._canvas || e._image;
  }

  function f(t) {
    if (!fabric.isLikelyNode) {
      return;
    }

    var e = fabric.jsdomImplForWrapper(t);

    if (e) {
      e._image = null;
      e._canvas = null;
      e._currentSrc = null;
      e._attributes = null;
      e._classList = null;
    }
  }

  fabric.util.getById = t;
  fabric.util.toArray = r;
  fabric.util.makeElement = n;
  fabric.util.addClass = s;
  fabric.util.wrapElement = o;
  fabric.util.getScrollLeftTop = c;
  fabric.util.getElementOffset = a;
  fabric.util.getElementStyle = l;
  fabric.util.getNodeCanvas = h;
  fabric.util.cleanUpJsdomNode = f;
})();

(function () {
  function o(t, e) {
    return t + (/\?/.test(t) ? "&" : "?") + e;
  }

  function a() {}

  function t(t, e) {
    e || (e = {});

    var i = e.method ? e.method.toUpperCase() : "GET",
        r = e.onComplete || function () {},
        n = new fabric.window.XMLHttpRequest(),
        s = e.body || e.parameters;

    n.onreadystatechange = function () {
      if (n.readyState === 4) {
        r(n);
        n.onreadystatechange = a;
      }
    };

    if (i === "GET") {
      s = null;

      if (typeof e.parameters === "string") {
        t = o(t, e.parameters);
      }
    }

    n.open(i, t, true);

    if (i === "POST" || i === "PUT") {
      n.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    }

    n.send(s);
    return n;
  }

  fabric.util.request = t;
})();

fabric.log = console.log;
fabric.warn = console.warn;

(function () {
  function i() {
    return false;
  }

  function r(t, e, i, r) {
    return -i * Math.cos(t / r * (Math.PI / 2)) + i + e;
  }

  function t(e) {
    m(function (t) {
      e || (e = {});
      var o = t || +new Date(),
          a = e.duration || 500,
          c = o + a,
          l,
          h = e.onChange || i,
          f = e.abort || i,
          u = e.onComplete || i,
          d = e.easing || r,
          g = "startValue" in e ? e.startValue : 0,
          p = "endValue" in e ? e.endValue : 100,
          v = e.byValue || p - g;
      e.onStart && e.onStart();

      (function t(e) {
        l = e || +new Date();
        var i = l > c ? a : l - o,
            r = i / a,
            n = d(i, g, v, a),
            s = Math.abs((n - g) / v);

        if (f()) {
          u(p, 1, 1);
          return;
        }

        if (l > c) {
          h(p, 1, 1);
          u(p, 1, 1);
          return;
        } else {
          h(n, s, r);
          m(t);
        }
      })(o);
    });
  }

  var e = fabric.window.requestAnimationFrame || fabric.window.webkitRequestAnimationFrame || fabric.window.mozRequestAnimationFrame || fabric.window.oRequestAnimationFrame || fabric.window.msRequestAnimationFrame || function (t) {
    return fabric.window.setTimeout(t, 1e3 / 60);
  };

  var n = fabric.window.cancelAnimationFrame || fabric.window.clearTimeout;

  function m() {
    return e.apply(fabric.window, arguments);
  }

  function s() {
    return n.apply(fabric.window, arguments);
  }

  fabric.util.animate = t;
  fabric.util.requestAnimFrame = m;
  fabric.util.cancelAnimFrame = s;
})();

(function () {
  function o(t, e, i) {
    var r = "rgba(" + parseInt(t[0] + i * (e[0] - t[0]), 10) + "," + parseInt(t[1] + i * (e[1] - t[1]), 10) + "," + parseInt(t[2] + i * (e[2] - t[2]), 10);
    r += "," + (t && e ? parseFloat(t[3] + i * (e[3] - t[3])) : 1);
    r += ")";
    return r;
  }

  function t(t, e, i, s) {
    var r = new fabric.Color(t).getSource(),
        n = new fabric.Color(e).getSource();
    s = s || {};
    fabric.util.animate(fabric.util.object.extend(s, {
      duration: i || 500,
      startValue: r,
      endValue: n,
      byValue: n,
      easing: function easing(t, e, i, r) {
        var n = s.colorEasing ? s.colorEasing(t, r) : 1 - Math.cos(t / r * (Math.PI / 2));
        return o(e, i, n);
      }
    }));
  }

  fabric.util.animateColor = t;
})();

(function () {
  function c(t, e, i, r) {
    if (t < Math.abs(e)) {
      t = e;
      r = i / 4;
    } else {
      if (e === 0 && t === 0) {
        r = i / (2 * Math.PI) * Math.asin(1);
      } else {
        r = i / (2 * Math.PI) * Math.asin(e / t);
      }
    }

    return {
      a: t,
      c: e,
      p: i,
      s: r
    };
  }

  function l(t, e, i) {
    return t.a * Math.pow(2, 10 * (e -= 1)) * Math.sin((e * i - t.s) * (2 * Math.PI) / t.p);
  }

  function t(t, e, i, r) {
    return i * ((t = t / r - 1) * t * t + 1) + e;
  }

  function e(t, e, i, r) {
    t /= r / 2;

    if (t < 1) {
      return i / 2 * t * t * t + e;
    }

    return i / 2 * ((t -= 2) * t * t + 2) + e;
  }

  function i(t, e, i, r) {
    return i * (t /= r) * t * t * t + e;
  }

  function r(t, e, i, r) {
    return -i * ((t = t / r - 1) * t * t * t - 1) + e;
  }

  function n(t, e, i, r) {
    t /= r / 2;

    if (t < 1) {
      return i / 2 * t * t * t * t + e;
    }

    return -i / 2 * ((t -= 2) * t * t * t - 2) + e;
  }

  function s(t, e, i, r) {
    return i * (t /= r) * t * t * t * t + e;
  }

  function o(t, e, i, r) {
    return i * ((t = t / r - 1) * t * t * t * t + 1) + e;
  }

  function a(t, e, i, r) {
    t /= r / 2;

    if (t < 1) {
      return i / 2 * t * t * t * t * t + e;
    }

    return i / 2 * ((t -= 2) * t * t * t * t + 2) + e;
  }

  function h(t, e, i, r) {
    return -i * Math.cos(t / r * (Math.PI / 2)) + i + e;
  }

  function f(t, e, i, r) {
    return i * Math.sin(t / r * (Math.PI / 2)) + e;
  }

  function u(t, e, i, r) {
    return -i / 2 * (Math.cos(Math.PI * t / r) - 1) + e;
  }

  function d(t, e, i, r) {
    return t === 0 ? e : i * Math.pow(2, 10 * (t / r - 1)) + e;
  }

  function g(t, e, i, r) {
    return t === r ? e + i : i * (-Math.pow(2, -10 * t / r) + 1) + e;
  }

  function p(t, e, i, r) {
    if (t === 0) {
      return e;
    }

    if (t === r) {
      return e + i;
    }

    t /= r / 2;

    if (t < 1) {
      return i / 2 * Math.pow(2, 10 * (t - 1)) + e;
    }

    return i / 2 * (-Math.pow(2, -10 * --t) + 2) + e;
  }

  function v(t, e, i, r) {
    return -i * (Math.sqrt(1 - (t /= r) * t) - 1) + e;
  }

  function m(t, e, i, r) {
    return i * Math.sqrt(1 - (t = t / r - 1) * t) + e;
  }

  function b(t, e, i, r) {
    t /= r / 2;

    if (t < 1) {
      return -i / 2 * (Math.sqrt(1 - t * t) - 1) + e;
    }

    return i / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + e;
  }

  function y(t, e, i, r) {
    var n = 1.70158,
        s = 0,
        o = i;

    if (t === 0) {
      return e;
    }

    t /= r;

    if (t === 1) {
      return e + i;
    }

    if (!s) {
      s = r * .3;
    }

    var a = c(o, i, s, n);
    return -l(a, t, r) + e;
  }

  function _(t, e, i, r) {
    var n = 1.70158,
        s = 0,
        o = i;

    if (t === 0) {
      return e;
    }

    t /= r;

    if (t === 1) {
      return e + i;
    }

    if (!s) {
      s = r * .3;
    }

    var a = c(o, i, s, n);
    return a.a * Math.pow(2, -10 * t) * Math.sin((t * r - a.s) * (2 * Math.PI) / a.p) + a.c + e;
  }

  function x(t, e, i, r) {
    var n = 1.70158,
        s = 0,
        o = i;

    if (t === 0) {
      return e;
    }

    t /= r / 2;

    if (t === 2) {
      return e + i;
    }

    if (!s) {
      s = r * (.3 * 1.5);
    }

    var a = c(o, i, s, n);

    if (t < 1) {
      return -.5 * l(a, t, r) + e;
    }

    return a.a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * r - a.s) * (2 * Math.PI) / a.p) * .5 + a.c + e;
  }

  function C(t, e, i, r, n) {
    if (n === undefined) {
      n = 1.70158;
    }

    return i * (t /= r) * t * ((n + 1) * t - n) + e;
  }

  function w(t, e, i, r, n) {
    if (n === undefined) {
      n = 1.70158;
    }

    return i * ((t = t / r - 1) * t * ((n + 1) * t + n) + 1) + e;
  }

  function S(t, e, i, r, n) {
    if (n === undefined) {
      n = 1.70158;
    }

    t /= r / 2;

    if (t < 1) {
      return i / 2 * (t * t * (((n *= 1.525) + 1) * t - n)) + e;
    }

    return i / 2 * ((t -= 2) * t * (((n *= 1.525) + 1) * t + n) + 2) + e;
  }

  function T(t, e, i, r) {
    return i - O(r - t, 0, i, r) + e;
  }

  function O(t, e, i, r) {
    if ((t /= r) < 1 / 2.75) {
      return i * (7.5625 * t * t) + e;
    } else if (t < 2 / 2.75) {
      return i * (7.5625 * (t -= 1.5 / 2.75) * t + .75) + e;
    } else if (t < 2.5 / 2.75) {
      return i * (7.5625 * (t -= 2.25 / 2.75) * t + .9375) + e;
    } else {
      return i * (7.5625 * (t -= 2.625 / 2.75) * t + .984375) + e;
    }
  }

  function j(t, e, i, r) {
    if (t < r / 2) {
      return T(t * 2, 0, i, r) * .5 + e;
    }

    return O(t * 2 - r, 0, i, r) * .5 + i * .5 + e;
  }

  fabric.util.ease = {
    easeInQuad: function easeInQuad(t, e, i, r) {
      return i * (t /= r) * t + e;
    },
    easeOutQuad: function easeOutQuad(t, e, i, r) {
      return -i * (t /= r) * (t - 2) + e;
    },
    easeInOutQuad: function easeInOutQuad(t, e, i, r) {
      t /= r / 2;

      if (t < 1) {
        return i / 2 * t * t + e;
      }

      return -i / 2 * (--t * (t - 2) - 1) + e;
    },
    easeInCubic: function easeInCubic(t, e, i, r) {
      return i * (t /= r) * t * t + e;
    },
    easeOutCubic: t,
    easeInOutCubic: e,
    easeInQuart: i,
    easeOutQuart: r,
    easeInOutQuart: n,
    easeInQuint: s,
    easeOutQuint: o,
    easeInOutQuint: a,
    easeInSine: h,
    easeOutSine: f,
    easeInOutSine: u,
    easeInExpo: d,
    easeOutExpo: g,
    easeInOutExpo: p,
    easeInCirc: v,
    easeOutCirc: m,
    easeInOutCirc: b,
    easeInElastic: y,
    easeOutElastic: _,
    easeInOutElastic: x,
    easeInBack: C,
    easeOutBack: w,
    easeInOutBack: S,
    easeInBounce: T,
    easeOutBounce: O,
    easeInOutBounce: j
  };
})();

(function (t) {
  "use strict";

  var C = t.fabric || (t.fabric = {}),
      g = C.util.object.extend,
      u = C.util.object.clone,
      r = C.util.toFixed,
      w = C.util.parseUnit,
      c = C.util.multiplyTransformMatrices,
      e = ["path", "circle", "polygon", "polyline", "ellipse", "rect", "line", "image", "text"],
      i = ["symbol", "image", "marker", "pattern", "view", "svg"],
      n = ["pattern", "defs", "symbol", "metadata", "clipPath", "mask", "desc"],
      s = ["symbol", "g", "a", "svg", "clipPath", "defs"],
      o = {
    cx: "left",
    x: "left",
    r: "radius",
    cy: "top",
    y: "top",
    display: "visible",
    visibility: "visible",
    transform: "transformMatrix",
    "fill-opacity": "fillOpacity",
    "fill-rule": "fillRule",
    "font-family": "fontFamily",
    "font-size": "fontSize",
    "font-style": "fontStyle",
    "font-weight": "fontWeight",
    "letter-spacing": "charSpacing",
    "paint-order": "paintFirst",
    "stroke-dasharray": "strokeDashArray",
    "stroke-dashoffset": "strokeDashOffset",
    "stroke-linecap": "strokeLineCap",
    "stroke-linejoin": "strokeLineJoin",
    "stroke-miterlimit": "strokeMiterLimit",
    "stroke-opacity": "strokeOpacity",
    "stroke-width": "strokeWidth",
    "text-decoration": "textDecoration",
    "text-anchor": "textAnchor",
    opacity: "opacity",
    "clip-path": "clipPath",
    "clip-rule": "clipRule",
    "vector-effect": "strokeUniform"
  },
      a = {
    stroke: "strokeOpacity",
    fill: "fillOpacity"
  },
      p = "font-size",
      v = "clip-path";
  C.svgValidTagNamesRegEx = l(e);
  C.svgViewBoxElementsRegEx = l(i);
  C.svgInvalidAncestorsRegEx = l(n);
  C.svgValidParentsRegEx = l(s);
  C.cssRules = {};
  C.gradientDefs = {};
  C.clipPaths = {};

  function m(t) {
    if (t in o) {
      return o[t];
    }

    return t;
  }

  function b(t, e, i, r) {
    var n = Object.prototype.toString.call(e) === "[object Array]",
        s;

    if ((t === "fill" || t === "stroke") && e === "none") {
      e = "";
    } else if (t === "vector-effect") {
      e = e === "non-scaling-stroke";
    } else if (t === "strokeDashArray") {
      if (e === "none") {
        e = null;
      } else {
        e = e.replace(/,/g, " ").split(/\s+/).map(parseFloat);
      }
    } else if (t === "transformMatrix") {
      if (i && i.transformMatrix) {
        e = c(i.transformMatrix, C.parseTransformAttribute(e));
      } else {
        e = C.parseTransformAttribute(e);
      }
    } else if (t === "visible") {
      e = e !== "none" && e !== "hidden";

      if (i && i.visible === false) {
        e = false;
      }
    } else if (t === "opacity") {
      e = parseFloat(e);

      if (i && typeof i.opacity !== "undefined") {
        e *= i.opacity;
      }
    } else if (t === "textAnchor") {
      e = e === "start" ? "left" : e === "end" ? "right" : "center";
    } else if (t === "charSpacing") {
      s = w(e, r) / r * 1e3;
    } else if (t === "paintFirst") {
      var o = e.indexOf("fill");
      var a = e.indexOf("stroke");
      var e = "fill";

      if (o > -1 && a > -1 && a < o) {
        e = "stroke";
      } else if (o === -1 && a > -1) {
        e = "stroke";
      }
    } else if (t === "href" || t === "xlink:href") {
      return e;
    } else {
      s = n ? e.map(w) : w(e, r);
    }

    return !n && isNaN(s) ? e : s;
  }

  function l(t) {
    return new RegExp("^(" + t.join("|") + ")\\b", "i");
  }

  function y(t) {
    for (var e in a) {
      if (typeof t[a[e]] === "undefined" || t[e] === "") {
        continue;
      }

      if (typeof t[e] === "undefined") {
        if (!C.Object.prototype[e]) {
          continue;
        }

        t[e] = C.Object.prototype[e];
      }

      if (t[e].indexOf("url(") === 0) {
        continue;
      }

      var i = new C.Color(t[e]);
      t[e] = i.setAlpha(r(i.getAlpha() * t[a[e]], 2)).toRgba();
    }

    return t;
  }

  function _(t, e) {
    var i,
        r = [],
        n,
        s,
        o;

    for (s = 0, o = e.length; s < o; s++) {
      i = e[s];
      n = t.getElementsByTagName(i);
      r = r.concat(Array.prototype.slice.call(n));
    }

    return r;
  }

  C.parseTransformAttribute = function () {
    function o(t, e) {
      var i = C.util.cos(e[0]),
          r = C.util.sin(e[0]),
          n = 0,
          s = 0;

      if (e.length === 3) {
        n = e[1];
        s = e[2];
      }

      t[0] = i;
      t[1] = r;
      t[2] = -r;
      t[3] = i;
      t[4] = n - (i * n - r * s);
      t[5] = s - (r * n + i * s);
    }

    function a(t, e) {
      var i = e[0],
          r = e.length === 2 ? e[1] : e[0];
      t[0] = i;
      t[3] = r;
    }

    function c(t, e, i) {
      t[i] = Math.tan(C.util.degreesToRadians(e[0]));
    }

    function l(t, e) {
      t[4] = e[0];

      if (e.length === 2) {
        t[5] = e[1];
      }
    }

    var h = C.iMatrix,
        t = C.reNum,
        e = "(?:\\s+,?\\s*|,\\s*)",
        i = "(?:(skewX)\\s*\\(\\s*(" + t + ")\\s*\\))",
        r = "(?:(skewY)\\s*\\(\\s*(" + t + ")\\s*\\))",
        n = "(?:(rotate)\\s*\\(\\s*(" + t + ")(?:" + e + "(" + t + ")" + e + "(" + t + "))?\\s*\\))",
        s = "(?:(scale)\\s*\\(\\s*(" + t + ")(?:" + e + "(" + t + "))?\\s*\\))",
        f = "(?:(translate)\\s*\\(\\s*(" + t + ")(?:" + e + "(" + t + "))?\\s*\\))",
        u = "(?:(matrix)\\s*\\(\\s*" + "(" + t + ")" + e + "(" + t + ")" + e + "(" + t + ")" + e + "(" + t + ")" + e + "(" + t + ")" + e + "(" + t + ")" + "\\s*\\))",
        d = "(?:" + u + "|" + f + "|" + s + "|" + n + "|" + i + "|" + r + ")",
        g = "(?:" + d + "(?:" + e + "*" + d + ")*" + ")",
        p = "^\\s*(?:" + g + "?)\\s*$",
        v = new RegExp(p),
        m = new RegExp(d, "g");
    return function (t) {
      var n = h.concat(),
          s = [];

      if (!t || t && !v.test(t)) {
        return n;
      }

      t.replace(m, function (t) {
        var e = new RegExp(d).exec(t).filter(function (t) {
          return !!t;
        }),
            i = e[1],
            r = e.slice(2).map(parseFloat);

        switch (i) {
          case "translate":
            l(n, r);
            break;

          case "rotate":
            r[0] = C.util.degreesToRadians(r[0]);
            o(n, r);
            break;

          case "scale":
            a(n, r);
            break;

          case "skewX":
            c(n, r, 2);
            break;

          case "skewY":
            c(n, r, 1);
            break;

          case "matrix":
            n = r;
            break;
        }

        s.push(n.concat());
        n = h.concat();
      });
      var e = s[0];

      while (s.length > 1) {
        s.shift();
        e = C.util.multiplyTransformMatrices(e, s[0]);
      }

      return e;
    };
  }();

  function h(t, i) {
    var r, n;
    t.replace(/;\s*$/, "").split(";").forEach(function (t) {
      var e = t.split(":");
      r = e[0].trim().toLowerCase();
      n = e[1].trim();
      i[r] = n;
    });
  }

  function f(t, e) {
    var i, r;

    for (var n in t) {
      if (typeof t[n] === "undefined") {
        continue;
      }

      i = n.toLowerCase();
      r = t[n];
      e[i] = r;
    }
  }

  function x(t, e) {
    var i = {};

    for (var r in C.cssRules[e]) {
      if (d(t, r.split(" "))) {
        for (var n in C.cssRules[e][r]) {
          i[n] = C.cssRules[e][r][n];
        }
      }
    }

    return i;
  }

  function d(t, e) {
    var i,
        r = true;
    i = T(t, e.pop());

    if (i && e.length) {
      r = S(t, e);
    }

    return i && r && e.length === 0;
  }

  function S(t, e) {
    var i,
        r = true;

    while (t.parentNode && t.parentNode.nodeType === 1 && e.length) {
      if (r) {
        i = e.pop();
      }

      t = t.parentNode;
      r = T(t, i);
    }

    return e.length === 0;
  }

  function T(t, e) {
    var i = t.nodeName,
        r = t.getAttribute("class"),
        n = t.getAttribute("id"),
        s,
        o;
    s = new RegExp("^" + i, "i");
    e = e.replace(s, "");

    if (n && e.length) {
      s = new RegExp("#" + n + "(?![a-zA-Z\\-]+)", "i");
      e = e.replace(s, "");
    }

    if (r && e.length) {
      r = r.split(" ");

      for (o = r.length; o--;) {
        s = new RegExp("\\." + r[o] + "(?![a-zA-Z\\-]+)", "i");
        e = e.replace(s, "");
      }
    }

    return e.length === 0;
  }

  function O(t, e) {
    var i;
    t.getElementById && (i = t.getElementById(e));

    if (i) {
      return i;
    }

    var r,
        n,
        s,
        o = t.getElementsByTagName("*");

    for (n = 0, s = o.length; n < s; n++) {
      r = o[n];

      if (e === r.getAttribute("id")) {
        return r;
      }
    }
  }

  function j(t) {
    var e = _(t, ["use", "svg:use"]),
        i = 0;

    while (e.length && i < e.length) {
      var r = e[i],
          n = (r.getAttribute("xlink:href") || r.getAttribute("href")).substr(1),
          s = r.getAttribute("x") || 0,
          o = r.getAttribute("y") || 0,
          a = O(t, n).cloneNode(true),
          c = (a.getAttribute("transform") || "") + " translate(" + s + ", " + o + ")",
          l,
          h = e.length,
          f,
          u,
          d,
          g,
          p = C.svgNS;
      P(a);

      if (/^svg$/i.test(a.nodeName)) {
        var v = a.ownerDocument.createElementNS(p, "g");

        for (u = 0, d = a.attributes, g = d.length; u < g; u++) {
          f = d.item(u);
          v.setAttributeNS(p, f.nodeName, f.nodeValue);
        }

        while (a.firstChild) {
          v.appendChild(a.firstChild);
        }

        a = v;
      }

      for (u = 0, d = r.attributes, g = d.length; u < g; u++) {
        f = d.item(u);

        if (f.nodeName === "x" || f.nodeName === "y" || f.nodeName === "xlink:href" || f.nodeName === "href") {
          continue;
        }

        if (f.nodeName === "transform") {
          c = f.nodeValue + " " + c;
        } else {
          a.setAttribute(f.nodeName, f.nodeValue);
        }
      }

      a.setAttribute("transform", c);
      a.setAttribute("instantiated_by_use", "1");
      a.removeAttribute("id");
      l = r.parentNode;
      l.replaceChild(a, r);

      if (e.length === h) {
        i++;
      }
    }
  }

  var k = new RegExp("^" + "\\s*(" + C.reNum + "+)\\s*,?" + "\\s*(" + C.reNum + "+)\\s*,?" + "\\s*(" + C.reNum + "+)\\s*,?" + "\\s*(" + C.reNum + "+)\\s*" + "$");

  function P(t) {
    var e = t.getAttribute("viewBox"),
        i = 1,
        r = 1,
        n = 0,
        s = 0,
        o,
        a,
        c,
        l,
        h = t.getAttribute("width"),
        f = t.getAttribute("height"),
        u = t.getAttribute("x") || 0,
        d = t.getAttribute("y") || 0,
        g = t.getAttribute("preserveAspectRatio") || "",
        p = !e || !C.svgViewBoxElementsRegEx.test(t.nodeName) || !(e = e.match(k)),
        v = !h || !f || h === "100%" || f === "100%",
        m = p && v,
        b = {},
        y = "",
        _ = 0,
        x = 0;
    b.width = 0;
    b.height = 0;
    b.toBeParsed = m;

    if (m) {
      return b;
    }

    if (p) {
      b.width = w(h);
      b.height = w(f);
      return b;
    }

    n = -parseFloat(e[1]);
    s = -parseFloat(e[2]);
    o = parseFloat(e[3]);
    a = parseFloat(e[4]);
    b.minX = n;
    b.minY = s;
    b.viewBoxWidth = o;
    b.viewBoxHeight = a;

    if (!v) {
      b.width = w(h);
      b.height = w(f);
      i = b.width / o;
      r = b.height / a;
    } else {
      b.width = o;
      b.height = a;
    }

    g = C.util.parsePreserveAspectRatioAttribute(g);

    if (g.alignX !== "none") {
      if (g.meetOrSlice === "meet") {
        r = i = i > r ? r : i;
      }

      if (g.meetOrSlice === "slice") {
        r = i = i > r ? i : r;
      }

      _ = b.width - o * i;
      x = b.height - a * i;

      if (g.alignX === "Mid") {
        _ /= 2;
      }

      if (g.alignY === "Mid") {
        x /= 2;
      }

      if (g.alignX === "Min") {
        _ = 0;
      }

      if (g.alignY === "Min") {
        x = 0;
      }
    }

    if (i === 1 && r === 1 && n === 0 && s === 0 && u === 0 && d === 0) {
      return b;
    }

    if (u || d) {
      y = " translate(" + w(u) + " " + w(d) + ") ";
    }

    c = y + " matrix(" + i + " 0" + " 0 " + r + " " + (n * i + _) + " " + (s * r + x) + ") ";
    b.viewboxTransform = C.parseTransformAttribute(c);

    if (t.nodeName === "svg") {
      l = t.ownerDocument.createElementNS(C.svgNS, "g");

      while (t.firstChild) {
        l.appendChild(t.firstChild);
      }

      t.appendChild(l);
    } else {
      l = t;
      c = l.getAttribute("transform") + c;
    }

    l.setAttribute("transform", c);
    return b;
  }

  function D(t, e) {
    while (t && (t = t.parentNode)) {
      if (t.nodeName && e.test(t.nodeName.replace("svg:", "")) && !t.getAttribute("instantiated_by_use")) {
        return true;
      }
    }

    return false;
  }

  C.parseSVGDocument = function (t, i, e, r) {
    if (!t) {
      return;
    }

    j(t);
    var n = C.Object.__uid++,
        s,
        o,
        a = P(t),
        c = C.util.toArray(t.getElementsByTagName("*"));
    a.crossOrigin = r && r.crossOrigin;
    a.svgUid = n;

    if (c.length === 0 && C.isLikelyNode) {
      c = t.selectNodes('//*[name(.)!="svg"]');
      var l = [];

      for (s = 0, o = c.length; s < o; s++) {
        l[s] = c[s];
      }

      c = l;
    }

    var h = c.filter(function (t) {
      P(t);
      return C.svgValidTagNamesRegEx.test(t.nodeName.replace("svg:", "")) && !D(t, C.svgInvalidAncestorsRegEx);
    });

    if (!h || h && !h.length) {
      i && i([], {});
      return;
    }

    var f = {};
    c.filter(function (t) {
      return t.nodeName.replace("svg:", "") === "clipPath";
    }).forEach(function (t) {
      var e = t.getAttribute("id");
      f[e] = C.util.toArray(t.getElementsByTagName("*")).filter(function (t) {
        return C.svgValidTagNamesRegEx.test(t.nodeName.replace("svg:", ""));
      });
    });
    C.gradientDefs[n] = C.getGradientDefs(t);
    C.cssRules[n] = C.getCSSRules(t);
    C.clipPaths[n] = f;
    C.parseElements(h, function (t, e) {
      if (i) {
        i(t, a, e, c);
        delete C.gradientDefs[n];
        delete C.cssRules[n];
        delete C.clipPaths[n];
      }
    }, u(a), e, r);
  };

  function E(t, e) {
    var i = ["gradientTransform", "x1", "x2", "y1", "y2", "gradientUnits", "cx", "cy", "r", "fx", "fy"],
        r = "xlink:href",
        n = e.getAttribute(r).substr(1),
        s = O(t, n);

    if (s && s.getAttribute(r)) {
      E(t, s);
    }

    i.forEach(function (t) {
      if (s && !e.hasAttribute(t) && s.hasAttribute(t)) {
        e.setAttribute(t, s.getAttribute(t));
      }
    });

    if (!e.children.length) {
      var o = s.cloneNode(true);

      while (o.firstChild) {
        e.appendChild(o.firstChild);
      }
    }

    e.removeAttribute(r);
  }

  var M = new RegExp("(normal|italic)?\\s*(normal|small-caps)?\\s*" + "(normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900)?\\s*(" + C.reNum + "(?:px|cm|mm|em|pt|pc|in)*)(?:\\/(normal|" + C.reNum + "))?\\s+(.*)");
  g(C, {
    parseFontDeclaration: function parseFontDeclaration(t, e) {
      var i = t.match(M);

      if (!i) {
        return;
      }

      var r = i[1],
          n = i[3],
          s = i[4],
          o = i[5],
          a = i[6];

      if (r) {
        e.fontStyle = r;
      }

      if (n) {
        e.fontWeight = isNaN(parseFloat(n)) ? n : parseFloat(n);
      }

      if (s) {
        e.fontSize = w(s);
      }

      if (a) {
        e.fontFamily = a;
      }

      if (o) {
        e.lineHeight = o === "normal" ? 1 : o;
      }
    },
    getGradientDefs: function getGradientDefs(t) {
      var e = ["linearGradient", "radialGradient", "svg:linearGradient", "svg:radialGradient"],
          i = _(t, e),
          r,
          n = 0,
          s = {};

      n = i.length;

      while (n--) {
        r = i[n];

        if (r.getAttribute("xlink:href")) {
          E(t, r);
        }

        s[r.getAttribute("id")] = r;
      }

      return s;
    },
    parseAttributes: function parseAttributes(i, t, e) {
      if (!i) {
        return;
      }

      var r,
          n = {},
          s,
          o;

      if (typeof e === "undefined") {
        e = i.getAttribute("svgUid");
      }

      if (i.parentNode && C.svgValidParentsRegEx.test(i.parentNode.nodeName)) {
        n = C.parseAttributes(i.parentNode, t, e);
      }

      var a = t.reduce(function (t, e) {
        r = i.getAttribute(e);

        if (r) {
          t[e] = r;
        }

        return t;
      }, {});
      var c = g(x(i, e), C.parseStyleAttribute(i));
      a = g(a, c);

      if (c[v]) {
        i.setAttribute(v, c[v]);
      }

      s = o = n.fontSize || C.Text.DEFAULT_SVG_FONT_SIZE;

      if (a[p]) {
        a[p] = s = w(a[p], o);
      }

      var l,
          h,
          f = {};

      for (var u in a) {
        l = m(u);
        h = b(l, a[u], n, s);
        f[l] = h;
      }

      if (f && f.font) {
        C.parseFontDeclaration(f.font, f);
      }

      var d = g(n, f);
      return C.svgValidParentsRegEx.test(i.nodeName) ? d : y(d);
    },
    parseElements: function parseElements(t, e, i, r, n) {
      new C.ElementsParser(t, e, i, r, n).parse();
    },
    parseStyleAttribute: function parseStyleAttribute(t) {
      var e = {},
          i = t.getAttribute("style");

      if (!i) {
        return e;
      }

      if (typeof i === "string") {
        h(i, e);
      } else {
        f(i, e);
      }

      return e;
    },
    parsePointsAttribute: function parsePointsAttribute(t) {
      if (!t) {
        return null;
      }

      t = t.replace(/,/g, " ").trim();
      t = t.split(/\s+/);
      var e = [],
          i,
          r;

      for (i = 0, r = t.length; i < r; i += 2) {
        e.push({
          x: parseFloat(t[i]),
          y: parseFloat(t[i + 1])
        });
      }

      return e;
    },
    getCSSRules: function getCSSRules(t) {
      var e = t.getElementsByTagName("style"),
          c,
          l,
          h = {},
          i;

      for (c = 0, l = e.length; c < l; c++) {
        var r = e[c].textContent || "";
        r = r.replace(/\/\*[\s\S]*?\*\//g, "");

        if (r.trim() === "") {
          continue;
        }

        i = r.match(/[^{]*\{[\s\S]*?\}/g);
        i = i.map(function (t) {
          return t.trim();
        });
        i.forEach(function (t) {
          var e = t.match(/([\s\S]*?)\s*\{([^}]*)\}/),
              i = {},
              r = e[2].trim(),
              n = r.replace(/;$/, "").split(/\s*;\s*/);

          for (c = 0, l = n.length; c < l; c++) {
            var s = n[c].split(/\s*:\s*/),
                o = s[0],
                a = s[1];
            i[o] = a;
          }

          t = e[1];
          t.split(",").forEach(function (t) {
            t = t.replace(/^svg/i, "").trim();

            if (t === "") {
              return;
            }

            if (h[t]) {
              C.util.object.extend(h[t], i);
            } else {
              h[t] = C.util.object.clone(i);
            }
          });
        });
      }

      return h;
    },
    loadSVGFromURL: function loadSVGFromURL(t, n, i, r) {
      t = t.replace(/^\n\s*/, "").trim();
      new C.util.request(t, {
        method: "get",
        onComplete: e
      });

      function e(t) {
        var e = t.responseXML;

        if (e && !e.documentElement && C.window.ActiveXObject && t.responseText) {
          e = new ActiveXObject("Microsoft.XMLDOM");
          e.async = "false";
          e.loadXML(t.responseText.replace(/<!DOCTYPE[\s\S]*?(\[[\s\S]*\])*?>/i, ""));
        }

        if (!e || !e.documentElement) {
          n && n(null);
          return false;
        }

        C.parseSVGDocument(e.documentElement, function (t, e, i, r) {
          n && n(t, e, i, r);
        }, i, r);
      }
    },
    loadSVGFromString: function loadSVGFromString(t, n, e, i) {
      t = t.trim();
      var r;

      if (typeof C.window.DOMParser !== "undefined") {
        var s = new C.window.DOMParser();

        if (s && s.parseFromString) {
          r = s.parseFromString(t, "text/xml");
        }
      } else if (C.window.ActiveXObject) {
        r = new ActiveXObject("Microsoft.XMLDOM");
        r.async = "false";
        r.loadXML(t.replace(/<!DOCTYPE[\s\S]*?(\[[\s\S]*\])*?>/i, ""));
      }

      C.parseSVGDocument(r.documentElement, function (t, e, i, r) {
        n(t, e, i, r);
      }, e, i);
    }
  });
})(typeof exports !== "undefined" ? exports : void 0);

fabric.ElementsParser = function (t, e, i, r, n, s) {
  this.elements = t;
  this.callback = e;
  this.options = i;
  this.reviver = r;
  this.svgUid = i && i.svgUid || 0;
  this.parsingOptions = n;
  this.regexUrl = /^url\(['"]?#([^'"]+)['"]?\)/g;
  this.doc = s;
};

(function (t) {
  t.parse = function () {
    this.instances = new Array(this.elements.length);
    this.numElements = this.elements.length;
    this.createObjects();
  };

  t.createObjects = function () {
    var i = this;
    this.elements.forEach(function (t, e) {
      t.setAttribute("svgUid", i.svgUid);
      i.createObject(t, e);
    });
  };

  t.findTag = function (t) {
    return fabric[fabric.util.string.capitalize(t.tagName.replace("svg:", ""))];
  };

  t.createObject = function (t, e) {
    var i = this.findTag(t);

    if (i && i.fromElement) {
      try {
        i.fromElement(t, this.createCallback(e, t), this.options);
      } catch (t) {
        fabric.log(t);
      }
    } else {
      this.checkIfDone();
    }
  };

  t.createCallback = function (i, r) {
    var n = this;
    return function (t) {
      var e;
      n.resolveGradient(t, r, "fill");
      n.resolveGradient(t, r, "stroke");

      if (t instanceof fabric.Image && t._originalElement) {
        e = t.parsePreserveAspectRatioAttribute(r);
      }

      t._removeTransformMatrix(e);

      n.resolveClipPath(t, r);
      n.reviver && n.reviver(r, t);
      n.instances[i] = t;
      n.checkIfDone();
    };
  };

  t.extractPropertyDefinition = function (t, e, i) {
    var r = t[e],
        n = this.regexUrl;

    if (!n.test(r)) {
      return;
    }

    n.lastIndex = 0;
    var s = n.exec(r)[1];
    n.lastIndex = 0;
    return fabric[i][this.svgUid][s];
  };

  t.resolveGradient = function (t, e, i) {
    var r = this.extractPropertyDefinition(t, i, "gradientDefs");

    if (r) {
      var n = e.getAttribute(i + "-opacity");
      var s = fabric.Gradient.fromElement(r, t, n, this.options);
      t.set(i, s);
    }
  };

  t.createClipPathCallback = function (t, e) {
    return function (t) {
      t._removeTransformMatrix();

      t.fillRule = t.clipRule;
      e.push(t);
    };
  };

  t.resolveClipPath = function (t, e) {
    var i = this.extractPropertyDefinition(t, "clipPath", "clipPaths"),
        r,
        n,
        s,
        o,
        a,
        c;

    if (i) {
      o = [];
      s = fabric.util.invertTransform(t.calcTransformMatrix());
      var l = i[0].parentNode;
      var h = e;

      while (h.parentNode && h.getAttribute("clip-path") !== t.clipPath) {
        h = h.parentNode;
      }

      h.parentNode.appendChild(l);

      for (var f = 0; f < i.length; f++) {
        r = i[f];
        n = this.findTag(r);
        n.fromElement(r, this.createClipPathCallback(t, o), this.options);
      }

      if (o.length === 1) {
        i = o[0];
      } else {
        i = new fabric.Group(o);
      }

      a = fabric.util.multiplyTransformMatrices(s, i.calcTransformMatrix());

      if (i.clipPath) {
        this.resolveClipPath(i, h);
      }

      var c = fabric.util.qrDecompose(a);
      i.flipX = false;
      i.flipY = false;
      i.set("scaleX", c.scaleX);
      i.set("scaleY", c.scaleY);
      i.angle = c.angle;
      i.skewX = c.skewX;
      i.skewY = 0;
      i.setPositionByOrigin({
        x: c.translateX,
        y: c.translateY
      }, "center", "center");
      t.clipPath = i;
    } else {
      delete t.clipPath;
    }
  };

  t.checkIfDone = function () {
    if (--this.numElements === 0) {
      this.instances = this.instances.filter(function (t) {
        return t != null;
      });
      this.callback(this.instances, this.elements);
    }
  };
})(fabric.ElementsParser.prototype);

(function (t) {
  "use strict";

  var e = t.fabric || (t.fabric = {});

  if (e.Point) {
    e.warn("fabric.Point is already defined");
    return;
  }

  e.Point = i;

  function i(t, e) {
    this.x = t;
    this.y = e;
  }

  i.prototype = {
    type: "point",
    constructor: i,
    add: function add(t) {
      return new i(this.x + t.x, this.y + t.y);
    },
    addEquals: function addEquals(t) {
      this.x += t.x;
      this.y += t.y;
      return this;
    },
    scalarAdd: function scalarAdd(t) {
      return new i(this.x + t, this.y + t);
    },
    scalarAddEquals: function scalarAddEquals(t) {
      this.x += t;
      this.y += t;
      return this;
    },
    subtract: function subtract(t) {
      return new i(this.x - t.x, this.y - t.y);
    },
    subtractEquals: function subtractEquals(t) {
      this.x -= t.x;
      this.y -= t.y;
      return this;
    },
    scalarSubtract: function scalarSubtract(t) {
      return new i(this.x - t, this.y - t);
    },
    scalarSubtractEquals: function scalarSubtractEquals(t) {
      this.x -= t;
      this.y -= t;
      return this;
    },
    multiply: function multiply(t) {
      return new i(this.x * t, this.y * t);
    },
    multiplyEquals: function multiplyEquals(t) {
      this.x *= t;
      this.y *= t;
      return this;
    },
    divide: function divide(t) {
      return new i(this.x / t, this.y / t);
    },
    divideEquals: function divideEquals(t) {
      this.x /= t;
      this.y /= t;
      return this;
    },
    eq: function eq(t) {
      return this.x === t.x && this.y === t.y;
    },
    lt: function lt(t) {
      return this.x < t.x && this.y < t.y;
    },
    lte: function lte(t) {
      return this.x <= t.x && this.y <= t.y;
    },
    gt: function gt(t) {
      return this.x > t.x && this.y > t.y;
    },
    gte: function gte(t) {
      return this.x >= t.x && this.y >= t.y;
    },
    lerp: function lerp(t, e) {
      if (typeof e === "undefined") {
        e = .5;
      }

      e = Math.max(Math.min(1, e), 0);
      return new i(this.x + (t.x - this.x) * e, this.y + (t.y - this.y) * e);
    },
    distanceFrom: function distanceFrom(t) {
      var e = this.x - t.x,
          i = this.y - t.y;
      return Math.sqrt(e * e + i * i);
    },
    midPointFrom: function midPointFrom(t) {
      return this.lerp(t);
    },
    min: function min(t) {
      return new i(Math.min(this.x, t.x), Math.min(this.y, t.y));
    },
    max: function max(t) {
      return new i(Math.max(this.x, t.x), Math.max(this.y, t.y));
    },
    toString: function toString() {
      return this.x + "," + this.y;
    },
    setXY: function setXY(t, e) {
      this.x = t;
      this.y = e;
      return this;
    },
    setX: function setX(t) {
      this.x = t;
      return this;
    },
    setY: function setY(t) {
      this.y = t;
      return this;
    },
    setFromPoint: function setFromPoint(t) {
      this.x = t.x;
      this.y = t.y;
      return this;
    },
    swap: function swap(t) {
      var e = this.x,
          i = this.y;
      this.x = t.x;
      this.y = t.y;
      t.x = e;
      t.y = i;
    },
    clone: function clone() {
      return new i(this.x, this.y);
    }
  };
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var u = t.fabric || (t.fabric = {});

  if (u.Intersection) {
    u.warn("fabric.Intersection is already defined");
    return;
  }

  function d(t) {
    this.status = t;
    this.points = [];
  }

  u.Intersection = d;
  u.Intersection.prototype = {
    constructor: d,
    appendPoint: function appendPoint(t) {
      this.points.push(t);
      return this;
    },
    appendPoints: function appendPoints(t) {
      this.points = this.points.concat(t);
      return this;
    }
  };

  u.Intersection.intersectLineLine = function (t, e, i, r) {
    var n,
        s = (r.x - i.x) * (t.y - i.y) - (r.y - i.y) * (t.x - i.x),
        o = (e.x - t.x) * (t.y - i.y) - (e.y - t.y) * (t.x - i.x),
        a = (r.y - i.y) * (e.x - t.x) - (r.x - i.x) * (e.y - t.y);

    if (a !== 0) {
      var c = s / a,
          l = o / a;

      if (0 <= c && c <= 1 && 0 <= l && l <= 1) {
        n = new d("Intersection");
        n.appendPoint(new u.Point(t.x + c * (e.x - t.x), t.y + c * (e.y - t.y)));
      } else {
        n = new d();
      }
    } else {
      if (s === 0 || o === 0) {
        n = new d("Coincident");
      } else {
        n = new d("Parallel");
      }
    }

    return n;
  };

  u.Intersection.intersectLinePolygon = function (t, e, i) {
    var r = new d(),
        n = i.length,
        s,
        o,
        a,
        c;

    for (c = 0; c < n; c++) {
      s = i[c];
      o = i[(c + 1) % n];
      a = d.intersectLineLine(t, e, s, o);
      r.appendPoints(a.points);
    }

    if (r.points.length > 0) {
      r.status = "Intersection";
    }

    return r;
  };

  u.Intersection.intersectPolygonPolygon = function (t, e) {
    var i = new d(),
        r = t.length,
        n;

    for (n = 0; n < r; n++) {
      var s = t[n],
          o = t[(n + 1) % r],
          a = d.intersectLinePolygon(s, o, e);
      i.appendPoints(a.points);
    }

    if (i.points.length > 0) {
      i.status = "Intersection";
    }

    return i;
  };

  u.Intersection.intersectPolygonRectangle = function (t, e, i) {
    var r = e.min(i),
        n = e.max(i),
        s = new u.Point(n.x, r.y),
        o = new u.Point(r.x, n.y),
        a = d.intersectLinePolygon(r, s, t),
        c = d.intersectLinePolygon(s, n, t),
        l = d.intersectLinePolygon(n, o, t),
        h = d.intersectLinePolygon(o, r, t),
        f = new d();
    f.appendPoints(a.points);
    f.appendPoints(c.points);
    f.appendPoints(l.points);
    f.appendPoints(h.points);

    if (f.points.length > 0) {
      f.status = "Intersection";
    }

    return f;
  };
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var l = t.fabric || (t.fabric = {});

  if (l.Color) {
    l.warn("fabric.Color is already defined.");
    return;
  }

  function h(t) {
    if (!t) {
      this.setSource([0, 0, 0, 1]);
    } else {
      this._tryParsingColor(t);
    }
  }

  l.Color = h;
  l.Color.prototype = {
    _tryParsingColor: function _tryParsingColor(t) {
      var e;

      if (t in h.colorNameMap) {
        t = h.colorNameMap[t];
      }

      if (t === "transparent") {
        e = [255, 255, 255, 0];
      }

      if (!e) {
        e = h.sourceFromHex(t);
      }

      if (!e) {
        e = h.sourceFromRgb(t);
      }

      if (!e) {
        e = h.sourceFromHsl(t);
      }

      if (!e) {
        e = [0, 0, 0, 1];
      }

      if (e) {
        this.setSource(e);
      }
    },
    _rgbToHsl: function _rgbToHsl(t, e, i) {
      t /= 255;
      e /= 255;
      i /= 255;
      var r,
          n,
          s,
          o = l.util.array.max([t, e, i]),
          a = l.util.array.min([t, e, i]);
      s = (o + a) / 2;

      if (o === a) {
        r = n = 0;
      } else {
        var c = o - a;
        n = s > .5 ? c / (2 - o - a) : c / (o + a);

        switch (o) {
          case t:
            r = (e - i) / c + (e < i ? 6 : 0);
            break;

          case e:
            r = (i - t) / c + 2;
            break;

          case i:
            r = (t - e) / c + 4;
            break;
        }

        r /= 6;
      }

      return [Math.round(r * 360), Math.round(n * 100), Math.round(s * 100)];
    },
    getSource: function getSource() {
      return this._source;
    },
    setSource: function setSource(t) {
      this._source = t;
    },
    toRgb: function toRgb() {
      var t = this.getSource();
      return "rgb(" + t[0] + "," + t[1] + "," + t[2] + ")";
    },
    toRgba: function toRgba() {
      var t = this.getSource();
      return "rgba(" + t[0] + "," + t[1] + "," + t[2] + "," + t[3] + ")";
    },
    toHsl: function toHsl() {
      var t = this.getSource(),
          e = this._rgbToHsl(t[0], t[1], t[2]);

      return "hsl(" + e[0] + "," + e[1] + "%," + e[2] + "%)";
    },
    toHsla: function toHsla() {
      var t = this.getSource(),
          e = this._rgbToHsl(t[0], t[1], t[2]);

      return "hsla(" + e[0] + "," + e[1] + "%," + e[2] + "%," + t[3] + ")";
    },
    toHex: function toHex() {
      var t = this.getSource(),
          e,
          i,
          r;
      e = t[0].toString(16);
      e = e.length === 1 ? "0" + e : e;
      i = t[1].toString(16);
      i = i.length === 1 ? "0" + i : i;
      r = t[2].toString(16);
      r = r.length === 1 ? "0" + r : r;
      return e.toUpperCase() + i.toUpperCase() + r.toUpperCase();
    },
    toHexa: function toHexa() {
      var t = this.getSource(),
          e;
      e = Math.round(t[3] * 255);
      e = e.toString(16);
      e = e.length === 1 ? "0" + e : e;
      return this.toHex() + e.toUpperCase();
    },
    getAlpha: function getAlpha() {
      return this.getSource()[3];
    },
    setAlpha: function setAlpha(t) {
      var e = this.getSource();
      e[3] = t;
      this.setSource(e);
      return this;
    },
    toGrayscale: function toGrayscale() {
      var t = this.getSource(),
          e = parseInt((t[0] * .3 + t[1] * .59 + t[2] * .11).toFixed(0), 10),
          i = t[3];
      this.setSource([e, e, e, i]);
      return this;
    },
    toBlackWhite: function toBlackWhite(t) {
      var e = this.getSource(),
          i = (e[0] * .3 + e[1] * .59 + e[2] * .11).toFixed(0),
          r = e[3];
      t = t || 127;
      i = Number(i) < Number(t) ? 0 : 255;
      this.setSource([i, i, i, r]);
      return this;
    },
    overlayWith: function overlayWith(t) {
      if (!(t instanceof h)) {
        t = new h(t);
      }

      var e = [],
          i = this.getAlpha(),
          r = .5,
          n = this.getSource(),
          s = t.getSource(),
          o;

      for (o = 0; o < 3; o++) {
        e.push(Math.round(n[o] * (1 - r) + s[o] * r));
      }

      e[3] = i;
      this.setSource(e);
      return this;
    }
  };
  l.Color.reRGBa = /^rgba?\(\s*(\d{1,3}(?:\.\d+)?\%?)\s*,\s*(\d{1,3}(?:\.\d+)?\%?)\s*,\s*(\d{1,3}(?:\.\d+)?\%?)\s*(?:\s*,\s*((?:\d*\.?\d+)?)\s*)?\)$/i;
  l.Color.reHSLa = /^hsla?\(\s*(\d{1,3})\s*,\s*(\d{1,3}\%)\s*,\s*(\d{1,3}\%)\s*(?:\s*,\s*(\d+(?:\.\d+)?)\s*)?\)$/i;
  l.Color.reHex = /^#?([0-9a-f]{8}|[0-9a-f]{6}|[0-9a-f]{4}|[0-9a-f]{3})$/i;
  l.Color.colorNameMap = {
    aliceblue: "#F0F8FF",
    antiquewhite: "#FAEBD7",
    aqua: "#00FFFF",
    aquamarine: "#7FFFD4",
    azure: "#F0FFFF",
    beige: "#F5F5DC",
    bisque: "#FFE4C4",
    black: "#000000",
    blanchedalmond: "#FFEBCD",
    blue: "#0000FF",
    blueviolet: "#8A2BE2",
    brown: "#A52A2A",
    burlywood: "#DEB887",
    cadetblue: "#5F9EA0",
    chartreuse: "#7FFF00",
    chocolate: "#D2691E",
    coral: "#FF7F50",
    cornflowerblue: "#6495ED",
    cornsilk: "#FFF8DC",
    crimson: "#DC143C",
    cyan: "#00FFFF",
    darkblue: "#00008B",
    darkcyan: "#008B8B",
    darkgoldenrod: "#B8860B",
    darkgray: "#A9A9A9",
    darkgrey: "#A9A9A9",
    darkgreen: "#006400",
    darkkhaki: "#BDB76B",
    darkmagenta: "#8B008B",
    darkolivegreen: "#556B2F",
    darkorange: "#FF8C00",
    darkorchid: "#9932CC",
    darkred: "#8B0000",
    darksalmon: "#E9967A",
    darkseagreen: "#8FBC8F",
    darkslateblue: "#483D8B",
    darkslategray: "#2F4F4F",
    darkslategrey: "#2F4F4F",
    darkturquoise: "#00CED1",
    darkviolet: "#9400D3",
    deeppink: "#FF1493",
    deepskyblue: "#00BFFF",
    dimgray: "#696969",
    dimgrey: "#696969",
    dodgerblue: "#1E90FF",
    firebrick: "#B22222",
    floralwhite: "#FFFAF0",
    forestgreen: "#228B22",
    fuchsia: "#FF00FF",
    gainsboro: "#DCDCDC",
    ghostwhite: "#F8F8FF",
    gold: "#FFD700",
    goldenrod: "#DAA520",
    gray: "#808080",
    grey: "#808080",
    green: "#008000",
    greenyellow: "#ADFF2F",
    honeydew: "#F0FFF0",
    hotpink: "#FF69B4",
    indianred: "#CD5C5C",
    indigo: "#4B0082",
    ivory: "#FFFFF0",
    khaki: "#F0E68C",
    lavender: "#E6E6FA",
    lavenderblush: "#FFF0F5",
    lawngreen: "#7CFC00",
    lemonchiffon: "#FFFACD",
    lightblue: "#ADD8E6",
    lightcoral: "#F08080",
    lightcyan: "#E0FFFF",
    lightgoldenrodyellow: "#FAFAD2",
    lightgray: "#D3D3D3",
    lightgrey: "#D3D3D3",
    lightgreen: "#90EE90",
    lightpink: "#FFB6C1",
    lightsalmon: "#FFA07A",
    lightseagreen: "#20B2AA",
    lightskyblue: "#87CEFA",
    lightslategray: "#778899",
    lightslategrey: "#778899",
    lightsteelblue: "#B0C4DE",
    lightyellow: "#FFFFE0",
    lime: "#00FF00",
    limegreen: "#32CD32",
    linen: "#FAF0E6",
    magenta: "#FF00FF",
    maroon: "#800000",
    mediumaquamarine: "#66CDAA",
    mediumblue: "#0000CD",
    mediumorchid: "#BA55D3",
    mediumpurple: "#9370DB",
    mediumseagreen: "#3CB371",
    mediumslateblue: "#7B68EE",
    mediumspringgreen: "#00FA9A",
    mediumturquoise: "#48D1CC",
    mediumvioletred: "#C71585",
    midnightblue: "#191970",
    mintcream: "#F5FFFA",
    mistyrose: "#FFE4E1",
    moccasin: "#FFE4B5",
    navajowhite: "#FFDEAD",
    navy: "#000080",
    oldlace: "#FDF5E6",
    olive: "#808000",
    olivedrab: "#6B8E23",
    orange: "#FFA500",
    orangered: "#FF4500",
    orchid: "#DA70D6",
    palegoldenrod: "#EEE8AA",
    palegreen: "#98FB98",
    paleturquoise: "#AFEEEE",
    palevioletred: "#DB7093",
    papayawhip: "#FFEFD5",
    peachpuff: "#FFDAB9",
    peru: "#CD853F",
    pink: "#FFC0CB",
    plum: "#DDA0DD",
    powderblue: "#B0E0E6",
    purple: "#800080",
    rebeccapurple: "#663399",
    red: "#FF0000",
    rosybrown: "#BC8F8F",
    royalblue: "#4169E1",
    saddlebrown: "#8B4513",
    salmon: "#FA8072",
    sandybrown: "#F4A460",
    seagreen: "#2E8B57",
    seashell: "#FFF5EE",
    sienna: "#A0522D",
    silver: "#C0C0C0",
    skyblue: "#87CEEB",
    slateblue: "#6A5ACD",
    slategray: "#708090",
    slategrey: "#708090",
    snow: "#FFFAFA",
    springgreen: "#00FF7F",
    steelblue: "#4682B4",
    tan: "#D2B48C",
    teal: "#008080",
    thistle: "#D8BFD8",
    tomato: "#FF6347",
    turquoise: "#40E0D0",
    violet: "#EE82EE",
    wheat: "#F5DEB3",
    white: "#FFFFFF",
    whitesmoke: "#F5F5F5",
    yellow: "#FFFF00",
    yellowgreen: "#9ACD32"
  };

  function f(t, e, i) {
    if (i < 0) {
      i += 1;
    }

    if (i > 1) {
      i -= 1;
    }

    if (i < 1 / 6) {
      return t + (e - t) * 6 * i;
    }

    if (i < 1 / 2) {
      return e;
    }

    if (i < 2 / 3) {
      return t + (e - t) * (2 / 3 - i) * 6;
    }

    return t;
  }

  l.Color.fromRgb = function (t) {
    return h.fromSource(h.sourceFromRgb(t));
  };

  l.Color.sourceFromRgb = function (t) {
    var e = t.match(h.reRGBa);

    if (e) {
      var i = parseInt(e[1], 10) / (/%$/.test(e[1]) ? 100 : 1) * (/%$/.test(e[1]) ? 255 : 1),
          r = parseInt(e[2], 10) / (/%$/.test(e[2]) ? 100 : 1) * (/%$/.test(e[2]) ? 255 : 1),
          n = parseInt(e[3], 10) / (/%$/.test(e[3]) ? 100 : 1) * (/%$/.test(e[3]) ? 255 : 1);
      return [parseInt(i, 10), parseInt(r, 10), parseInt(n, 10), e[4] ? parseFloat(e[4]) : 1];
    }
  };

  l.Color.fromRgba = h.fromRgb;

  l.Color.fromHsl = function (t) {
    return h.fromSource(h.sourceFromHsl(t));
  };

  l.Color.sourceFromHsl = function (t) {
    var e = t.match(h.reHSLa);

    if (!e) {
      return;
    }

    var i = (parseFloat(e[1]) % 360 + 360) % 360 / 360,
        r = parseFloat(e[2]) / (/%$/.test(e[2]) ? 100 : 1),
        n = parseFloat(e[3]) / (/%$/.test(e[3]) ? 100 : 1),
        s,
        o,
        a;

    if (r === 0) {
      s = o = a = n;
    } else {
      var c = n <= .5 ? n * (r + 1) : n + r - n * r,
          l = n * 2 - c;
      s = f(l, c, i + 1 / 3);
      o = f(l, c, i);
      a = f(l, c, i - 1 / 3);
    }

    return [Math.round(s * 255), Math.round(o * 255), Math.round(a * 255), e[4] ? parseFloat(e[4]) : 1];
  };

  l.Color.fromHsla = h.fromHsl;

  l.Color.fromHex = function (t) {
    return h.fromSource(h.sourceFromHex(t));
  };

  l.Color.sourceFromHex = function (t) {
    if (t.match(h.reHex)) {
      var e = t.slice(t.indexOf("#") + 1),
          i = e.length === 3 || e.length === 4,
          r = e.length === 8 || e.length === 4,
          n = i ? e.charAt(0) + e.charAt(0) : e.substring(0, 2),
          s = i ? e.charAt(1) + e.charAt(1) : e.substring(2, 4),
          o = i ? e.charAt(2) + e.charAt(2) : e.substring(4, 6),
          a = r ? i ? e.charAt(3) + e.charAt(3) : e.substring(6, 8) : "FF";
      return [parseInt(n, 16), parseInt(s, 16), parseInt(o, 16), parseFloat((parseInt(a, 16) / 255).toFixed(2))];
    }
  };

  l.Color.fromSource = function (t) {
    var e = new h();
    e.setSource(t);
    return e;
  };
})(typeof exports !== "undefined" ? exports : void 0);

(function () {
  var t = fabric.util.object.clone;
  fabric.Gradient = fabric.util.createClass({
    offsetX: 0,
    offsetY: 0,
    gradientTransform: null,
    gradientUnits: "pixels",
    type: "linear",
    initialize: function initialize(e) {
      e || (e = {});
      e.coords || (e.coords = {});
      var t,
          i = this;
      Object.keys(e).forEach(function (t) {
        i[t] = e[t];
      });

      if (this.id) {
        this.id += "_" + fabric.Object.__uid++;
      } else {
        this.id = fabric.Object.__uid++;
      }

      t = {
        x1: e.coords.x1 || 0,
        y1: e.coords.y1 || 0,
        x2: e.coords.x2 || 0,
        y2: e.coords.y2 || 0
      };

      if (this.type === "radial") {
        t.r1 = e.coords.r1 || 0;
        t.r2 = e.coords.r2 || 0;
      }

      this.coords = t;
      this.colorStops = e.colorStops.slice();
    },
    addColorStop: function addColorStop(t) {
      for (var e in t) {
        var i = new fabric.Color(t[e]);
        this.colorStops.push({
          offset: parseFloat(e),
          color: i.toRgb(),
          opacity: i.getAlpha()
        });
      }

      return this;
    },
    toObject: function toObject(t) {
      var e = {
        type: this.type,
        coords: this.coords,
        colorStops: this.colorStops,
        offsetX: this.offsetX,
        offsetY: this.offsetY,
        gradientUnits: this.gradientUnits,
        gradientTransform: this.gradientTransform ? this.gradientTransform.concat() : this.gradientTransform
      };
      fabric.util.populateWithProperties(this, e, t);
      return e;
    },
    toLive: function toLive(t, e) {
      var i,
          r = fabric.util.object.clone(this.coords),
          n,
          s,
          o = r.x1,
          a = r.y1,
          c = r.x2,
          l = r.y2,
          h = this.colorStops;

      if (!this.type) {
        return;
      }

      if (e instanceof fabric.Text && this.gradientUnits === "percentage") {
        o *= e.width;
        a *= e.height;
        c *= e.width;
        l *= e.height;
      }

      if (this.type === "linear") {
        i = t.createLinearGradient(o, a, c, l);
      } else if (this.type === "radial") {
        i = t.createRadialGradient(o, a, r.r1, c, l, r.r2);
      }

      for (n = 0, s = h.length; n < s; n++) {
        var f = h[n].color,
            u = h[n].opacity,
            d = h[n].offset;

        if (typeof u !== "undefined") {
          f = new fabric.Color(f).setAlpha(u).toRgba();
        }

        i.addColorStop(d, f);
      }

      return i;
    }
  });
  fabric.util.object.extend(fabric.Gradient, {
    forObject: function forObject(t, e) {
      e || (e = {});
      i(t, e.coords, e.gradientUnits, {
        viewBoxWidth: 100,
        viewBoxHeight: 100
      });
      return new fabric.Gradient(e);
    }
  });

  function i(t, e, i, r) {
    var n, s;
    Object.keys(e).forEach(function (t) {
      n = e[t];

      if (n === "Infinity") {
        s = 1;
      } else if (n === "-Infinity") {
        s = 0;
      } else {
        s = parseFloat(e[t], 10);

        if (typeof n === "string" && /^(\d+\.\d+)%|(\d+)%$/.test(n)) {
          s *= .01;

          if (r === "pixels") {
            if (t === "x1" || t === "x2" || t === "r2") {
              s *= i.viewBoxWidth || i.width;
            }

            if (t === "y1" || t === "y2") {
              s *= i.viewBoxHeight || i.height;
            }
          }
        }
      }

      e[t] = s;
    });
  }
})();

(function () {
  "use strict";

  var n = fabric.util.toFixed;
  fabric.Pattern = fabric.util.createClass({
    repeat: "repeat",
    offsetX: 0,
    offsetY: 0,
    crossOrigin: "",
    patternTransform: null,
    initialize: function initialize(t, e) {
      t || (t = {});
      this.id = fabric.Object.__uid++;
      this.setOptions(t);

      if (!t.source || t.source && typeof t.source !== "string") {
        e && e(this);
        return;
      }

      if (typeof fabric.util.getFunctionBody(t.source) !== "undefined") {
        this.source = new Function(fabric.util.getFunctionBody(t.source));
        e && e(this);
      } else {
        var i = this;
        this.source = fabric.util.createImage();
        fabric.util.loadImage(t.source, function (t) {
          i.source = t;
          e && e(i);
        }, null, this.crossOrigin);
      }
    },
    toObject: function toObject(t) {
      var e = fabric.Object.NUM_FRACTION_DIGITS,
          i,
          r;

      if (typeof this.source === "function") {
        i = String(this.source);
      } else if (typeof this.source.src === "string") {
        i = this.source.src;
      } else if ((0, _typeof2["default"])(this.source) === "object" && this.source.toDataURL) {
        i = this.source.toDataURL();
      }

      r = {
        type: "pattern",
        source: i,
        repeat: this.repeat,
        crossOrigin: this.crossOrigin,
        offsetX: n(this.offsetX, e),
        offsetY: n(this.offsetY, e),
        patternTransform: this.patternTransform ? this.patternTransform.concat() : null
      };
      fabric.util.populateWithProperties(this, r, t);
      return r;
    },
    setOptions: function setOptions(t) {
      for (var e in t) {
        this[e] = t[e];
      }
    },
    toLive: function toLive(t) {
      var e = typeof this.source === "function" ? this.source() : this.source;

      if (!e) {
        return "";
      }

      if (typeof e.src !== "undefined") {
        if (!e.complete) {
          return "";
        }

        if (e.naturalWidth === 0 || e.naturalHeight === 0) {
          return "";
        }
      }

      return t.createPattern(e, this.repeat);
    }
  });
})();

(function (t) {
  "use strict";

  var n = t.fabric || (t.fabric = {}),
      e = n.util.toFixed;

  if (n.Shadow) {
    n.warn("fabric.Shadow is already defined.");
    return;
  }

  n.Shadow = n.util.createClass({
    color: "rgb(0,0,0)",
    blur: 0,
    offsetX: 0,
    offsetY: 0,
    affectStroke: false,
    includeDefaultValues: true,
    nonScaling: false,
    initialize: function initialize(t) {
      if (typeof t === "string") {
        t = this._parseShadow(t);
      }

      for (var e in t) {
        this[e] = t[e];
      }

      this.id = n.Object.__uid++;
    },
    _parseShadow: function _parseShadow(t) {
      var e = t.trim(),
          i = n.Shadow.reOffsetsAndBlur.exec(e) || [],
          r = e.replace(n.Shadow.reOffsetsAndBlur, "") || "rgb(0,0,0)";
      return {
        color: r.trim(),
        offsetX: parseInt(i[1], 10) || 0,
        offsetY: parseInt(i[2], 10) || 0,
        blur: parseInt(i[3], 10) || 0
      };
    },
    toString: function toString() {
      return [this.offsetX, this.offsetY, this.blur, this.color].join("px ");
    },
    toObject: function toObject() {
      if (this.includeDefaultValues) {
        return {
          color: this.color,
          blur: this.blur,
          offsetX: this.offsetX,
          offsetY: this.offsetY,
          affectStroke: this.affectStroke,
          nonScaling: this.nonScaling
        };
      }

      var e = {},
          i = n.Shadow.prototype;
      ["color", "blur", "offsetX", "offsetY", "affectStroke", "nonScaling"].forEach(function (t) {
        if (this[t] !== i[t]) {
          e[t] = this[t];
        }
      }, this);
      return e;
    }
  });
  n.Shadow.reOffsetsAndBlur = /(?:\s|^)(-?\d+(?:px)?(?:\s?|$))?(-?\d+(?:px)?(?:\s?|$))?(\d+(?:px)?)?(?:\s?|$)(?:$|\s)/;
})(typeof exports !== "undefined" ? exports : void 0);

(function () {
  "use strict";

  if (fabric.StaticCanvas) {
    fabric.warn("fabric.StaticCanvas is already defined.");
    return;
  }

  var n = fabric.util.object.extend,
      t = fabric.util.getElementOffset,
      l = fabric.util.removeFromArray,
      e = fabric.util.toFixed,
      s = fabric.util.transformPoint,
      o = fabric.util.invertTransform,
      i = fabric.util.getNodeCanvas,
      r = fabric.util.createCanvasElement,
      a = new Error("Could not initialize `canvas` element");
  fabric.StaticCanvas = fabric.util.createClass(fabric.CommonMethods, {
    initialize: function initialize(t, e) {
      e || (e = {});
      this.renderAndResetBound = this.renderAndReset.bind(this);
      this.requestRenderAllBound = this.requestRenderAll.bind(this);

      this._initStatic(t, e);
    },
    backgroundColor: "",
    backgroundImage: null,
    overlayColor: "",
    overlayImage: null,
    includeDefaultValues: true,
    stateful: false,
    renderOnAddRemove: true,
    clipTo: null,
    controlsAboveOverlay: false,
    allowTouchScrolling: false,
    imageSmoothingEnabled: true,
    viewportTransform: fabric.iMatrix.concat(),
    backgroundVpt: true,
    overlayVpt: true,
    onBeforeScaleRotate: function onBeforeScaleRotate() {},
    enableRetinaScaling: true,
    vptCoords: {},
    skipOffscreen: true,
    clipPath: undefined,
    _initStatic: function _initStatic(t, e) {
      var i = this.requestRenderAllBound;
      this._objects = [];

      this._createLowerCanvas(t);

      this._initOptions(e);

      this._setImageSmoothing();

      if (!this.interactive) {
        this._initRetinaScaling();
      }

      if (e.overlayImage) {
        this.setOverlayImage(e.overlayImage, i);
      }

      if (e.backgroundImage) {
        this.setBackgroundImage(e.backgroundImage, i);
      }

      if (e.backgroundColor) {
        this.setBackgroundColor(e.backgroundColor, i);
      }

      if (e.overlayColor) {
        this.setOverlayColor(e.overlayColor, i);
      }

      this.calcOffset();
    },
    _isRetinaScaling: function _isRetinaScaling() {
      return fabric.devicePixelRatio !== 1 && this.enableRetinaScaling;
    },
    getRetinaScaling: function getRetinaScaling() {
      return this._isRetinaScaling() ? fabric.devicePixelRatio : 1;
    },
    _initRetinaScaling: function _initRetinaScaling() {
      if (!this._isRetinaScaling()) {
        return;
      }

      var t = fabric.devicePixelRatio;

      this.__initRetinaScaling(t, this.lowerCanvasEl, this.contextContainer);

      if (this.upperCanvasEl) {
        this.__initRetinaScaling(t, this.upperCanvasEl, this.contextTop);
      }
    },
    __initRetinaScaling: function __initRetinaScaling(t, e, i) {
      e.setAttribute("width", this.width * t);
      e.setAttribute("height", this.height * t);
      i.scale(t, t);
    },
    calcOffset: function calcOffset() {
      this._offset = t(this.lowerCanvasEl);
      return this;
    },
    setOverlayImage: function setOverlayImage(t, e, i) {
      return this.__setBgOverlayImage("overlayImage", t, e, i);
    },
    setBackgroundImage: function setBackgroundImage(t, e, i) {
      return this.__setBgOverlayImage("backgroundImage", t, e, i);
    },
    setOverlayColor: function setOverlayColor(t, e) {
      return this.__setBgOverlayColor("overlayColor", t, e);
    },
    setBackgroundColor: function setBackgroundColor(t, e) {
      return this.__setBgOverlayColor("backgroundColor", t, e);
    },
    _setImageSmoothing: function _setImageSmoothing() {
      var t = this.getContext();
      t.imageSmoothingEnabled = t.imageSmoothingEnabled || t.webkitImageSmoothingEnabled || t.mozImageSmoothingEnabled || t.msImageSmoothingEnabled || t.oImageSmoothingEnabled;
      t.imageSmoothingEnabled = this.imageSmoothingEnabled;
    },
    __setBgOverlayImage: function __setBgOverlayImage(i, t, r, n) {
      if (typeof t === "string") {
        fabric.util.loadImage(t, function (t) {
          if (t) {
            var e = new fabric.Image(t, n);
            this[i] = e;
            e.canvas = this;
          }

          r && r(t);
        }, this, n && n.crossOrigin);
      } else {
        n && t.setOptions(n);
        this[i] = t;
        t && (t.canvas = this);
        r && r(t);
      }

      return this;
    },
    __setBgOverlayColor: function __setBgOverlayColor(t, e, i) {
      this[t] = e;

      this._initGradient(e, t);

      this._initPattern(e, t, i);

      return this;
    },
    _createCanvasElement: function _createCanvasElement() {
      var t = r();

      if (!t) {
        throw a;
      }

      if (!t.style) {
        t.style = {};
      }

      if (typeof t.getContext === "undefined") {
        throw a;
      }

      return t;
    },
    _initOptions: function _initOptions(t) {
      var e = this.lowerCanvasEl;

      this._setOptions(t);

      this.width = this.width || parseInt(e.width, 10) || 0;
      this.height = this.height || parseInt(e.height, 10) || 0;

      if (!this.lowerCanvasEl.style) {
        return;
      }

      e.width = this.width;
      e.height = this.height;
      e.style.width = this.width + "px";
      e.style.height = this.height + "px";
      this.viewportTransform = this.viewportTransform.slice();
    },
    _createLowerCanvas: function _createLowerCanvas(t) {
      if (t && t.getContext) {
        this.lowerCanvasEl = t;
      } else {
        this.lowerCanvasEl = fabric.util.getById(t) || this._createCanvasElement();
      }

      fabric.util.addClass(this.lowerCanvasEl, "lower-canvas");

      if (this.interactive) {
        this._applyCanvasStyle(this.lowerCanvasEl);
      }

      this.contextContainer = this.lowerCanvasEl.getContext("2d");
    },
    getWidth: function getWidth() {
      return this.width;
    },
    getHeight: function getHeight() {
      return this.height;
    },
    setWidth: function setWidth(t, e) {
      return this.setDimensions({
        width: t
      }, e);
    },
    setHeight: function setHeight(t, e) {
      return this.setDimensions({
        height: t
      }, e);
    },
    setDimensions: function setDimensions(t, e) {
      var i;
      e = e || {};

      for (var r in t) {
        i = t[r];

        if (!e.cssOnly) {
          this._setBackstoreDimension(r, t[r]);

          i += "px";
          this.hasLostContext = true;
        }

        if (!e.backstoreOnly) {
          this._setCssDimension(r, i);
        }
      }

      if (this._isCurrentlyDrawing) {
        this.freeDrawingBrush && this.freeDrawingBrush._setBrushStyles();
      }

      this._initRetinaScaling();

      this._setImageSmoothing();

      this.calcOffset();

      if (!e.cssOnly) {
        this.requestRenderAll();
      }

      return this;
    },
    _setBackstoreDimension: function _setBackstoreDimension(t, e) {
      this.lowerCanvasEl[t] = e;

      if (this.upperCanvasEl) {
        this.upperCanvasEl[t] = e;
      }

      if (this.cacheCanvasEl) {
        this.cacheCanvasEl[t] = e;
      }

      this[t] = e;
      return this;
    },
    _setCssDimension: function _setCssDimension(t, e) {
      this.lowerCanvasEl.style[t] = e;

      if (this.upperCanvasEl) {
        this.upperCanvasEl.style[t] = e;
      }

      if (this.wrapperEl) {
        this.wrapperEl.style[t] = e;
      }

      return this;
    },
    getZoom: function getZoom() {
      return this.viewportTransform[0];
    },
    setViewportTransform: function setViewportTransform(t) {
      var e = this._activeObject,
          i,
          r = false,
          n = true,
          s,
          o;
      this.viewportTransform = t;

      for (s = 0, o = this._objects.length; s < o; s++) {
        i = this._objects[s];
        i.group || i.setCoords(r, n);
      }

      if (e && e.type === "activeSelection") {
        e.setCoords(r, n);
      }

      this.calcViewportBoundaries();
      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },
    zoomToPoint: function zoomToPoint(t, e) {
      var i = t,
          r = this.viewportTransform.slice(0);
      t = s(t, o(this.viewportTransform));
      r[0] = e;
      r[3] = e;
      var n = s(t, r);
      r[4] += i.x - n.x;
      r[5] += i.y - n.y;
      return this.setViewportTransform(r);
    },
    setZoom: function setZoom(t) {
      this.zoomToPoint(new fabric.Point(0, 0), t);
      return this;
    },
    absolutePan: function absolutePan(t) {
      var e = this.viewportTransform.slice(0);
      e[4] = -t.x;
      e[5] = -t.y;
      return this.setViewportTransform(e);
    },
    relativePan: function relativePan(t) {
      return this.absolutePan(new fabric.Point(-t.x - this.viewportTransform[4], -t.y - this.viewportTransform[5]));
    },
    getElement: function getElement() {
      return this.lowerCanvasEl;
    },
    _onObjectAdded: function _onObjectAdded(t) {
      this.stateful && t.setupState();

      t._set("canvas", this);

      t.setCoords();
      this.fire("object:added", {
        target: t
      });
      t.fire("added");
    },
    _onObjectRemoved: function _onObjectRemoved(t) {
      this.fire("object:removed", {
        target: t
      });
      t.fire("removed");
      delete t.canvas;
    },
    clearContext: function clearContext(t) {
      t.clearRect(0, 0, this.width, this.height);
      return this;
    },
    getContext: function getContext() {
      return this.contextContainer;
    },
    clear: function clear() {
      this._objects.length = 0;
      this.backgroundImage = null;
      this.overlayImage = null;
      this.backgroundColor = "";
      this.overlayColor = "";

      if (this._hasITextHandlers) {
        this.off("mouse:up", this._mouseUpITextHandler);
        this._iTextInstances = null;
        this._hasITextHandlers = false;
      }

      this.clearContext(this.contextContainer);
      this.fire("canvas:cleared");
      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },
    renderAll: function renderAll() {
      var t = this.contextContainer;
      this.renderCanvas(t, this._objects);
      return this;
    },
    renderAndReset: function renderAndReset() {
      this.isRendering = 0;
      this.renderAll();
    },
    requestRenderAll: function requestRenderAll() {
      if (!this.isRendering) {
        this.isRendering = fabric.util.requestAnimFrame(this.renderAndResetBound);
      }

      return this;
    },
    calcViewportBoundaries: function calcViewportBoundaries() {
      var t = {},
          e = this.width,
          i = this.height,
          r = o(this.viewportTransform);
      t.tl = s({
        x: 0,
        y: 0
      }, r);
      t.br = s({
        x: e,
        y: i
      }, r);
      t.tr = new fabric.Point(t.br.x, t.tl.y);
      t.bl = new fabric.Point(t.tl.x, t.br.y);
      this.vptCoords = t;
      return t;
    },
    cancelRequestedRender: function cancelRequestedRender() {
      if (this.isRendering) {
        fabric.util.cancelAnimFrame(this.isRendering);
        this.isRendering = 0;
      }
    },
    renderCanvas: function renderCanvas(t, e) {
      var i = this.viewportTransform,
          r = this.clipPath;
      this.cancelRequestedRender();
      this.calcViewportBoundaries();
      this.clearContext(t);
      this.fire("before:render", {
        ctx: t
      });

      if (this.clipTo) {
        fabric.util.clipContext(this, t);
      }

      this._renderBackground(t);

      t.save();
      t.transform(i[0], i[1], i[2], i[3], i[4], i[5]);

      this._renderObjects(t, e);

      t.restore();

      if (!this.controlsAboveOverlay && this.interactive) {
        this.drawControls(t);
      }

      if (this.clipTo) {
        t.restore();
      }

      if (r) {
        r.canvas = this;
        r.shouldCache();
        r._transformDone = true;
        r.renderCache({
          forClipping: true
        });
        this.drawClipPathOnCanvas(t);
      }

      this._renderOverlay(t);

      if (this.controlsAboveOverlay && this.interactive) {
        this.drawControls(t);
      }

      this.fire("after:render", {
        ctx: t
      });
    },
    drawClipPathOnCanvas: function drawClipPathOnCanvas(t) {
      var e = this.viewportTransform,
          i = this.clipPath;
      t.save();
      t.transform(e[0], e[1], e[2], e[3], e[4], e[5]);
      t.globalCompositeOperation = "destination-in";
      i.transform(t);
      t.scale(1 / i.zoomX, 1 / i.zoomY);
      t.drawImage(i._cacheCanvas, -i.cacheTranslationX, -i.cacheTranslationY);
      t.restore();
    },
    _renderObjects: function _renderObjects(t, e) {
      var i, r;

      for (i = 0, r = e.length; i < r; ++i) {
        e[i] && e[i].render(t);
      }
    },
    _renderBackgroundOrOverlay: function _renderBackgroundOrOverlay(t, e) {
      var i = this[e + "Color"],
          r = this[e + "Image"],
          n = this.viewportTransform,
          s = this[e + "Vpt"];

      if (!i && !r) {
        return;
      }

      if (i) {
        t.save();
        t.beginPath();
        t.moveTo(0, 0);
        t.lineTo(this.width, 0);
        t.lineTo(this.width, this.height);
        t.lineTo(0, this.height);
        t.closePath();
        t.fillStyle = i.toLive ? i.toLive(t, this) : i;

        if (s) {
          t.transform(n[0], n[1], n[2], n[3], n[4], n[5]);
        }

        t.transform(1, 0, 0, 1, i.offsetX || 0, i.offsetY || 0);
        var o = i.gradientTransform || i.patternTransform;
        o && t.transform(o[0], o[1], o[2], o[3], o[4], o[5]);
        t.fill();
        t.restore();
      }

      if (r) {
        t.save();

        if (s) {
          t.transform(n[0], n[1], n[2], n[3], n[4], n[5]);
        }

        r.render(t);
        t.restore();
      }
    },
    _renderBackground: function _renderBackground(t) {
      this._renderBackgroundOrOverlay(t, "background");
    },
    _renderOverlay: function _renderOverlay(t) {
      this._renderBackgroundOrOverlay(t, "overlay");
    },
    getCenter: function getCenter() {
      return {
        top: this.height / 2,
        left: this.width / 2
      };
    },
    centerObjectH: function centerObjectH(t) {
      return this._centerObject(t, new fabric.Point(this.getCenter().left, t.getCenterPoint().y));
    },
    centerObjectV: function centerObjectV(t) {
      return this._centerObject(t, new fabric.Point(t.getCenterPoint().x, this.getCenter().top));
    },
    centerObject: function centerObject(t) {
      var e = this.getCenter();
      return this._centerObject(t, new fabric.Point(e.left, e.top));
    },
    viewportCenterObject: function viewportCenterObject(t) {
      var e = this.getVpCenter();
      return this._centerObject(t, e);
    },
    viewportCenterObjectH: function viewportCenterObjectH(t) {
      var e = this.getVpCenter();

      this._centerObject(t, new fabric.Point(e.x, t.getCenterPoint().y));

      return this;
    },
    viewportCenterObjectV: function viewportCenterObjectV(t) {
      var e = this.getVpCenter();
      return this._centerObject(t, new fabric.Point(t.getCenterPoint().x, e.y));
    },
    getVpCenter: function getVpCenter() {
      var t = this.getCenter(),
          e = o(this.viewportTransform);
      return s({
        x: t.left,
        y: t.top
      }, e);
    },
    _centerObject: function _centerObject(t, e) {
      t.setPositionByOrigin(e, "center", "center");
      t.setCoords();
      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },
    toDatalessJSON: function toDatalessJSON(t) {
      return this.toDatalessObject(t);
    },
    toObject: function toObject(t) {
      return this._toObjectMethod("toObject", t);
    },
    toDatalessObject: function toDatalessObject(t) {
      return this._toObjectMethod("toDatalessObject", t);
    },
    _toObjectMethod: function _toObjectMethod(t, e) {
      var i = this.clipPath,
          r = {
        version: fabric.version,
        objects: this._toObjects(t, e)
      };

      if (i) {
        r.clipPath = this._toObject(this.clipPath, t, e);
      }

      n(r, this.__serializeBgOverlay(t, e));
      fabric.util.populateWithProperties(this, r, e);
      return r;
    },
    _toObjects: function _toObjects(e, i) {
      return this._objects.filter(function (t) {
        return !t.excludeFromExport;
      }).map(function (t) {
        return this._toObject(t, e, i);
      }, this);
    },
    _toObject: function _toObject(t, e, i) {
      var r;

      if (!this.includeDefaultValues) {
        r = t.includeDefaultValues;
        t.includeDefaultValues = false;
      }

      var n = t[e](i);

      if (!this.includeDefaultValues) {
        t.includeDefaultValues = r;
      }

      return n;
    },
    __serializeBgOverlay: function __serializeBgOverlay(t, e) {
      var i = {},
          r = this.backgroundImage,
          n = this.overlayImage;

      if (this.backgroundColor) {
        i.background = this.backgroundColor.toObject ? this.backgroundColor.toObject(e) : this.backgroundColor;
      }

      if (this.overlayColor) {
        i.overlay = this.overlayColor.toObject ? this.overlayColor.toObject(e) : this.overlayColor;
      }

      if (r && !r.excludeFromExport) {
        i.backgroundImage = this._toObject(r, t, e);
      }

      if (n && !n.excludeFromExport) {
        i.overlayImage = this._toObject(n, t, e);
      }

      return i;
    },
    sendToBack: function sendToBack(t) {
      if (!t) {
        return this;
      }

      var e = this._activeObject,
          i,
          r,
          n;

      if (t === e && t.type === "activeSelection") {
        n = e._objects;

        for (i = n.length; i--;) {
          r = n[i];
          l(this._objects, r);

          this._objects.unshift(r);
        }
      } else {
        l(this._objects, t);

        this._objects.unshift(t);
      }

      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },
    bringToFront: function bringToFront(t) {
      if (!t) {
        return this;
      }

      var e = this._activeObject,
          i,
          r,
          n;

      if (t === e && t.type === "activeSelection") {
        n = e._objects;

        for (i = 0; i < n.length; i++) {
          r = n[i];
          l(this._objects, r);

          this._objects.push(r);
        }
      } else {
        l(this._objects, t);

        this._objects.push(t);
      }

      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },
    sendBackwards: function sendBackwards(t, e) {
      if (!t) {
        return this;
      }

      var i = this._activeObject,
          r,
          n,
          s,
          o,
          a,
          c = 0;

      if (t === i && t.type === "activeSelection") {
        a = i._objects;

        for (r = 0; r < a.length; r++) {
          n = a[r];
          s = this._objects.indexOf(n);

          if (s > 0 + c) {
            o = s - 1;
            l(this._objects, n);

            this._objects.splice(o, 0, n);
          }

          c++;
        }
      } else {
        s = this._objects.indexOf(t);

        if (s !== 0) {
          o = this._findNewLowerIndex(t, s, e);
          l(this._objects, t);

          this._objects.splice(o, 0, t);
        }
      }

      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },
    _findNewLowerIndex: function _findNewLowerIndex(t, e, i) {
      var r, n;

      if (i) {
        r = e;

        for (n = e - 1; n >= 0; --n) {
          var s = t.intersectsWithObject(this._objects[n]) || t.isContainedWithinObject(this._objects[n]) || this._objects[n].isContainedWithinObject(t);

          if (s) {
            r = n;
            break;
          }
        }
      } else {
        r = e - 1;
      }

      return r;
    },
    bringForward: function bringForward(t, e) {
      if (!t) {
        return this;
      }

      var i = this._activeObject,
          r,
          n,
          s,
          o,
          a,
          c = 0;

      if (t === i && t.type === "activeSelection") {
        a = i._objects;

        for (r = a.length; r--;) {
          n = a[r];
          s = this._objects.indexOf(n);

          if (s < this._objects.length - 1 - c) {
            o = s + 1;
            l(this._objects, n);

            this._objects.splice(o, 0, n);
          }

          c++;
        }
      } else {
        s = this._objects.indexOf(t);

        if (s !== this._objects.length - 1) {
          o = this._findNewUpperIndex(t, s, e);
          l(this._objects, t);

          this._objects.splice(o, 0, t);
        }
      }

      this.renderOnAddRemove && this.requestRenderAll();
      return this;
    },
    _findNewUpperIndex: function _findNewUpperIndex(t, e, i) {
      var r, n, s;

      if (i) {
        r = e;

        for (n = e + 1, s = this._objects.length; n < s; ++n) {
          var o = t.intersectsWithObject(this._objects[n]) || t.isContainedWithinObject(this._objects[n]) || this._objects[n].isContainedWithinObject(t);

          if (o) {
            r = n;
            break;
          }
        }
      } else {
        r = e + 1;
      }

      return r;
    },
    moveTo: function moveTo(t, e) {
      l(this._objects, t);

      this._objects.splice(e, 0, t);

      return this.renderOnAddRemove && this.requestRenderAll();
    },
    dispose: function dispose() {
      if (this.isRendering) {
        fabric.util.cancelAnimFrame(this.isRendering);
        this.isRendering = 0;
      }

      this.forEachObject(function (t) {
        t.dispose && t.dispose();
      });
      this._objects = [];

      if (this.backgroundImage && this.backgroundImage.dispose) {
        this.backgroundImage.dispose();
      }

      this.backgroundImage = null;

      if (this.overlayImage && this.overlayImage.dispose) {
        this.overlayImage.dispose();
      }

      this.overlayImage = null;
      this._iTextInstances = null;
      this.contextContainer = null;
      fabric.util.cleanUpJsdomNode(this.lowerCanvasEl);
      this.lowerCanvasEl = undefined;
      return this;
    },
    toString: function toString() {
      return "#<fabric.Canvas (" + this.complexity() + "): " + "{ objects: " + this._objects.length + " }>";
    }
  });
  n(fabric.StaticCanvas.prototype, fabric.Observable);
  n(fabric.StaticCanvas.prototype, fabric.Collection);
  n(fabric.StaticCanvas.prototype, fabric.DataURLExporter);
  n(fabric.StaticCanvas, {
    EMPTY_JSON: '{"objects": [], "background": "white"}',
    supports: function supports(t) {
      var e = r();

      if (!e || !e.getContext) {
        return null;
      }

      var i = e.getContext("2d");

      if (!i) {
        return null;
      }

      switch (t) {
        case "setLineDash":
          return typeof i.setLineDash !== "undefined";

        default:
          return null;
      }
    }
  });
  fabric.StaticCanvas.prototype.toJSON = fabric.StaticCanvas.prototype.toObject;

  if (fabric.isLikelyNode) {
    fabric.StaticCanvas.prototype.createPNGStream = function () {
      var t = i(this.lowerCanvasEl);
      return t && t.createPNGStream();
    };

    fabric.StaticCanvas.prototype.createJPEGStream = function (t) {
      var e = i(this.lowerCanvasEl);
      return e && e.createJPEGStream(t);
    };
  }
})();

fabric.BaseBrush = fabric.util.createClass({
  color: "rgb(0, 0, 0)",
  width: 1,
  shadow: null,
  strokeLineCap: "round",
  strokeLineJoin: "round",
  strokeMiterLimit: 10,
  strokeDashArray: null,
  setShadow: function setShadow(t) {
    this.shadow = new fabric.Shadow(t);
    return this;
  },
  _setBrushStyles: function _setBrushStyles() {
    var t = this.canvas.contextTop;
    t.strokeStyle = this.color;
    t.lineWidth = this.width;
    t.lineCap = this.strokeLineCap;
    t.miterLimit = this.strokeMiterLimit;
    t.lineJoin = this.strokeLineJoin;

    if (fabric.StaticCanvas.supports("setLineDash")) {
      t.setLineDash(this.strokeDashArray || []);
    }
  },
  _saveAndTransform: function _saveAndTransform(t) {
    var e = this.canvas.viewportTransform;
    t.save();
    t.transform(e[0], e[1], e[2], e[3], e[4], e[5]);
  },
  _setShadow: function _setShadow() {
    if (!this.shadow) {
      return;
    }

    var t = this.canvas,
        e = this.shadow,
        i = t.contextTop,
        r = t.getZoom();

    if (t && t._isRetinaScaling()) {
      r *= fabric.devicePixelRatio;
    }

    i.shadowColor = e.color;
    i.shadowBlur = e.blur * r;
    i.shadowOffsetX = e.offsetX * r;
    i.shadowOffsetY = e.offsetY * r;
  },
  needsFullRender: function needsFullRender() {
    var t = new fabric.Color(this.color);
    return t.getAlpha() < 1 || !!this.shadow;
  },
  _resetShadow: function _resetShadow() {
    var t = this.canvas.contextTop;
    t.shadowColor = "";
    t.shadowBlur = t.shadowOffsetX = t.shadowOffsetY = 0;
  }
});

(function () {
  fabric.PencilBrush = fabric.util.createClass(fabric.BaseBrush, {
    decimate: .4,
    initialize: function initialize(t) {
      this.canvas = t;
      this._points = [];
    },
    _drawSegment: function _drawSegment(t, e, i) {
      var r = e.midPointFrom(i);
      t.quadraticCurveTo(e.x, e.y, r.x, r.y);
      return r;
    },
    onMouseDown: function onMouseDown(t, e) {
      if (!this.canvas._isMainEvent(e.e)) {
        return;
      }

      this._prepareForDrawing(t);

      this._captureDrawingPath(t);

      this._render();
    },
    onMouseMove: function onMouseMove(t, e) {
      if (!this.canvas._isMainEvent(e.e)) {
        return;
      }

      if (this._captureDrawingPath(t) && this._points.length > 1) {
        if (this.needsFullRender()) {
          this.canvas.clearContext(this.canvas.contextTop);

          this._render();
        } else {
          var i = this._points,
              r = i.length,
              n = this.canvas.contextTop;

          this._saveAndTransform(n);

          if (this.oldEnd) {
            n.beginPath();
            n.moveTo(this.oldEnd.x, this.oldEnd.y);
          }

          this.oldEnd = this._drawSegment(n, i[r - 2], i[r - 1], true);
          n.stroke();
          n.restore();
        }
      }
    },
    onMouseUp: function onMouseUp(t) {
      if (!this.canvas._isMainEvent(t.e)) {
        return true;
      }

      this.oldEnd = undefined;

      this._finalizeAndAddPath();

      return false;
    },
    _prepareForDrawing: function _prepareForDrawing(t) {
      var e = new fabric.Point(t.x, t.y);

      this._reset();

      this._addPoint(e);

      this.canvas.contextTop.moveTo(e.x, e.y);
    },
    _addPoint: function _addPoint(t) {
      if (this._points.length > 1 && t.eq(this._points[this._points.length - 1])) {
        return false;
      }

      this._points.push(t);

      return true;
    },
    _reset: function _reset() {
      this._points = [];

      this._setBrushStyles();

      this._setShadow();
    },
    _captureDrawingPath: function _captureDrawingPath(t) {
      var e = new fabric.Point(t.x, t.y);
      return this._addPoint(e);
    },
    _render: function _render() {
      var t = this.canvas.contextTop,
          e,
          i,
          r = this._points[0],
          n = this._points[1];

      this._saveAndTransform(t);

      t.beginPath();

      if (this._points.length === 2 && r.x === n.x && r.y === n.y) {
        var s = this.width / 1e3;
        r = new fabric.Point(r.x, r.y);
        n = new fabric.Point(n.x, n.y);
        r.x -= s;
        n.x += s;
      }

      t.moveTo(r.x, r.y);

      for (e = 1, i = this._points.length; e < i; e++) {
        this._drawSegment(t, r, n);

        r = this._points[e];
        n = this._points[e + 1];
      }

      t.lineTo(r.x, r.y);
      t.stroke();
      t.restore();
    },
    convertPointsToSVGPath: function convertPointsToSVGPath(t) {
      var e = [],
          i,
          r = this.width / 1e3,
          n = new fabric.Point(t[0].x, t[0].y),
          s = new fabric.Point(t[1].x, t[1].y),
          o = t.length,
          a = 1,
          c = 0,
          l = o > 2;

      if (l) {
        a = t[2].x < s.x ? -1 : t[2].x === s.x ? 0 : 1;
        c = t[2].y < s.y ? -1 : t[2].y === s.y ? 0 : 1;
      }

      e.push("M ", n.x - a * r, " ", n.y - c * r, " ");

      for (i = 1; i < o; i++) {
        if (!n.eq(s)) {
          var h = n.midPointFrom(s);
          e.push("Q ", n.x, " ", n.y, " ", h.x, " ", h.y, " ");
        }

        n = t[i];

        if (i + 1 < t.length) {
          s = t[i + 1];
        }
      }

      if (l) {
        a = n.x > t[i - 2].x ? 1 : n.x === t[i - 2].x ? 0 : -1;
        c = n.y > t[i - 2].y ? 1 : n.y === t[i - 2].y ? 0 : -1;
      }

      e.push("L ", n.x + a * r, " ", n.y + c * r);
      return e;
    },
    createPath: function createPath(t) {
      var e = new fabric.Path(t, {
        fill: null,
        stroke: this.color,
        strokeWidth: this.width,
        strokeLineCap: this.strokeLineCap,
        strokeMiterLimit: this.strokeMiterLimit,
        strokeLineJoin: this.strokeLineJoin,
        strokeDashArray: this.strokeDashArray
      });

      if (this.shadow) {
        this.shadow.affectStroke = true;
        e.setShadow(this.shadow);
      }

      return e;
    },
    decimatePoints: function decimatePoints(t, e) {
      if (t.length <= 2) {
        return t;
      }

      var i = this.canvas.getZoom(),
          r = Math.pow(e / i, 2),
          n,
          s = t.length - 1,
          o = t[0],
          a = [o],
          c;

      for (n = 1; n < s; n++) {
        c = Math.pow(o.x - t[n].x, 2) + Math.pow(o.y - t[n].y, 2);

        if (c >= r) {
          o = t[n];
          a.push(o);
        }
      }

      if (a.length === 1) {
        a.push(new fabric.Point(a[0].x, a[0].y));
      }

      return a;
    },
    _finalizeAndAddPath: function _finalizeAndAddPath() {
      var t = this.canvas.contextTop;
      t.closePath();

      if (this.decimate) {
        this._points = this.decimatePoints(this._points, this.decimate);
      }

      var e = this.convertPointsToSVGPath(this._points).join("");

      if (e === "M 0 0 Q 0 0 0 0 L 0 0") {
        this.canvas.requestRenderAll();
        return;
      }

      var i = this.createPath(e);
      this.canvas.clearContext(this.canvas.contextTop);
      this.canvas.add(i);
      this.canvas.requestRenderAll();
      i.setCoords();

      this._resetShadow();

      this.canvas.fire("path:created", {
        path: i
      });
    }
  });
})();

fabric.CircleBrush = fabric.util.createClass(fabric.BaseBrush, {
  width: 10,
  initialize: function initialize(t) {
    this.canvas = t;
    this.points = [];
  },
  drawDot: function drawDot(t) {
    var e = this.addPoint(t),
        i = this.canvas.contextTop;

    this._saveAndTransform(i);

    this.dot(i, e);
    i.restore();
  },
  dot: function dot(t, e) {
    t.fillStyle = e.fill;
    t.beginPath();
    t.arc(e.x, e.y, e.radius, 0, Math.PI * 2, false);
    t.closePath();
    t.fill();
  },
  onMouseDown: function onMouseDown(t) {
    this.points.length = 0;
    this.canvas.clearContext(this.canvas.contextTop);

    this._setShadow();

    this.drawDot(t);
  },
  _render: function _render() {
    var t = this.canvas.contextTop,
        e,
        i,
        r = this.points;

    this._saveAndTransform(t);

    for (e = 0, i = r.length; e < i; e++) {
      this.dot(t, r[e]);
    }

    t.restore();
  },
  onMouseMove: function onMouseMove(t) {
    if (this.needsFullRender()) {
      this.canvas.clearContext(this.canvas.contextTop);
      this.addPoint(t);

      this._render();
    } else {
      this.drawDot(t);
    }
  },
  onMouseUp: function onMouseUp() {
    var t = this.canvas.renderOnAddRemove,
        e,
        i;
    this.canvas.renderOnAddRemove = false;
    var r = [];

    for (e = 0, i = this.points.length; e < i; e++) {
      var n = this.points[e],
          s = new fabric.Circle({
        radius: n.radius,
        left: n.x,
        top: n.y,
        originX: "center",
        originY: "center",
        fill: n.fill
      });
      this.shadow && s.setShadow(this.shadow);
      r.push(s);
    }

    var o = new fabric.Group(r);
    o.canvas = this.canvas;
    this.canvas.add(o);
    this.canvas.fire("path:created", {
      path: o
    });
    this.canvas.clearContext(this.canvas.contextTop);

    this._resetShadow();

    this.canvas.renderOnAddRemove = t;
    this.canvas.requestRenderAll();
  },
  addPoint: function addPoint(t) {
    var e = new fabric.Point(t.x, t.y),
        i = fabric.util.getRandomInt(Math.max(0, this.width - 20), this.width + 20) / 2,
        r = new fabric.Color(this.color).setAlpha(fabric.util.getRandomInt(0, 100) / 100).toRgba();
    e.radius = i;
    e.fill = r;
    this.points.push(e);
    return e;
  }
});
fabric.SprayBrush = fabric.util.createClass(fabric.BaseBrush, {
  width: 10,
  density: 20,
  dotWidth: 1,
  dotWidthVariance: 1,
  randomOpacity: false,
  optimizeOverlapping: true,
  initialize: function initialize(t) {
    this.canvas = t;
    this.sprayChunks = [];
  },
  onMouseDown: function onMouseDown(t) {
    this.sprayChunks.length = 0;
    this.canvas.clearContext(this.canvas.contextTop);

    this._setShadow();

    this.addSprayChunk(t);
    this.render(this.sprayChunkPoints);
  },
  onMouseMove: function onMouseMove(t) {
    this.addSprayChunk(t);
    this.render(this.sprayChunkPoints);
  },
  onMouseUp: function onMouseUp() {
    var t = this.canvas.renderOnAddRemove;
    this.canvas.renderOnAddRemove = false;
    var e = [];

    for (var i = 0, r = this.sprayChunks.length; i < r; i++) {
      var n = this.sprayChunks[i];

      for (var s = 0, o = n.length; s < o; s++) {
        var a = new fabric.Rect({
          width: n[s].width,
          height: n[s].width,
          left: n[s].x + 1,
          top: n[s].y + 1,
          originX: "center",
          originY: "center",
          fill: this.color
        });
        e.push(a);
      }
    }

    if (this.optimizeOverlapping) {
      e = this._getOptimizedRects(e);
    }

    var c = new fabric.Group(e);
    this.shadow && c.setShadow(this.shadow);
    this.canvas.add(c);
    this.canvas.fire("path:created", {
      path: c
    });
    this.canvas.clearContext(this.canvas.contextTop);

    this._resetShadow();

    this.canvas.renderOnAddRemove = t;
    this.canvas.requestRenderAll();
  },
  _getOptimizedRects: function _getOptimizedRects(t) {
    var e = {},
        i,
        r,
        n;

    for (r = 0, n = t.length; r < n; r++) {
      i = t[r].left + "" + t[r].top;

      if (!e[i]) {
        e[i] = t[r];
      }
    }

    var s = [];

    for (i in e) {
      s.push(e[i]);
    }

    return s;
  },
  render: function render(t) {
    var e = this.canvas.contextTop,
        i,
        r;
    e.fillStyle = this.color;

    this._saveAndTransform(e);

    for (i = 0, r = t.length; i < r; i++) {
      var n = t[i];

      if (typeof n.opacity !== "undefined") {
        e.globalAlpha = n.opacity;
      }

      e.fillRect(n.x, n.y, n.width, n.width);
    }

    e.restore();
  },
  _render: function _render() {
    var t = this.canvas.contextTop,
        e,
        i;
    t.fillStyle = this.color;

    this._saveAndTransform(t);

    for (e = 0, i = this.sprayChunks.length; e < i; e++) {
      this.render(this.sprayChunks[e]);
    }

    t.restore();
  },
  addSprayChunk: function addSprayChunk(t) {
    this.sprayChunkPoints = [];
    var e,
        i,
        r,
        n = this.width / 2,
        s;

    for (s = 0; s < this.density; s++) {
      e = fabric.util.getRandomInt(t.x - n, t.x + n);
      i = fabric.util.getRandomInt(t.y - n, t.y + n);

      if (this.dotWidthVariance) {
        r = fabric.util.getRandomInt(Math.max(1, this.dotWidth - this.dotWidthVariance), this.dotWidth + this.dotWidthVariance);
      } else {
        r = this.dotWidth;
      }

      var o = new fabric.Point(e, i);
      o.width = r;

      if (this.randomOpacity) {
        o.opacity = fabric.util.getRandomInt(0, 100) / 100;
      }

      this.sprayChunkPoints.push(o);
    }

    this.sprayChunks.push(this.sprayChunkPoints);
  }
});
fabric.PatternBrush = fabric.util.createClass(fabric.PencilBrush, {
  getPatternSrc: function getPatternSrc() {
    var t = 20,
        e = 5,
        i = fabric.util.createCanvasElement(),
        r = i.getContext("2d");
    i.width = i.height = t + e;
    r.fillStyle = this.color;
    r.beginPath();
    r.arc(t / 2, t / 2, t / 2, 0, Math.PI * 2, false);
    r.closePath();
    r.fill();
    return i;
  },
  getPatternSrcFunction: function getPatternSrcFunction() {
    return String(this.getPatternSrc).replace("this.color", '"' + this.color + '"');
  },
  getPattern: function getPattern() {
    return this.canvas.contextTop.createPattern(this.source || this.getPatternSrc(), "repeat");
  },
  _setBrushStyles: function _setBrushStyles() {
    this.callSuper("_setBrushStyles");
    this.canvas.contextTop.strokeStyle = this.getPattern();
  },
  createPath: function createPath(t) {
    var e = this.callSuper("createPath", t),
        i = e._getLeftTopCoords().scalarAdd(e.strokeWidth / 2);

    e.stroke = new fabric.Pattern({
      source: this.source || this.getPatternSrcFunction(),
      offsetX: -i.x,
      offsetY: -i.y
    });
    return e;
  }
});

(function () {
  var l = fabric.util.getPointer,
      a = fabric.util.degreesToRadians,
      d = fabric.util.radiansToDegrees,
      g = Math.atan2,
      c = Math.abs,
      h = fabric.StaticCanvas.supports("setLineDash"),
      f = .5;
  fabric.Canvas = fabric.util.createClass(fabric.StaticCanvas, {
    initialize: function initialize(t, e) {
      e || (e = {});
      this.renderAndResetBound = this.renderAndReset.bind(this);
      this.requestRenderAllBound = this.requestRenderAll.bind(this);

      this._initStatic(t, e);

      this._initInteractive();

      this._createCacheCanvas();
    },
    uniScaleTransform: false,
    uniScaleKey: "shiftKey",
    centeredScaling: false,
    centeredRotation: false,
    centeredKey: "altKey",
    altActionKey: "shiftKey",
    interactive: true,
    selection: true,
    selectionKey: "shiftKey",
    altSelectionKey: null,
    selectionColor: "rgba(100, 100, 255, 0.3)",
    selectionDashArray: [],
    selectionBorderColor: "rgba(255, 255, 255, 0.3)",
    selectionLineWidth: 1,
    selectionFullyContained: false,
    hoverCursor: "move",
    moveCursor: "move",
    defaultCursor: "default",
    freeDrawingCursor: "crosshair",
    rotationCursor: "crosshair",
    notAllowedCursor: "not-allowed",
    containerClass: "canvas-container",
    perPixelTargetFind: false,
    targetFindTolerance: 0,
    skipTargetFind: false,
    isDrawingMode: false,
    preserveObjectStacking: false,
    snapAngle: 0,
    snapThreshold: null,
    stopContextMenu: false,
    fireRightClick: false,
    fireMiddleClick: false,
    targets: [],
    _hoveredTarget: null,
    _hoveredTargets: [],
    _initInteractive: function _initInteractive() {
      this._currentTransform = null;
      this._groupSelector = null;

      this._initWrapperElement();

      this._createUpperCanvas();

      this._initEventListeners();

      this._initRetinaScaling();

      this.freeDrawingBrush = fabric.PencilBrush && new fabric.PencilBrush(this);
      this.calcOffset();
    },
    _chooseObjectsToRender: function _chooseObjectsToRender() {
      var t = this.getActiveObjects(),
          e,
          i,
          r;

      if (t.length > 0 && !this.preserveObjectStacking) {
        i = [];
        r = [];

        for (var n = 0, s = this._objects.length; n < s; n++) {
          e = this._objects[n];

          if (t.indexOf(e) === -1) {
            i.push(e);
          } else {
            r.push(e);
          }
        }

        if (t.length > 1) {
          this._activeObject._objects = r;
        }

        i.push.apply(i, r);
      } else {
        i = this._objects;
      }

      return i;
    },
    renderAll: function renderAll() {
      if (this.contextTopDirty && !this._groupSelector && !this.isDrawingMode) {
        this.clearContext(this.contextTop);
        this.contextTopDirty = false;
      }

      if (this.hasLostContext) {
        this.renderTopLayer(this.contextTop);
      }

      var t = this.contextContainer;
      this.renderCanvas(t, this._chooseObjectsToRender());
      return this;
    },
    renderTopLayer: function renderTopLayer(t) {
      t.save();

      if (this.isDrawingMode && this._isCurrentlyDrawing) {
        this.freeDrawingBrush && this.freeDrawingBrush._render();
        this.contextTopDirty = true;
      }

      if (this.selection && this._groupSelector) {
        this._drawSelection(t);

        this.contextTopDirty = true;
      }

      t.restore();
    },
    renderTop: function renderTop() {
      var t = this.contextTop;
      this.clearContext(t);
      this.renderTopLayer(t);
      this.fire("after:render");
      return this;
    },
    _resetCurrentTransform: function _resetCurrentTransform() {
      var t = this._currentTransform;
      t.target.set({
        scaleX: t.original.scaleX,
        scaleY: t.original.scaleY,
        skewX: t.original.skewX,
        skewY: t.original.skewY,
        left: t.original.left,
        top: t.original.top
      });

      if (this._shouldCenterTransform(t.target)) {
        if (t.originX !== "center") {
          if (t.originX === "right") {
            t.mouseXSign = -1;
          } else {
            t.mouseXSign = 1;
          }
        }

        if (t.originY !== "center") {
          if (t.originY === "bottom") {
            t.mouseYSign = -1;
          } else {
            t.mouseYSign = 1;
          }
        }

        t.originX = "center";
        t.originY = "center";
      } else {
        t.originX = t.original.originX;
        t.originY = t.original.originY;
      }
    },
    containsPoint: function containsPoint(t, e, i) {
      var r = true,
          n = i || this.getPointer(t, r),
          s;

      if (e.group && e.group === this._activeObject && e.group.type === "activeSelection") {
        s = this._normalizePointer(e.group, n);
      } else {
        s = {
          x: n.x,
          y: n.y
        };
      }

      return e.containsPoint(s) || e._findTargetCorner(n);
    },
    _normalizePointer: function _normalizePointer(t, e) {
      var i = t.calcTransformMatrix(),
          r = fabric.util.invertTransform(i),
          n = this.restorePointerVpt(e);
      return fabric.util.transformPoint(n, r);
    },
    isTargetTransparent: function isTargetTransparent(t, e, i) {
      if (t.shouldCache() && t._cacheCanvas && t !== this._activeObject) {
        var r = this._normalizePointer(t, {
          x: e,
          y: i
        }),
            n = Math.max(t.cacheTranslationX + r.x * t.zoomX, 0),
            s = Math.max(t.cacheTranslationY + r.y * t.zoomY, 0);

        var o = fabric.util.isTransparent(t._cacheContext, Math.round(n), Math.round(s), this.targetFindTolerance);
        return o;
      }

      var a = this.contextCache,
          c = t.selectionBackgroundColor,
          l = this.viewportTransform;
      t.selectionBackgroundColor = "";
      this.clearContext(a);
      a.save();
      a.transform(l[0], l[1], l[2], l[3], l[4], l[5]);
      t.render(a);
      a.restore();
      t === this._activeObject && t._renderControls(a, {
        hasBorders: false,
        transparentCorners: false
      }, {
        hasBorders: false
      });
      t.selectionBackgroundColor = c;
      var o = fabric.util.isTransparent(a, e, i, this.targetFindTolerance);
      return o;
    },
    _isSelectionKeyPressed: function _isSelectionKeyPressed(e) {
      var t = false;

      if (Object.prototype.toString.call(this.selectionKey) === "[object Array]") {
        t = !!this.selectionKey.find(function (t) {
          return e[t] === true;
        });
      } else {
        t = e[this.selectionKey];
      }

      return t;
    },
    _shouldClearSelection: function _shouldClearSelection(t, e) {
      var i = this.getActiveObjects(),
          r = this._activeObject;
      return !e || e && r && i.length > 1 && i.indexOf(e) === -1 && r !== e && !this._isSelectionKeyPressed(t) || e && !e.evented || e && !e.selectable && r && r !== e;
    },
    _shouldCenterTransform: function _shouldCenterTransform(t) {
      if (!t) {
        return;
      }

      var e = this._currentTransform,
          i;

      if (e.action === "scale" || e.action === "scaleX" || e.action === "scaleY") {
        i = this.centeredScaling || t.centeredScaling;
      } else if (e.action === "rotate") {
        i = this.centeredRotation || t.centeredRotation;
      }

      return i ? !e.altKey : e.altKey;
    },
    _getOriginFromCorner: function _getOriginFromCorner(t, e) {
      var i = {
        x: t.originX,
        y: t.originY
      };

      if (e === "ml" || e === "tl" || e === "bl") {
        i.x = "right";
      } else if (e === "mr" || e === "tr" || e === "br") {
        i.x = "left";
      }

      if (e === "tl" || e === "mt" || e === "tr") {
        i.y = "bottom";
      } else if (e === "bl" || e === "mb" || e === "br") {
        i.y = "top";
      }

      return i;
    },
    _getActionFromCorner: function _getActionFromCorner(t, e, i) {
      if (!e || !t) {
        return "drag";
      }

      switch (e) {
        case "mtr":
          return "rotate";

        case "ml":
        case "mr":
          return i[this.altActionKey] ? "skewY" : "scaleX";

        case "mt":
        case "mb":
          return i[this.altActionKey] ? "skewX" : "scaleY";

        default:
          return "scale";
      }
    },
    _setupCurrentTransform: function _setupCurrentTransform(t, e, i) {
      if (!e) {
        return;
      }

      var r = this.getPointer(t),
          n = e._findTargetCorner(this.getPointer(t, true)),
          s = this._getActionFromCorner(i, n, t, e),
          o = this._getOriginFromCorner(e, n);

      this._currentTransform = {
        target: e,
        action: s,
        corner: n,
        scaleX: e.scaleX,
        scaleY: e.scaleY,
        skewX: e.skewX,
        skewY: e.skewY,
        offsetX: r.x - e.left,
        offsetY: r.y - e.top,
        originX: o.x,
        originY: o.y,
        ex: r.x,
        ey: r.y,
        lastX: r.x,
        lastY: r.y,
        theta: a(e.angle),
        width: e.width * e.scaleX,
        mouseXSign: 1,
        mouseYSign: 1,
        shiftKey: t.shiftKey,
        altKey: t[this.centeredKey],
        original: fabric.util.saveObjectTransform(e)
      };
      this._currentTransform.original.originX = o.x;
      this._currentTransform.original.originY = o.y;

      this._resetCurrentTransform();

      this._beforeTransform(t);
    },
    _translateObject: function _translateObject(t, e) {
      var i = this._currentTransform,
          r = i.target,
          n = t - i.offsetX,
          s = e - i.offsetY,
          o = !r.get("lockMovementX") && r.left !== n,
          a = !r.get("lockMovementY") && r.top !== s;
      o && r.set("left", n);
      a && r.set("top", s);
      return o || a;
    },
    _changeSkewTransformOrigin: function _changeSkewTransformOrigin(t, e, i) {
      var r = "originX",
          n = {
        0: "center"
      },
          s = e.target.skewX,
          o = "left",
          a = "right",
          c = e.corner === "mt" || e.corner === "ml" ? 1 : -1,
          l = 1;
      t = t > 0 ? 1 : -1;

      if (i === "y") {
        s = e.target.skewY;
        o = "top";
        a = "bottom";
        r = "originY";
      }

      n[-1] = o;
      n[1] = a;
      e.target.flipX && (l *= -1);
      e.target.flipY && (l *= -1);

      if (s === 0) {
        e.skewSign = -c * t * l;
        e[r] = n[-t];
      } else {
        s = s > 0 ? 1 : -1;
        e.skewSign = s;
        e[r] = n[s * c * l];
      }
    },
    _skewObject: function _skewObject(t, e, i) {
      var r = this._currentTransform,
          n = r.target,
          s = false,
          o = n.get("lockSkewingX"),
          a = n.get("lockSkewingY");

      if (o && i === "x" || a && i === "y") {
        return false;
      }

      var c = n.getCenterPoint(),
          l = n.toLocalPoint(new fabric.Point(t, e), "center", "center")[i],
          h = n.toLocalPoint(new fabric.Point(r.lastX, r.lastY), "center", "center")[i],
          f,
          u,
          d = n._getTransformedDimensions();

      this._changeSkewTransformOrigin(l - h, r, i);

      f = n.toLocalPoint(new fabric.Point(t, e), r.originX, r.originY)[i];
      u = n.translateToOriginPoint(c, r.originX, r.originY);
      s = this._setObjectSkew(f, r, i, d);
      r.lastX = t;
      r.lastY = e;
      n.setPositionByOrigin(u, r.originX, r.originY);
      return s;
    },
    _setObjectSkew: function _setObjectSkew(t, e, i, r) {
      var n = e.target,
          s,
          o = false,
          a = e.skewSign,
          c,
          l,
          h,
          f,
          u,
          d,
          g,
          p;

      if (i === "x") {
        h = "y";
        f = "Y";
        u = "X";
        g = 0;
        p = n.skewY;
      } else {
        h = "x";
        f = "X";
        u = "Y";
        g = n.skewX;
        p = 0;
      }

      l = n._getTransformedDimensions(g, p);
      d = 2 * Math.abs(t) - l[i];

      if (d <= 2) {
        s = 0;
      } else {
        s = a * Math.atan(d / n["scale" + u] / (l[h] / n["scale" + f]));
        s = fabric.util.radiansToDegrees(s);
      }

      o = n["skew" + u] !== s;
      n.set("skew" + u, s);

      if (n["skew" + f] !== 0) {
        c = n._getTransformedDimensions();
        s = r[h] / c[h] * n["scale" + f];
        n.set("scale" + f, s);
      }

      return o;
    },
    _scaleObject: function _scaleObject(t, e, i) {
      var r = this._currentTransform,
          n = r.target,
          s = n.lockScalingX,
          o = n.lockScalingY,
          a = n.lockScalingFlip;

      if (s && o) {
        return false;
      }

      var c = n.translateToOriginPoint(n.getCenterPoint(), r.originX, r.originY),
          l = n.toLocalPoint(new fabric.Point(t, e), r.originX, r.originY),
          h = n._getTransformedDimensions(),
          f = false;

      this._setLocalMouse(l, r);

      f = this._setObjectScale(l, r, s, o, i, a, h);
      n.setPositionByOrigin(c, r.originX, r.originY);
      return f;
    },
    _setObjectScale: function _setObjectScale(t, e, i, r, n, s, o) {
      var a = e.target,
          c = false,
          l = false,
          h = false,
          f = t.x * a.scaleX / o.x,
          u = t.y * a.scaleY / o.y,
          d = a.scaleX !== f,
          g = a.scaleY !== u;
      e.newScaleX = f;
      e.newScaleY = u;

      if (fabric.Textbox && n === "x" && a instanceof fabric.Textbox) {
        var p = a.width * (t.x / o.x);

        if (p >= a.getMinWidth()) {
          h = p !== a.width;
          a.set("width", p);
          return h;
        }

        return false;
      }

      if (s && f <= 0 && f < a.scaleX) {
        c = true;
        t.x = 0;
      }

      if (s && u <= 0 && u < a.scaleY) {
        l = true;
        t.y = 0;
      }

      if (n === "equally" && !i && !r) {
        h = this._scaleObjectEqually(t, a, e, o);
      } else if (!n) {
        c || i || a.set("scaleX", f) && (h = h || d);
        l || r || a.set("scaleY", u) && (h = h || g);
      } else if (n === "x" && !a.get("lockUniScaling")) {
        c || i || a.set("scaleX", f) && (h = d);
      } else if (n === "y" && !a.get("lockUniScaling")) {
        l || r || a.set("scaleY", u) && (h = g);
      }

      c || l || this._flipObject(e, n);
      return h;
    },
    _scaleObjectEqually: function _scaleObjectEqually(t, e, i, r) {
      var n = t.y + t.x,
          s = r.y * i.original.scaleY / e.scaleY + r.x * i.original.scaleX / e.scaleX,
          o,
          a = t.x < 0 ? -1 : 1,
          c = t.y < 0 ? -1 : 1,
          l,
          h;
      l = a * Math.abs(i.original.scaleX * n / s);
      h = c * Math.abs(i.original.scaleY * n / s);
      o = l !== e.scaleX || h !== e.scaleY;
      e.set("scaleX", l);
      e.set("scaleY", h);
      return o;
    },
    _flipObject: function _flipObject(t, e) {
      if (t.newScaleX < 0 && e !== "y") {
        if (t.originX === "left") {
          t.originX = "right";
        } else if (t.originX === "right") {
          t.originX = "left";
        }
      }

      if (t.newScaleY < 0 && e !== "x") {
        if (t.originY === "top") {
          t.originY = "bottom";
        } else if (t.originY === "bottom") {
          t.originY = "top";
        }
      }
    },
    _setLocalMouse: function _setLocalMouse(t, e) {
      var i = e.target,
          r = this.getZoom(),
          n = i.padding / r;

      if (e.originX === "right") {
        t.x *= -1;
      } else if (e.originX === "center") {
        t.x *= e.mouseXSign * 2;

        if (t.x < 0) {
          e.mouseXSign = -e.mouseXSign;
        }
      }

      if (e.originY === "bottom") {
        t.y *= -1;
      } else if (e.originY === "center") {
        t.y *= e.mouseYSign * 2;

        if (t.y < 0) {
          e.mouseYSign = -e.mouseYSign;
        }
      }

      if (c(t.x) > n) {
        if (t.x < 0) {
          t.x += n;
        } else {
          t.x -= n;
        }
      } else {
        t.x = 0;
      }

      if (c(t.y) > n) {
        if (t.y < 0) {
          t.y += n;
        } else {
          t.y -= n;
        }
      } else {
        t.y = 0;
      }
    },
    _rotateObject: function _rotateObject(t, e) {
      var i = this._currentTransform,
          r = i.target,
          n,
          n = r.translateToOriginPoint(r.getCenterPoint(), i.originX, i.originY);

      if (r.lockRotation) {
        return false;
      }

      var s = g(i.ey - n.y, i.ex - n.x),
          o = g(e - n.y, t - n.x),
          a = d(o - s + i.theta),
          c = true;

      if (r.snapAngle > 0) {
        var l = r.snapAngle,
            h = r.snapThreshold || l,
            f = Math.ceil(a / l) * l,
            u = Math.floor(a / l) * l;

        if (Math.abs(a - u) < h) {
          a = u;
        } else if (Math.abs(a - f) < h) {
          a = f;
        }
      }

      if (a < 0) {
        a = 360 + a;
      }

      a %= 360;

      if (r.angle === a) {
        c = false;
      } else {
        r.angle = a;
        r.setPositionByOrigin(n, i.originX, i.originY);
      }

      return c;
    },
    setCursor: function setCursor(t) {
      this.upperCanvasEl.style.cursor = t;
    },
    _drawSelection: function _drawSelection(t) {
      var e = this._groupSelector,
          i = e.left,
          r = e.top,
          n = c(i),
          s = c(r);

      if (this.selectionColor) {
        t.fillStyle = this.selectionColor;
        t.fillRect(e.ex - (i > 0 ? 0 : -i), e.ey - (r > 0 ? 0 : -r), n, s);
      }

      if (!this.selectionLineWidth || !this.selectionBorderColor) {
        return;
      }

      t.lineWidth = this.selectionLineWidth;
      t.strokeStyle = this.selectionBorderColor;

      if (this.selectionDashArray.length > 1 && !h) {
        var o = e.ex + f - (i > 0 ? 0 : n),
            a = e.ey + f - (r > 0 ? 0 : s);
        t.beginPath();
        fabric.util.drawDashedLine(t, o, a, o + n, a, this.selectionDashArray);
        fabric.util.drawDashedLine(t, o, a + s - 1, o + n, a + s - 1, this.selectionDashArray);
        fabric.util.drawDashedLine(t, o, a, o, a + s, this.selectionDashArray);
        fabric.util.drawDashedLine(t, o + n - 1, a, o + n - 1, a + s, this.selectionDashArray);
        t.closePath();
        t.stroke();
      } else {
        fabric.Object.prototype._setLineDash.call(this, t, this.selectionDashArray);

        t.strokeRect(e.ex + f - (i > 0 ? 0 : n), e.ey + f - (r > 0 ? 0 : s), n, s);
      }
    },
    findTarget: function findTarget(t, e) {
      if (this.skipTargetFind) {
        return;
      }

      var i = true,
          r = this.getPointer(t, i),
          n = this._activeObject,
          s = this.getActiveObjects(),
          o,
          a;
      this.targets = [];

      if (s.length > 1 && !e && n === this._searchPossibleTargets([n], r)) {
        return n;
      }

      if (s.length === 1 && n._findTargetCorner(r)) {
        return n;
      }

      if (s.length === 1 && n === this._searchPossibleTargets([n], r)) {
        if (!this.preserveObjectStacking) {
          return n;
        } else {
          o = n;
          a = this.targets;
          this.targets = [];
        }
      }

      var c = this._searchPossibleTargets(this._objects, r);

      if (t[this.altSelectionKey] && c && o && c !== o) {
        c = o;
        this.targets = a;
      }

      return c;
    },
    _checkTarget: function _checkTarget(t, e, i) {
      if (e && e.visible && e.evented && this.containsPoint(null, e, t)) {
        if ((this.perPixelTargetFind || e.perPixelTargetFind) && !e.isEditing) {
          var r = this.isTargetTransparent(e, i.x, i.y);

          if (!r) {
            return true;
          }
        } else {
          return true;
        }
      }
    },
    _searchPossibleTargets: function _searchPossibleTargets(t, e) {
      var i,
          r = t.length,
          n;

      while (r--) {
        var s = t[r];
        var o = s.group && s.group.type !== "activeSelection" ? this._normalizePointer(s.group, e) : e;

        if (this._checkTarget(o, s, e)) {
          i = t[r];

          if (i.subTargetCheck && i instanceof fabric.Group) {
            n = this._searchPossibleTargets(i._objects, e);
            n && this.targets.push(n);
          }

          break;
        }
      }

      return i;
    },
    restorePointerVpt: function restorePointerVpt(t) {
      return fabric.util.transformPoint(t, fabric.util.invertTransform(this.viewportTransform));
    },
    getPointer: function getPointer(t, e) {
      if (this._absolutePointer && !e) {
        return this._absolutePointer;
      }

      if (this._pointer && e) {
        return this._pointer;
      }

      var i = l(t),
          r = this.upperCanvasEl,
          n = r.getBoundingClientRect(),
          s = n.width || 0,
          o = n.height || 0,
          a;

      if (!s || !o) {
        if ("top" in n && "bottom" in n) {
          o = Math.abs(n.top - n.bottom);
        }

        if ("right" in n && "left" in n) {
          s = Math.abs(n.right - n.left);
        }
      }

      this.calcOffset();
      i.x = i.x - this._offset.left;
      i.y = i.y - this._offset.top;

      if (!e) {
        i = this.restorePointerVpt(i);
      }

      var c = this.getRetinaScaling();

      if (c !== 1) {
        i.x /= c;
        i.y /= c;
      }

      if (s === 0 || o === 0) {
        a = {
          width: 1,
          height: 1
        };
      } else {
        a = {
          width: r.width / s,
          height: r.height / o
        };
      }

      return {
        x: i.x * a.width,
        y: i.y * a.height
      };
    },
    _createUpperCanvas: function _createUpperCanvas() {
      var t = this.lowerCanvasEl.className.replace(/\s*lower-canvas\s*/, ""),
          e = this.lowerCanvasEl,
          i = this.upperCanvasEl;

      if (i) {
        i.className = "";
      } else {
        i = this._createCanvasElement();
        this.upperCanvasEl = i;
      }

      fabric.util.addClass(i, "upper-canvas " + t);
      this.wrapperEl.appendChild(i);

      this._copyCanvasStyle(e, i);

      this._applyCanvasStyle(i);

      this.contextTop = i.getContext("2d");
    },
    _createCacheCanvas: function _createCacheCanvas() {
      this.cacheCanvasEl = this._createCanvasElement();
      this.cacheCanvasEl.setAttribute("width", this.width);
      this.cacheCanvasEl.setAttribute("height", this.height);
      this.contextCache = this.cacheCanvasEl.getContext("2d");
    },
    _initWrapperElement: function _initWrapperElement() {
      this.wrapperEl = fabric.util.wrapElement(this.lowerCanvasEl, "div", {
        "class": this.containerClass
      });
      fabric.util.setStyle(this.wrapperEl, {
        width: this.width + "px",
        height: this.height + "px",
        position: "relative"
      });
      fabric.util.makeElementUnselectable(this.wrapperEl);
    },
    _applyCanvasStyle: function _applyCanvasStyle(t) {
      var e = this.width || t.width,
          i = this.height || t.height;
      fabric.util.setStyle(t, {
        position: "absolute",
        width: e + "px",
        height: i + "px",
        left: 0,
        top: 0,
        "touch-action": this.allowTouchScrolling ? "manipulation" : "none",
        "-ms-touch-action": this.allowTouchScrolling ? "manipulation" : "none"
      });
      t.width = e;
      t.height = i;
      fabric.util.makeElementUnselectable(t);
    },
    _copyCanvasStyle: function _copyCanvasStyle(t, e) {
      e.style.cssText = t.style.cssText;
    },
    getSelectionContext: function getSelectionContext() {
      return this.contextTop;
    },
    getSelectionElement: function getSelectionElement() {
      return this.upperCanvasEl;
    },
    getActiveObject: function getActiveObject() {
      return this._activeObject;
    },
    getActiveObjects: function getActiveObjects() {
      var t = this._activeObject;

      if (t) {
        if (t.type === "activeSelection" && t._objects) {
          return t._objects.slice(0);
        } else {
          return [t];
        }
      }

      return [];
    },
    _onObjectRemoved: function _onObjectRemoved(t) {
      if (t === this._activeObject) {
        this.fire("before:selection:cleared", {
          target: t
        });

        this._discardActiveObject();

        this.fire("selection:cleared", {
          target: t
        });
        t.fire("deselected");
      }

      if (t === this._hoveredTarget) {
        this._hoveredTarget = null;
        this._hoveredTargets = [];
      }

      this.callSuper("_onObjectRemoved", t);
    },
    _fireSelectionEvents: function _fireSelectionEvents(e, t) {
      var i = false,
          r = this.getActiveObjects(),
          n = [],
          s = [],
          o = {
        e: t
      };
      e.forEach(function (t) {
        if (r.indexOf(t) === -1) {
          i = true;
          t.fire("deselected", o);
          s.push(t);
        }
      });
      r.forEach(function (t) {
        if (e.indexOf(t) === -1) {
          i = true;
          t.fire("selected", o);
          n.push(t);
        }
      });

      if (e.length > 0 && r.length > 0) {
        o.selected = n;
        o.deselected = s;
        o.updated = n[0] || s[0];
        o.target = this._activeObject;
        i && this.fire("selection:updated", o);
      } else if (r.length > 0) {
        if (r.length === 1) {
          o.target = n[0];
          this.fire("object:selected", o);
        }

        o.selected = n;
        o.target = this._activeObject;
        this.fire("selection:created", o);
      } else if (e.length > 0) {
        o.deselected = s;
        this.fire("selection:cleared", o);
      }
    },
    setActiveObject: function setActiveObject(t, e) {
      var i = this.getActiveObjects();

      this._setActiveObject(t, e);

      this._fireSelectionEvents(i, e);

      return this;
    },
    _setActiveObject: function _setActiveObject(t, e) {
      if (this._activeObject === t) {
        return false;
      }

      if (!this._discardActiveObject(e, t)) {
        return false;
      }

      if (t.onSelect({
        e: e
      })) {
        return false;
      }

      this._activeObject = t;
      return true;
    },
    _discardActiveObject: function _discardActiveObject(t, e) {
      var i = this._activeObject;

      if (i) {
        if (i.onDeselect({
          e: t,
          object: e
        })) {
          return false;
        }

        this._activeObject = null;
      }

      return true;
    },
    discardActiveObject: function discardActiveObject(t) {
      var e = this.getActiveObjects(),
          i = this.getActiveObject();

      if (e.length) {
        this.fire("before:selection:cleared", {
          target: i,
          e: t
        });
      }

      this._discardActiveObject(t);

      this._fireSelectionEvents(e, t);

      return this;
    },
    dispose: function dispose() {
      var t = this.wrapperEl;
      this.removeListeners();
      t.removeChild(this.upperCanvasEl);
      t.removeChild(this.lowerCanvasEl);
      this.contextCache = null;
      this.contextTop = null;
      ["upperCanvasEl", "cacheCanvasEl"].forEach(function (t) {
        fabric.util.cleanUpJsdomNode(this[t]);
        this[t] = undefined;
      }.bind(this));

      if (t.parentNode) {
        t.parentNode.replaceChild(this.lowerCanvasEl, this.wrapperEl);
      }

      delete this.wrapperEl;
      fabric.StaticCanvas.prototype.dispose.call(this);
      return this;
    },
    clear: function clear() {
      this.discardActiveObject();
      this.clearContext(this.contextTop);
      return this.callSuper("clear");
    },
    drawControls: function drawControls(t) {
      var e = this._activeObject;

      if (e) {
        e._renderControls(t);
      }
    },
    _toObject: function _toObject(t, e, i) {
      var r = this._realizeGroupTransformOnObject(t),
          n = this.callSuper("_toObject", t, e, i);

      this._unwindGroupTransformOnObject(t, r);

      return n;
    },
    _realizeGroupTransformOnObject: function _realizeGroupTransformOnObject(e) {
      if (e.group && e.group.type === "activeSelection" && this._activeObject === e.group) {
        var t = ["angle", "flipX", "flipY", "left", "scaleX", "scaleY", "skewX", "skewY", "top"];
        var i = {};
        t.forEach(function (t) {
          i[t] = e[t];
        });

        this._activeObject.realizeTransform(e);

        return i;
      } else {
        return null;
      }
    },
    _unwindGroupTransformOnObject: function _unwindGroupTransformOnObject(t, e) {
      if (e) {
        t.set(e);
      }
    },
    _setSVGObject: function _setSVGObject(t, e, i) {
      var r = this._realizeGroupTransformOnObject(e);

      this.callSuper("_setSVGObject", t, e, i);

      this._unwindGroupTransformOnObject(e, r);
    },
    setViewportTransform: function setViewportTransform(t) {
      if (this.renderOnAddRemove && this._activeObject && this._activeObject.isEditing) {
        this._activeObject.clearContextTop();
      }

      fabric.StaticCanvas.prototype.setViewportTransform.call(this, t);
    }
  });

  for (var t in fabric.StaticCanvas) {
    if (t !== "prototype") {
      fabric.Canvas[t] = fabric.StaticCanvas[t];
    }
  }
})();

(function () {
  var n = {
    mt: 0,
    tr: 1,
    mr: 2,
    br: 3,
    mb: 4,
    bl: 5,
    ml: 6,
    tl: 7
  },
      r = fabric.util.addListener,
      s = fabric.util.removeListener,
      o = 3,
      a = 2,
      c = 1,
      l = {
    passive: false
  };

  function h(t, e) {
    return t.button && t.button === e - 1;
  }

  fabric.util.object.extend(fabric.Canvas.prototype, {
    cursorMap: ["n-resize", "ne-resize", "e-resize", "se-resize", "s-resize", "sw-resize", "w-resize", "nw-resize"],
    mainTouchId: null,
    _initEventListeners: function _initEventListeners() {
      this.removeListeners();

      this._bindEvents();

      this.addOrRemove(r, "add");
    },
    _getEventPrefix: function _getEventPrefix() {
      return this.enablePointerEvents ? "pointer" : "mouse";
    },
    addOrRemove: function addOrRemove(t, e) {
      var i = this.upperCanvasEl,
          r = this._getEventPrefix();

      t(fabric.window, "resize", this._onResize);
      t(i, r + "down", this._onMouseDown);
      t(i, r + "move", this._onMouseMove, l);
      t(i, r + "out", this._onMouseOut);
      t(i, r + "enter", this._onMouseEnter);
      t(i, "wheel", this._onMouseWheel);
      t(i, "contextmenu", this._onContextMenu);
      t(i, "dblclick", this._onDoubleClick);
      t(i, "dragover", this._onDragOver);
      t(i, "dragenter", this._onDragEnter);
      t(i, "dragleave", this._onDragLeave);
      t(i, "drop", this._onDrop);

      if (!this.enablePointerEvents) {
        t(i, "touchstart", this._onTouchStart, l);
      }

      if (typeof eventjs !== "undefined" && e in eventjs) {
        eventjs[e](i, "gesture", this._onGesture);
        eventjs[e](i, "drag", this._onDrag);
        eventjs[e](i, "orientation", this._onOrientationChange);
        eventjs[e](i, "shake", this._onShake);
        eventjs[e](i, "longpress", this._onLongPress);
      }
    },
    removeListeners: function removeListeners() {
      this.addOrRemove(s, "remove");

      var t = this._getEventPrefix();

      s(fabric.document, t + "up", this._onMouseUp);
      s(fabric.document, "touchend", this._onTouchEnd, l);
      s(fabric.document, t + "move", this._onMouseMove, l);
      s(fabric.document, "touchmove", this._onMouseMove, l);
    },
    _bindEvents: function _bindEvents() {
      if (this.eventsBound) {
        return;
      }

      this._onMouseDown = this._onMouseDown.bind(this);
      this._onTouchStart = this._onTouchStart.bind(this);
      this._onMouseMove = this._onMouseMove.bind(this);
      this._onMouseUp = this._onMouseUp.bind(this);
      this._onTouchEnd = this._onTouchEnd.bind(this);
      this._onResize = this._onResize.bind(this);
      this._onGesture = this._onGesture.bind(this);
      this._onDrag = this._onDrag.bind(this);
      this._onShake = this._onShake.bind(this);
      this._onLongPress = this._onLongPress.bind(this);
      this._onOrientationChange = this._onOrientationChange.bind(this);
      this._onMouseWheel = this._onMouseWheel.bind(this);
      this._onMouseOut = this._onMouseOut.bind(this);
      this._onMouseEnter = this._onMouseEnter.bind(this);
      this._onContextMenu = this._onContextMenu.bind(this);
      this._onDoubleClick = this._onDoubleClick.bind(this);
      this._onDragOver = this._onDragOver.bind(this);
      this._onDragEnter = this._simpleEventHandler.bind(this, "dragenter");
      this._onDragLeave = this._simpleEventHandler.bind(this, "dragleave");
      this._onDrop = this._simpleEventHandler.bind(this, "drop");
      this.eventsBound = true;
    },
    _onGesture: function _onGesture(t, e) {
      this.__onTransformGesture && this.__onTransformGesture(t, e);
    },
    _onDrag: function _onDrag(t, e) {
      this.__onDrag && this.__onDrag(t, e);
    },
    _onMouseWheel: function _onMouseWheel(t) {
      this.__onMouseWheel(t);
    },
    _onMouseOut: function _onMouseOut(e) {
      var i = this._hoveredTarget;
      this.fire("mouse:out", {
        target: i,
        e: e
      });
      this._hoveredTarget = null;
      i && i.fire("mouseout", {
        e: e
      });
      var r = this;

      this._hoveredTargets.forEach(function (t) {
        r.fire("mouse:out", {
          target: i,
          e: e
        });
        t && i.fire("mouseout", {
          e: e
        });
      });

      this._hoveredTargets = [];

      if (this._iTextInstances) {
        this._iTextInstances.forEach(function (t) {
          if (t.isEditing) {
            t.hiddenTextarea.focus();
          }
        });
      }
    },
    _onMouseEnter: function _onMouseEnter(t) {
      if (!this.currentTransform && !this.findTarget(t)) {
        this.fire("mouse:over", {
          target: null,
          e: t
        });
        this._hoveredTarget = null;
        this._hoveredTargets = [];
      }
    },
    _onOrientationChange: function _onOrientationChange(t, e) {
      this.__onOrientationChange && this.__onOrientationChange(t, e);
    },
    _onShake: function _onShake(t, e) {
      this.__onShake && this.__onShake(t, e);
    },
    _onLongPress: function _onLongPress(t, e) {
      this.__onLongPress && this.__onLongPress(t, e);
    },
    _onDragOver: function _onDragOver(t) {
      t.preventDefault();

      var e = this._simpleEventHandler("dragover", t);

      this._fireEnterLeaveEvents(e, t);
    },
    _onContextMenu: function _onContextMenu(t) {
      if (this.stopContextMenu) {
        t.stopPropagation();
        t.preventDefault();
      }

      return false;
    },
    _onDoubleClick: function _onDoubleClick(t) {
      this._cacheTransformEventData(t);

      this._handleEvent(t, "dblclick");

      this._resetTransformEventData(t);
    },
    getPointerId: function getPointerId(t) {
      var e = t.changedTouches;

      if (e) {
        return e[0] && e[0].identifier;
      }

      if (this.enablePointerEvents) {
        return t.pointerId;
      }

      return -1;
    },
    _isMainEvent: function _isMainEvent(t) {
      if (t.isPrimary === true) {
        return true;
      }

      if (t.isPrimary === false) {
        return false;
      }

      if (t.type === "touchend" && t.touches.length === 0) {
        return true;
      }

      if (t.changedTouches) {
        return t.changedTouches[0].identifier === this.mainTouchId;
      }

      return true;
    },
    _onTouchStart: function _onTouchStart(t) {
      t.preventDefault();

      if (this.mainTouchId === null) {
        this.mainTouchId = this.getPointerId(t);
      }

      this.__onMouseDown(t);

      this._resetTransformEventData();

      var e = this.upperCanvasEl,
          i = this._getEventPrefix();

      r(fabric.document, "touchend", this._onTouchEnd, l);
      r(fabric.document, "touchmove", this._onMouseMove, l);
      s(e, i + "down", this._onMouseDown);
    },
    _onMouseDown: function _onMouseDown(t) {
      this.__onMouseDown(t);

      this._resetTransformEventData();

      var e = this.upperCanvasEl,
          i = this._getEventPrefix();

      s(e, i + "move", this._onMouseMove, l);
      r(fabric.document, i + "up", this._onMouseUp);
      r(fabric.document, i + "move", this._onMouseMove, l);
    },
    _onTouchEnd: function _onTouchEnd(t) {
      if (t.touches.length > 0) {
        return;
      }

      this.__onMouseUp(t);

      this._resetTransformEventData();

      this.mainTouchId = null;

      var e = this._getEventPrefix();

      s(fabric.document, "touchend", this._onTouchEnd, l);
      s(fabric.document, "touchmove", this._onMouseMove, l);
      var i = this;

      if (this._willAddMouseDown) {
        clearTimeout(this._willAddMouseDown);
      }

      this._willAddMouseDown = setTimeout(function () {
        r(i.upperCanvasEl, e + "down", i._onMouseDown);
        i._willAddMouseDown = 0;
      }, 400);
    },
    _onMouseUp: function _onMouseUp(t) {
      this.__onMouseUp(t);

      this._resetTransformEventData();

      var e = this.upperCanvasEl,
          i = this._getEventPrefix();

      if (this._isMainEvent(t)) {
        s(fabric.document, i + "up", this._onMouseUp);
        s(fabric.document, i + "move", this._onMouseMove, l);
        r(e, i + "move", this._onMouseMove, l);
      }
    },
    _onMouseMove: function _onMouseMove(t) {
      !this.allowTouchScrolling && t.preventDefault && t.preventDefault();

      this.__onMouseMove(t);
    },
    _onResize: function _onResize() {
      this.calcOffset();
    },
    _shouldRender: function _shouldRender(t) {
      var e = this._activeObject;

      if (!!e !== !!t || e && t && e !== t) {
        return true;
      } else if (e && e.isEditing) {
        return false;
      }

      return false;
    },
    __onMouseUp: function __onMouseUp(t) {
      var e,
          i = this._currentTransform,
          r = this._groupSelector,
          n = false,
          s = !r || r.left === 0 && r.top === 0;

      this._cacheTransformEventData(t);

      e = this._target;

      this._handleEvent(t, "up:before");

      if (h(t, o)) {
        if (this.fireRightClick) {
          this._handleEvent(t, "up", o, s);
        }

        return;
      }

      if (h(t, a)) {
        if (this.fireMiddleClick) {
          this._handleEvent(t, "up", a, s);
        }

        this._resetTransformEventData();

        return;
      }

      if (this.isDrawingMode && this._isCurrentlyDrawing) {
        this._onMouseUpInDrawingMode(t);

        return;
      }

      if (!this._isMainEvent(t)) {
        return;
      }

      if (i) {
        this._finalizeCurrentTransform(t);

        n = i.actionPerformed;
      }

      if (!s) {
        this._maybeGroupObjects(t);

        n || (n = this._shouldRender(e));
      }

      if (e) {
        e.isMoving = false;
      }

      this._setCursorFromEvent(t, e);

      this._handleEvent(t, "up", c, s);

      this._groupSelector = null;
      this._currentTransform = null;
      e && (e.__corner = 0);

      if (n) {
        this.requestRenderAll();
      } else if (!s) {
        this.renderTop();
      }
    },
    _simpleEventHandler: function _simpleEventHandler(t, e) {
      var i = this.findTarget(e),
          r = this.targets,
          n = {
        e: e,
        target: i,
        subTargets: r
      };
      this.fire(t, n);
      i && i.fire(t, n);

      if (!r) {
        return i;
      }

      for (var s = 0; s < r.length; s++) {
        r[s].fire(t, n);
      }

      return i;
    },
    _handleEvent: function _handleEvent(t, e, i, r) {
      var n = this._target,
          s = this.targets || [],
          o = {
        e: t,
        target: n,
        subTargets: s,
        button: i || c,
        isClick: r || false,
        pointer: this._pointer,
        absolutePointer: this._absolutePointer,
        transform: this._currentTransform
      };
      this.fire("mouse:" + e, o);
      n && n.fire("mouse" + e, o);

      for (var a = 0; a < s.length; a++) {
        s[a].fire("mouse" + e, o);
      }
    },
    _finalizeCurrentTransform: function _finalizeCurrentTransform(t) {
      var e = this._currentTransform,
          i = e.target,
          r,
          n = {
        e: t,
        target: i,
        transform: e
      };

      if (i._scaling) {
        i._scaling = false;
      }

      i.setCoords();

      if (e.actionPerformed || this.stateful && i.hasStateChanged()) {
        if (e.actionPerformed) {
          r = this._addEventOptions(n, e);

          this._fire(r, n);
        }

        this._fire("modified", n);
      }
    },
    _addEventOptions: function _addEventOptions(t, e) {
      var i, r;

      switch (e.action) {
        case "scaleX":
          i = "scaled";
          r = "x";
          break;

        case "scaleY":
          i = "scaled";
          r = "y";
          break;

        case "skewX":
          i = "skewed";
          r = "x";
          break;

        case "skewY":
          i = "skewed";
          r = "y";
          break;

        case "scale":
          i = "scaled";
          r = "equally";
          break;

        case "rotate":
          i = "rotated";
          break;

        case "drag":
          i = "moved";
          break;
      }

      t.by = r;
      return i;
    },
    _onMouseDownInDrawingMode: function _onMouseDownInDrawingMode(t) {
      this._isCurrentlyDrawing = true;

      if (this.getActiveObject()) {
        this.discardActiveObject(t).requestRenderAll();
      }

      if (this.clipTo) {
        fabric.util.clipContext(this, this.contextTop);
      }

      var e = this.getPointer(t);
      this.freeDrawingBrush.onMouseDown(e, {
        e: t,
        pointer: e
      });

      this._handleEvent(t, "down");
    },
    _onMouseMoveInDrawingMode: function _onMouseMoveInDrawingMode(t) {
      if (this._isCurrentlyDrawing) {
        var e = this.getPointer(t);
        this.freeDrawingBrush.onMouseMove(e, {
          e: t,
          pointer: e
        });
      }

      this.setCursor(this.freeDrawingCursor);

      this._handleEvent(t, "move");
    },
    _onMouseUpInDrawingMode: function _onMouseUpInDrawingMode(t) {
      if (this.clipTo) {
        this.contextTop.restore();
      }

      var e = this.getPointer(t);
      this._isCurrentlyDrawing = this.freeDrawingBrush.onMouseUp({
        e: t,
        pointer: e
      });

      this._handleEvent(t, "up");
    },
    __onMouseDown: function __onMouseDown(t) {
      this._cacheTransformEventData(t);

      this._handleEvent(t, "down:before");

      var e = this._target;

      if (h(t, o)) {
        if (this.fireRightClick) {
          this._handleEvent(t, "down", o);
        }

        return;
      }

      if (h(t, a)) {
        if (this.fireMiddleClick) {
          this._handleEvent(t, "down", a);
        }

        return;
      }

      if (this.isDrawingMode) {
        this._onMouseDownInDrawingMode(t);

        return;
      }

      if (!this._isMainEvent(t)) {
        return;
      }

      if (this._currentTransform) {
        return;
      }

      var i = this._pointer;
      this._previousPointer = i;

      var r = this._shouldRender(e),
          n = this._shouldGroup(t, e);

      if (this._shouldClearSelection(t, e)) {
        this.discardActiveObject(t);
      } else if (n) {
        this._handleGrouping(t, e);

        e = this._activeObject;
      }

      if (this.selection && (!e || !e.selectable && !e.isEditing && e !== this._activeObject)) {
        this._groupSelector = {
          ex: i.x,
          ey: i.y,
          top: 0,
          left: 0
        };
      }

      if (e) {
        var s = e === this._activeObject;

        if (e.selectable) {
          this.setActiveObject(e, t);
        }

        if (e === this._activeObject && (e.__corner || !n)) {
          this._setupCurrentTransform(t, e, s);
        }
      }

      this._handleEvent(t, "down");

      (r || n) && this.requestRenderAll();
    },
    _resetTransformEventData: function _resetTransformEventData() {
      this._target = null;
      this._pointer = null;
      this._absolutePointer = null;
    },
    _cacheTransformEventData: function _cacheTransformEventData(t) {
      this._resetTransformEventData();

      this._pointer = this.getPointer(t, true);
      this._absolutePointer = this.restorePointerVpt(this._pointer);
      this._target = this._currentTransform ? this._currentTransform.target : this.findTarget(t) || null;
    },
    _beforeTransform: function _beforeTransform(t) {
      var e = this._currentTransform;
      this.stateful && e.target.saveState();
      this.fire("before:transform", {
        e: t,
        transform: e
      });

      if (e.corner) {
        this.onBeforeScaleRotate(e.target);
      }
    },
    __onMouseMove: function __onMouseMove(t) {
      this._handleEvent(t, "move:before");

      this._cacheTransformEventData(t);

      var e, i;

      if (this.isDrawingMode) {
        this._onMouseMoveInDrawingMode(t);

        return;
      }

      if (!this._isMainEvent(t)) {
        return;
      }

      var r = this._groupSelector;

      if (r) {
        i = this._pointer;
        r.left = i.x - r.ex;
        r.top = i.y - r.ey;
        this.renderTop();
      } else if (!this._currentTransform) {
        e = this.findTarget(t) || null;

        this._setCursorFromEvent(t, e);

        this._fireOverOutEvents(e, t);
      } else {
        this._transformObject(t);
      }

      this._handleEvent(t, "move");

      this._resetTransformEventData();
    },
    _fireOverOutEvents: function _fireOverOutEvents(t, e) {
      var i = this._hoveredTarget,
          r = this._hoveredTargets,
          n = this.targets,
          s = Math.max(r.length, n.length);
      this.fireSyntheticInOutEvents(t, e, {
        oldTarget: i,
        evtOut: "mouseout",
        canvasEvtOut: "mouse:out",
        evtIn: "mouseover",
        canvasEvtIn: "mouse:over"
      });

      for (var o = 0; o < s; o++) {
        this.fireSyntheticInOutEvents(n[o], e, {
          oldTarget: r[o],
          evtOut: "mouseout",
          evtIn: "mouseover"
        });
      }

      this._hoveredTarget = t;
      this._hoveredTargets = this.targets.concat();
    },
    _fireEnterLeaveEvents: function _fireEnterLeaveEvents(t, e) {
      var i = this._draggedoverTarget,
          r = this._hoveredTargets,
          n = this.targets,
          s = Math.max(r.length, n.length);
      this.fireSyntheticInOutEvents(t, e, {
        oldTarget: i,
        evtOut: "dragleave",
        evtIn: "dragenter"
      });

      for (var o = 0; o < s; o++) {
        this.fireSyntheticInOutEvents(n[o], e, {
          oldTarget: r[o],
          evtOut: "dragleave",
          evtIn: "dragenter"
        });
      }

      this._draggedoverTarget = t;
    },
    fireSyntheticInOutEvents: function fireSyntheticInOutEvents(t, e, i) {
      var r,
          n,
          s = i.oldTarget,
          o,
          a,
          c = s !== t,
          l = i.canvasEvtIn,
          h = i.canvasEvtOut;

      if (c) {
        r = {
          e: e,
          target: t,
          previousTarget: s
        };
        n = {
          e: e,
          target: s,
          nextTarget: t
        };
      }

      a = t && c;
      o = s && c;

      if (o) {
        h && this.fire(h, n);
        s.fire(i.evtOut, n);
      }

      if (a) {
        l && this.fire(l, r);
        t.fire(i.evtIn, r);
      }
    },
    __onMouseWheel: function __onMouseWheel(t) {
      this._cacheTransformEventData(t);

      this._handleEvent(t, "wheel");

      this._resetTransformEventData();
    },
    _transformObject: function _transformObject(t) {
      var e = this.getPointer(t),
          i = this._currentTransform;
      i.reset = false;
      i.target.isMoving = true;
      i.shiftKey = t.shiftKey;
      i.altKey = t[this.centeredKey];

      this._beforeScaleTransform(t, i);

      this._performTransformAction(t, i, e);

      i.actionPerformed && this.requestRenderAll();
    },
    _performTransformAction: function _performTransformAction(t, e, i) {
      var r = i.x,
          n = i.y,
          s = e.action,
          o = false,
          a = {
        target: e.target,
        e: t,
        transform: e,
        pointer: i
      };

      if (s === "rotate") {
        (o = this._rotateObject(r, n)) && this._fire("rotating", a);
      } else if (s === "scale") {
        (o = this._onScale(t, e, r, n)) && this._fire("scaling", a);
      } else if (s === "scaleX") {
        (o = this._scaleObject(r, n, "x")) && this._fire("scaling", a);
      } else if (s === "scaleY") {
        (o = this._scaleObject(r, n, "y")) && this._fire("scaling", a);
      } else if (s === "skewX") {
        (o = this._skewObject(r, n, "x")) && this._fire("skewing", a);
      } else if (s === "skewY") {
        (o = this._skewObject(r, n, "y")) && this._fire("skewing", a);
      } else {
        o = this._translateObject(r, n);

        if (o) {
          this._fire("moving", a);

          this.setCursor(a.target.moveCursor || this.moveCursor);
        }
      }

      e.actionPerformed = e.actionPerformed || o;
    },
    _fire: function _fire(t, e) {
      this.fire("object:" + t, e);
      e.target.fire(t, e);
    },
    _beforeScaleTransform: function _beforeScaleTransform(t, e) {
      if (e.action === "scale" || e.action === "scaleX" || e.action === "scaleY") {
        var i = this._shouldCenterTransform(e.target);

        if (i && (e.originX !== "center" || e.originY !== "center") || !i && e.originX === "center" && e.originY === "center") {
          this._resetCurrentTransform();

          e.reset = true;
        }
      }
    },
    _onScale: function _onScale(t, e, i, r) {
      if (this._isUniscalePossible(t, e.target)) {
        e.currentAction = "scale";
        return this._scaleObject(i, r);
      } else {
        if (!e.reset && e.currentAction === "scale") {
          this._resetCurrentTransform();
        }

        e.currentAction = "scaleEqually";
        return this._scaleObject(i, r, "equally");
      }
    },
    _isUniscalePossible: function _isUniscalePossible(t, e) {
      return (t[this.uniScaleKey] || this.uniScaleTransform) && !e.get("lockUniScaling");
    },
    _setCursorFromEvent: function _setCursorFromEvent(t, e) {
      if (!e) {
        this.setCursor(this.defaultCursor);
        return false;
      }

      var i = e.hoverCursor || this.hoverCursor,
          r = this._activeObject && this._activeObject.type === "activeSelection" ? this._activeObject : null,
          n = (!r || !r.contains(e)) && e._findTargetCorner(this.getPointer(t, true));

      if (!n) {
        if (e.subTargetCheck) {
          this.targets.concat().reverse().map(function (t) {
            i = t.hoverCursor || i;
          });
        }

        this.setCursor(i);
      } else {
        this.setCursor(this.getCornerCursor(n, e, t));
      }
    },
    getCornerCursor: function getCornerCursor(t, e, i) {
      if (this.actionIsDisabled(t, e, i)) {
        return this.notAllowedCursor;
      } else if (t in n) {
        return this._getRotatedCornerCursor(t, e, i);
      } else if (t === "mtr" && e.hasRotatingPoint) {
        return this.rotationCursor;
      } else {
        return this.defaultCursor;
      }
    },
    actionIsDisabled: function actionIsDisabled(t, e, i) {
      if (t === "mt" || t === "mb") {
        return i[this.altActionKey] ? e.lockSkewingX : e.lockScalingY;
      } else if (t === "ml" || t === "mr") {
        return i[this.altActionKey] ? e.lockSkewingY : e.lockScalingX;
      } else if (t === "mtr") {
        return e.lockRotation;
      } else {
        return this._isUniscalePossible(i, e) ? e.lockScalingX && e.lockScalingY : e.lockScalingX || e.lockScalingY;
      }
    },
    _getRotatedCornerCursor: function _getRotatedCornerCursor(t, e, i) {
      var r = Math.round(e.angle % 360 / 45);

      if (r < 0) {
        r += 8;
      }

      r += n[t];

      if (i[this.altActionKey] && n[t] % 2 === 0) {
        r += 2;
      }

      r %= 8;
      return this.cursorMap[r];
    }
  });
})();

(function () {
  var u = Math.min,
      d = Math.max;
  fabric.util.object.extend(fabric.Canvas.prototype, {
    _shouldGroup: function _shouldGroup(t, e) {
      var i = this._activeObject;
      return i && this._isSelectionKeyPressed(t) && e && e.selectable && this.selection && (i !== e || i.type === "activeSelection") && !e.onSelect({
        e: t
      });
    },
    _handleGrouping: function _handleGrouping(t, e) {
      var i = this._activeObject;

      if (i.__corner) {
        return;
      }

      if (e === i) {
        e = this.findTarget(t, true);

        if (!e || !e.selectable) {
          return;
        }
      }

      if (i && i.type === "activeSelection") {
        this._updateActiveSelection(e, t);
      } else {
        this._createActiveSelection(e, t);
      }
    },
    _updateActiveSelection: function _updateActiveSelection(t, e) {
      var i = this._activeObject,
          r = i._objects.slice(0);

      if (i.contains(t)) {
        i.removeWithUpdate(t);
        this._hoveredTarget = t;
        this._hoveredTargets = this.targets.concat();

        if (i.size() === 1) {
          this._setActiveObject(i.item(0), e);
        }
      } else {
        i.addWithUpdate(t);
        this._hoveredTarget = i;
        this._hoveredTargets = this.targets.concat();
      }

      this._fireSelectionEvents(r, e);
    },
    _createActiveSelection: function _createActiveSelection(t, e) {
      var i = this.getActiveObjects(),
          r = this._createGroup(t);

      this._hoveredTarget = r;

      this._setActiveObject(r, e);

      this._fireSelectionEvents(i, e);
    },
    _createGroup: function _createGroup(t) {
      var e = this._objects,
          i = e.indexOf(this._activeObject) < e.indexOf(t),
          r = i ? [this._activeObject, t] : [t, this._activeObject];
      this._activeObject.isEditing && this._activeObject.exitEditing();
      return new fabric.ActiveSelection(r, {
        canvas: this
      });
    },
    _groupSelectedObjects: function _groupSelectedObjects(t) {
      var e = this._collectObjects(t),
          i;

      if (e.length === 1) {
        this.setActiveObject(e[0], t);
      } else if (e.length > 1) {
        i = new fabric.ActiveSelection(e.reverse(), {
          canvas: this
        });
        this.setActiveObject(i, t);
      }
    },
    _collectObjects: function _collectObjects(e) {
      var t = [],
          i,
          r = this._groupSelector.ex,
          n = this._groupSelector.ey,
          s = r + this._groupSelector.left,
          o = n + this._groupSelector.top,
          a = new fabric.Point(u(r, s), u(n, o)),
          c = new fabric.Point(d(r, s), d(n, o)),
          l = !this.selectionFullyContained,
          h = r === s && n === o;

      for (var f = this._objects.length; f--;) {
        i = this._objects[f];

        if (!i || !i.selectable || !i.visible) {
          continue;
        }

        if (l && i.intersectsWithRect(a, c) || i.isContainedWithinRect(a, c) || l && i.containsPoint(a) || l && i.containsPoint(c)) {
          t.push(i);

          if (h) {
            break;
          }
        }
      }

      if (t.length > 1) {
        t = t.filter(function (t) {
          return !t.onSelect({
            e: e
          });
        });
      }

      return t;
    },
    _maybeGroupObjects: function _maybeGroupObjects(t) {
      if (this.selection && this._groupSelector) {
        this._groupSelectedObjects(t);
      }

      this.setCursor(this.defaultCursor);
      this._groupSelector = null;
    }
  });
})();

(function () {
  fabric.util.object.extend(fabric.StaticCanvas.prototype, {
    toDataURL: function toDataURL(t) {
      t || (t = {});
      var e = t.format || "png",
          i = t.quality || 1,
          r = (t.multiplier || 1) * (t.enableRetinaScaling ? this.getRetinaScaling() : 1),
          n = this.toCanvasElement(r, t);
      return fabric.util.toDataURL(n, e, i);
    },
    toCanvasElement: function toCanvasElement(t, e) {
      t = t || 1;
      e = e || {};
      var i = (e.width || this.width) * t,
          r = (e.height || this.height) * t,
          n = this.getZoom(),
          s = this.width,
          o = this.height,
          a = n * t,
          c = this.viewportTransform,
          l = (c[4] - (e.left || 0)) * t,
          h = (c[5] - (e.top || 0)) * t,
          f = this.interactive,
          u = [a, 0, 0, a, l, h],
          d = this.enableRetinaScaling,
          g = fabric.util.createCanvasElement(),
          p = this.contextTop;
      g.width = i;
      g.height = r;
      this.contextTop = null;
      this.enableRetinaScaling = false;
      this.interactive = false;
      this.viewportTransform = u;
      this.width = i;
      this.height = r;
      this.calcViewportBoundaries();
      this.renderCanvas(g.getContext("2d"), this._objects);
      this.viewportTransform = c;
      this.width = s;
      this.height = o;
      this.calcViewportBoundaries();
      this.interactive = f;
      this.enableRetinaScaling = d;
      this.contextTop = p;
      return g;
    }
  });
})();

fabric.util.object.extend(fabric.StaticCanvas.prototype, {
  loadFromDatalessJSON: function loadFromDatalessJSON(t, e, i) {
    return this.loadFromJSON(t, e, i);
  },
  loadFromJSON: function loadFromJSON(t, i, e) {
    if (!t) {
      return;
    }

    var r = typeof t === "string" ? JSON.parse(t) : fabric.util.object.clone(t);
    var n = this,
        s = r.clipPath,
        o = this.renderOnAddRemove;
    this.renderOnAddRemove = false;
    delete r.clipPath;

    this._enlivenObjects(r.objects, function (e) {
      n.clear();

      n._setBgOverlay(r, function () {
        if (s) {
          n._enlivenObjects([s], function (t) {
            n.clipPath = t[0];

            n.__setupCanvas.call(n, r, e, o, i);
          });
        } else {
          n.__setupCanvas.call(n, r, e, o, i);
        }
      });
    }, e);

    return this;
  },
  __setupCanvas: function __setupCanvas(t, e, i, r) {
    var n = this;
    e.forEach(function (t, e) {
      n.insertAt(t, e);
    });
    this.renderOnAddRemove = i;
    delete t.objects;
    delete t.backgroundImage;
    delete t.overlayImage;
    delete t.background;
    delete t.overlay;

    this._setOptions(t);

    this.renderAll();
    r && r();
  },
  _setBgOverlay: function _setBgOverlay(t, e) {
    var i = {
      backgroundColor: false,
      overlayColor: false,
      backgroundImage: false,
      overlayImage: false
    };

    if (!t.backgroundImage && !t.overlayImage && !t.background && !t.overlay) {
      e && e();
      return;
    }

    var r = function r() {
      if (i.backgroundImage && i.overlayImage && i.backgroundColor && i.overlayColor) {
        e && e();
      }
    };

    this.__setBgOverlay("backgroundImage", t.backgroundImage, i, r);

    this.__setBgOverlay("overlayImage", t.overlayImage, i, r);

    this.__setBgOverlay("backgroundColor", t.background, i, r);

    this.__setBgOverlay("overlayColor", t.overlay, i, r);
  },
  __setBgOverlay: function __setBgOverlay(e, t, i, r) {
    var n = this;

    if (!t) {
      i[e] = true;
      r && r();
      return;
    }

    if (e === "backgroundImage" || e === "overlayImage") {
      fabric.util.enlivenObjects([t], function (t) {
        n[e] = t[0];
        i[e] = true;
        r && r();
      });
    } else {
      this["set" + fabric.util.string.capitalize(e, true)](t, function () {
        i[e] = true;
        r && r();
      });
    }
  },
  _enlivenObjects: function _enlivenObjects(t, e, i) {
    if (!t || t.length === 0) {
      e && e([]);
      return;
    }

    fabric.util.enlivenObjects(t, function (t) {
      e && e(t);
    }, null, i);
  },
  _toDataURL: function _toDataURL(e, i) {
    this.clone(function (t) {
      i(t.toDataURL(e));
    });
  },
  _toDataURLWithMultiplier: function _toDataURLWithMultiplier(e, i, r) {
    this.clone(function (t) {
      r(t.toDataURLWithMultiplier(e, i));
    });
  },
  clone: function clone(e, t) {
    var i = JSON.stringify(this.toJSON(t));
    this.cloneWithoutData(function (t) {
      t.loadFromJSON(i, function () {
        e && e(t);
      });
    });
  },
  cloneWithoutData: function cloneWithoutData(t) {
    var e = fabric.util.createCanvasElement();
    e.width = this.width;
    e.height = this.height;
    var i = new fabric.Canvas(e);
    i.clipTo = this.clipTo;

    if (this.backgroundImage) {
      i.setBackgroundImage(this.backgroundImage.src, function () {
        i.renderAll();
        t && t(i);
      });
      i.backgroundImageOpacity = this.backgroundImageOpacity;
      i.backgroundImageStretch = this.backgroundImageStretch;
    } else {
      t && t(i);
    }
  }
});

(function () {
  var r = fabric.util.degreesToRadians,
      n = fabric.util.radiansToDegrees;
  fabric.util.object.extend(fabric.Canvas.prototype, {
    __onTransformGesture: function __onTransformGesture(t, e) {
      if (this.isDrawingMode || !t.touches || t.touches.length !== 2 || "gesture" !== e.gesture) {
        return;
      }

      var i = this.findTarget(t);

      if ("undefined" !== typeof i) {
        this.__gesturesParams = {
          e: t,
          self: e,
          target: i
        };

        this.__gesturesRenderer();
      }

      this.fire("touch:gesture", {
        target: i,
        e: t,
        self: e
      });
    },
    __gesturesParams: null,
    __gesturesRenderer: function __gesturesRenderer() {
      if (this.__gesturesParams === null || this._currentTransform === null) {
        return;
      }

      var t = this.__gesturesParams.self,
          e = this._currentTransform,
          i = this.__gesturesParams.e;
      e.action = "scale";
      e.originX = e.originY = "center";

      this._scaleObjectBy(t.scale, i);

      if (t.rotation !== 0) {
        e.action = "rotate";

        this._rotateObjectByAngle(t.rotation, i);
      }

      this.requestRenderAll();
      e.action = "drag";
    },
    __onDrag: function __onDrag(t, e) {
      this.fire("touch:drag", {
        e: t,
        self: e
      });
    },
    __onOrientationChange: function __onOrientationChange(t, e) {
      this.fire("touch:orientation", {
        e: t,
        self: e
      });
    },
    __onShake: function __onShake(t, e) {
      this.fire("touch:shake", {
        e: t,
        self: e
      });
    },
    __onLongPress: function __onLongPress(t, e) {
      this.fire("touch:longpress", {
        e: t,
        self: e
      });
    },
    _scaleObjectBy: function _scaleObjectBy(t, e) {
      var i = this._currentTransform,
          r = i.target,
          n = r.get("lockScalingX"),
          s = r.get("lockScalingY");

      if (n && s) {
        return;
      }

      r._scaling = true;

      var o = r.translateToOriginPoint(r.getCenterPoint(), i.originX, i.originY),
          a = r._getTransformedDimensions();

      this._setObjectScale(new fabric.Point(i.scaleX * a.x * t / r.scaleX, i.scaleY * a.y * t / r.scaleY), i, n, s, null, r.get("lockScalingFlip"), a);

      r.setPositionByOrigin(o, i.originX, i.originY);

      this._fire("scaling", {
        target: r,
        e: e,
        transform: i
      });
    },
    _rotateObjectByAngle: function _rotateObjectByAngle(t, e) {
      var i = this._currentTransform;

      if (i.target.get("lockRotation")) {
        return;
      }

      i.target.rotate(n(r(t) + i.theta));

      this._fire("rotating", {
        target: i.target,
        e: e,
        transform: i
      });
    }
  });
})();

(function (t) {
  "use strict";

  var C = t.fabric || (t.fabric = {}),
      e = C.util.object.extend,
      o = C.util.object.clone,
      r = C.util.toFixed,
      i = C.util.string.capitalize,
      a = C.util.degreesToRadians,
      n = C.StaticCanvas.supports("setLineDash"),
      s = !C.isLikelyNode,
      c = 2;

  if (C.Object) {
    return;
  }

  C.Object = C.util.createClass(C.CommonMethods, {
    type: "object",
    originX: "left",
    originY: "top",
    top: 0,
    left: 0,
    width: 0,
    height: 0,
    scaleX: 1,
    scaleY: 1,
    flipX: false,
    flipY: false,
    opacity: 1,
    angle: 0,
    skewX: 0,
    skewY: 0,
    cornerSize: 13,
    transparentCorners: true,
    hoverCursor: null,
    moveCursor: null,
    padding: 0,
    borderColor: "rgba(102,153,255,0.75)",
    borderDashArray: null,
    cornerColor: "rgba(102,153,255,0.5)",
    cornerStrokeColor: null,
    cornerStyle: "rect",
    cornerDashArray: null,
    centeredScaling: false,
    centeredRotation: true,
    fill: "rgb(0,0,0)",
    fillRule: "nonzero",
    globalCompositeOperation: "source-over",
    backgroundColor: "",
    selectionBackgroundColor: "",
    stroke: null,
    strokeWidth: 1,
    strokeDashArray: null,
    strokeDashOffset: 0,
    strokeLineCap: "butt",
    strokeLineJoin: "miter",
    strokeMiterLimit: 4,
    shadow: null,
    borderOpacityWhenMoving: .4,
    borderScaleFactor: 1,
    transformMatrix: null,
    minScaleLimit: 0,
    selectable: true,
    evented: true,
    visible: true,
    hasControls: true,
    hasBorders: true,
    hasRotatingPoint: true,
    rotatingPointOffset: 40,
    perPixelTargetFind: false,
    includeDefaultValues: true,
    clipTo: null,
    lockMovementX: false,
    lockMovementY: false,
    lockRotation: false,
    lockScalingX: false,
    lockScalingY: false,
    lockUniScaling: false,
    lockSkewingX: false,
    lockSkewingY: false,
    lockScalingFlip: false,
    excludeFromExport: false,
    objectCaching: s,
    statefullCache: false,
    noScaleCache: true,
    strokeUniform: false,
    dirty: true,
    __corner: 0,
    paintFirst: "fill",
    stateProperties: ("top left width height scaleX scaleY flipX flipY originX originY transformMatrix " + "stroke strokeWidth strokeDashArray strokeLineCap strokeDashOffset strokeLineJoin strokeMiterLimit " + "angle opacity fill globalCompositeOperation shadow clipTo visible backgroundColor " + "skewX skewY fillRule paintFirst clipPath strokeUniform").split(" "),
    cacheProperties: ("fill stroke strokeWidth strokeDashArray width height paintFirst strokeUniform" + " strokeLineCap strokeDashOffset strokeLineJoin strokeMiterLimit backgroundColor clipPath").split(" "),
    clipPath: undefined,
    inverted: false,
    absolutePositioned: false,
    initialize: function initialize(t) {
      if (t) {
        this.setOptions(t);
      }
    },
    _createCacheCanvas: function _createCacheCanvas() {
      this._cacheProperties = {};
      this._cacheCanvas = C.util.createCanvasElement();
      this._cacheContext = this._cacheCanvas.getContext("2d");

      this._updateCacheCanvas();

      this.dirty = true;
    },
    _limitCacheSize: function _limitCacheSize(t) {
      var e = C.perfLimitSizeTotal,
          i = t.width,
          r = t.height,
          n = C.maxCacheSideLimit,
          s = C.minCacheSideLimit;

      if (i <= n && r <= n && i * r <= e) {
        if (i < s) {
          t.width = s;
        }

        if (r < s) {
          t.height = s;
        }

        return t;
      }

      var o = i / r,
          a = C.util.limitDimsByArea(o, e),
          c = C.util.capValue,
          l = c(s, a.x, n),
          h = c(s, a.y, n);

      if (i > l) {
        t.zoomX /= i / l;
        t.width = l;
        t.capped = true;
      }

      if (r > h) {
        t.zoomY /= r / h;
        t.height = h;
        t.capped = true;
      }

      return t;
    },
    _getCacheCanvasDimensions: function _getCacheCanvasDimensions() {
      var t = this.getTotalObjectScaling(),
          e = this._getTransformedDimensions(0, 0),
          i = e.x * t.scaleX / this.scaleX,
          r = e.y * t.scaleY / this.scaleY;

      return {
        width: i + c,
        height: r + c,
        zoomX: t.scaleX,
        zoomY: t.scaleY,
        x: i,
        y: r
      };
    },
    _updateCacheCanvas: function _updateCacheCanvas() {
      var t = this.canvas;

      if (this.noScaleCache && t && t._currentTransform) {
        var e = t._currentTransform.target,
            i = t._currentTransform.action;

        if (this === e && i.slice && i.slice(0, 5) === "scale") {
          return false;
        }
      }

      var r = this._cacheCanvas,
          n = this._limitCacheSize(this._getCacheCanvasDimensions()),
          s = C.minCacheSideLimit,
          o = n.width,
          a = n.height,
          c,
          l,
          h = n.zoomX,
          f = n.zoomY,
          u = o !== this.cacheWidth || a !== this.cacheHeight,
          d = this.zoomX !== h || this.zoomY !== f,
          g = u || d,
          p = 0,
          v = 0,
          m = false;

      if (u) {
        var b = this._cacheCanvas.width,
            y = this._cacheCanvas.height,
            _ = o > b || a > y,
            x = (o < b * .9 || a < y * .9) && b > s && y > s;

        m = _ || x;

        if (_ && !n.capped && (o > s || a > s)) {
          p = o * .1;
          v = a * .1;
        }
      }

      if (g) {
        if (m) {
          r.width = Math.ceil(o + p);
          r.height = Math.ceil(a + v);
        } else {
          this._cacheContext.setTransform(1, 0, 0, 1, 0, 0);

          this._cacheContext.clearRect(0, 0, r.width, r.height);
        }

        c = n.x / 2;
        l = n.y / 2;
        this.cacheTranslationX = Math.round(r.width / 2 - c) + c;
        this.cacheTranslationY = Math.round(r.height / 2 - l) + l;
        this.cacheWidth = o;
        this.cacheHeight = a;

        this._cacheContext.translate(this.cacheTranslationX, this.cacheTranslationY);

        this._cacheContext.scale(h, f);

        this.zoomX = h;
        this.zoomY = f;
        return true;
      }

      return false;
    },
    setOptions: function setOptions(t) {
      this._setOptions(t);

      this._initGradient(t.fill, "fill");

      this._initGradient(t.stroke, "stroke");

      this._initClipping(t);

      this._initPattern(t.fill, "fill");

      this._initPattern(t.stroke, "stroke");
    },
    transform: function transform(t) {
      var e;

      if (this.group && !this.group._transformDone) {
        e = this.calcTransformMatrix();
      } else {
        e = this.calcOwnMatrix();
      }

      t.transform(e[0], e[1], e[2], e[3], e[4], e[5]);
    },
    toObject: function toObject(t) {
      var e = C.Object.NUM_FRACTION_DIGITS,
          i = {
        type: this.type,
        version: C.version,
        originX: this.originX,
        originY: this.originY,
        left: r(this.left, e),
        top: r(this.top, e),
        width: r(this.width, e),
        height: r(this.height, e),
        fill: this.fill && this.fill.toObject ? this.fill.toObject() : this.fill,
        stroke: this.stroke && this.stroke.toObject ? this.stroke.toObject() : this.stroke,
        strokeWidth: r(this.strokeWidth, e),
        strokeDashArray: this.strokeDashArray ? this.strokeDashArray.concat() : this.strokeDashArray,
        strokeLineCap: this.strokeLineCap,
        strokeDashOffset: this.strokeDashOffset,
        strokeLineJoin: this.strokeLineJoin,
        strokeMiterLimit: r(this.strokeMiterLimit, e),
        scaleX: r(this.scaleX, e),
        scaleY: r(this.scaleY, e),
        angle: r(this.angle, e),
        flipX: this.flipX,
        flipY: this.flipY,
        opacity: r(this.opacity, e),
        shadow: this.shadow && this.shadow.toObject ? this.shadow.toObject() : this.shadow,
        visible: this.visible,
        clipTo: this.clipTo && String(this.clipTo),
        backgroundColor: this.backgroundColor,
        fillRule: this.fillRule,
        paintFirst: this.paintFirst,
        globalCompositeOperation: this.globalCompositeOperation,
        transformMatrix: this.transformMatrix ? this.transformMatrix.concat() : null,
        skewX: r(this.skewX, e),
        skewY: r(this.skewY, e)
      };

      if (this.clipPath) {
        i.clipPath = this.clipPath.toObject(t);
        i.clipPath.inverted = this.clipPath.inverted;
        i.clipPath.absolutePositioned = this.clipPath.absolutePositioned;
      }

      C.util.populateWithProperties(this, i, t);

      if (!this.includeDefaultValues) {
        i = this._removeDefaultValues(i);
      }

      return i;
    },
    toDatalessObject: function toDatalessObject(t) {
      return this.toObject(t);
    },
    _removeDefaultValues: function _removeDefaultValues(i) {
      var r = C.util.getKlass(i.type).prototype,
          t = r.stateProperties;
      t.forEach(function (t) {
        if (t === "left" || t === "top") {
          return;
        }

        if (i[t] === r[t]) {
          delete i[t];
        }

        var e = Object.prototype.toString.call(i[t]) === "[object Array]" && Object.prototype.toString.call(r[t]) === "[object Array]";

        if (e && i[t].length === 0 && r[t].length === 0) {
          delete i[t];
        }
      });
      return i;
    },
    toString: function toString() {
      return "#<fabric." + i(this.type) + ">";
    },
    getObjectScaling: function getObjectScaling() {
      var t = C.util.qrDecompose(this.calcTransformMatrix());
      return {
        scaleX: Math.abs(t.scaleX),
        scaleY: Math.abs(t.scaleY)
      };
    },
    getTotalObjectScaling: function getTotalObjectScaling() {
      var t = this.getObjectScaling(),
          e = t.scaleX,
          i = t.scaleY;

      if (this.canvas) {
        var r = this.canvas.getZoom();
        var n = this.canvas.getRetinaScaling();
        e *= r * n;
        i *= r * n;
      }

      return {
        scaleX: e,
        scaleY: i
      };
    },
    getObjectOpacity: function getObjectOpacity() {
      var t = this.opacity;

      if (this.group) {
        t *= this.group.getObjectOpacity();
      }

      return t;
    },
    _set: function _set(t, e) {
      var i = t === "scaleX" || t === "scaleY",
          r = this[t] !== e,
          n = false;

      if (i) {
        e = this._constrainScale(e);
      }

      if (t === "scaleX" && e < 0) {
        this.flipX = !this.flipX;
        e *= -1;
      } else if (t === "scaleY" && e < 0) {
        this.flipY = !this.flipY;
        e *= -1;
      } else if (t === "shadow" && e && !(e instanceof C.Shadow)) {
        e = new C.Shadow(e);
      } else if (t === "dirty" && this.group) {
        this.group.set("dirty", e);
      }

      this[t] = e;

      if (r) {
        n = this.group && this.group.isOnACache();

        if (this.cacheProperties.indexOf(t) > -1) {
          this.dirty = true;
          n && this.group.set("dirty", true);
        } else if (n && this.stateProperties.indexOf(t) > -1) {
          this.group.set("dirty", true);
        }
      }

      return this;
    },
    setOnGroup: function setOnGroup() {},
    getViewportTransform: function getViewportTransform() {
      if (this.canvas && this.canvas.viewportTransform) {
        return this.canvas.viewportTransform;
      }

      return C.iMatrix.concat();
    },
    isNotVisible: function isNotVisible() {
      return this.opacity === 0 || this.width === 0 && this.height === 0 && this.strokeWidth === 0 || !this.visible;
    },
    render: function render(t) {
      if (this.isNotVisible()) {
        return;
      }

      if (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen()) {
        return;
      }

      t.save();

      this._setupCompositeOperation(t);

      this.drawSelectionBackground(t);
      this.transform(t);

      this._setOpacity(t);

      this._setShadow(t, this);

      if (this.transformMatrix) {
        t.transform.apply(t, this.transformMatrix);
      }

      this.clipTo && C.util.clipContext(this, t);

      if (this.shouldCache()) {
        this.renderCache();
        this.drawCacheOnCanvas(t);
      } else {
        this._removeCacheCanvas();

        this.dirty = false;
        this.drawObject(t);

        if (this.objectCaching && this.statefullCache) {
          this.saveState({
            propertySet: "cacheProperties"
          });
        }
      }

      this.clipTo && t.restore();
      t.restore();
    },
    renderCache: function renderCache(t) {
      t = t || {};

      if (!this._cacheCanvas) {
        this._createCacheCanvas();
      }

      if (this.isCacheDirty()) {
        this.statefullCache && this.saveState({
          propertySet: "cacheProperties"
        });
        this.drawObject(this._cacheContext, t.forClipping);
        this.dirty = false;
      }
    },
    _removeCacheCanvas: function _removeCacheCanvas() {
      this._cacheCanvas = null;
      this.cacheWidth = 0;
      this.cacheHeight = 0;
    },
    hasStroke: function hasStroke() {
      return this.stroke && this.stroke !== "transparent" && this.strokeWidth !== 0;
    },
    hasFill: function hasFill() {
      return this.fill && this.fill !== "transparent";
    },
    needsItsOwnCache: function needsItsOwnCache() {
      if (this.paintFirst === "stroke" && this.hasFill() && this.hasStroke() && (0, _typeof2["default"])(this.shadow) === "object") {
        return true;
      }

      if (this.clipPath) {
        return true;
      }

      return false;
    },
    shouldCache: function shouldCache() {
      this.ownCaching = this.needsItsOwnCache() || this.objectCaching && (!this.group || !this.group.isOnACache());
      return this.ownCaching;
    },
    willDrawShadow: function willDrawShadow() {
      return !!this.shadow && (this.shadow.offsetX !== 0 || this.shadow.offsetY !== 0);
    },
    drawClipPathOnCache: function drawClipPathOnCache(t) {
      var e = this.clipPath;
      t.save();

      if (e.inverted) {
        t.globalCompositeOperation = "destination-out";
      } else {
        t.globalCompositeOperation = "destination-in";
      }

      if (e.absolutePositioned) {
        var i = C.util.invertTransform(this.calcTransformMatrix());
        t.transform(i[0], i[1], i[2], i[3], i[4], i[5]);
      }

      e.transform(t);
      t.scale(1 / e.zoomX, 1 / e.zoomY);
      t.drawImage(e._cacheCanvas, -e.cacheTranslationX, -e.cacheTranslationY);
      t.restore();
    },
    drawObject: function drawObject(t, e) {
      var i = this.fill,
          r = this.stroke;

      if (e) {
        this.fill = "black";
        this.stroke = "";

        this._setClippingProperties(t);
      } else {
        this._renderBackground(t);

        this._setStrokeStyles(t, this);

        this._setFillStyles(t, this);
      }

      this._render(t);

      this._drawClipPath(t);

      this.fill = i;
      this.stroke = r;
    },
    _drawClipPath: function _drawClipPath(t) {
      var e = this.clipPath;

      if (!e) {
        return;
      }

      e.canvas = this.canvas;
      e.shouldCache();
      e._transformDone = true;
      e.renderCache({
        forClipping: true
      });
      this.drawClipPathOnCache(t);
    },
    drawCacheOnCanvas: function drawCacheOnCanvas(t) {
      t.scale(1 / this.zoomX, 1 / this.zoomY);
      t.drawImage(this._cacheCanvas, -this.cacheTranslationX, -this.cacheTranslationY);
    },
    isCacheDirty: function isCacheDirty(t) {
      if (this.isNotVisible()) {
        return false;
      }

      if (this._cacheCanvas && !t && this._updateCacheCanvas()) {
        return true;
      } else {
        if (this.dirty || this.clipPath && this.clipPath.absolutePositioned || this.statefullCache && this.hasStateChanged("cacheProperties")) {
          if (this._cacheCanvas && !t) {
            var e = this.cacheWidth / this.zoomX;
            var i = this.cacheHeight / this.zoomY;

            this._cacheContext.clearRect(-e / 2, -i / 2, e, i);
          }

          return true;
        }
      }

      return false;
    },
    _renderBackground: function _renderBackground(t) {
      if (!this.backgroundColor) {
        return;
      }

      var e = this._getNonTransformedDimensions();

      t.fillStyle = this.backgroundColor;
      t.fillRect(-e.x / 2, -e.y / 2, e.x, e.y);

      this._removeShadow(t);
    },
    _setOpacity: function _setOpacity(t) {
      if (this.group && !this.group._transformDone) {
        t.globalAlpha = this.getObjectOpacity();
      } else {
        t.globalAlpha *= this.opacity;
      }
    },
    _setStrokeStyles: function _setStrokeStyles(t, e) {
      if (e.stroke) {
        t.lineWidth = e.strokeWidth;
        t.lineCap = e.strokeLineCap;
        t.lineDashOffset = e.strokeDashOffset;
        t.lineJoin = e.strokeLineJoin;
        t.miterLimit = e.strokeMiterLimit;
        t.strokeStyle = e.stroke.toLive ? e.stroke.toLive(t, this) : e.stroke;
      }
    },
    _setFillStyles: function _setFillStyles(t, e) {
      if (e.fill) {
        t.fillStyle = e.fill.toLive ? e.fill.toLive(t, this) : e.fill;
      }
    },
    _setClippingProperties: function _setClippingProperties(t) {
      t.globalAlpha = 1;
      t.strokeStyle = "transparent";
      t.fillStyle = "#000000";
    },
    _setLineDash: function _setLineDash(t, e, i) {
      if (!e || e.length === 0) {
        return;
      }

      if (1 & e.length) {
        e.push.apply(e, e);
      }

      if (n) {
        t.setLineDash(e);
      } else {
        i && i(t);
      }
    },
    _renderControls: function _renderControls(t, e) {
      var i = this.getViewportTransform(),
          r = this.calcTransformMatrix(),
          n,
          s,
          o;
      e = e || {};
      s = typeof e.hasBorders !== "undefined" ? e.hasBorders : this.hasBorders;
      o = typeof e.hasControls !== "undefined" ? e.hasControls : this.hasControls;
      r = C.util.multiplyTransformMatrices(i, r);
      n = C.util.qrDecompose(r);
      t.save();
      t.translate(n.translateX, n.translateY);
      t.lineWidth = 1 * this.borderScaleFactor;

      if (!this.group) {
        t.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
      }

      if (e.forActiveSelection) {
        t.rotate(a(n.angle));
        s && this.drawBordersInGroup(t, n, e);
      } else {
        t.rotate(a(this.angle));
        s && this.drawBorders(t, e);
      }

      o && this.drawControls(t, e);
      t.restore();
    },
    _setShadow: function _setShadow(t) {
      if (!this.shadow) {
        return;
      }

      var e = this.shadow,
          i = this.canvas,
          r,
          n = i && i.viewportTransform[0] || 1,
          s = i && i.viewportTransform[3] || 1;

      if (e.nonScaling) {
        r = {
          scaleX: 1,
          scaleY: 1
        };
      } else {
        r = this.getObjectScaling();
      }

      if (i && i._isRetinaScaling()) {
        n *= C.devicePixelRatio;
        s *= C.devicePixelRatio;
      }

      t.shadowColor = e.color;
      t.shadowBlur = e.blur * C.browserShadowBlurConstant * (n + s) * (r.scaleX + r.scaleY) / 4;
      t.shadowOffsetX = e.offsetX * n * r.scaleX;
      t.shadowOffsetY = e.offsetY * s * r.scaleY;
    },
    _removeShadow: function _removeShadow(t) {
      if (!this.shadow) {
        return;
      }

      t.shadowColor = "";
      t.shadowBlur = t.shadowOffsetX = t.shadowOffsetY = 0;
    },
    _applyPatternGradientTransform: function _applyPatternGradientTransform(t, e) {
      if (!e || !e.toLive) {
        return {
          offsetX: 0,
          offsetY: 0
        };
      }

      var i = e.gradientTransform || e.patternTransform;
      var r = -this.width / 2 + e.offsetX || 0,
          n = -this.height / 2 + e.offsetY || 0;

      if (e.gradientUnits === "percentage") {
        t.transform(this.width, 0, 0, this.height, r, n);
      } else {
        t.transform(1, 0, 0, 1, r, n);
      }

      if (i) {
        t.transform(i[0], i[1], i[2], i[3], i[4], i[5]);
      }

      return {
        offsetX: r,
        offsetY: n
      };
    },
    _renderPaintInOrder: function _renderPaintInOrder(t) {
      if (this.paintFirst === "stroke") {
        this._renderStroke(t);

        this._renderFill(t);
      } else {
        this._renderFill(t);

        this._renderStroke(t);
      }
    },
    _render: function _render() {},
    _renderFill: function _renderFill(t) {
      if (!this.fill) {
        return;
      }

      t.save();

      this._applyPatternGradientTransform(t, this.fill);

      if (this.fillRule === "evenodd") {
        t.fill("evenodd");
      } else {
        t.fill();
      }

      t.restore();
    },
    _renderStroke: function _renderStroke(t) {
      if (!this.stroke || this.strokeWidth === 0) {
        return;
      }

      if (this.shadow && !this.shadow.affectStroke) {
        this._removeShadow(t);
      }

      t.save();

      if (this.strokeUniform && this.group) {
        var e = this.getObjectScaling();
        t.scale(1 / e.scaleX, 1 / e.scaleY);
      } else if (this.strokeUniform) {
        t.scale(1 / this.scaleX, 1 / this.scaleY);
      }

      this._setLineDash(t, this.strokeDashArray, this._renderDashedStroke);

      if (this.stroke.toLive && this.stroke.gradientUnits === "percentage") {
        this._applyPatternForTransformedGradient(t, this.stroke);
      } else {
        this._applyPatternGradientTransform(t, this.stroke);
      }

      t.stroke();
      t.restore();
    },
    _applyPatternForTransformedGradient: function _applyPatternForTransformedGradient(t, e) {
      var i = this._limitCacheSize(this._getCacheCanvasDimensions()),
          r = C.util.createCanvasElement(),
          n,
          s = this.canvas.getRetinaScaling(),
          o = i.x / this.scaleX / s,
          a = i.y / this.scaleY / s;

      r.width = o;
      r.height = a;
      n = r.getContext("2d");
      n.beginPath();
      n.moveTo(0, 0);
      n.lineTo(o, 0);
      n.lineTo(o, a);
      n.lineTo(0, a);
      n.closePath();
      n.translate(o / 2, a / 2);
      n.scale(i.zoomX / this.scaleX / s, i.zoomY / this.scaleY / s);

      this._applyPatternGradientTransform(n, e);

      n.fillStyle = e.toLive(t);
      n.fill();
      t.translate(-this.width / 2 - this.strokeWidth / 2, -this.height / 2 - this.strokeWidth / 2);
      t.scale(s * this.scaleX / i.zoomX, s * this.scaleY / i.zoomY);
      t.strokeStyle = n.createPattern(r, "no-repeat");
    },
    _findCenterFromElement: function _findCenterFromElement() {
      return {
        x: this.left + this.width / 2,
        y: this.top + this.height / 2
      };
    },
    _assignTransformMatrixProps: function _assignTransformMatrixProps() {
      if (this.transformMatrix) {
        var t = C.util.qrDecompose(this.transformMatrix);
        this.flipX = false;
        this.flipY = false;
        this.set("scaleX", t.scaleX);
        this.set("scaleY", t.scaleY);
        this.angle = t.angle;
        this.skewX = t.skewX;
        this.skewY = 0;
      }
    },
    _removeTransformMatrix: function _removeTransformMatrix(t) {
      var e = this._findCenterFromElement();

      if (this.transformMatrix) {
        this._assignTransformMatrixProps();

        e = C.util.transformPoint(e, this.transformMatrix);
      }

      this.transformMatrix = null;

      if (t) {
        this.scaleX *= t.scaleX;
        this.scaleY *= t.scaleY;
        this.cropX = t.cropX;
        this.cropY = t.cropY;
        e.x += t.offsetLeft;
        e.y += t.offsetTop;
        this.width = t.width;
        this.height = t.height;
      }

      this.setPositionByOrigin(e, "center", "center");
    },
    clone: function clone(t, e) {
      var i = this.toObject(e);

      if (this.constructor.fromObject) {
        this.constructor.fromObject(i, t);
      } else {
        C.Object._fromObject("Object", i, t);
      }
    },
    cloneAsImage: function cloneAsImage(t, e) {
      var i = this.toCanvasElement(e);

      if (t) {
        t(new C.Image(i));
      }

      return this;
    },
    toCanvasElement: function toCanvasElement(t) {
      t || (t = {});
      var e = C.util,
          i = e.saveObjectTransform(this),
          r = this.group,
          n = this.shadow,
          s = Math.abs,
          o = (t.multiplier || 1) * (t.enableRetinaScaling ? C.devicePixelRatio : 1);
      delete this.group;

      if (t.withoutTransform) {
        e.resetObjectTransform(this);
      }

      if (t.withoutShadow) {
        this.shadow = null;
      }

      var a = C.util.createCanvasElement(),
          c = this.getBoundingRect(true, true),
          l = this.shadow,
          h,
          f = {
        x: 0,
        y: 0
      },
          u,
          d,
          g;

      if (l) {
        u = l.blur;

        if (l.nonScaling) {
          h = {
            scaleX: 1,
            scaleY: 1
          };
        } else {
          h = this.getObjectScaling();
        }

        f.x = 2 * Math.round(s(l.offsetX) + u) * s(h.scaleX);
        f.y = 2 * Math.round(s(l.offsetY) + u) * s(h.scaleY);
      }

      d = c.width + f.x;
      g = c.height + f.y;
      a.width = Math.ceil(d);
      a.height = Math.ceil(g);
      var p = new C.StaticCanvas(a, {
        enableRetinaScaling: false,
        renderOnAddRemove: false,
        skipOffscreen: false
      });

      if (t.format === "jpeg") {
        p.backgroundColor = "#fff";
      }

      this.setPositionByOrigin(new C.Point(p.width / 2, p.height / 2), "center", "center");
      var v = this.canvas;
      p.add(this);
      var m = p.toCanvasElement(o || 1, t);
      this.shadow = n;
      this.set("canvas", v);

      if (r) {
        this.group = r;
      }

      this.set(i).setCoords();
      p._objects = [];
      p.dispose();
      p = null;
      return m;
    },
    toDataURL: function toDataURL(t) {
      t || (t = {});
      return C.util.toDataURL(this.toCanvasElement(t), t.format || "png", t.quality || 1);
    },
    isType: function isType(t) {
      return this.type === t;
    },
    complexity: function complexity() {
      return 1;
    },
    toJSON: function toJSON(t) {
      return this.toObject(t);
    },
    setGradient: function setGradient(t, e) {
      e || (e = {});
      var i = {
        colorStops: []
      };
      i.type = e.type || (e.r1 || e.r2 ? "radial" : "linear");
      i.coords = {
        x1: e.x1,
        y1: e.y1,
        x2: e.x2,
        y2: e.y2
      };
      i.gradientUnits = e.gradientUnits || "pixels";

      if (e.r1 || e.r2) {
        i.coords.r1 = e.r1;
        i.coords.r2 = e.r2;
      }

      i.gradientTransform = e.gradientTransform;
      C.Gradient.prototype.addColorStop.call(i, e.colorStops);
      return this.set(t, C.Gradient.forObject(this, i));
    },
    setPatternFill: function setPatternFill(t, e) {
      return this.set("fill", new C.Pattern(t, e));
    },
    setShadow: function setShadow(t) {
      return this.set("shadow", t ? new C.Shadow(t) : null);
    },
    setColor: function setColor(t) {
      this.set("fill", t);
      return this;
    },
    rotate: function rotate(t) {
      var e = (this.originX !== "center" || this.originY !== "center") && this.centeredRotation;

      if (e) {
        this._setOriginToCenter();
      }

      this.set("angle", t);

      if (e) {
        this._resetOrigin();
      }

      return this;
    },
    centerH: function centerH() {
      this.canvas && this.canvas.centerObjectH(this);
      return this;
    },
    viewportCenterH: function viewportCenterH() {
      this.canvas && this.canvas.viewportCenterObjectH(this);
      return this;
    },
    centerV: function centerV() {
      this.canvas && this.canvas.centerObjectV(this);
      return this;
    },
    viewportCenterV: function viewportCenterV() {
      this.canvas && this.canvas.viewportCenterObjectV(this);
      return this;
    },
    center: function center() {
      this.canvas && this.canvas.centerObject(this);
      return this;
    },
    viewportCenter: function viewportCenter() {
      this.canvas && this.canvas.viewportCenterObject(this);
      return this;
    },
    getLocalPointer: function getLocalPointer(t, e) {
      e = e || this.canvas.getPointer(t);

      var i = new C.Point(e.x, e.y),
          r = this._getLeftTopCoords();

      if (this.angle) {
        i = C.util.rotatePoint(i, r, a(-this.angle));
      }

      return {
        x: i.x - r.x,
        y: i.y - r.y
      };
    },
    _setupCompositeOperation: function _setupCompositeOperation(t) {
      if (this.globalCompositeOperation) {
        t.globalCompositeOperation = this.globalCompositeOperation;
      }
    }
  });
  C.util.createAccessors && C.util.createAccessors(C.Object);
  e(C.Object.prototype, C.Observable);
  C.Object.NUM_FRACTION_DIGITS = 2;

  C.Object._fromObject = function (t, i, r, n) {
    var s = C[t];
    i = o(i, true);
    C.util.enlivenPatterns([i.fill, i.stroke], function (t) {
      if (typeof t[0] !== "undefined") {
        i.fill = t[0];
      }

      if (typeof t[1] !== "undefined") {
        i.stroke = t[1];
      }

      C.util.enlivenObjects([i.clipPath], function (t) {
        i.clipPath = t[0];
        var e = n ? new s(i[n], i) : new s(i);
        r && r(e);
      });
    });
  };

  C.Object.__uid = 0;
})(typeof exports !== "undefined" ? exports : void 0);

(function () {
  var a = fabric.util.degreesToRadians,
      h = {
    left: -.5,
    center: 0,
    right: .5
  },
      f = {
    top: -.5,
    center: 0,
    bottom: .5
  };
  fabric.util.object.extend(fabric.Object.prototype, {
    translateToGivenOrigin: function translateToGivenOrigin(t, e, i, r, n) {
      var s = t.x,
          o = t.y,
          a,
          c,
          l;

      if (typeof e === "string") {
        e = h[e];
      } else {
        e -= .5;
      }

      if (typeof r === "string") {
        r = h[r];
      } else {
        r -= .5;
      }

      a = r - e;

      if (typeof i === "string") {
        i = f[i];
      } else {
        i -= .5;
      }

      if (typeof n === "string") {
        n = f[n];
      } else {
        n -= .5;
      }

      c = n - i;

      if (a || c) {
        l = this._getTransformedDimensions();
        s = t.x + a * l.x;
        o = t.y + c * l.y;
      }

      return new fabric.Point(s, o);
    },
    translateToCenterPoint: function translateToCenterPoint(t, e, i) {
      var r = this.translateToGivenOrigin(t, e, i, "center", "center");

      if (this.angle) {
        return fabric.util.rotatePoint(r, t, a(this.angle));
      }

      return r;
    },
    translateToOriginPoint: function translateToOriginPoint(t, e, i) {
      var r = this.translateToGivenOrigin(t, "center", "center", e, i);

      if (this.angle) {
        return fabric.util.rotatePoint(r, t, a(this.angle));
      }

      return r;
    },
    getCenterPoint: function getCenterPoint() {
      var t = new fabric.Point(this.left, this.top);
      return this.translateToCenterPoint(t, this.originX, this.originY);
    },
    getPointByOrigin: function getPointByOrigin(t, e) {
      var i = this.getCenterPoint();
      return this.translateToOriginPoint(i, t, e);
    },
    toLocalPoint: function toLocalPoint(t, e, i) {
      var r = this.getCenterPoint(),
          n,
          s;

      if (typeof e !== "undefined" && typeof i !== "undefined") {
        n = this.translateToGivenOrigin(r, "center", "center", e, i);
      } else {
        n = new fabric.Point(this.left, this.top);
      }

      s = new fabric.Point(t.x, t.y);

      if (this.angle) {
        s = fabric.util.rotatePoint(s, r, -a(this.angle));
      }

      return s.subtractEquals(n);
    },
    setPositionByOrigin: function setPositionByOrigin(t, e, i) {
      var r = this.translateToCenterPoint(t, e, i),
          n = this.translateToOriginPoint(r, this.originX, this.originY);
      this.set("left", n.x);
      this.set("top", n.y);
    },
    adjustPosition: function adjustPosition(t) {
      var e = a(this.angle),
          i = this.getScaledWidth(),
          r = fabric.util.cos(e) * i,
          n = fabric.util.sin(e) * i,
          s,
          o;

      if (typeof this.originX === "string") {
        s = h[this.originX];
      } else {
        s = this.originX - .5;
      }

      if (typeof t === "string") {
        o = h[t];
      } else {
        o = t - .5;
      }

      this.left += r * (o - s);
      this.top += n * (o - s);
      this.setCoords();
      this.originX = t;
    },
    _setOriginToCenter: function _setOriginToCenter() {
      this._originalOriginX = this.originX;
      this._originalOriginY = this.originY;
      var t = this.getCenterPoint();
      this.originX = "center";
      this.originY = "center";
      this.left = t.x;
      this.top = t.y;
    },
    _resetOrigin: function _resetOrigin() {
      var t = this.translateToOriginPoint(this.getCenterPoint(), this._originalOriginX, this._originalOriginY);
      this.originX = this._originalOriginX;
      this.originY = this._originalOriginY;
      this.left = t.x;
      this.top = t.y;
      this._originalOriginX = null;
      this._originalOriginY = null;
    },
    _getLeftTopCoords: function _getLeftTopCoords() {
      return this.translateToOriginPoint(this.getCenterPoint(), "left", "top");
    }
  });
})();

(function () {
  function r(t) {
    return [new fabric.Point(t.tl.x, t.tl.y), new fabric.Point(t.tr.x, t.tr.y), new fabric.Point(t.br.x, t.br.y), new fabric.Point(t.bl.x, t.bl.y)];
  }

  var j = fabric.util.degreesToRadians,
      k = fabric.util.multiplyTransformMatrices,
      P = fabric.util.transformPoint;
  fabric.util.object.extend(fabric.Object.prototype, {
    oCoords: null,
    aCoords: null,
    ownMatrixCache: null,
    matrixCache: null,
    getCoords: function getCoords(t, e) {
      if (!this.oCoords) {
        this.setCoords();
      }

      var i = t ? this.aCoords : this.oCoords;
      return r(e ? this.calcCoords(t) : i);
    },
    intersectsWithRect: function intersectsWithRect(t, e, i, r) {
      var n = this.getCoords(i, r),
          s = fabric.Intersection.intersectPolygonRectangle(n, t, e);
      return s.status === "Intersection";
    },
    intersectsWithObject: function intersectsWithObject(t, e, i) {
      var r = fabric.Intersection.intersectPolygonPolygon(this.getCoords(e, i), t.getCoords(e, i));
      return r.status === "Intersection" || t.isContainedWithinObject(this, e, i) || this.isContainedWithinObject(t, e, i);
    },
    isContainedWithinObject: function isContainedWithinObject(t, e, i) {
      var r = this.getCoords(e, i),
          n = 0,
          s = t._getImageLines(i ? t.calcCoords(e) : e ? t.aCoords : t.oCoords);

      for (; n < 4; n++) {
        if (!t.containsPoint(r[n], s)) {
          return false;
        }
      }

      return true;
    },
    isContainedWithinRect: function isContainedWithinRect(t, e, i, r) {
      var n = this.getBoundingRect(i, r);
      return n.left >= t.x && n.left + n.width <= e.x && n.top >= t.y && n.top + n.height <= e.y;
    },
    containsPoint: function containsPoint(t, e, i, r) {
      var e = e || this._getImageLines(r ? this.calcCoords(i) : i ? this.aCoords : this.oCoords),
          n = this._findCrossPoints(t, e);

      return n !== 0 && n % 2 === 1;
    },
    isOnScreen: function isOnScreen(t) {
      if (!this.canvas) {
        return false;
      }

      var e = this.canvas.vptCoords.tl,
          i = this.canvas.vptCoords.br;
      var r = this.getCoords(true, t),
          n;

      for (var s = 0; s < 4; s++) {
        n = r[s];

        if (n.x <= i.x && n.x >= e.x && n.y <= i.y && n.y >= e.y) {
          return true;
        }
      }

      if (this.intersectsWithRect(e, i, true, t)) {
        return true;
      }

      return this._containsCenterOfCanvas(e, i, t);
    },
    _containsCenterOfCanvas: function _containsCenterOfCanvas(t, e, i) {
      var r = {
        x: (t.x + e.x) / 2,
        y: (t.y + e.y) / 2
      };

      if (this.containsPoint(r, null, true, i)) {
        return true;
      }

      return false;
    },
    isPartiallyOnScreen: function isPartiallyOnScreen(t) {
      if (!this.canvas) {
        return false;
      }

      var e = this.canvas.vptCoords.tl,
          i = this.canvas.vptCoords.br;

      if (this.intersectsWithRect(e, i, true, t)) {
        return true;
      }

      return this._containsCenterOfCanvas(e, i, t);
    },
    _getImageLines: function _getImageLines(t) {
      return {
        topline: {
          o: t.tl,
          d: t.tr
        },
        rightline: {
          o: t.tr,
          d: t.br
        },
        bottomline: {
          o: t.br,
          d: t.bl
        },
        leftline: {
          o: t.bl,
          d: t.tl
        }
      };
    },
    _findCrossPoints: function _findCrossPoints(t, e) {
      var i,
          r,
          n,
          s,
          o,
          a = 0,
          c;

      for (var l in e) {
        c = e[l];

        if (c.o.y < t.y && c.d.y < t.y) {
          continue;
        }

        if (c.o.y >= t.y && c.d.y >= t.y) {
          continue;
        }

        if (c.o.x === c.d.x && c.o.x >= t.x) {
          o = c.o.x;
        } else {
          i = 0;
          r = (c.d.y - c.o.y) / (c.d.x - c.o.x);
          n = t.y - i * t.x;
          s = c.o.y - r * c.o.x;
          o = -(n - s) / (i - r);
        }

        if (o >= t.x) {
          a += 1;
        }

        if (a === 2) {
          break;
        }
      }

      return a;
    },
    getBoundingRect: function getBoundingRect(t, e) {
      var i = this.getCoords(t, e);
      return fabric.util.makeBoundingBoxFromPoints(i);
    },
    getScaledWidth: function getScaledWidth() {
      return this._getTransformedDimensions().x;
    },
    getScaledHeight: function getScaledHeight() {
      return this._getTransformedDimensions().y;
    },
    _constrainScale: function _constrainScale(t) {
      if (Math.abs(t) < this.minScaleLimit) {
        if (t < 0) {
          return -this.minScaleLimit;
        } else {
          return this.minScaleLimit;
        }
      } else if (t === 0) {
        return 1e-4;
      }

      return t;
    },
    scale: function scale(t) {
      this._set("scaleX", t);

      this._set("scaleY", t);

      return this.setCoords();
    },
    scaleToWidth: function scaleToWidth(t, e) {
      var i = this.getBoundingRect(e).width / this.getScaledWidth();
      return this.scale(t / this.width / i);
    },
    scaleToHeight: function scaleToHeight(t, e) {
      var i = this.getBoundingRect(e).height / this.getScaledHeight();
      return this.scale(t / this.height / i);
    },
    calcCoords: function calcCoords(t) {
      var e = this._calcRotateMatrix(),
          i = this._calcTranslateMatrix(),
          r = k(i, e),
          n = this.getViewportTransform(),
          s = t ? r : k(n, r),
          o = this._getTransformedDimensions(),
          a = o.x / 2,
          c = o.y / 2,
          l = P({
        x: -a,
        y: -c
      }, s),
          h = P({
        x: a,
        y: -c
      }, s),
          f = P({
        x: -a,
        y: c
      }, s),
          u = P({
        x: a,
        y: c
      }, s);

      if (!t) {
        var d = this.padding,
            g = j(this.angle),
            p = fabric.util.cos(g),
            v = fabric.util.sin(g),
            m = p * d,
            b = v * d,
            y = m + b,
            _ = m - b;

        if (d) {
          l.x -= _;
          l.y -= y;
          h.x += y;
          h.y -= _;
          f.x -= y;
          f.y += _;
          u.x += _;
          u.y += y;
        }

        var x = new fabric.Point((l.x + f.x) / 2, (l.y + f.y) / 2),
            C = new fabric.Point((h.x + l.x) / 2, (h.y + l.y) / 2),
            w = new fabric.Point((u.x + h.x) / 2, (u.y + h.y) / 2),
            S = new fabric.Point((u.x + f.x) / 2, (u.y + f.y) / 2),
            T = new fabric.Point(C.x + v * this.rotatingPointOffset, C.y - p * this.rotatingPointOffset);
      }

      var O = {
        tl: l,
        tr: h,
        br: u,
        bl: f
      };

      if (!t) {
        O.ml = x;
        O.mt = C;
        O.mr = w;
        O.mb = S;
        O.mtr = T;
      }

      return O;
    },
    setCoords: function setCoords(t, e) {
      this.oCoords = this.calcCoords(t);

      if (!e) {
        this.aCoords = this.calcCoords(true);
      }

      t || this._setCornerCoords && this._setCornerCoords();
      return this;
    },
    _calcRotateMatrix: function _calcRotateMatrix() {
      return fabric.util.calcRotateMatrix(this);
    },
    _calcTranslateMatrix: function _calcTranslateMatrix() {
      var t = this.getCenterPoint();
      return [1, 0, 0, 1, t.x, t.y];
    },
    transformMatrixKey: function transformMatrixKey(t) {
      var e = "_",
          i = "";

      if (!t && this.group) {
        i = this.group.transformMatrixKey(t) + e;
      }

      return i + this.top + e + this.left + e + this.scaleX + e + this.scaleY + e + this.skewX + e + this.skewY + e + this.angle + e + this.originX + e + this.originY + e + this.width + e + this.height + e + this.strokeWidth + this.flipX + this.flipY;
    },
    calcTransformMatrix: function calcTransformMatrix(t) {
      if (t) {
        return this.calcOwnMatrix();
      }

      var e = this.transformMatrixKey(),
          i = this.matrixCache || (this.matrixCache = {});

      if (i.key === e) {
        return i.value;
      }

      var r = this.calcOwnMatrix();

      if (this.group) {
        r = k(this.group.calcTransformMatrix(), r);
      }

      i.key = e;
      i.value = r;
      return r;
    },
    calcOwnMatrix: function calcOwnMatrix() {
      var t = this.transformMatrixKey(true),
          e = this.ownMatrixCache || (this.ownMatrixCache = {});

      if (e.key === t) {
        return e.value;
      }

      var i = this._calcTranslateMatrix();

      this.translateX = i[4];
      this.translateY = i[5];
      e.key = t;
      e.value = fabric.util.composeMatrix(this);
      return e.value;
    },
    _calcDimensionsTransformMatrix: function _calcDimensionsTransformMatrix(t, e, i) {
      return fabric.util.calcDimensionsMatrix({
        skewX: t,
        skewY: e,
        scaleX: this.scaleX * (i && this.flipX ? -1 : 1),
        scaleY: this.scaleY * (i && this.flipY ? -1 : 1)
      });
    },
    _getNonTransformedDimensions: function _getNonTransformedDimensions() {
      var t = this.strokeWidth,
          e = this.width + t,
          i = this.height + t;
      return {
        x: e,
        y: i
      };
    },
    _getTransformedDimensions: function _getTransformedDimensions(t, e) {
      if (typeof t === "undefined") {
        t = this.skewX;
      }

      if (typeof e === "undefined") {
        e = this.skewY;
      }

      var i = this._getNonTransformedDimensions(),
          r,
          n,
          s = t === 0 && e === 0;

      if (this.strokeUniform) {
        r = this.width;
        n = this.height;
      } else {
        r = i.x;
        n = i.y;
      }

      if (s) {
        return this._finalizeDimensions(r * this.scaleX, n * this.scaleY);
      } else {
        r /= 2;
        n /= 2;
      }

      var o = [{
        x: -r,
        y: -n
      }, {
        x: r,
        y: -n
      }, {
        x: -r,
        y: n
      }, {
        x: r,
        y: n
      }],
          a = fabric.util.calcDimensionsMatrix({
        scaleX: this.scaleX,
        scaleY: this.scaleY,
        skewX: t,
        skewY: e
      }),
          c = fabric.util.makeBoundingBoxFromPoints(o, a);
      return this._finalizeDimensions(c.width, c.height);
    },
    _finalizeDimensions: function _finalizeDimensions(t, e) {
      return this.strokeUniform ? {
        x: t + this.strokeWidth,
        y: e + this.strokeWidth
      } : {
        x: t,
        y: e
      };
    },
    _calculateCurrentDimensions: function _calculateCurrentDimensions() {
      var t = this.getViewportTransform(),
          e = this._getTransformedDimensions(),
          i = fabric.util.transformPoint(e, t, true);

      return i.scalarAdd(2 * this.padding);
    }
  });
})();

fabric.util.object.extend(fabric.Object.prototype, {
  sendToBack: function sendToBack() {
    if (this.group) {
      fabric.StaticCanvas.prototype.sendToBack.call(this.group, this);
    } else if (this.canvas) {
      this.canvas.sendToBack(this);
    }

    return this;
  },
  bringToFront: function bringToFront() {
    if (this.group) {
      fabric.StaticCanvas.prototype.bringToFront.call(this.group, this);
    } else if (this.canvas) {
      this.canvas.bringToFront(this);
    }

    return this;
  },
  sendBackwards: function sendBackwards(t) {
    if (this.group) {
      fabric.StaticCanvas.prototype.sendBackwards.call(this.group, this, t);
    } else if (this.canvas) {
      this.canvas.sendBackwards(this, t);
    }

    return this;
  },
  bringForward: function bringForward(t) {
    if (this.group) {
      fabric.StaticCanvas.prototype.bringForward.call(this.group, this, t);
    } else if (this.canvas) {
      this.canvas.bringForward(this, t);
    }

    return this;
  },
  moveTo: function moveTo(t) {
    if (this.group && this.group.type !== "activeSelection") {
      fabric.StaticCanvas.prototype.moveTo.call(this.group, this, t);
    } else if (this.canvas) {
      this.canvas.moveTo(this, t);
    }

    return this;
  }
});

(function () {
  var s = fabric.util.object.extend,
      r = "stateProperties";

  function n(e, t, i) {
    var r = {},
        n = true;
    i.forEach(function (t) {
      r[t] = e[t];
    });
    s(e[t], r, n);
  }

  function a(t, e, i) {
    if (t === e) {
      return true;
    } else if (Array.isArray(t)) {
      if (!Array.isArray(e) || t.length !== e.length) {
        return false;
      }

      for (var r = 0, n = t.length; r < n; r++) {
        if (!a(t[r], e[r])) {
          return false;
        }
      }

      return true;
    } else if (t && (0, _typeof2["default"])(t) === "object") {
      var s = Object.keys(t),
          o;

      if (!e || (0, _typeof2["default"])(e) !== "object" || !i && s.length !== Object.keys(e).length) {
        return false;
      }

      for (var r = 0, n = s.length; r < n; r++) {
        o = s[r];

        if (o === "canvas") {
          continue;
        }

        if (!a(t[o], e[o])) {
          return false;
        }
      }

      return true;
    }
  }

  fabric.util.object.extend(fabric.Object.prototype, {
    hasStateChanged: function hasStateChanged(t) {
      t = t || r;
      var e = "_" + t;

      if (Object.keys(this[e]).length < this[t].length) {
        return true;
      }

      return !a(this[e], this, true);
    },
    saveState: function saveState(t) {
      var e = t && t.propertySet || r,
          i = "_" + e;

      if (!this[i]) {
        return this.setupState(t);
      }

      n(this, i, this[e]);

      if (t && t.stateProperties) {
        n(this, i, t.stateProperties);
      }

      return this;
    },
    setupState: function setupState(t) {
      t = t || {};
      var e = t.propertySet || r;
      t.propertySet = e;
      this["_" + e] = {};
      this.saveState(t);
      return this;
    }
  });
})();

(function () {
  var c = fabric.util.degreesToRadians;
  fabric.util.object.extend(fabric.Object.prototype, {
    _controlsVisibility: null,
    _findTargetCorner: function _findTargetCorner(t) {
      if (!this.hasControls || this.group || !this.canvas || this.canvas._activeObject !== this) {
        return false;
      }

      var e = t.x,
          i = t.y,
          r,
          n;
      this.__corner = 0;

      for (var s in this.oCoords) {
        if (!this.isControlVisible(s)) {
          continue;
        }

        if (s === "mtr" && !this.hasRotatingPoint) {
          continue;
        }

        if (this.get("lockUniScaling") && (s === "mt" || s === "mr" || s === "mb" || s === "ml")) {
          continue;
        }

        n = this._getImageLines(this.oCoords[s].corner);
        r = this._findCrossPoints({
          x: e,
          y: i
        }, n);

        if (r !== 0 && r % 2 === 1) {
          this.__corner = s;
          return s;
        }
      }

      return false;
    },
    _setCornerCoords: function _setCornerCoords() {
      var t = this.oCoords,
          e = c(45 - this.angle),
          i = this.cornerSize * .707106,
          r = i * fabric.util.cos(e),
          n = i * fabric.util.sin(e),
          s,
          o;

      for (var a in t) {
        s = t[a].x;
        o = t[a].y;
        t[a].corner = {
          tl: {
            x: s - n,
            y: o - r
          },
          tr: {
            x: s + r,
            y: o - n
          },
          bl: {
            x: s - r,
            y: o + n
          },
          br: {
            x: s + n,
            y: o + r
          }
        };
      }
    },
    drawSelectionBackground: function drawSelectionBackground(t) {
      if (!this.selectionBackgroundColor || this.canvas && !this.canvas.interactive || this.canvas && this.canvas._activeObject !== this) {
        return this;
      }

      t.save();

      var e = this.getCenterPoint(),
          i = this._calculateCurrentDimensions(),
          r = this.canvas.viewportTransform;

      t.translate(e.x, e.y);
      t.scale(1 / r[0], 1 / r[3]);
      t.rotate(c(this.angle));
      t.fillStyle = this.selectionBackgroundColor;
      t.fillRect(-i.x / 2, -i.y / 2, i.x, i.y);
      t.restore();
      return this;
    },
    drawBorders: function drawBorders(t, e) {
      e = e || {};

      var i = this._calculateCurrentDimensions(),
          r = this.borderScaleFactor,
          n = i.x + r,
          s = i.y + r,
          o = typeof e.hasRotatingPoint !== "undefined" ? e.hasRotatingPoint : this.hasRotatingPoint,
          a = typeof e.hasControls !== "undefined" ? e.hasControls : this.hasControls,
          c = typeof e.rotatingPointOffset !== "undefined" ? e.rotatingPointOffset : this.rotatingPointOffset;

      t.save();
      t.strokeStyle = e.borderColor || this.borderColor;

      this._setLineDash(t, e.borderDashArray || this.borderDashArray, null);

      t.strokeRect(-n / 2, -s / 2, n, s);

      if (o && this.isControlVisible("mtr") && a) {
        var l = -s / 2;
        t.beginPath();
        t.moveTo(0, l);
        t.lineTo(0, l - c);
        t.stroke();
      }

      t.restore();
      return this;
    },
    drawBordersInGroup: function drawBordersInGroup(t, e, i) {
      i = i || {};
      var r = {
        x: this.width,
        y: this.height
      },
          n = fabric.util.composeMatrix({
        scaleX: e.scaleX,
        scaleY: e.scaleY,
        skewX: e.skewX
      }),
          s = fabric.util.transformPoint(r, n),
          o = this.strokeWidth,
          a = this.borderScaleFactor,
          c = s.x + o * (this.strokeUniform ? this.canvas.getZoom() : e.scaleX) + a,
          l = s.y + o * (this.strokeUniform ? this.canvas.getZoom() : e.scaleY) + a;
      t.save();

      this._setLineDash(t, i.borderDashArray || this.borderDashArray, null);

      t.strokeStyle = i.borderColor || this.borderColor;
      t.strokeRect(-c / 2, -l / 2, c, l);
      t.restore();
      return this;
    },
    drawControls: function drawControls(t, e) {
      e = e || {};

      var i = this._calculateCurrentDimensions(),
          r = i.x,
          n = i.y,
          s = e.cornerSize || this.cornerSize,
          o = -(r + s) / 2,
          a = -(n + s) / 2,
          c = typeof e.transparentCorners !== "undefined" ? e.transparentCorners : this.transparentCorners,
          l = typeof e.hasRotatingPoint !== "undefined" ? e.hasRotatingPoint : this.hasRotatingPoint,
          h = c ? "stroke" : "fill";

      t.save();
      t.strokeStyle = t.fillStyle = e.cornerColor || this.cornerColor;

      if (!this.transparentCorners) {
        t.strokeStyle = e.cornerStrokeColor || this.cornerStrokeColor;
      }

      this._setLineDash(t, e.cornerDashArray || this.cornerDashArray, null);

      this._drawControl("tl", t, h, o, a, e);

      this._drawControl("tr", t, h, o + r, a, e);

      this._drawControl("bl", t, h, o, a + n, e);

      this._drawControl("br", t, h, o + r, a + n, e);

      if (!this.get("lockUniScaling")) {
        this._drawControl("mt", t, h, o + r / 2, a, e);

        this._drawControl("mb", t, h, o + r / 2, a + n, e);

        this._drawControl("mr", t, h, o + r, a + n / 2, e);

        this._drawControl("ml", t, h, o, a + n / 2, e);
      }

      if (l) {
        this._drawControl("mtr", t, h, o + r / 2, a - this.rotatingPointOffset, e);
      }

      t.restore();
      return this;
    },
    _drawControl: function _drawControl(t, e, i, r, n, s) {
      s = s || {};

      if (!this.isControlVisible(t)) {
        return;
      }

      var o = this.cornerSize,
          a = !this.transparentCorners && this.cornerStrokeColor;

      switch (s.cornerStyle || this.cornerStyle) {
        case "circle":
          e.beginPath();
          e.arc(r + o / 2, n + o / 2, o / 2, 0, 2 * Math.PI, false);
          e[i]();

          if (a) {
            e.stroke();
          }

          break;

        default:
          this.transparentCorners || e.clearRect(r, n, o, o);
          e[i + "Rect"](r, n, o, o);

          if (a) {
            e.strokeRect(r, n, o, o);
          }

      }
    },
    isControlVisible: function isControlVisible(t) {
      return this._getControlsVisibility()[t];
    },
    setControlVisible: function setControlVisible(t, e) {
      this._getControlsVisibility()[t] = e;
      return this;
    },
    setControlsVisibility: function setControlsVisibility(t) {
      t || (t = {});

      for (var e in t) {
        this.setControlVisible(e, t[e]);
      }

      return this;
    },
    _getControlsVisibility: function _getControlsVisibility() {
      if (!this._controlsVisibility) {
        this._controlsVisibility = {
          tl: true,
          tr: true,
          br: true,
          bl: true,
          ml: true,
          mt: true,
          mr: true,
          mb: true,
          mtr: true
        };
      }

      return this._controlsVisibility;
    },
    onDeselect: function onDeselect() {},
    onSelect: function onSelect() {}
  });
})();

fabric.util.object.extend(fabric.StaticCanvas.prototype, {
  FX_DURATION: 500,
  fxCenterObjectH: function fxCenterObjectH(e, t) {
    t = t || {};

    var i = function i() {},
        r = t.onComplete || i,
        n = t.onChange || i,
        s = this;

    fabric.util.animate({
      startValue: e.left,
      endValue: this.getCenter().left,
      duration: this.FX_DURATION,
      onChange: function onChange(t) {
        e.set("left", t);
        s.requestRenderAll();
        n();
      },
      onComplete: function onComplete() {
        e.setCoords();
        r();
      }
    });
    return this;
  },
  fxCenterObjectV: function fxCenterObjectV(e, t) {
    t = t || {};

    var i = function i() {},
        r = t.onComplete || i,
        n = t.onChange || i,
        s = this;

    fabric.util.animate({
      startValue: e.top,
      endValue: this.getCenter().top,
      duration: this.FX_DURATION,
      onChange: function onChange(t) {
        e.set("top", t);
        s.requestRenderAll();
        n();
      },
      onComplete: function onComplete() {
        e.setCoords();
        r();
      }
    });
    return this;
  },
  fxRemove: function fxRemove(e, t) {
    t = t || {};

    var i = function i() {},
        r = t.onComplete || i,
        n = t.onChange || i,
        s = this;

    fabric.util.animate({
      startValue: e.opacity,
      endValue: 0,
      duration: this.FX_DURATION,
      onChange: function onChange(t) {
        e.set("opacity", t);
        s.requestRenderAll();
        n();
      },
      onComplete: function onComplete() {
        s.remove(e);
        r();
      }
    });
    return this;
  }
});
fabric.util.object.extend(fabric.Object.prototype, {
  animate: function animate() {
    if (arguments[0] && (0, _typeof2["default"])(arguments[0]) === "object") {
      var t = [],
          e,
          i;

      for (e in arguments[0]) {
        t.push(e);
      }

      for (var r = 0, n = t.length; r < n; r++) {
        e = t[r];
        i = r !== n - 1;

        this._animate(e, arguments[0][e], arguments[1], i);
      }
    } else {
      this._animate.apply(this, arguments);
    }

    return this;
  },
  _animate: function _animate(r, t, n, s) {
    var o = this,
        a;
    t = t.toString();

    if (!n) {
      n = {};
    } else {
      n = fabric.util.object.clone(n);
    }

    if (~r.indexOf(".")) {
      a = r.split(".");
    }

    var e = a ? this.get(a[0])[a[1]] : this.get(r);

    if (!("from" in n)) {
      n.from = e;
    }

    if (~t.indexOf("=")) {
      t = e + parseFloat(t.replace("=", ""));
    } else {
      t = parseFloat(t);
    }

    fabric.util.animate({
      startValue: n.from,
      endValue: t,
      byValue: n.by,
      easing: n.easing,
      duration: n.duration,
      abort: n.abort && function () {
        return n.abort.call(o);
      },
      onChange: function onChange(t, e, i) {
        if (a) {
          o[a[0]][a[1]] = t;
        } else {
          o.set(r, t);
        }

        if (s) {
          return;
        }

        n.onChange && n.onChange(t, e, i);
      },
      onComplete: function onComplete(t, e, i) {
        if (s) {
          return;
        }

        o.setCoords();
        n.onComplete && n.onComplete(t, e, i);
      }
    });
  }
});

(function (t) {
  "use strict";

  var n = t.fabric || (t.fabric = {}),
      e = n.util.object.extend,
      s = n.util.object.clone,
      i = {
    x1: 1,
    x2: 1,
    y1: 1,
    y2: 1
  },
      r = n.StaticCanvas.supports("setLineDash");

  if (n.Line) {
    n.warn("fabric.Line is already defined");
    return;
  }

  n.Line = n.util.createClass(n.Object, {
    type: "line",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 0,
    cacheProperties: n.Object.prototype.cacheProperties.concat("x1", "x2", "y1", "y2"),
    initialize: function initialize(t, e) {
      if (!t) {
        t = [0, 0, 0, 0];
      }

      this.callSuper("initialize", e);
      this.set("x1", t[0]);
      this.set("y1", t[1]);
      this.set("x2", t[2]);
      this.set("y2", t[3]);

      this._setWidthHeight(e);
    },
    _setWidthHeight: function _setWidthHeight(t) {
      t || (t = {});
      this.width = Math.abs(this.x2 - this.x1);
      this.height = Math.abs(this.y2 - this.y1);
      this.left = "left" in t ? t.left : this._getLeftToOriginX();
      this.top = "top" in t ? t.top : this._getTopToOriginY();
    },
    _set: function _set(t, e) {
      this.callSuper("_set", t, e);

      if (typeof i[t] !== "undefined") {
        this._setWidthHeight();
      }

      return this;
    },
    _getLeftToOriginX: o({
      origin: "originX",
      axis1: "x1",
      axis2: "x2",
      dimension: "width"
    }, {
      nearest: "left",
      center: "center",
      farthest: "right"
    }),
    _getTopToOriginY: o({
      origin: "originY",
      axis1: "y1",
      axis2: "y2",
      dimension: "height"
    }, {
      nearest: "top",
      center: "center",
      farthest: "bottom"
    }),
    _render: function _render(t) {
      t.beginPath();

      if (!this.strokeDashArray || this.strokeDashArray && r) {
        var e = this.calcLinePoints();
        t.moveTo(e.x1, e.y1);
        t.lineTo(e.x2, e.y2);
      }

      t.lineWidth = this.strokeWidth;
      var i = t.strokeStyle;
      t.strokeStyle = this.stroke || t.fillStyle;
      this.stroke && this._renderStroke(t);
      t.strokeStyle = i;
    },
    _renderDashedStroke: function _renderDashedStroke(t) {
      var e = this.calcLinePoints();
      t.beginPath();
      n.util.drawDashedLine(t, e.x1, e.y1, e.x2, e.y2, this.strokeDashArray);
      t.closePath();
    },
    _findCenterFromElement: function _findCenterFromElement() {
      return {
        x: (this.x1 + this.x2) / 2,
        y: (this.y1 + this.y2) / 2
      };
    },
    toObject: function toObject(t) {
      return e(this.callSuper("toObject", t), this.calcLinePoints());
    },
    _getNonTransformedDimensions: function _getNonTransformedDimensions() {
      var t = this.callSuper("_getNonTransformedDimensions");

      if (this.strokeLineCap === "butt") {
        if (this.width === 0) {
          t.y -= this.strokeWidth;
        }

        if (this.height === 0) {
          t.x -= this.strokeWidth;
        }
      }

      return t;
    },
    calcLinePoints: function calcLinePoints() {
      var t = this.x1 <= this.x2 ? -1 : 1,
          e = this.y1 <= this.y2 ? -1 : 1,
          i = t * this.width * .5,
          r = e * this.height * .5,
          n = t * this.width * -.5,
          s = e * this.height * -.5;
      return {
        x1: i,
        x2: n,
        y1: r,
        y2: s
      };
    }
  });

  n.Line.fromObject = function (t, e) {
    function i(t) {
      delete t.points;
      e && e(t);
    }

    var r = s(t, true);
    r.points = [t.x1, t.y1, t.x2, t.y2];

    n.Object._fromObject("Line", r, i, "points");
  };

  function o(t, e) {
    var i = t.origin,
        r = t.axis1,
        n = t.axis2,
        s = t.dimension,
        o = e.nearest,
        a = e.center,
        c = e.farthest;
    return function () {
      switch (this.get(i)) {
        case o:
          return Math.min(this.get(r), this.get(n));

        case a:
          return Math.min(this.get(r), this.get(n)) + .5 * this.get(s);

        case c:
          return Math.max(this.get(r), this.get(n));
      }
    };
  }
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var i = t.fabric || (t.fabric = {}),
      e = Math.PI;

  if (i.Circle) {
    i.warn("fabric.Circle is already defined.");
    return;
  }

  i.Circle = i.util.createClass(i.Object, {
    type: "circle",
    radius: 0,
    startAngle: 0,
    endAngle: e * 2,
    cacheProperties: i.Object.prototype.cacheProperties.concat("radius", "startAngle", "endAngle"),
    _set: function _set(t, e) {
      this.callSuper("_set", t, e);

      if (t === "radius") {
        this.setRadius(e);
      }

      return this;
    },
    toObject: function toObject(t) {
      return this.callSuper("toObject", ["radius", "startAngle", "endAngle"].concat(t));
    },
    _render: function _render(t) {
      t.beginPath();
      t.arc(0, 0, this.radius, this.startAngle, this.endAngle, false);

      this._renderPaintInOrder(t);
    },
    getRadiusX: function getRadiusX() {
      return this.get("radius") * this.get("scaleX");
    },
    getRadiusY: function getRadiusY() {
      return this.get("radius") * this.get("scaleY");
    },
    setRadius: function setRadius(t) {
      this.radius = t;
      return this.set("width", t * 2).set("height", t * 2);
    }
  });

  i.Circle.fromObject = function (t, e) {
    return i.Object._fromObject("Circle", t, e);
  };
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var r = t.fabric || (t.fabric = {});

  if (r.Triangle) {
    r.warn("fabric.Triangle is already defined");
    return;
  }

  r.Triangle = r.util.createClass(r.Object, {
    type: "triangle",
    width: 100,
    height: 100,
    _render: function _render(t) {
      var e = this.width / 2,
          i = this.height / 2;
      t.beginPath();
      t.moveTo(-e, i);
      t.lineTo(0, -i);
      t.lineTo(e, i);
      t.closePath();

      this._renderPaintInOrder(t);
    },
    _renderDashedStroke: function _renderDashedStroke(t) {
      var e = this.width / 2,
          i = this.height / 2;
      t.beginPath();
      r.util.drawDashedLine(t, -e, i, 0, -i, this.strokeDashArray);
      r.util.drawDashedLine(t, 0, -i, e, i, this.strokeDashArray);
      r.util.drawDashedLine(t, e, i, -e, i, this.strokeDashArray);
      t.closePath();
    }
  });

  r.Triangle.fromObject = function (t, e) {
    return r.Object._fromObject("Triangle", t, e);
  };
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var i = t.fabric || (t.fabric = {}),
      e = Math.PI * 2;

  if (i.Ellipse) {
    i.warn("fabric.Ellipse is already defined.");
    return;
  }

  i.Ellipse = i.util.createClass(i.Object, {
    type: "ellipse",
    rx: 0,
    ry: 0,
    cacheProperties: i.Object.prototype.cacheProperties.concat("rx", "ry"),
    initialize: function initialize(t) {
      this.callSuper("initialize", t);
      this.set("rx", t && t.rx || 0);
      this.set("ry", t && t.ry || 0);
    },
    _set: function _set(t, e) {
      this.callSuper("_set", t, e);

      switch (t) {
        case "rx":
          this.rx = e;
          this.set("width", e * 2);
          break;

        case "ry":
          this.ry = e;
          this.set("height", e * 2);
          break;
      }

      return this;
    },
    getRx: function getRx() {
      return this.get("rx") * this.get("scaleX");
    },
    getRy: function getRy() {
      return this.get("ry") * this.get("scaleY");
    },
    toObject: function toObject(t) {
      return this.callSuper("toObject", ["rx", "ry"].concat(t));
    },
    _render: function _render(t) {
      t.beginPath();
      t.save();
      t.transform(1, 0, 0, this.ry / this.rx, 0, 0);
      t.arc(0, 0, this.rx, 0, e, false);
      t.restore();

      this._renderPaintInOrder(t);
    }
  });

  i.Ellipse.fromObject = function (t, e) {
    return i.Object._fromObject("Ellipse", t, e);
  };
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var s = t.fabric || (t.fabric = {}),
      e = s.util.object.extend;

  if (s.Rect) {
    s.warn("fabric.Rect is already defined");
    return;
  }

  s.Rect = s.util.createClass(s.Object, {
    stateProperties: s.Object.prototype.stateProperties.concat("rx", "ry"),
    type: "rect",
    rx: 0,
    ry: 0,
    cacheProperties: s.Object.prototype.cacheProperties.concat("rx", "ry"),
    initialize: function initialize(t) {
      this.callSuper("initialize", t);

      this._initRxRy();
    },
    _initRxRy: function _initRxRy() {
      if (this.rx && !this.ry) {
        this.ry = this.rx;
      } else if (this.ry && !this.rx) {
        this.rx = this.ry;
      }
    },
    _render: function _render(t) {
      var e = this.rx ? Math.min(this.rx, this.width / 2) : 0,
          i = this.ry ? Math.min(this.ry, this.height / 2) : 0,
          r = this.width,
          n = this.height,
          s = -this.width / 2,
          o = -this.height / 2,
          a = e !== 0 || i !== 0,
          c = 1 - .5522847498;
      t.beginPath();
      t.moveTo(s + e, o);
      t.lineTo(s + r - e, o);
      a && t.bezierCurveTo(s + r - c * e, o, s + r, o + c * i, s + r, o + i);
      t.lineTo(s + r, o + n - i);
      a && t.bezierCurveTo(s + r, o + n - c * i, s + r - c * e, o + n, s + r - e, o + n);
      t.lineTo(s + e, o + n);
      a && t.bezierCurveTo(s + c * e, o + n, s, o + n - c * i, s, o + n - i);
      t.lineTo(s, o + i);
      a && t.bezierCurveTo(s, o + c * i, s + c * e, o, s + e, o);
      t.closePath();

      this._renderPaintInOrder(t);
    },
    _renderDashedStroke: function _renderDashedStroke(t) {
      var e = -this.width / 2,
          i = -this.height / 2,
          r = this.width,
          n = this.height;
      t.beginPath();
      s.util.drawDashedLine(t, e, i, e + r, i, this.strokeDashArray);
      s.util.drawDashedLine(t, e + r, i, e + r, i + n, this.strokeDashArray);
      s.util.drawDashedLine(t, e + r, i + n, e, i + n, this.strokeDashArray);
      s.util.drawDashedLine(t, e, i + n, e, i, this.strokeDashArray);
      t.closePath();
    },
    toObject: function toObject(t) {
      return this.callSuper("toObject", ["rx", "ry"].concat(t));
    }
  });

  s.Rect.fromObject = function (t, e) {
    return s.Object._fromObject("Rect", t, e);
  };
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var s = t.fabric || (t.fabric = {}),
      e = s.util.object.extend,
      a = s.util.array.min,
      c = s.util.array.max,
      i = s.util.toFixed;

  if (s.Polyline) {
    s.warn("fabric.Polyline is already defined");
    return;
  }

  s.Polyline = s.util.createClass(s.Object, {
    type: "polyline",
    points: null,
    cacheProperties: s.Object.prototype.cacheProperties.concat("points"),
    initialize: function initialize(t, e) {
      e = e || {};
      this.points = t || [];
      this.callSuper("initialize", e);

      this._setPositionDimensions(e);
    },
    _setPositionDimensions: function _setPositionDimensions(t) {
      var e = this._calcDimensions(t),
          i;

      this.width = e.width;
      this.height = e.height;

      if (!t.fromSVG) {
        i = this.translateToGivenOrigin({
          x: e.left - this.strokeWidth / 2,
          y: e.top - this.strokeWidth / 2
        }, "left", "top", this.originX, this.originY);
      }

      if (typeof t.left === "undefined") {
        this.left = t.fromSVG ? e.left : i.x;
      }

      if (typeof t.top === "undefined") {
        this.top = t.fromSVG ? e.top : i.y;
      }

      this.pathOffset = {
        x: e.left + this.width / 2,
        y: e.top + this.height / 2
      };
    },
    _calcDimensions: function _calcDimensions() {
      var t = this.points,
          e = a(t, "x") || 0,
          i = a(t, "y") || 0,
          r = c(t, "x") || 0,
          n = c(t, "y") || 0,
          s = r - e,
          o = n - i;
      return {
        left: e,
        top: i,
        width: s,
        height: o
      };
    },
    toObject: function toObject(t) {
      return e(this.callSuper("toObject", t), {
        points: this.points.concat()
      });
    },
    commonRender: function commonRender(t) {
      var e,
          i = this.points.length,
          r = this.pathOffset.x,
          n = this.pathOffset.y;

      if (!i || isNaN(this.points[i - 1].y)) {
        return false;
      }

      t.beginPath();
      t.moveTo(this.points[0].x - r, this.points[0].y - n);

      for (var s = 0; s < i; s++) {
        e = this.points[s];
        t.lineTo(e.x - r, e.y - n);
      }

      return true;
    },
    _render: function _render(t) {
      if (!this.commonRender(t)) {
        return;
      }

      this._renderPaintInOrder(t);
    },
    _renderDashedStroke: function _renderDashedStroke(t) {
      var e, i;
      t.beginPath();

      for (var r = 0, n = this.points.length; r < n; r++) {
        e = this.points[r];
        i = this.points[r + 1] || e;
        s.util.drawDashedLine(t, e.x, e.y, i.x, i.y, this.strokeDashArray);
      }
    },
    complexity: function complexity() {
      return this.get("points").length;
    }
  });

  s.Polyline.fromObject = function (t, e) {
    return s.Object._fromObject("Polyline", t, e, "points");
  };
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var i = t.fabric || (t.fabric = {});

  if (i.Polygon) {
    i.warn("fabric.Polygon is already defined");
    return;
  }

  i.Polygon = i.util.createClass(i.Polyline, {
    type: "polygon",
    _render: function _render(t) {
      if (!this.commonRender(t)) {
        return;
      }

      t.closePath();

      this._renderPaintInOrder(t);
    },
    _renderDashedStroke: function _renderDashedStroke(t) {
      this.callSuper("_renderDashedStroke", t);
      t.closePath();
    }
  });

  i.Polygon.fromObject = function (t, e) {
    return i.Object._fromObject("Polygon", t, e, "points");
  };
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var x = t.fabric || (t.fabric = {}),
      C = x.util.array.min,
      w = x.util.array.max,
      e = x.util.object.extend,
      r = Object.prototype.toString,
      p = x.util.drawArc,
      i = x.util.toFixed,
      m = {
    m: 2,
    l: 2,
    h: 1,
    v: 1,
    c: 6,
    s: 4,
    q: 4,
    t: 2,
    a: 7
  },
      b = {
    m: "l",
    M: "L"
  };

  if (x.Path) {
    x.warn("fabric.Path is already defined");
    return;
  }

  x.Path = x.util.createClass(x.Object, {
    type: "path",
    path: null,
    cacheProperties: x.Object.prototype.cacheProperties.concat("path", "fillRule"),
    stateProperties: x.Object.prototype.stateProperties.concat("path"),
    initialize: function initialize(t, e) {
      e = e || {};
      this.callSuper("initialize", e);

      if (!t) {
        t = [];
      }

      var i = r.call(t) === "[object Array]";
      this.path = i ? t : t.match && t.match(/[mzlhvcsqta][^mzlhvcsqta]*/gi);

      if (!this.path) {
        return;
      }

      if (!i) {
        this.path = this._parsePath();
      }

      x.Polyline.prototype._setPositionDimensions.call(this, e);
    },
    _renderPathCommands: function _renderPathCommands(t) {
      var e,
          i = null,
          r = 0,
          n = 0,
          s = 0,
          o = 0,
          a = 0,
          c = 0,
          l,
          h,
          f = -this.pathOffset.x,
          u = -this.pathOffset.y;
      t.beginPath();

      for (var d = 0, g = this.path.length; d < g; ++d) {
        e = this.path[d];

        switch (e[0]) {
          case "l":
            s += e[1];
            o += e[2];
            t.lineTo(s + f, o + u);
            break;

          case "L":
            s = e[1];
            o = e[2];
            t.lineTo(s + f, o + u);
            break;

          case "h":
            s += e[1];
            t.lineTo(s + f, o + u);
            break;

          case "H":
            s = e[1];
            t.lineTo(s + f, o + u);
            break;

          case "v":
            o += e[1];
            t.lineTo(s + f, o + u);
            break;

          case "V":
            o = e[1];
            t.lineTo(s + f, o + u);
            break;

          case "m":
            s += e[1];
            o += e[2];
            r = s;
            n = o;
            t.moveTo(s + f, o + u);
            break;

          case "M":
            s = e[1];
            o = e[2];
            r = s;
            n = o;
            t.moveTo(s + f, o + u);
            break;

          case "c":
            l = s + e[5];
            h = o + e[6];
            a = s + e[3];
            c = o + e[4];
            t.bezierCurveTo(s + e[1] + f, o + e[2] + u, a + f, c + u, l + f, h + u);
            s = l;
            o = h;
            break;

          case "C":
            s = e[5];
            o = e[6];
            a = e[3];
            c = e[4];
            t.bezierCurveTo(e[1] + f, e[2] + u, a + f, c + u, s + f, o + u);
            break;

          case "s":
            l = s + e[3];
            h = o + e[4];

            if (i[0].match(/[CcSs]/) === null) {
              a = s;
              c = o;
            } else {
              a = 2 * s - a;
              c = 2 * o - c;
            }

            t.bezierCurveTo(a + f, c + u, s + e[1] + f, o + e[2] + u, l + f, h + u);
            a = s + e[1];
            c = o + e[2];
            s = l;
            o = h;
            break;

          case "S":
            l = e[3];
            h = e[4];

            if (i[0].match(/[CcSs]/) === null) {
              a = s;
              c = o;
            } else {
              a = 2 * s - a;
              c = 2 * o - c;
            }

            t.bezierCurveTo(a + f, c + u, e[1] + f, e[2] + u, l + f, h + u);
            s = l;
            o = h;
            a = e[1];
            c = e[2];
            break;

          case "q":
            l = s + e[3];
            h = o + e[4];
            a = s + e[1];
            c = o + e[2];
            t.quadraticCurveTo(a + f, c + u, l + f, h + u);
            s = l;
            o = h;
            break;

          case "Q":
            l = e[3];
            h = e[4];
            t.quadraticCurveTo(e[1] + f, e[2] + u, l + f, h + u);
            s = l;
            o = h;
            a = e[1];
            c = e[2];
            break;

          case "t":
            l = s + e[1];
            h = o + e[2];

            if (i[0].match(/[QqTt]/) === null) {
              a = s;
              c = o;
            } else {
              a = 2 * s - a;
              c = 2 * o - c;
            }

            t.quadraticCurveTo(a + f, c + u, l + f, h + u);
            s = l;
            o = h;
            break;

          case "T":
            l = e[1];
            h = e[2];

            if (i[0].match(/[QqTt]/) === null) {
              a = s;
              c = o;
            } else {
              a = 2 * s - a;
              c = 2 * o - c;
            }

            t.quadraticCurveTo(a + f, c + u, l + f, h + u);
            s = l;
            o = h;
            break;

          case "a":
            p(t, s + f, o + u, [e[1], e[2], e[3], e[4], e[5], e[6] + s + f, e[7] + o + u]);
            s += e[6];
            o += e[7];
            break;

          case "A":
            p(t, s + f, o + u, [e[1], e[2], e[3], e[4], e[5], e[6] + f, e[7] + u]);
            s = e[6];
            o = e[7];
            break;

          case "z":
          case "Z":
            s = r;
            o = n;
            t.closePath();
            break;
        }

        i = e;
      }
    },
    _render: function _render(t) {
      this._renderPathCommands(t);

      this._renderPaintInOrder(t);
    },
    toString: function toString() {
      return "#<fabric.Path (" + this.complexity() + '): { "top": ' + this.top + ', "left": ' + this.left + " }>";
    },
    toObject: function toObject(t) {
      return e(this.callSuper("toObject", t), {
        path: this.path.map(function (t) {
          return t.slice();
        })
      });
    },
    toDatalessObject: function toDatalessObject(t) {
      var e = this.toObject(["sourcePath"].concat(t));

      if (e.sourcePath) {
        delete e.path;
      }

      return e;
    },
    complexity: function complexity() {
      return this.path.length;
    },
    _parsePath: function _parsePath() {
      var t = [],
          e = [],
          i,
          r,
          n = x.rePathCommand,
          s,
          o;

      for (var a = 0, c, l = this.path.length; a < l; a++) {
        i = this.path[a];
        o = i.slice(1).trim();
        e.length = 0;

        while (s = n.exec(o)) {
          e.push(s[0]);
        }

        c = [i.charAt(0)];

        for (var h = 0, f = e.length; h < f; h++) {
          r = parseFloat(e[h]);

          if (!isNaN(r)) {
            c.push(r);
          }
        }

        var u = c[0],
            d = m[u.toLowerCase()],
            g = b[u] || u;

        if (c.length - 1 > d) {
          for (var p = 1, v = c.length; p < v; p += d) {
            t.push([u].concat(c.slice(p, p + d)));
            u = g;
          }
        } else {
          t.push(c);
        }
      }

      return t;
    },
    _calcDimensions: function _calcDimensions() {
      var e = [],
          i = [],
          t,
          r = null,
          n = 0,
          s = 0,
          o = 0,
          a = 0,
          c = 0,
          l = 0,
          h,
          f,
          u;

      for (var d = 0, g = this.path.length; d < g; ++d) {
        t = this.path[d];

        switch (t[0]) {
          case "l":
            o += t[1];
            a += t[2];
            u = [];
            break;

          case "L":
            o = t[1];
            a = t[2];
            u = [];
            break;

          case "h":
            o += t[1];
            u = [];
            break;

          case "H":
            o = t[1];
            u = [];
            break;

          case "v":
            a += t[1];
            u = [];
            break;

          case "V":
            a = t[1];
            u = [];
            break;

          case "m":
            o += t[1];
            a += t[2];
            n = o;
            s = a;
            u = [];
            break;

          case "M":
            o = t[1];
            a = t[2];
            n = o;
            s = a;
            u = [];
            break;

          case "c":
            h = o + t[5];
            f = a + t[6];
            c = o + t[3];
            l = a + t[4];
            u = x.util.getBoundsOfCurve(o, a, o + t[1], a + t[2], c, l, h, f);
            o = h;
            a = f;
            break;

          case "C":
            c = t[3];
            l = t[4];
            u = x.util.getBoundsOfCurve(o, a, t[1], t[2], c, l, t[5], t[6]);
            o = t[5];
            a = t[6];
            break;

          case "s":
            h = o + t[3];
            f = a + t[4];

            if (r[0].match(/[CcSs]/) === null) {
              c = o;
              l = a;
            } else {
              c = 2 * o - c;
              l = 2 * a - l;
            }

            u = x.util.getBoundsOfCurve(o, a, c, l, o + t[1], a + t[2], h, f);
            c = o + t[1];
            l = a + t[2];
            o = h;
            a = f;
            break;

          case "S":
            h = t[3];
            f = t[4];

            if (r[0].match(/[CcSs]/) === null) {
              c = o;
              l = a;
            } else {
              c = 2 * o - c;
              l = 2 * a - l;
            }

            u = x.util.getBoundsOfCurve(o, a, c, l, t[1], t[2], h, f);
            o = h;
            a = f;
            c = t[1];
            l = t[2];
            break;

          case "q":
            h = o + t[3];
            f = a + t[4];
            c = o + t[1];
            l = a + t[2];
            u = x.util.getBoundsOfCurve(o, a, c, l, c, l, h, f);
            o = h;
            a = f;
            break;

          case "Q":
            c = t[1];
            l = t[2];
            u = x.util.getBoundsOfCurve(o, a, c, l, c, l, t[3], t[4]);
            o = t[3];
            a = t[4];
            break;

          case "t":
            h = o + t[1];
            f = a + t[2];

            if (r[0].match(/[QqTt]/) === null) {
              c = o;
              l = a;
            } else {
              c = 2 * o - c;
              l = 2 * a - l;
            }

            u = x.util.getBoundsOfCurve(o, a, c, l, c, l, h, f);
            o = h;
            a = f;
            break;

          case "T":
            h = t[1];
            f = t[2];

            if (r[0].match(/[QqTt]/) === null) {
              c = o;
              l = a;
            } else {
              c = 2 * o - c;
              l = 2 * a - l;
            }

            u = x.util.getBoundsOfCurve(o, a, c, l, c, l, h, f);
            o = h;
            a = f;
            break;

          case "a":
            u = x.util.getBoundsOfArc(o, a, t[1], t[2], t[3], t[4], t[5], t[6] + o, t[7] + a);
            o += t[6];
            a += t[7];
            break;

          case "A":
            u = x.util.getBoundsOfArc(o, a, t[1], t[2], t[3], t[4], t[5], t[6], t[7]);
            o = t[6];
            a = t[7];
            break;

          case "z":
          case "Z":
            o = n;
            a = s;
            break;
        }

        r = t;
        u.forEach(function (t) {
          e.push(t.x);
          i.push(t.y);
        });
        e.push(o);
        i.push(a);
      }

      var p = C(e) || 0,
          v = C(i) || 0,
          m = w(e) || 0,
          b = w(i) || 0,
          y = m - p,
          _ = b - v;

      return {
        left: p,
        top: v,
        width: y,
        height: _
      };
    }
  });

  x.Path.fromObject = function (i, r) {
    if (typeof i.sourcePath === "string") {
      var t = i.sourcePath;
      x.loadSVGFromURL(t, function (t) {
        var e = t[0];
        e.setOptions(i);
        r && r(e);
      });
    } else {
      x.Object._fromObject("Path", i, r, "path");
    }
  };
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var l = t.fabric || (t.fabric = {}),
      h = l.util.array.min,
      f = l.util.array.max;

  if (l.Group) {
    return;
  }

  l.Group = l.util.createClass(l.Object, l.Collection, {
    type: "group",
    strokeWidth: 0,
    subTargetCheck: false,
    cacheProperties: [],
    useSetOnGroup: false,
    initialize: function initialize(t, e, i) {
      e = e || {};
      this._objects = [];
      i && this.callSuper("initialize", e);
      this._objects = t || [];

      for (var r = this._objects.length; r--;) {
        this._objects[r].group = this;
      }

      if (!i) {
        var n = e && e.centerPoint;

        if (e.originX !== undefined) {
          this.originX = e.originX;
        }

        if (e.originY !== undefined) {
          this.originY = e.originY;
        }

        n || this._calcBounds();

        this._updateObjectsCoords(n);

        delete e.centerPoint;
        this.callSuper("initialize", e);
      } else {
        this._updateObjectsACoords();
      }

      this.setCoords();
    },
    _updateObjectsACoords: function _updateObjectsACoords() {
      var t = true,
          e = true;

      for (var i = this._objects.length; i--;) {
        this._objects[i].setCoords(t, e);
      }
    },
    _updateObjectsCoords: function _updateObjectsCoords(t) {
      var t = t || this.getCenterPoint();

      for (var e = this._objects.length; e--;) {
        this._updateObjectCoords(this._objects[e], t);
      }
    },
    _updateObjectCoords: function _updateObjectCoords(t, e) {
      var i = t.left,
          r = t.top,
          n = true,
          s = true;
      t.set({
        left: i - e.x,
        top: r - e.y
      });
      t.group = this;
      t.setCoords(n, s);
    },
    toString: function toString() {
      return "#<fabric.Group: (" + this.complexity() + ")>";
    },
    addWithUpdate: function addWithUpdate(t) {
      this._restoreObjectsState();

      l.util.resetObjectTransform(this);

      if (t) {
        this._objects.push(t);

        t.group = this;

        t._set("canvas", this.canvas);
      }

      this._calcBounds();

      this._updateObjectsCoords();

      this.setCoords();
      this.dirty = true;
      return this;
    },
    removeWithUpdate: function removeWithUpdate(t) {
      this._restoreObjectsState();

      l.util.resetObjectTransform(this);
      this.remove(t);

      this._calcBounds();

      this._updateObjectsCoords();

      this.setCoords();
      this.dirty = true;
      return this;
    },
    _onObjectAdded: function _onObjectAdded(t) {
      this.dirty = true;
      t.group = this;

      t._set("canvas", this.canvas);
    },
    _onObjectRemoved: function _onObjectRemoved(t) {
      this.dirty = true;
      delete t.group;
    },
    _set: function _set(t, e) {
      var i = this._objects.length;

      if (this.useSetOnGroup) {
        while (i--) {
          this._objects[i].setOnGroup(t, e);
        }
      }

      if (t === "canvas") {
        while (i--) {
          this._objects[i]._set(t, e);
        }
      }

      l.Object.prototype._set.call(this, t, e);
    },
    toObject: function toObject(r) {
      var n = this.includeDefaultValues;

      var t = this._objects.map(function (t) {
        var e = t.includeDefaultValues;
        t.includeDefaultValues = n;
        var i = t.toObject(r);
        t.includeDefaultValues = e;
        return i;
      });

      var e = l.Object.prototype.toObject.call(this, r);
      e.objects = t;
      return e;
    },
    toDatalessObject: function toDatalessObject(r) {
      var t,
          e = this.sourcePath;

      if (e) {
        t = e;
      } else {
        var n = this.includeDefaultValues;
        t = this._objects.map(function (t) {
          var e = t.includeDefaultValues;
          t.includeDefaultValues = n;
          var i = t.toDatalessObject(r);
          t.includeDefaultValues = e;
          return i;
        });
      }

      var i = l.Object.prototype.toDatalessObject.call(this, r);
      i.objects = t;
      return i;
    },
    render: function render(t) {
      this._transformDone = true;
      this.callSuper("render", t);
      this._transformDone = false;
    },
    shouldCache: function shouldCache() {
      var t = l.Object.prototype.shouldCache.call(this);

      if (t) {
        for (var e = 0, i = this._objects.length; e < i; e++) {
          if (this._objects[e].willDrawShadow()) {
            this.ownCaching = false;
            return false;
          }
        }
      }

      return t;
    },
    willDrawShadow: function willDrawShadow() {
      if (l.Object.prototype.willDrawShadow.call(this)) {
        return true;
      }

      for (var t = 0, e = this._objects.length; t < e; t++) {
        if (this._objects[t].willDrawShadow()) {
          return true;
        }
      }

      return false;
    },
    isOnACache: function isOnACache() {
      return this.ownCaching || this.group && this.group.isOnACache();
    },
    drawObject: function drawObject(t) {
      for (var e = 0, i = this._objects.length; e < i; e++) {
        this._objects[e].render(t);
      }

      this._drawClipPath(t);
    },
    isCacheDirty: function isCacheDirty(t) {
      if (this.callSuper("isCacheDirty", t)) {
        return true;
      }

      if (!this.statefullCache) {
        return false;
      }

      for (var e = 0, i = this._objects.length; e < i; e++) {
        if (this._objects[e].isCacheDirty(true)) {
          if (this._cacheCanvas) {
            var r = this.cacheWidth / this.zoomX,
                n = this.cacheHeight / this.zoomY;

            this._cacheContext.clearRect(-r / 2, -n / 2, r, n);
          }

          return true;
        }
      }

      return false;
    },
    _restoreObjectsState: function _restoreObjectsState() {
      this._objects.forEach(this._restoreObjectState, this);

      return this;
    },
    realizeTransform: function realizeTransform(t) {
      var e = t.calcTransformMatrix(),
          i = l.util.qrDecompose(e),
          r = new l.Point(i.translateX, i.translateY);
      t.flipX = false;
      t.flipY = false;
      t.set("scaleX", i.scaleX);
      t.set("scaleY", i.scaleY);
      t.skewX = i.skewX;
      t.skewY = i.skewY;
      t.angle = i.angle;
      t.setPositionByOrigin(r, "center", "center");
      return t;
    },
    _restoreObjectState: function _restoreObjectState(t) {
      this.realizeTransform(t);
      t.setCoords();
      delete t.group;
      return this;
    },
    destroy: function destroy() {
      this._objects.forEach(function (t) {
        t.set("dirty", true);
      });

      return this._restoreObjectsState();
    },
    toActiveSelection: function toActiveSelection() {
      if (!this.canvas) {
        return;
      }

      var t = this._objects,
          e = this.canvas;
      this._objects = [];
      var i = this.toObject();
      delete i.objects;
      var r = new l.ActiveSelection([]);
      r.set(i);
      r.type = "activeSelection";
      e.remove(this);
      t.forEach(function (t) {
        t.group = r;
        t.dirty = true;
        e.add(t);
      });
      r.canvas = e;
      r._objects = t;
      e._activeObject = r;
      r.setCoords();
      return r;
    },
    ungroupOnCanvas: function ungroupOnCanvas() {
      return this._restoreObjectsState();
    },
    setObjectsCoords: function setObjectsCoords() {
      var e = true,
          i = true;
      this.forEachObject(function (t) {
        t.setCoords(e, i);
      });
      return this;
    },
    _calcBounds: function _calcBounds(t) {
      var e = [],
          i = [],
          r,
          n,
          s = ["tr", "br", "bl", "tl"],
          o = 0,
          a = this._objects.length,
          c,
          l = s.length,
          h = true;

      for (; o < a; ++o) {
        r = this._objects[o];
        r.setCoords(h);

        for (c = 0; c < l; c++) {
          n = s[c];
          e.push(r.oCoords[n].x);
          i.push(r.oCoords[n].y);
        }
      }

      this._getBounds(e, i, t);
    },
    _getBounds: function _getBounds(t, e, i) {
      var r = new l.Point(h(t), h(e)),
          n = new l.Point(f(t), f(e)),
          s = r.y || 0,
          o = r.x || 0,
          a = n.x - r.x || 0,
          c = n.y - r.y || 0;
      this.width = a;
      this.height = c;

      if (!i) {
        this.setPositionByOrigin({
          x: o,
          y: s
        }, "left", "top");
      }
    }
  });

  l.Group.fromObject = function (r, n) {
    var i = r.objects,
        s = l.util.object.clone(r, true);
    delete s.objects;

    if (typeof i === "string") {
      l.loadSVGFromURL(i, function (t) {
        var e = l.util.groupSVGElements(t, r, i);
        e.set(s);
        n && n(e);
      });
      return;
    }

    l.util.enlivenObjects(i, function (i) {
      l.util.enlivenObjects([r.clipPath], function (t) {
        var e = l.util.object.clone(r, true);
        e.clipPath = t[0];
        delete e.objects;
        n && n(new l.Group(i, e, true));
      });
    });
  };
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var n = t.fabric || (t.fabric = {});

  if (n.ActiveSelection) {
    return;
  }

  n.ActiveSelection = n.util.createClass(n.Group, {
    type: "activeSelection",
    initialize: function initialize(t, e) {
      e = e || {};
      this._objects = t || [];

      for (var i = this._objects.length; i--;) {
        this._objects[i].group = this;
      }

      if (e.originX) {
        this.originX = e.originX;
      }

      if (e.originY) {
        this.originY = e.originY;
      }

      this._calcBounds();

      this._updateObjectsCoords();

      n.Object.prototype.initialize.call(this, e);
      this.setCoords();
    },
    toGroup: function toGroup() {
      var t = this._objects.concat();

      this._objects = [];
      var e = n.Object.prototype.toObject.call(this);
      var i = new n.Group([]);
      delete e.type;
      i.set(e);
      t.forEach(function (t) {
        t.canvas.remove(t);
        t.group = i;
      });
      i._objects = t;

      if (!this.canvas) {
        return i;
      }

      var r = this.canvas;
      r.add(i);
      r._activeObject = i;
      i.setCoords();
      return i;
    },
    onDeselect: function onDeselect() {
      this.destroy();
      return false;
    },
    toString: function toString() {
      return "#<fabric.ActiveSelection: (" + this.complexity() + ")>";
    },
    shouldCache: function shouldCache() {
      return false;
    },
    isOnACache: function isOnACache() {
      return false;
    },
    _renderControls: function _renderControls(t, e, i) {
      t.save();
      t.globalAlpha = this.isMoving ? this.borderOpacityWhenMoving : 1;
      this.callSuper("_renderControls", t, e);
      i = i || {};

      if (typeof i.hasControls === "undefined") {
        i.hasControls = false;
      }

      if (typeof i.hasRotatingPoint === "undefined") {
        i.hasRotatingPoint = false;
      }

      i.forActiveSelection = true;

      for (var r = 0, n = this._objects.length; r < n; r++) {
        this._objects[r]._renderControls(t, i);
      }

      t.restore();
    }
  });

  n.ActiveSelection.fromObject = function (e, i) {
    n.util.enlivenObjects(e.objects, function (t) {
      delete e.objects;
      i && i(new n.ActiveSelection(t, e, true));
    });
  };
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var r = fabric.util.object.extend;

  if (!t.fabric) {
    t.fabric = {};
  }

  if (t.fabric.Image) {
    fabric.warn("fabric.Image is already defined.");
    return;
  }

  fabric.Image = fabric.util.createClass(fabric.Object, {
    type: "image",
    crossOrigin: "",
    strokeWidth: 0,
    srcFromAttribute: false,
    _lastScaleX: 1,
    _lastScaleY: 1,
    _filterScalingX: 1,
    _filterScalingY: 1,
    minimumScaleTrigger: .5,
    stateProperties: fabric.Object.prototype.stateProperties.concat("cropX", "cropY"),
    cacheKey: "",
    cropX: 0,
    cropY: 0,
    initialize: function initialize(t, e) {
      e || (e = {});
      this.filters = [];
      this.cacheKey = "texture" + fabric.Object.__uid++;
      this.callSuper("initialize", e);

      this._initElement(t, e);
    },
    getElement: function getElement() {
      return this._element || {};
    },
    setElement: function setElement(t, e) {
      this.removeTexture(this.cacheKey);
      this.removeTexture(this.cacheKey + "_filtered");
      this._element = t;
      this._originalElement = t;

      this._initConfig(e);

      if (this.filters.length !== 0) {
        this.applyFilters();
      }

      if (this.resizeFilter) {
        this.applyResizeFilters();
      }

      return this;
    },
    removeTexture: function removeTexture(t) {
      var e = fabric.filterBackend;

      if (e && e.evictCachesForKey) {
        e.evictCachesForKey(t);
      }
    },
    dispose: function dispose() {
      this.removeTexture(this.cacheKey);
      this.removeTexture(this.cacheKey + "_filtered");
      this._cacheContext = undefined;
      ["_originalElement", "_element", "_filteredEl", "_cacheCanvas"].forEach(function (t) {
        fabric.util.cleanUpJsdomNode(this[t]);
        this[t] = undefined;
      }.bind(this));
    },
    setCrossOrigin: function setCrossOrigin(t) {
      this.crossOrigin = t;
      this._element.crossOrigin = t;
      return this;
    },
    getOriginalSize: function getOriginalSize() {
      var t = this.getElement();
      return {
        width: t.naturalWidth || t.width,
        height: t.naturalHeight || t.height
      };
    },
    _stroke: function _stroke(t) {
      if (!this.stroke || this.strokeWidth === 0) {
        return;
      }

      var e = this.width / 2,
          i = this.height / 2;
      t.beginPath();
      t.moveTo(-e, -i);
      t.lineTo(e, -i);
      t.lineTo(e, i);
      t.lineTo(-e, i);
      t.lineTo(-e, -i);
      t.closePath();
    },
    _renderDashedStroke: function _renderDashedStroke(t) {
      var e = -this.width / 2,
          i = -this.height / 2,
          r = this.width,
          n = this.height;
      t.save();

      this._setStrokeStyles(t, this);

      t.beginPath();
      fabric.util.drawDashedLine(t, e, i, e + r, i, this.strokeDashArray);
      fabric.util.drawDashedLine(t, e + r, i, e + r, i + n, this.strokeDashArray);
      fabric.util.drawDashedLine(t, e + r, i + n, e, i + n, this.strokeDashArray);
      fabric.util.drawDashedLine(t, e, i + n, e, i, this.strokeDashArray);
      t.closePath();
      t.restore();
    },
    toObject: function toObject(t) {
      var e = [];
      this.filters.forEach(function (t) {
        if (t) {
          e.push(t.toObject());
        }
      });
      var i = r(this.callSuper("toObject", ["crossOrigin", "cropX", "cropY"].concat(t)), {
        src: this.getSrc(),
        filters: e
      });

      if (this.resizeFilter) {
        i.resizeFilter = this.resizeFilter.toObject();
      }

      return i;
    },
    hasCrop: function hasCrop() {
      return this.cropX || this.cropY || this.width < this._element.width || this.height < this._element.height;
    },
    getSrc: function getSrc(t) {
      var e = t ? this._element : this._originalElement;

      if (e) {
        if (e.toDataURL) {
          return e.toDataURL();
        }

        if (this.srcFromAttribute) {
          return e.getAttribute("src");
        } else {
          return e.src;
        }
      } else {
        return this.src || "";
      }
    },
    setSrc: function setSrc(t, e, i) {
      fabric.util.loadImage(t, function (t) {
        this.setElement(t, i);

        this._setWidthHeight();

        e && e(this);
      }, this, i && i.crossOrigin);
      return this;
    },
    toString: function toString() {
      return '#<fabric.Image: { src: "' + this.getSrc() + '" }>';
    },
    applyResizeFilters: function applyResizeFilters() {
      var t = this.resizeFilter,
          e = this.minimumScaleTrigger,
          i = this.getTotalObjectScaling(),
          r = i.scaleX,
          n = i.scaleY,
          s = this._filteredEl || this._originalElement;

      if (this.group) {
        this.set("dirty", true);
      }

      if (!t || r > e && n > e) {
        this._element = s;
        this._filterScalingX = 1;
        this._filterScalingY = 1;
        this._lastScaleX = r;
        this._lastScaleY = n;
        return;
      }

      if (!fabric.filterBackend) {
        fabric.filterBackend = fabric.initFilterBackend();
      }

      var o = fabric.util.createCanvasElement(),
          a = this._filteredEl ? this.cacheKey + "_filtered" : this.cacheKey,
          c = s.width,
          l = s.height;
      o.width = c;
      o.height = l;
      this._element = o;
      this._lastScaleX = t.scaleX = r;
      this._lastScaleY = t.scaleY = n;
      fabric.filterBackend.applyFilters([t], s, c, l, this._element, a);
      this._filterScalingX = o.width / this._originalElement.width;
      this._filterScalingY = o.height / this._originalElement.height;
    },
    applyFilters: function applyFilters(t) {
      t = t || this.filters || [];
      t = t.filter(function (t) {
        return t && !t.isNeutralState();
      });
      this.set("dirty", true);
      this.removeTexture(this.cacheKey + "_filtered");

      if (t.length === 0) {
        this._element = this._originalElement;
        this._filteredEl = null;
        this._filterScalingX = 1;
        this._filterScalingY = 1;
        return this;
      }

      var e = this._originalElement,
          i = e.naturalWidth || e.width,
          r = e.naturalHeight || e.height;

      if (this._element === this._originalElement) {
        var n = fabric.util.createCanvasElement();
        n.width = i;
        n.height = r;
        this._element = n;
        this._filteredEl = n;
      } else {
        this._element = this._filteredEl;

        this._filteredEl.getContext("2d").clearRect(0, 0, i, r);

        this._lastScaleX = 1;
        this._lastScaleY = 1;
      }

      if (!fabric.filterBackend) {
        fabric.filterBackend = fabric.initFilterBackend();
      }

      fabric.filterBackend.applyFilters(t, this._originalElement, i, r, this._element, this.cacheKey);

      if (this._originalElement.width !== this._element.width || this._originalElement.height !== this._element.height) {
        this._filterScalingX = this._element.width / this._originalElement.width;
        this._filterScalingY = this._element.height / this._originalElement.height;
      }

      return this;
    },
    _render: function _render(t) {
      if (this.isMoving !== true && this.resizeFilter && this._needsResize()) {
        this.applyResizeFilters();
      }

      this._stroke(t);

      this._renderPaintInOrder(t);
    },
    shouldCache: function shouldCache() {
      return this.needsItsOwnCache();
    },
    _renderFill: function _renderFill(t) {
      var e = this._element,
          i = this.width,
          r = this.height,
          n = Math.min(e.naturalWidth || e.width, i * this._filterScalingX),
          s = Math.min(e.naturalHeight || e.height, r * this._filterScalingY),
          o = -i / 2,
          a = -r / 2,
          c = Math.max(0, this.cropX * this._filterScalingX),
          l = Math.max(0, this.cropY * this._filterScalingY);
      e && t.drawImage(e, c, l, n, s, o, a, i, r);
    },
    _needsResize: function _needsResize() {
      var t = this.getTotalObjectScaling();
      return t.scaleX !== this._lastScaleX || t.scaleY !== this._lastScaleY;
    },
    _resetWidthHeight: function _resetWidthHeight() {
      this.set(this.getOriginalSize());
    },
    _initElement: function _initElement(t, e) {
      this.setElement(fabric.util.getById(t), e);
      fabric.util.addClass(this.getElement(), fabric.Image.CSS_CANVAS);
    },
    _initConfig: function _initConfig(t) {
      t || (t = {});
      this.setOptions(t);

      this._setWidthHeight(t);

      if (this._element && this.crossOrigin) {
        this._element.crossOrigin = this.crossOrigin;
      }
    },
    _initFilters: function _initFilters(t, e) {
      if (t && t.length) {
        fabric.util.enlivenObjects(t, function (t) {
          e && e(t);
        }, "fabric.Image.filters");
      } else {
        e && e();
      }
    },
    _setWidthHeight: function _setWidthHeight(t) {
      t || (t = {});
      var e = this.getElement();
      this.width = t.width || e.naturalWidth || e.width || 0;
      this.height = t.height || e.naturalHeight || e.height || 0;
    },
    parsePreserveAspectRatioAttribute: function parsePreserveAspectRatioAttribute() {
      var t = fabric.util.parsePreserveAspectRatioAttribute(this.preserveAspectRatio || ""),
          e = this._element.width,
          i = this._element.height,
          r = 1,
          n = 1,
          s = 0,
          o = 0,
          a = 0,
          c = 0,
          l,
          h = this.width,
          f = this.height,
          u = {
        width: h,
        height: f
      };

      if (t && (t.alignX !== "none" || t.alignY !== "none")) {
        if (t.meetOrSlice === "meet") {
          r = n = fabric.util.findScaleToFit(this._element, u);
          l = (h - e * r) / 2;

          if (t.alignX === "Min") {
            s = -l;
          }

          if (t.alignX === "Max") {
            s = l;
          }

          l = (f - i * n) / 2;

          if (t.alignY === "Min") {
            o = -l;
          }

          if (t.alignY === "Max") {
            o = l;
          }
        }

        if (t.meetOrSlice === "slice") {
          r = n = fabric.util.findScaleToCover(this._element, u);
          l = e - h / r;

          if (t.alignX === "Mid") {
            a = l / 2;
          }

          if (t.alignX === "Max") {
            a = l;
          }

          l = i - f / n;

          if (t.alignY === "Mid") {
            c = l / 2;
          }

          if (t.alignY === "Max") {
            c = l;
          }

          e = h / r;
          i = f / n;
        }
      } else {
        r = h / e;
        n = f / i;
      }

      return {
        width: e,
        height: i,
        scaleX: r,
        scaleY: n,
        offsetLeft: s,
        offsetTop: o,
        cropX: a,
        cropY: c
      };
    }
  });
  fabric.Image.CSS_CANVAS = "canvas-img";
  fabric.Image.prototype.getSvgSrc = fabric.Image.prototype.getSrc;

  fabric.Image.fromObject = function (t, r) {
    var n = fabric.util.object.clone(t);
    fabric.util.loadImage(n.src, function (i, t) {
      if (t) {
        r && r(null, t);
        return;
      }

      fabric.Image.prototype._initFilters.call(n, n.filters, function (t) {
        n.filters = t || [];

        fabric.Image.prototype._initFilters.call(n, [n.resizeFilter], function (t) {
          n.resizeFilter = t[0];
          fabric.util.enlivenObjects([n.clipPath], function (t) {
            n.clipPath = t[0];
            var e = new fabric.Image(i, n);
            r(e);
          });
        });
      });
    }, null, n.crossOrigin);
  };

  fabric.Image.fromURL = function (t, e, i) {
    fabric.util.loadImage(t, function (t) {
      e && e(new fabric.Image(t, i));
    }, null, i && i.crossOrigin);
  };
})(typeof exports !== "undefined" ? exports : void 0);

fabric.util.object.extend(fabric.Object.prototype, {
  _getAngleValueForStraighten: function _getAngleValueForStraighten() {
    var t = this.angle % 360;

    if (t > 0) {
      return Math.round((t - 1) / 90) * 90;
    }

    return Math.round(t / 90) * 90;
  },
  straighten: function straighten() {
    this.rotate(this._getAngleValueForStraighten());
    return this;
  },
  fxStraighten: function fxStraighten(t) {
    t = t || {};

    var e = function e() {},
        i = t.onComplete || e,
        r = t.onChange || e,
        n = this;

    fabric.util.animate({
      startValue: this.get("angle"),
      endValue: this._getAngleValueForStraighten(),
      duration: this.FX_DURATION,
      onChange: function onChange(t) {
        n.rotate(t);
        r();
      },
      onComplete: function onComplete() {
        n.setCoords();
        i();
      }
    });
    return this;
  }
});
fabric.util.object.extend(fabric.StaticCanvas.prototype, {
  straightenObject: function straightenObject(t) {
    t.straighten();
    this.requestRenderAll();
    return this;
  },
  fxStraightenObject: function fxStraightenObject(t) {
    t.fxStraighten({
      onChange: this.requestRenderAllBound
    });
    return this;
  }
});

(function () {
  "use strict";

  function o(t, e) {
    var i = "precision " + e + " float;\nvoid main(){}";
    var r = t.createShader(t.FRAGMENT_SHADER);
    t.shaderSource(r, i);
    t.compileShader(r);

    if (!t.getShaderParameter(r, t.COMPILE_STATUS)) {
      return false;
    }

    return true;
  }

  fabric.isWebglSupported = function (t) {
    if (fabric.isLikelyNode) {
      return false;
    }

    t = t || fabric.WebglFilterBackend.prototype.tileSize;
    var e = document.createElement("canvas");
    var i = e.getContext("webgl") || e.getContext("experimental-webgl");
    var r = false;

    if (i) {
      fabric.maxTextureSize = i.getParameter(i.MAX_TEXTURE_SIZE);
      r = fabric.maxTextureSize >= t;
      var n = ["highp", "mediump", "lowp"];

      for (var s = 0; s < 3; s++) {
        if (o(i, n[s])) {
          fabric.webGlPrecision = n[s];
          break;
        }
      }
    }

    this.isSupported = r;
    return r;
  };

  fabric.WebglFilterBackend = t;

  function t(t) {
    if (t && t.tileSize) {
      this.tileSize = t.tileSize;
    }

    this.setupGLContext(this.tileSize, this.tileSize);
    this.captureGPUInfo();
  }

  t.prototype = {
    tileSize: 2048,
    resources: {},
    setupGLContext: function setupGLContext(t, e) {
      this.dispose();
      this.createWebGLCanvas(t, e);
      this.aPosition = new Float32Array([0, 0, 0, 1, 1, 0, 1, 1]);
      this.chooseFastestCopyGLTo2DMethod(t, e);
    },
    chooseFastestCopyGLTo2DMethod: function chooseFastestCopyGLTo2DMethod(t, e) {
      var i = typeof window.performance !== "undefined",
          r;

      try {
        new ImageData(1, 1);
        r = true;
      } catch (t) {
        r = false;
      }

      var n = typeof ArrayBuffer !== "undefined";
      var s = typeof Uint8ClampedArray !== "undefined";

      if (!(i && r && n && s)) {
        return;
      }

      var o = fabric.util.createCanvasElement();
      var a = new ArrayBuffer(t * e * 4);

      if (fabric.forceGLPutImageData) {
        this.imageBuffer = a;
        this.copyGLTo2D = copyGLTo2DPutImageData;
        return;
      }

      var c = {
        imageBuffer: a,
        destinationWidth: t,
        destinationHeight: e,
        targetCanvas: o
      };
      var l, h, f;
      o.width = t;
      o.height = e;
      l = window.performance.now();
      copyGLTo2DDrawImage.call(c, this.gl, c);
      h = window.performance.now() - l;
      l = window.performance.now();
      copyGLTo2DPutImageData.call(c, this.gl, c);
      f = window.performance.now() - l;

      if (h > f) {
        this.imageBuffer = a;
        this.copyGLTo2D = copyGLTo2DPutImageData;
      } else {
        this.copyGLTo2D = copyGLTo2DDrawImage;
      }
    },
    createWebGLCanvas: function createWebGLCanvas(t, e) {
      var i = fabric.util.createCanvasElement();
      i.width = t;
      i.height = e;
      var r = {
        alpha: true,
        premultipliedAlpha: false,
        depth: false,
        stencil: false,
        antialias: false
      },
          n = i.getContext("webgl", r);

      if (!n) {
        n = i.getContext("experimental-webgl", r);
      }

      if (!n) {
        return;
      }

      n.clearColor(0, 0, 0, 0);
      this.canvas = i;
      this.gl = n;
    },
    applyFilters: function applyFilters(t, e, i, r, n, s) {
      var o = this.gl;
      var a;

      if (s) {
        a = this.getCachedTexture(s, e);
      }

      var c = {
        originalWidth: e.width || e.originalWidth,
        originalHeight: e.height || e.originalHeight,
        sourceWidth: i,
        sourceHeight: r,
        destinationWidth: i,
        destinationHeight: r,
        context: o,
        sourceTexture: this.createTexture(o, i, r, !a && e),
        targetTexture: this.createTexture(o, i, r),
        originalTexture: a || this.createTexture(o, i, r, !a && e),
        passes: t.length,
        webgl: true,
        aPosition: this.aPosition,
        programCache: this.programCache,
        pass: 0,
        filterBackend: this,
        targetCanvas: n
      };
      var l = o.createFramebuffer();
      o.bindFramebuffer(o.FRAMEBUFFER, l);
      t.forEach(function (t) {
        t && t.applyTo(c);
      });
      resizeCanvasIfNeeded(c);
      this.copyGLTo2D(o, c);
      o.bindTexture(o.TEXTURE_2D, null);
      o.deleteTexture(c.sourceTexture);
      o.deleteTexture(c.targetTexture);
      o.deleteFramebuffer(l);
      n.getContext("2d").setTransform(1, 0, 0, 1, 0, 0);
      return c;
    },
    dispose: function dispose() {
      if (this.canvas) {
        this.canvas = null;
        this.gl = null;
      }

      this.clearWebGLCaches();
    },
    clearWebGLCaches: function clearWebGLCaches() {
      this.programCache = {};
      this.textureCache = {};
    },
    createTexture: function createTexture(t, e, i, r) {
      var n = t.createTexture();
      t.bindTexture(t.TEXTURE_2D, n);
      t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.NEAREST);
      t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.NEAREST);
      t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.CLAMP_TO_EDGE);
      t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.CLAMP_TO_EDGE);

      if (r) {
        t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, r);
      } else {
        t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, e, i, 0, t.RGBA, t.UNSIGNED_BYTE, null);
      }

      return n;
    },
    getCachedTexture: function getCachedTexture(t, e) {
      if (this.textureCache[t]) {
        return this.textureCache[t];
      } else {
        var i = this.createTexture(this.gl, e.width, e.height, e);
        this.textureCache[t] = i;
        return i;
      }
    },
    evictCachesForKey: function evictCachesForKey(t) {
      if (this.textureCache[t]) {
        this.gl.deleteTexture(this.textureCache[t]);
        delete this.textureCache[t];
      }
    },
    copyGLTo2D: copyGLTo2DDrawImage,
    captureGPUInfo: function captureGPUInfo() {
      if (this.gpuInfo) {
        return this.gpuInfo;
      }

      var t = this.gl,
          e = {
        renderer: "",
        vendor: ""
      };

      if (!t) {
        return e;
      }

      var i = t.getExtension("WEBGL_debug_renderer_info");

      if (i) {
        var r = t.getParameter(i.UNMASKED_RENDERER_WEBGL);
        var n = t.getParameter(i.UNMASKED_VENDOR_WEBGL);

        if (r) {
          e.renderer = r.toLowerCase();
        }

        if (n) {
          e.vendor = n.toLowerCase();
        }
      }

      this.gpuInfo = e;
      return e;
    }
  };
})();

function resizeCanvasIfNeeded(t) {
  var e = t.targetCanvas,
      i = e.width,
      r = e.height,
      n = t.destinationWidth,
      s = t.destinationHeight;

  if (i !== n || r !== s) {
    e.width = n;
    e.height = s;
  }
}

function copyGLTo2DDrawImage(t, e) {
  var i = t.canvas,
      r = e.targetCanvas,
      n = r.getContext("2d");
  n.translate(0, r.height);
  n.scale(1, -1);
  var s = i.height - r.height;
  n.drawImage(i, 0, s, r.width, r.height, 0, 0, r.width, r.height);
}

function copyGLTo2DPutImageData(t, e) {
  var i = e.targetCanvas,
      r = i.getContext("2d"),
      n = e.destinationWidth,
      s = e.destinationHeight,
      o = n * s * 4;
  var a = new Uint8Array(this.imageBuffer, 0, o);
  var c = new Uint8ClampedArray(this.imageBuffer, 0, o);
  t.readPixels(0, 0, n, s, t.RGBA, t.UNSIGNED_BYTE, a);
  var l = new ImageData(c, n, s);
  r.putImageData(l, 0, 0);
}

(function () {
  "use strict";

  var t = function t() {};

  fabric.Canvas2dFilterBackend = e;

  function e() {}

  e.prototype = {
    evictCachesForKey: t,
    dispose: t,
    clearWebGLCaches: t,
    resources: {},
    applyFilters: function applyFilters(t, e, i, r, n) {
      var s = n.getContext("2d");
      s.drawImage(e, 0, 0, i, r);
      var o = s.getImageData(0, 0, i, r);
      var a = s.getImageData(0, 0, i, r);
      var c = {
        sourceWidth: i,
        sourceHeight: r,
        imageData: o,
        originalEl: e,
        originalImageData: a,
        canvasEl: n,
        ctx: s,
        filterBackend: this
      };
      t.forEach(function (t) {
        t.applyTo(c);
      });

      if (c.imageData.width !== i || c.imageData.height !== r) {
        n.width = c.imageData.width;
        n.height = c.imageData.height;
      }

      s.putImageData(c.imageData, 0, 0);
      return c;
    }
  };
})();

fabric.Image = fabric.Image || {};
fabric.Image.filters = fabric.Image.filters || {};
fabric.Image.filters.BaseFilter = fabric.util.createClass({
  type: "BaseFilter",
  vertexSource: "attribute vec2 aPosition;\n" + "varying vec2 vTexCoord;\n" + "void main() {\n" + "vTexCoord = aPosition;\n" + "gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);\n" + "}",
  fragmentSource: "precision highp float;\n" + "varying vec2 vTexCoord;\n" + "uniform sampler2D uTexture;\n" + "void main() {\n" + "gl_FragColor = texture2D(uTexture, vTexCoord);\n" + "}",
  initialize: function initialize(t) {
    if (t) {
      this.setOptions(t);
    }
  },
  setOptions: function setOptions(t) {
    for (var e in t) {
      this[e] = t[e];
    }
  },
  createProgram: function createProgram(t, e, i) {
    e = e || this.fragmentSource;
    i = i || this.vertexSource;

    if (fabric.webGlPrecision !== "highp") {
      e = e.replace(/precision highp float/g, "precision " + fabric.webGlPrecision + " float");
    }

    var r = t.createShader(t.VERTEX_SHADER);
    t.shaderSource(r, i);
    t.compileShader(r);

    if (!t.getShaderParameter(r, t.COMPILE_STATUS)) {
      throw new Error("Vertex shader compile error for " + this.type + ": " + t.getShaderInfoLog(r));
    }

    var n = t.createShader(t.FRAGMENT_SHADER);
    t.shaderSource(n, e);
    t.compileShader(n);

    if (!t.getShaderParameter(n, t.COMPILE_STATUS)) {
      throw new Error("Fragment shader compile error for " + this.type + ": " + t.getShaderInfoLog(n));
    }

    var s = t.createProgram();
    t.attachShader(s, r);
    t.attachShader(s, n);
    t.linkProgram(s);

    if (!t.getProgramParameter(s, t.LINK_STATUS)) {
      throw new Error('Shader link error for "${this.type}" ' + t.getProgramInfoLog(s));
    }

    var o = this.getAttributeLocations(t, s);
    var a = this.getUniformLocations(t, s) || {};
    a.uStepW = t.getUniformLocation(s, "uStepW");
    a.uStepH = t.getUniformLocation(s, "uStepH");
    return {
      program: s,
      attributeLocations: o,
      uniformLocations: a
    };
  },
  getAttributeLocations: function getAttributeLocations(t, e) {
    return {
      aPosition: t.getAttribLocation(e, "aPosition")
    };
  },
  getUniformLocations: function getUniformLocations() {
    return {};
  },
  sendAttributeData: function sendAttributeData(t, e, i) {
    var r = e.aPosition;
    var n = t.createBuffer();
    t.bindBuffer(t.ARRAY_BUFFER, n);
    t.enableVertexAttribArray(r);
    t.vertexAttribPointer(r, 2, t.FLOAT, false, 0, 0);
    t.bufferData(t.ARRAY_BUFFER, i, t.STATIC_DRAW);
  },
  _setupFrameBuffer: function _setupFrameBuffer(t) {
    var e = t.context,
        i,
        r;

    if (t.passes > 1) {
      i = t.destinationWidth;
      r = t.destinationHeight;

      if (t.sourceWidth !== i || t.sourceHeight !== r) {
        e.deleteTexture(t.targetTexture);
        t.targetTexture = t.filterBackend.createTexture(e, i, r);
      }

      e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, t.targetTexture, 0);
    } else {
      e.bindFramebuffer(e.FRAMEBUFFER, null);
      e.finish();
    }
  },
  _swapTextures: function _swapTextures(t) {
    t.passes--;
    t.pass++;
    var e = t.targetTexture;
    t.targetTexture = t.sourceTexture;
    t.sourceTexture = e;
  },
  isNeutralState: function isNeutralState() {
    var t = this.mainParameter,
        e = fabric.Image.filters[this.type].prototype;

    if (t) {
      if (Array.isArray(e[t])) {
        for (var i = e[t].length; i--;) {
          if (this[t][i] !== e[t][i]) {
            return false;
          }
        }

        return true;
      } else {
        return e[t] === this[t];
      }
    } else {
      return false;
    }
  },
  applyTo: function applyTo(t) {
    if (t.webgl) {
      this._setupFrameBuffer(t);

      this.applyToWebGL(t);

      this._swapTextures(t);
    } else {
      this.applyTo2d(t);
    }
  },
  retrieveShader: function retrieveShader(t) {
    if (!t.programCache.hasOwnProperty(this.type)) {
      t.programCache[this.type] = this.createProgram(t.context);
    }

    return t.programCache[this.type];
  },
  applyToWebGL: function applyToWebGL(t) {
    var e = t.context;
    var i = this.retrieveShader(t);

    if (t.pass === 0 && t.originalTexture) {
      e.bindTexture(e.TEXTURE_2D, t.originalTexture);
    } else {
      e.bindTexture(e.TEXTURE_2D, t.sourceTexture);
    }

    e.useProgram(i.program);
    this.sendAttributeData(e, i.attributeLocations, t.aPosition);
    e.uniform1f(i.uniformLocations.uStepW, 1 / t.sourceWidth);
    e.uniform1f(i.uniformLocations.uStepH, 1 / t.sourceHeight);
    this.sendUniformData(e, i.uniformLocations);
    e.viewport(0, 0, t.destinationWidth, t.destinationHeight);
    e.drawArrays(e.TRIANGLE_STRIP, 0, 4);
  },
  bindAdditionalTexture: function bindAdditionalTexture(t, e, i) {
    t.activeTexture(i);
    t.bindTexture(t.TEXTURE_2D, e);
    t.activeTexture(t.TEXTURE0);
  },
  unbindAdditionalTexture: function unbindAdditionalTexture(t, e) {
    t.activeTexture(e);
    t.bindTexture(t.TEXTURE_2D, null);
    t.activeTexture(t.TEXTURE0);
  },
  getMainParameter: function getMainParameter() {
    return this[this.mainParameter];
  },
  setMainParameter: function setMainParameter(t) {
    this[this.mainParameter] = t;
  },
  sendUniformData: function sendUniformData() {},
  createHelpLayer: function createHelpLayer(t) {
    if (!t.helpLayer) {
      var e = document.createElement("canvas");
      e.width = t.sourceWidth;
      e.height = t.sourceHeight;
      t.helpLayer = e;
    }
  },
  toObject: function toObject() {
    var t = {
      type: this.type
    },
        e = this.mainParameter;

    if (e) {
      t[e] = this[e];
    }

    return t;
  },
  toJSON: function toJSON() {
    return this.toObject();
  }
});

fabric.Image.filters.BaseFilter.fromObject = function (t, e) {
  var i = new fabric.Image.filters[t.type](t);
  e && e(i);
  return i;
};

(function (t) {
  "use strict";

  var e = t.fabric || (t.fabric = {}),
      i = e.Image.filters,
      r = e.util.createClass;
  i.ColorMatrix = r(i.BaseFilter, {
    type: "ColorMatrix",
    fragmentSource: "precision highp float;\n" + "uniform sampler2D uTexture;\n" + "varying vec2 vTexCoord;\n" + "uniform mat4 uColorMatrix;\n" + "uniform vec4 uConstants;\n" + "void main() {\n" + "vec4 color = texture2D(uTexture, vTexCoord);\n" + "color *= uColorMatrix;\n" + "color += uConstants;\n" + "gl_FragColor = color;\n" + "}",
    matrix: [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0],
    mainParameter: "matrix",
    colorsOnly: true,
    initialize: function initialize(t) {
      this.callSuper("initialize", t);
      this.matrix = this.matrix.slice(0);
    },
    applyTo2d: function applyTo2d(t) {
      var e = t.imageData,
          i = e.data,
          r = i.length,
          n = this.matrix,
          s,
          o,
          a,
          c,
          l,
          h = this.colorsOnly;

      for (l = 0; l < r; l += 4) {
        s = i[l];
        o = i[l + 1];
        a = i[l + 2];

        if (h) {
          i[l] = s * n[0] + o * n[1] + a * n[2] + n[4] * 255;
          i[l + 1] = s * n[5] + o * n[6] + a * n[7] + n[9] * 255;
          i[l + 2] = s * n[10] + o * n[11] + a * n[12] + n[14] * 255;
        } else {
          c = i[l + 3];
          i[l] = s * n[0] + o * n[1] + a * n[2] + c * n[3] + n[4] * 255;
          i[l + 1] = s * n[5] + o * n[6] + a * n[7] + c * n[8] + n[9] * 255;
          i[l + 2] = s * n[10] + o * n[11] + a * n[12] + c * n[13] + n[14] * 255;
          i[l + 3] = s * n[15] + o * n[16] + a * n[17] + c * n[18] + n[19] * 255;
        }
      }
    },
    getUniformLocations: function getUniformLocations(t, e) {
      return {
        uColorMatrix: t.getUniformLocation(e, "uColorMatrix"),
        uConstants: t.getUniformLocation(e, "uConstants")
      };
    },
    sendUniformData: function sendUniformData(t, e) {
      var i = this.matrix,
          r = [i[0], i[1], i[2], i[3], i[5], i[6], i[7], i[8], i[10], i[11], i[12], i[13], i[15], i[16], i[17], i[18]],
          n = [i[4], i[9], i[14], i[19]];
      t.uniformMatrix4fv(e.uColorMatrix, false, r);
      t.uniform4fv(e.uConstants, n);
    }
  });
  e.Image.filters.ColorMatrix.fromObject = e.Image.filters.BaseFilter.fromObject;
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var e = t.fabric || (t.fabric = {}),
      i = e.Image.filters,
      r = e.util.createClass;
  i.Brightness = r(i.BaseFilter, {
    type: "Brightness",
    fragmentSource: "precision highp float;\n" + "uniform sampler2D uTexture;\n" + "uniform float uBrightness;\n" + "varying vec2 vTexCoord;\n" + "void main() {\n" + "vec4 color = texture2D(uTexture, vTexCoord);\n" + "color.rgb += uBrightness;\n" + "gl_FragColor = color;\n" + "}",
    brightness: 0,
    mainParameter: "brightness",
    applyTo2d: function applyTo2d(t) {
      if (this.brightness === 0) {
        return;
      }

      var e = t.imageData,
          i = e.data,
          r,
          n = i.length,
          s = Math.round(this.brightness * 255);

      for (r = 0; r < n; r += 4) {
        i[r] = i[r] + s;
        i[r + 1] = i[r + 1] + s;
        i[r + 2] = i[r + 2] + s;
      }
    },
    getUniformLocations: function getUniformLocations(t, e) {
      return {
        uBrightness: t.getUniformLocation(e, "uBrightness")
      };
    },
    sendUniformData: function sendUniformData(t, e) {
      t.uniform1f(e.uBrightness, this.brightness);
    }
  });
  e.Image.filters.Brightness.fromObject = e.Image.filters.BaseFilter.fromObject;
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var e = t.fabric || (t.fabric = {}),
      i = e.util.object.extend,
      r = e.Image.filters,
      n = e.util.createClass;
  r.Convolute = n(r.BaseFilter, {
    type: "Convolute",
    opaque: false,
    matrix: [0, 0, 0, 0, 1, 0, 0, 0, 0],
    fragmentSource: {
      Convolute_3_1: "precision highp float;\n" + "uniform sampler2D uTexture;\n" + "uniform float uMatrix[9];\n" + "uniform float uStepW;\n" + "uniform float uStepH;\n" + "varying vec2 vTexCoord;\n" + "void main() {\n" + "vec4 color = vec4(0, 0, 0, 0);\n" + "for (float h = 0.0; h < 3.0; h+=1.0) {\n" + "for (float w = 0.0; w < 3.0; w+=1.0) {\n" + "vec2 matrixPos = vec2(uStepW * (w - 1), uStepH * (h - 1));\n" + "color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 3.0 + w)];\n" + "}\n" + "}\n" + "gl_FragColor = color;\n" + "}",
      Convolute_3_0: "precision highp float;\n" + "uniform sampler2D uTexture;\n" + "uniform float uMatrix[9];\n" + "uniform float uStepW;\n" + "uniform float uStepH;\n" + "varying vec2 vTexCoord;\n" + "void main() {\n" + "vec4 color = vec4(0, 0, 0, 1);\n" + "for (float h = 0.0; h < 3.0; h+=1.0) {\n" + "for (float w = 0.0; w < 3.0; w+=1.0) {\n" + "vec2 matrixPos = vec2(uStepW * (w - 1.0), uStepH * (h - 1.0));\n" + "color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 3.0 + w)];\n" + "}\n" + "}\n" + "float alpha = texture2D(uTexture, vTexCoord).a;\n" + "gl_FragColor = color;\n" + "gl_FragColor.a = alpha;\n" + "}",
      Convolute_5_1: "precision highp float;\n" + "uniform sampler2D uTexture;\n" + "uniform float uMatrix[25];\n" + "uniform float uStepW;\n" + "uniform float uStepH;\n" + "varying vec2 vTexCoord;\n" + "void main() {\n" + "vec4 color = vec4(0, 0, 0, 0);\n" + "for (float h = 0.0; h < 5.0; h+=1.0) {\n" + "for (float w = 0.0; w < 5.0; w+=1.0) {\n" + "vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));\n" + "color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 5.0 + w)];\n" + "}\n" + "}\n" + "gl_FragColor = color;\n" + "}",
      Convolute_5_0: "precision highp float;\n" + "uniform sampler2D uTexture;\n" + "uniform float uMatrix[25];\n" + "uniform float uStepW;\n" + "uniform float uStepH;\n" + "varying vec2 vTexCoord;\n" + "void main() {\n" + "vec4 color = vec4(0, 0, 0, 1);\n" + "for (float h = 0.0; h < 5.0; h+=1.0) {\n" + "for (float w = 0.0; w < 5.0; w+=1.0) {\n" + "vec2 matrixPos = vec2(uStepW * (w - 2.0), uStepH * (h - 2.0));\n" + "color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 5.0 + w)];\n" + "}\n" + "}\n" + "float alpha = texture2D(uTexture, vTexCoord).a;\n" + "gl_FragColor = color;\n" + "gl_FragColor.a = alpha;\n" + "}",
      Convolute_7_1: "precision highp float;\n" + "uniform sampler2D uTexture;\n" + "uniform float uMatrix[49];\n" + "uniform float uStepW;\n" + "uniform float uStepH;\n" + "varying vec2 vTexCoord;\n" + "void main() {\n" + "vec4 color = vec4(0, 0, 0, 0);\n" + "for (float h = 0.0; h < 7.0; h+=1.0) {\n" + "for (float w = 0.0; w < 7.0; w+=1.0) {\n" + "vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));\n" + "color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 7.0 + w)];\n" + "}\n" + "}\n" + "gl_FragColor = color;\n" + "}",
      Convolute_7_0: "precision highp float;\n" + "uniform sampler2D uTexture;\n" + "uniform float uMatrix[49];\n" + "uniform float uStepW;\n" + "uniform float uStepH;\n" + "varying vec2 vTexCoord;\n" + "void main() {\n" + "vec4 color = vec4(0, 0, 0, 1);\n" + "for (float h = 0.0; h < 7.0; h+=1.0) {\n" + "for (float w = 0.0; w < 7.0; w+=1.0) {\n" + "vec2 matrixPos = vec2(uStepW * (w - 3.0), uStepH * (h - 3.0));\n" + "color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 7.0 + w)];\n" + "}\n" + "}\n" + "float alpha = texture2D(uTexture, vTexCoord).a;\n" + "gl_FragColor = color;\n" + "gl_FragColor.a = alpha;\n" + "}",
      Convolute_9_1: "precision highp float;\n" + "uniform sampler2D uTexture;\n" + "uniform float uMatrix[81];\n" + "uniform float uStepW;\n" + "uniform float uStepH;\n" + "varying vec2 vTexCoord;\n" + "void main() {\n" + "vec4 color = vec4(0, 0, 0, 0);\n" + "for (float h = 0.0; h < 9.0; h+=1.0) {\n" + "for (float w = 0.0; w < 9.0; w+=1.0) {\n" + "vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));\n" + "color += texture2D(uTexture, vTexCoord + matrixPos) * uMatrix[int(h * 9.0 + w)];\n" + "}\n" + "}\n" + "gl_FragColor = color;\n" + "}",
      Convolute_9_0: "precision highp float;\n" + "uniform sampler2D uTexture;\n" + "uniform float uMatrix[81];\n" + "uniform float uStepW;\n" + "uniform float uStepH;\n" + "varying vec2 vTexCoord;\n" + "void main() {\n" + "vec4 color = vec4(0, 0, 0, 1);\n" + "for (float h = 0.0; h < 9.0; h+=1.0) {\n" + "for (float w = 0.0; w < 9.0; w+=1.0) {\n" + "vec2 matrixPos = vec2(uStepW * (w - 4.0), uStepH * (h - 4.0));\n" + "color.rgb += texture2D(uTexture, vTexCoord + matrixPos).rgb * uMatrix[int(h * 9.0 + w)];\n" + "}\n" + "}\n" + "float alpha = texture2D(uTexture, vTexCoord).a;\n" + "gl_FragColor = color;\n" + "gl_FragColor.a = alpha;\n" + "}"
    },
    retrieveShader: function retrieveShader(t) {
      var e = Math.sqrt(this.matrix.length);
      var i = this.type + "_" + e + "_" + (this.opaque ? 1 : 0);
      var r = this.fragmentSource[i];

      if (!t.programCache.hasOwnProperty(i)) {
        t.programCache[i] = this.createProgram(t.context, r);
      }

      return t.programCache[i];
    },
    applyTo2d: function applyTo2d(t) {
      var e = t.imageData,
          i = e.data,
          r = this.matrix,
          n = Math.round(Math.sqrt(r.length)),
          s = Math.floor(n / 2),
          o = e.width,
          a = e.height,
          c = t.ctx.createImageData(o, a),
          l = c.data,
          h = this.opaque ? 1 : 0,
          f,
          u,
          d,
          g,
          p,
          v,
          m,
          b,
          y,
          _,
          x,
          C,
          w;

      for (x = 0; x < a; x++) {
        for (_ = 0; _ < o; _++) {
          p = (x * o + _) * 4;
          f = 0;
          u = 0;
          d = 0;
          g = 0;

          for (w = 0; w < n; w++) {
            for (C = 0; C < n; C++) {
              m = x + w - s;
              v = _ + C - s;

              if (m < 0 || m >= a || v < 0 || v >= o) {
                continue;
              }

              b = (m * o + v) * 4;
              y = r[w * n + C];
              f += i[b] * y;
              u += i[b + 1] * y;
              d += i[b + 2] * y;

              if (!h) {
                g += i[b + 3] * y;
              }
            }
          }

          l[p] = f;
          l[p + 1] = u;
          l[p + 2] = d;

          if (!h) {
            l[p + 3] = g;
          } else {
            l[p + 3] = i[p + 3];
          }
        }
      }

      t.imageData = c;
    },
    getUniformLocations: function getUniformLocations(t, e) {
      return {
        uMatrix: t.getUniformLocation(e, "uMatrix"),
        uOpaque: t.getUniformLocation(e, "uOpaque"),
        uHalfSize: t.getUniformLocation(e, "uHalfSize"),
        uSize: t.getUniformLocation(e, "uSize")
      };
    },
    sendUniformData: function sendUniformData(t, e) {
      t.uniform1fv(e.uMatrix, this.matrix);
    },
    toObject: function toObject() {
      return i(this.callSuper("toObject"), {
        opaque: this.opaque,
        matrix: this.matrix
      });
    }
  });
  e.Image.filters.Convolute.fromObject = e.Image.filters.BaseFilter.fromObject;
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var e = t.fabric || (t.fabric = {}),
      i = e.Image.filters,
      r = e.util.createClass;
  i.Grayscale = r(i.BaseFilter, {
    type: "Grayscale",
    fragmentSource: {
      average: "precision highp float;\n" + "uniform sampler2D uTexture;\n" + "varying vec2 vTexCoord;\n" + "void main() {\n" + "vec4 color = texture2D(uTexture, vTexCoord);\n" + "float average = (color.r + color.b + color.g) / 3.0;\n" + "gl_FragColor = vec4(average, average, average, color.a);\n" + "}",
      lightness: "precision highp float;\n" + "uniform sampler2D uTexture;\n" + "uniform int uMode;\n" + "varying vec2 vTexCoord;\n" + "void main() {\n" + "vec4 col = texture2D(uTexture, vTexCoord);\n" + "float average = (max(max(col.r, col.g),col.b) + min(min(col.r, col.g),col.b)) / 2.0;\n" + "gl_FragColor = vec4(average, average, average, col.a);\n" + "}",
      luminosity: "precision highp float;\n" + "uniform sampler2D uTexture;\n" + "uniform int uMode;\n" + "varying vec2 vTexCoord;\n" + "void main() {\n" + "vec4 col = texture2D(uTexture, vTexCoord);\n" + "float average = 0.21 * col.r + 0.72 * col.g + 0.07 * col.b;\n" + "gl_FragColor = vec4(average, average, average, col.a);\n" + "}"
    },
    mode: "average",
    mainParameter: "mode",
    applyTo2d: function applyTo2d(t) {
      var e = t.imageData,
          i = e.data,
          r,
          n = i.length,
          s,
          o = this.mode;

      for (r = 0; r < n; r += 4) {
        if (o === "average") {
          s = (i[r] + i[r + 1] + i[r + 2]) / 3;
        } else if (o === "lightness") {
          s = (Math.min(i[r], i[r + 1], i[r + 2]) + Math.max(i[r], i[r + 1], i[r + 2])) / 2;
        } else if (o === "luminosity") {
          s = .21 * i[r] + .72 * i[r + 1] + .07 * i[r + 2];
        }

        i[r] = s;
        i[r + 1] = s;
        i[r + 2] = s;
      }
    },
    retrieveShader: function retrieveShader(t) {
      var e = this.type + "_" + this.mode;

      if (!t.programCache.hasOwnProperty(e)) {
        var i = this.fragmentSource[this.mode];
        t.programCache[e] = this.createProgram(t.context, i);
      }

      return t.programCache[e];
    },
    getUniformLocations: function getUniformLocations(t, e) {
      return {
        uMode: t.getUniformLocation(e, "uMode")
      };
    },
    sendUniformData: function sendUniformData(t, e) {
      var i = 1;
      t.uniform1i(e.uMode, i);
    },
    isNeutralState: function isNeutralState() {
      return false;
    }
  });
  e.Image.filters.Grayscale.fromObject = e.Image.filters.BaseFilter.fromObject;
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var e = t.fabric || (t.fabric = {}),
      i = e.Image.filters,
      r = e.util.createClass;
  i.Invert = r(i.BaseFilter, {
    type: "Invert",
    fragmentSource: "precision highp float;\n" + "uniform sampler2D uTexture;\n" + "uniform int uInvert;\n" + "varying vec2 vTexCoord;\n" + "void main() {\n" + "vec4 color = texture2D(uTexture, vTexCoord);\n" + "if (uInvert == 1) {\n" + "gl_FragColor = vec4(1.0 - color.r,1.0 -color.g,1.0 -color.b,color.a);\n" + "} else {\n" + "gl_FragColor = color;\n" + "}\n" + "}",
    invert: true,
    mainParameter: "invert",
    applyTo2d: function applyTo2d(t) {
      var e = t.imageData,
          i = e.data,
          r,
          n = i.length;

      for (r = 0; r < n; r += 4) {
        i[r] = 255 - i[r];
        i[r + 1] = 255 - i[r + 1];
        i[r + 2] = 255 - i[r + 2];
      }
    },
    isNeutralState: function isNeutralState() {
      return !this.invert;
    },
    getUniformLocations: function getUniformLocations(t, e) {
      return {
        uInvert: t.getUniformLocation(e, "uInvert")
      };
    },
    sendUniformData: function sendUniformData(t, e) {
      t.uniform1i(e.uInvert, this.invert);
    }
  });
  e.Image.filters.Invert.fromObject = e.Image.filters.BaseFilter.fromObject;
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var e = t.fabric || (t.fabric = {}),
      i = e.util.object.extend,
      r = e.Image.filters,
      n = e.util.createClass;
  r.Noise = n(r.BaseFilter, {
    type: "Noise",
    fragmentSource: "precision highp float;\n" + "uniform sampler2D uTexture;\n" + "uniform float uStepH;\n" + "uniform float uNoise;\n" + "uniform float uSeed;\n" + "varying vec2 vTexCoord;\n" + "float rand(vec2 co, float seed, float vScale) {\n" + "return fract(sin(dot(co.xy * vScale ,vec2(12.9898 , 78.233))) * 43758.5453 * (seed + 0.01) / 2.0);\n" + "}\n" + "void main() {\n" + "vec4 color = texture2D(uTexture, vTexCoord);\n" + "color.rgb += (0.5 - rand(vTexCoord, uSeed, 0.1 / uStepH)) * uNoise;\n" + "gl_FragColor = color;\n" + "}",
    mainParameter: "noise",
    noise: 0,
    applyTo2d: function applyTo2d(t) {
      if (this.noise === 0) {
        return;
      }

      var e = t.imageData,
          i = e.data,
          r,
          n = i.length,
          s = this.noise,
          o;

      for (r = 0, n = i.length; r < n; r += 4) {
        o = (.5 - Math.random()) * s;
        i[r] += o;
        i[r + 1] += o;
        i[r + 2] += o;
      }
    },
    getUniformLocations: function getUniformLocations(t, e) {
      return {
        uNoise: t.getUniformLocation(e, "uNoise"),
        uSeed: t.getUniformLocation(e, "uSeed")
      };
    },
    sendUniformData: function sendUniformData(t, e) {
      t.uniform1f(e.uNoise, this.noise / 255);
      t.uniform1f(e.uSeed, Math.random());
    },
    toObject: function toObject() {
      return i(this.callSuper("toObject"), {
        noise: this.noise
      });
    }
  });
  e.Image.filters.Noise.fromObject = e.Image.filters.BaseFilter.fromObject;
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var e = t.fabric || (t.fabric = {}),
      i = e.Image.filters,
      r = e.util.createClass;
  i.Pixelate = r(i.BaseFilter, {
    type: "Pixelate",
    blocksize: 4,
    mainParameter: "blocksize",
    fragmentSource: "precision highp float;\n" + "uniform sampler2D uTexture;\n" + "uniform float uBlocksize;\n" + "uniform float uStepW;\n" + "uniform float uStepH;\n" + "varying vec2 vTexCoord;\n" + "void main() {\n" + "float blockW = uBlocksize * uStepW;\n" + "float blockH = uBlocksize * uStepW;\n" + "int posX = int(vTexCoord.x / blockW);\n" + "int posY = int(vTexCoord.y / blockH);\n" + "float fposX = float(posX);\n" + "float fposY = float(posY);\n" + "vec2 squareCoords = vec2(fposX * blockW, fposY * blockH);\n" + "vec4 color = texture2D(uTexture, squareCoords);\n" + "gl_FragColor = color;\n" + "}",
    applyTo2d: function applyTo2d(t) {
      var e = t.imageData,
          i = e.data,
          r = e.height,
          n = e.width,
          s,
          o,
          a,
          c,
          l,
          h,
          f,
          u,
          d,
          g,
          p;

      for (o = 0; o < r; o += this.blocksize) {
        for (a = 0; a < n; a += this.blocksize) {
          s = o * 4 * n + a * 4;
          c = i[s];
          l = i[s + 1];
          h = i[s + 2];
          f = i[s + 3];
          g = Math.min(o + this.blocksize, r);
          p = Math.min(a + this.blocksize, n);

          for (u = o; u < g; u++) {
            for (d = a; d < p; d++) {
              s = u * 4 * n + d * 4;
              i[s] = c;
              i[s + 1] = l;
              i[s + 2] = h;
              i[s + 3] = f;
            }
          }
        }
      }
    },
    isNeutralState: function isNeutralState() {
      return this.blocksize === 1;
    },
    getUniformLocations: function getUniformLocations(t, e) {
      return {
        uBlocksize: t.getUniformLocation(e, "uBlocksize"),
        uStepW: t.getUniformLocation(e, "uStepW"),
        uStepH: t.getUniformLocation(e, "uStepH")
      };
    },
    sendUniformData: function sendUniformData(t, e) {
      t.uniform1f(e.uBlocksize, this.blocksize);
    }
  });
  e.Image.filters.Pixelate.fromObject = e.Image.filters.BaseFilter.fromObject;
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var f = t.fabric || (t.fabric = {}),
      e = f.util.object.extend,
      i = f.Image.filters,
      r = f.util.createClass;
  i.RemoveColor = r(i.BaseFilter, {
    type: "RemoveColor",
    color: "#FFFFFF",
    fragmentSource: "precision highp float;\n" + "uniform sampler2D uTexture;\n" + "uniform vec4 uLow;\n" + "uniform vec4 uHigh;\n" + "varying vec2 vTexCoord;\n" + "void main() {\n" + "gl_FragColor = texture2D(uTexture, vTexCoord);\n" + "if(all(greaterThan(gl_FragColor.rgb,uLow.rgb)) && all(greaterThan(uHigh.rgb,gl_FragColor.rgb))) {\n" + "gl_FragColor.a = 0.0;\n" + "}\n" + "}",
    distance: .02,
    useAlpha: false,
    applyTo2d: function applyTo2d(t) {
      var e = t.imageData,
          i = e.data,
          r,
          n = this.distance * 255,
          s,
          o,
          a,
          c = new f.Color(this.color).getSource(),
          l = [c[0] - n, c[1] - n, c[2] - n],
          h = [c[0] + n, c[1] + n, c[2] + n];

      for (r = 0; r < i.length; r += 4) {
        s = i[r];
        o = i[r + 1];
        a = i[r + 2];

        if (s > l[0] && o > l[1] && a > l[2] && s < h[0] && o < h[1] && a < h[2]) {
          i[r + 3] = 0;
        }
      }
    },
    getUniformLocations: function getUniformLocations(t, e) {
      return {
        uLow: t.getUniformLocation(e, "uLow"),
        uHigh: t.getUniformLocation(e, "uHigh")
      };
    },
    sendUniformData: function sendUniformData(t, e) {
      var i = new f.Color(this.color).getSource(),
          r = parseFloat(this.distance),
          n = [0 + i[0] / 255 - r, 0 + i[1] / 255 - r, 0 + i[2] / 255 - r, 1],
          s = [i[0] / 255 + r, i[1] / 255 + r, i[2] / 255 + r, 1];
      t.uniform4fv(e.uLow, n);
      t.uniform4fv(e.uHigh, s);
    },
    toObject: function toObject() {
      return e(this.callSuper("toObject"), {
        color: this.color,
        distance: this.distance
      });
    }
  });
  f.Image.filters.RemoveColor.fromObject = f.Image.filters.BaseFilter.fromObject;
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var e = t.fabric || (t.fabric = {}),
      i = e.Image.filters,
      r = e.util.createClass;
  var n = {
    Brownie: [.5997, .34553, -.27082, 0, .186, -.0377, .86095, .15059, 0, -.1449, .24113, -.07441, .44972, 0, -.02965, 0, 0, 0, 1, 0],
    Vintage: [.62793, .32021, -.03965, 0, .03784, .02578, .64411, .03259, 0, .02926, .0466, -.08512, .52416, 0, .02023, 0, 0, 0, 1, 0],
    Kodachrome: [1.12855, -.39673, -.03992, 0, .24991, -.16404, 1.08352, -.05498, 0, .09698, -.16786, -.56034, 1.60148, 0, .13972, 0, 0, 0, 1, 0],
    Technicolor: [1.91252, -.85453, -.09155, 0, .04624, -.30878, 1.76589, -.10601, 0, -.27589, -.2311, -.75018, 1.84759, 0, .12137, 0, 0, 0, 1, 0],
    Polaroid: [1.438, -.062, -.062, 0, 0, -.122, 1.378, -.122, 0, 0, -.016, -.016, 1.483, 0, 0, 0, 0, 0, 1, 0],
    Sepia: [.393, .769, .189, 0, 0, .349, .686, .168, 0, 0, .272, .534, .131, 0, 0, 0, 0, 0, 1, 0],
    BlackWhite: [1.5, 1.5, 1.5, 0, -1, 1.5, 1.5, 1.5, 0, -1, 1.5, 1.5, 1.5, 0, -1, 0, 0, 0, 1, 0]
  };

  for (var s in n) {
    i[s] = r(i.ColorMatrix, {
      type: s,
      matrix: n[s],
      mainParameter: false,
      colorsOnly: true
    });
    e.Image.filters[s].fromObject = e.Image.filters.BaseFilter.fromObject;
  }
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var d = t.fabric,
      e = d.Image.filters,
      i = d.util.createClass;
  e.BlendColor = i(e.BaseFilter, {
    type: "BlendColor",
    color: "#F95C63",
    mode: "multiply",
    alpha: 1,
    fragmentSource: {
      multiply: "gl_FragColor.rgb *= uColor.rgb;\n",
      screen: "gl_FragColor.rgb = 1.0 - (1.0 - gl_FragColor.rgb) * (1.0 - uColor.rgb);\n",
      add: "gl_FragColor.rgb += uColor.rgb;\n",
      diff: "gl_FragColor.rgb = abs(gl_FragColor.rgb - uColor.rgb);\n",
      subtract: "gl_FragColor.rgb -= uColor.rgb;\n",
      lighten: "gl_FragColor.rgb = max(gl_FragColor.rgb, uColor.rgb);\n",
      darken: "gl_FragColor.rgb = min(gl_FragColor.rgb, uColor.rgb);\n",
      exclusion: "gl_FragColor.rgb += uColor.rgb - 2.0 * (uColor.rgb * gl_FragColor.rgb);\n",
      overlay: "if (uColor.r < 0.5) {\n" + "gl_FragColor.r *= 2.0 * uColor.r;\n" + "} else {\n" + "gl_FragColor.r = 1.0 - 2.0 * (1.0 - gl_FragColor.r) * (1.0 - uColor.r);\n" + "}\n" + "if (uColor.g < 0.5) {\n" + "gl_FragColor.g *= 2.0 * uColor.g;\n" + "} else {\n" + "gl_FragColor.g = 1.0 - 2.0 * (1.0 - gl_FragColor.g) * (1.0 - uColor.g);\n" + "}\n" + "if (uColor.b < 0.5) {\n" + "gl_FragColor.b *= 2.0 * uColor.b;\n" + "} else {\n" + "gl_FragColor.b = 1.0 - 2.0 * (1.0 - gl_FragColor.b) * (1.0 - uColor.b);\n" + "}\n",
      tint: "gl_FragColor.rgb *= (1.0 - uColor.a);\n" + "gl_FragColor.rgb += uColor.rgb;\n"
    },
    buildSource: function buildSource(t) {
      return "precision highp float;\n" + "uniform sampler2D uTexture;\n" + "uniform vec4 uColor;\n" + "varying vec2 vTexCoord;\n" + "void main() {\n" + "vec4 color = texture2D(uTexture, vTexCoord);\n" + "gl_FragColor = color;\n" + "if (color.a > 0.0) {\n" + this.fragmentSource[t] + "}\n" + "}";
    },
    retrieveShader: function retrieveShader(t) {
      var e = this.type + "_" + this.mode,
          i;

      if (!t.programCache.hasOwnProperty(e)) {
        i = this.buildSource(this.mode);
        t.programCache[e] = this.createProgram(t.context, i);
      }

      return t.programCache[e];
    },
    applyTo2d: function applyTo2d(t) {
      var e = t.imageData,
          i = e.data,
          r = i.length,
          n,
          s,
          o,
          a,
          c,
          l,
          h,
          f = 1 - this.alpha;
      h = new d.Color(this.color).getSource();
      n = h[0] * this.alpha;
      s = h[1] * this.alpha;
      o = h[2] * this.alpha;

      for (var u = 0; u < r; u += 4) {
        a = i[u];
        c = i[u + 1];
        l = i[u + 2];

        switch (this.mode) {
          case "multiply":
            i[u] = a * n / 255;
            i[u + 1] = c * s / 255;
            i[u + 2] = l * o / 255;
            break;

          case "screen":
            i[u] = 255 - (255 - a) * (255 - n) / 255;
            i[u + 1] = 255 - (255 - c) * (255 - s) / 255;
            i[u + 2] = 255 - (255 - l) * (255 - o) / 255;
            break;

          case "add":
            i[u] = a + n;
            i[u + 1] = c + s;
            i[u + 2] = l + o;
            break;

          case "diff":
          case "difference":
            i[u] = Math.abs(a - n);
            i[u + 1] = Math.abs(c - s);
            i[u + 2] = Math.abs(l - o);
            break;

          case "subtract":
            i[u] = a - n;
            i[u + 1] = c - s;
            i[u + 2] = l - o;
            break;

          case "darken":
            i[u] = Math.min(a, n);
            i[u + 1] = Math.min(c, s);
            i[u + 2] = Math.min(l, o);
            break;

          case "lighten":
            i[u] = Math.max(a, n);
            i[u + 1] = Math.max(c, s);
            i[u + 2] = Math.max(l, o);
            break;

          case "overlay":
            i[u] = n < 128 ? 2 * a * n / 255 : 255 - 2 * (255 - a) * (255 - n) / 255;
            i[u + 1] = s < 128 ? 2 * c * s / 255 : 255 - 2 * (255 - c) * (255 - s) / 255;
            i[u + 2] = o < 128 ? 2 * l * o / 255 : 255 - 2 * (255 - l) * (255 - o) / 255;
            break;

          case "exclusion":
            i[u] = n + a - 2 * n * a / 255;
            i[u + 1] = s + c - 2 * s * c / 255;
            i[u + 2] = o + l - 2 * o * l / 255;
            break;

          case "tint":
            i[u] = n + a * f;
            i[u + 1] = s + c * f;
            i[u + 2] = o + l * f;
        }
      }
    },
    getUniformLocations: function getUniformLocations(t, e) {
      return {
        uColor: t.getUniformLocation(e, "uColor")
      };
    },
    sendUniformData: function sendUniformData(t, e) {
      var i = new d.Color(this.color).getSource();
      i[0] = this.alpha * i[0] / 255;
      i[1] = this.alpha * i[1] / 255;
      i[2] = this.alpha * i[2] / 255;
      i[3] = this.alpha;
      t.uniform4fv(e.uColor, i);
    },
    toObject: function toObject() {
      return {
        type: this.type,
        color: this.color,
        mode: this.mode,
        alpha: this.alpha
      };
    }
  });
  d.Image.filters.BlendColor.fromObject = d.Image.filters.BaseFilter.fromObject;
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var _ = t.fabric,
      e = _.Image.filters,
      i = _.util.createClass;
  e.BlendImage = i(e.BaseFilter, {
    type: "BlendImage",
    image: null,
    mode: "multiply",
    alpha: 1,
    vertexSource: "attribute vec2 aPosition;\n" + "varying vec2 vTexCoord;\n" + "varying vec2 vTexCoord2;\n" + "uniform mat3 uTransformMatrix;\n" + "void main() {\n" + "vTexCoord = aPosition;\n" + "vTexCoord2 = (uTransformMatrix * vec3(aPosition, 1.0)).xy;\n" + "gl_Position = vec4(aPosition * 2.0 - 1.0, 0.0, 1.0);\n" + "}",
    fragmentSource: {
      multiply: "precision highp float;\n" + "uniform sampler2D uTexture;\n" + "uniform sampler2D uImage;\n" + "uniform vec4 uColor;\n" + "varying vec2 vTexCoord;\n" + "varying vec2 vTexCoord2;\n" + "void main() {\n" + "vec4 color = texture2D(uTexture, vTexCoord);\n" + "vec4 color2 = texture2D(uImage, vTexCoord2);\n" + "color.rgba *= color2.rgba;\n" + "gl_FragColor = color;\n" + "}",
      mask: "precision highp float;\n" + "uniform sampler2D uTexture;\n" + "uniform sampler2D uImage;\n" + "uniform vec4 uColor;\n" + "varying vec2 vTexCoord;\n" + "varying vec2 vTexCoord2;\n" + "void main() {\n" + "vec4 color = texture2D(uTexture, vTexCoord);\n" + "vec4 color2 = texture2D(uImage, vTexCoord2);\n" + "color.a = color2.a;\n" + "gl_FragColor = color;\n" + "}"
    },
    retrieveShader: function retrieveShader(t) {
      var e = this.type + "_" + this.mode;
      var i = this.fragmentSource[this.mode];

      if (!t.programCache.hasOwnProperty(e)) {
        t.programCache[e] = this.createProgram(t.context, i);
      }

      return t.programCache[e];
    },
    applyToWebGL: function applyToWebGL(t) {
      var e = t.context,
          i = this.createTexture(t.filterBackend, this.image);
      this.bindAdditionalTexture(e, i, e.TEXTURE1);
      this.callSuper("applyToWebGL", t);
      this.unbindAdditionalTexture(e, e.TEXTURE1);
    },
    createTexture: function createTexture(t, e) {
      return t.getCachedTexture(e.cacheKey, e._element);
    },
    calculateMatrix: function calculateMatrix() {
      var t = this.image,
          e = t._element.width,
          i = t._element.height;
      return [1 / t.scaleX, 0, 0, 0, 1 / t.scaleY, 0, -t.left / e, -t.top / i, 1];
    },
    applyTo2d: function applyTo2d(t) {
      var e = t.imageData,
          i = t.filterBackend.resources,
          r = e.data,
          n = r.length,
          s = e.width,
          o = e.height,
          a,
          c,
          l,
          h,
          f,
          u,
          d,
          g,
          p,
          v,
          m = this.image,
          b;

      if (!i.blendImage) {
        i.blendImage = _.util.createCanvasElement();
      }

      p = i.blendImage;
      v = p.getContext("2d");

      if (p.width !== s || p.height !== o) {
        p.width = s;
        p.height = o;
      } else {
        v.clearRect(0, 0, s, o);
      }

      v.setTransform(m.scaleX, 0, 0, m.scaleY, m.left, m.top);
      v.drawImage(m._element, 0, 0, s, o);
      b = v.getImageData(0, 0, s, o).data;

      for (var y = 0; y < n; y += 4) {
        f = r[y];
        u = r[y + 1];
        d = r[y + 2];
        g = r[y + 3];
        a = b[y];
        c = b[y + 1];
        l = b[y + 2];
        h = b[y + 3];

        switch (this.mode) {
          case "multiply":
            r[y] = f * a / 255;
            r[y + 1] = u * c / 255;
            r[y + 2] = d * l / 255;
            r[y + 3] = g * h / 255;
            break;

          case "mask":
            r[y + 3] = h;
            break;
        }
      }
    },
    getUniformLocations: function getUniformLocations(t, e) {
      return {
        uTransformMatrix: t.getUniformLocation(e, "uTransformMatrix"),
        uImage: t.getUniformLocation(e, "uImage")
      };
    },
    sendUniformData: function sendUniformData(t, e) {
      var i = this.calculateMatrix();
      t.uniform1i(e.uImage, 1);
      t.uniformMatrix3fv(e.uTransformMatrix, false, i);
    },
    toObject: function toObject() {
      return {
        type: this.type,
        image: this.image && this.image.toObject(),
        mode: this.mode,
        alpha: this.alpha
      };
    }
  });

  _.Image.filters.BlendImage.fromObject = function (i, r) {
    _.Image.fromObject(i.image, function (t) {
      var e = _.util.object.clone(i);

      e.image = t;
      r(new _.Image.filters.BlendImage(e));
    });
  };
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var b = t.fabric || (t.fabric = {}),
      E = Math.pow,
      M = Math.floor,
      F = Math.sqrt,
      A = Math.abs,
      l = Math.round,
      r = Math.sin,
      L = Math.ceil,
      e = b.Image.filters,
      i = b.util.createClass;
  e.Resize = i(e.BaseFilter, {
    type: "Resize",
    resizeType: "hermite",
    scaleX: 1,
    scaleY: 1,
    lanczosLobes: 3,
    getUniformLocations: function getUniformLocations(t, e) {
      return {
        uDelta: t.getUniformLocation(e, "uDelta"),
        uTaps: t.getUniformLocation(e, "uTaps")
      };
    },
    sendUniformData: function sendUniformData(t, e) {
      t.uniform2fv(e.uDelta, this.horizontal ? [1 / this.width, 0] : [0, 1 / this.height]);
      t.uniform1fv(e.uTaps, this.taps);
    },
    retrieveShader: function retrieveShader(t) {
      var e = this.getFilterWindow(),
          i = this.type + "_" + e;

      if (!t.programCache.hasOwnProperty(i)) {
        var r = this.generateShader(e);
        t.programCache[i] = this.createProgram(t.context, r);
      }

      return t.programCache[i];
    },
    getFilterWindow: function getFilterWindow() {
      var t = this.tempScale;
      return Math.ceil(this.lanczosLobes / t);
    },
    getTaps: function getTaps() {
      var t = this.lanczosCreate(this.lanczosLobes),
          e = this.tempScale,
          i = this.getFilterWindow(),
          r = new Array(i);

      for (var n = 1; n <= i; n++) {
        r[n - 1] = t(n * e);
      }

      return r;
    },
    generateShader: function generateShader(t) {
      var e = new Array(t),
          i = this.fragmentSourceTOP,
          t;

      for (var r = 1; r <= t; r++) {
        e[r - 1] = r + ".0 * uDelta";
      }

      i += "uniform float uTaps[" + t + "];\n";
      i += "void main() {\n";
      i += "  vec4 color = texture2D(uTexture, vTexCoord);\n";
      i += "  float sum = 1.0;\n";
      e.forEach(function (t, e) {
        i += "  color += texture2D(uTexture, vTexCoord + " + t + ") * uTaps[" + e + "];\n";
        i += "  color += texture2D(uTexture, vTexCoord - " + t + ") * uTaps[" + e + "];\n";
        i += "  sum += 2.0 * uTaps[" + e + "];\n";
      });
      i += "  gl_FragColor = color / sum;\n";
      i += "}";
      return i;
    },
    fragmentSourceTOP: "precision highp float;\n" + "uniform sampler2D uTexture;\n" + "uniform vec2 uDelta;\n" + "varying vec2 vTexCoord;\n",
    applyTo: function applyTo(t) {
      if (t.webgl) {
        t.passes++;
        this.width = t.sourceWidth;
        this.horizontal = true;
        this.dW = Math.round(this.width * this.scaleX);
        this.dH = t.sourceHeight;
        this.tempScale = this.dW / this.width;
        this.taps = this.getTaps();
        t.destinationWidth = this.dW;

        this._setupFrameBuffer(t);

        this.applyToWebGL(t);

        this._swapTextures(t);

        t.sourceWidth = t.destinationWidth;
        this.height = t.sourceHeight;
        this.horizontal = false;
        this.dH = Math.round(this.height * this.scaleY);
        this.tempScale = this.dH / this.height;
        this.taps = this.getTaps();
        t.destinationHeight = this.dH;

        this._setupFrameBuffer(t);

        this.applyToWebGL(t);

        this._swapTextures(t);

        t.sourceHeight = t.destinationHeight;
      } else {
        this.applyTo2d(t);
      }
    },
    isNeutralState: function isNeutralState() {
      return this.scaleX === 1 && this.scaleY === 1;
    },
    lanczosCreate: function lanczosCreate(i) {
      return function (t) {
        if (t >= i || t <= -i) {
          return 0;
        }

        if (t < 1.1920929e-7 && t > -1.1920929e-7) {
          return 1;
        }

        t *= Math.PI;
        var e = t / i;
        return r(t) / t * r(e) / e;
      };
    },
    applyTo2d: function applyTo2d(t) {
      var e = t.imageData,
          i = this.scaleX,
          r = this.scaleY;
      this.rcpScaleX = 1 / i;
      this.rcpScaleY = 1 / r;
      var n = e.width,
          s = e.height,
          o = l(n * i),
          a = l(s * r),
          c;

      if (this.resizeType === "sliceHack") {
        c = this.sliceByTwo(t, n, s, o, a);
      } else if (this.resizeType === "hermite") {
        c = this.hermiteFastResize(t, n, s, o, a);
      } else if (this.resizeType === "bilinear") {
        c = this.bilinearFiltering(t, n, s, o, a);
      } else if (this.resizeType === "lanczos") {
        c = this.lanczosResize(t, n, s, o, a);
      }

      t.imageData = c;
    },
    sliceByTwo: function sliceByTwo(t, e, i, r, n) {
      var s = t.imageData,
          o = .5,
          a = false,
          c = false,
          l = e * o,
          h = i * o,
          f = b.filterBackend.resources,
          u,
          d,
          g = 0,
          p = 0,
          v = e,
          m = 0;

      if (!f.sliceByTwo) {
        f.sliceByTwo = document.createElement("canvas");
      }

      u = f.sliceByTwo;

      if (u.width < e * 1.5 || u.height < i) {
        u.width = e * 1.5;
        u.height = i;
      }

      d = u.getContext("2d");
      d.clearRect(0, 0, e * 1.5, i);
      d.putImageData(s, 0, 0);
      r = M(r);
      n = M(n);

      while (!a || !c) {
        e = l;
        i = h;

        if (r < M(l * o)) {
          l = M(l * o);
        } else {
          l = r;
          a = true;
        }

        if (n < M(h * o)) {
          h = M(h * o);
        } else {
          h = n;
          c = true;
        }

        d.drawImage(u, g, p, e, i, v, m, l, h);
        g = v;
        p = m;
        m += h;
      }

      return d.getImageData(g, p, r, n);
    },
    lanczosResize: function lanczosResize(t, d, g, p, v) {
      function m(t) {
        var e, i, r, n, s, o, a, c, l, h, f;
        P.x = (t + .5) * C;
        D.x = M(P.x);

        for (e = 0; e < v; e++) {
          P.y = (e + .5) * w;
          D.y = M(P.y);
          s = 0;
          o = 0;
          a = 0;
          c = 0;
          l = 0;

          for (i = D.x - O; i <= D.x + O; i++) {
            if (i < 0 || i >= d) {
              continue;
            }

            h = M(1e3 * A(i - P.x));

            if (!k[h]) {
              k[h] = {};
            }

            for (var u = D.y - j; u <= D.y + j; u++) {
              if (u < 0 || u >= g) {
                continue;
              }

              f = M(1e3 * A(u - P.y));

              if (!k[h][f]) {
                k[h][f] = x(F(E(h * S, 2) + E(f * T, 2)) / 1e3);
              }

              r = k[h][f];

              if (r > 0) {
                n = (u * d + i) * 4;
                s += r;
                o += r * b[n];
                a += r * b[n + 1];
                c += r * b[n + 2];
                l += r * b[n + 3];
              }
            }
          }

          n = (e * p + t) * 4;
          _[n] = o / s;
          _[n + 1] = a / s;
          _[n + 2] = c / s;
          _[n + 3] = l / s;
        }

        if (++t < p) {
          return m(t);
        } else {
          return y;
        }
      }

      var b = t.imageData.data,
          y = t.ctx.createImageData(p, v),
          _ = y.data,
          x = this.lanczosCreate(this.lanczosLobes),
          C = this.rcpScaleX,
          w = this.rcpScaleY,
          S = 2 / this.rcpScaleX,
          T = 2 / this.rcpScaleY,
          O = L(C * this.lanczosLobes / 2),
          j = L(w * this.lanczosLobes / 2),
          k = {},
          P = {},
          D = {};
      return m(0);
    },
    bilinearFiltering: function bilinearFiltering(t, e, i, r, n) {
      var s,
          o,
          a,
          c,
          l,
          h,
          f,
          u,
          d,
          g,
          p,
          v,
          m = 0,
          b,
          y = this.rcpScaleX,
          _ = this.rcpScaleY,
          x = 4 * (e - 1),
          C = t.imageData,
          w = C.data,
          S = t.ctx.createImageData(r, n),
          T = S.data;

      for (f = 0; f < n; f++) {
        for (u = 0; u < r; u++) {
          l = M(y * u);
          h = M(_ * f);
          d = y * u - l;
          g = _ * f - h;
          b = 4 * (h * e + l);

          for (p = 0; p < 4; p++) {
            s = w[b + p];
            o = w[b + 4 + p];
            a = w[b + x + p];
            c = w[b + x + 4 + p];
            v = s * (1 - d) * (1 - g) + o * d * (1 - g) + a * g * (1 - d) + c * d * g;
            T[m++] = v;
          }
        }
      }

      return S;
    },
    hermiteFastResize: function hermiteFastResize(t, e, i, r, n) {
      var s = this.rcpScaleX,
          o = this.rcpScaleY,
          a = L(s / 2),
          c = L(o / 2),
          l = t.imageData,
          h = l.data,
          f = t.ctx.createImageData(r, n),
          u = f.data;

      for (var d = 0; d < n; d++) {
        for (var g = 0; g < r; g++) {
          var p = (g + d * r) * 4,
              v = 0,
              m = 0,
              b = 0,
              y = 0,
              _ = 0,
              x = 0,
              C = 0,
              w = (d + .5) * o;

          for (var S = M(d * o); S < (d + 1) * o; S++) {
            var T = A(w - (S + .5)) / c,
                O = (g + .5) * s,
                j = T * T;

            for (var k = M(g * s); k < (g + 1) * s; k++) {
              var P = A(O - (k + .5)) / a,
                  D = F(j + P * P);

              if (D > 1 && D < -1) {
                continue;
              }

              v = 2 * D * D * D - 3 * D * D + 1;

              if (v > 0) {
                P = 4 * (k + S * e);
                C += v * h[P + 3];
                b += v;

                if (h[P + 3] < 255) {
                  v = v * h[P + 3] / 250;
                }

                y += v * h[P];
                _ += v * h[P + 1];
                x += v * h[P + 2];
                m += v;
              }
            }
          }

          u[p] = y / m;
          u[p + 1] = _ / m;
          u[p + 2] = x / m;
          u[p + 3] = C / b;
        }
      }

      return f;
    },
    toObject: function toObject() {
      return {
        type: this.type,
        scaleX: this.scaleX,
        scaleY: this.scaleY,
        resizeType: this.resizeType,
        lanczosLobes: this.lanczosLobes
      };
    }
  });
  b.Image.filters.Resize.fromObject = b.Image.filters.BaseFilter.fromObject;
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var e = t.fabric || (t.fabric = {}),
      i = e.Image.filters,
      r = e.util.createClass;
  i.Contrast = r(i.BaseFilter, {
    type: "Contrast",
    fragmentSource: "precision highp float;\n" + "uniform sampler2D uTexture;\n" + "uniform float uContrast;\n" + "varying vec2 vTexCoord;\n" + "void main() {\n" + "vec4 color = texture2D(uTexture, vTexCoord);\n" + "float contrastF = 1.015 * (uContrast + 1.0) / (1.0 * (1.015 - uContrast));\n" + "color.rgb = contrastF * (color.rgb - 0.5) + 0.5;\n" + "gl_FragColor = color;\n" + "}",
    contrast: 0,
    mainParameter: "contrast",
    applyTo2d: function applyTo2d(t) {
      if (this.contrast === 0) {
        return;
      }

      var e = t.imageData,
          i,
          r,
          n = e.data,
          r = n.length,
          s = Math.floor(this.contrast * 255),
          o = 259 * (s + 255) / (255 * (259 - s));

      for (i = 0; i < r; i += 4) {
        n[i] = o * (n[i] - 128) + 128;
        n[i + 1] = o * (n[i + 1] - 128) + 128;
        n[i + 2] = o * (n[i + 2] - 128) + 128;
      }
    },
    getUniformLocations: function getUniformLocations(t, e) {
      return {
        uContrast: t.getUniformLocation(e, "uContrast")
      };
    },
    sendUniformData: function sendUniformData(t, e) {
      t.uniform1f(e.uContrast, this.contrast);
    }
  });
  e.Image.filters.Contrast.fromObject = e.Image.filters.BaseFilter.fromObject;
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var e = t.fabric || (t.fabric = {}),
      i = e.Image.filters,
      r = e.util.createClass;
  i.Saturation = r(i.BaseFilter, {
    type: "Saturation",
    fragmentSource: "precision highp float;\n" + "uniform sampler2D uTexture;\n" + "uniform float uSaturation;\n" + "varying vec2 vTexCoord;\n" + "void main() {\n" + "vec4 color = texture2D(uTexture, vTexCoord);\n" + "float rgMax = max(color.r, color.g);\n" + "float rgbMax = max(rgMax, color.b);\n" + "color.r += rgbMax != color.r ? (rgbMax - color.r) * uSaturation : 0.00;\n" + "color.g += rgbMax != color.g ? (rgbMax - color.g) * uSaturation : 0.00;\n" + "color.b += rgbMax != color.b ? (rgbMax - color.b) * uSaturation : 0.00;\n" + "gl_FragColor = color;\n" + "}",
    saturation: 0,
    mainParameter: "saturation",
    applyTo2d: function applyTo2d(t) {
      if (this.saturation === 0) {
        return;
      }

      var e = t.imageData,
          i = e.data,
          r = i.length,
          n = -this.saturation,
          s,
          o;

      for (s = 0; s < r; s += 4) {
        o = Math.max(i[s], i[s + 1], i[s + 2]);
        i[s] += o !== i[s] ? (o - i[s]) * n : 0;
        i[s + 1] += o !== i[s + 1] ? (o - i[s + 1]) * n : 0;
        i[s + 2] += o !== i[s + 2] ? (o - i[s + 2]) * n : 0;
      }
    },
    getUniformLocations: function getUniformLocations(t, e) {
      return {
        uSaturation: t.getUniformLocation(e, "uSaturation")
      };
    },
    sendUniformData: function sendUniformData(t, e) {
      t.uniform1f(e.uSaturation, -this.saturation);
    }
  });
  e.Image.filters.Saturation.fromObject = e.Image.filters.BaseFilter.fromObject;
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var p = t.fabric || (t.fabric = {}),
      e = p.Image.filters,
      i = p.util.createClass;
  e.Blur = i(e.BaseFilter, {
    type: "Blur",
    fragmentSource: "precision highp float;\n" + "uniform sampler2D uTexture;\n" + "uniform vec2 uDelta;\n" + "varying vec2 vTexCoord;\n" + "const float nSamples = 15.0;\n" + "vec3 v3offset = vec3(12.9898, 78.233, 151.7182);\n" + "float random(vec3 scale) {\n" + "return fract(sin(dot(gl_FragCoord.xyz, scale)) * 43758.5453);\n" + "}\n" + "void main() {\n" + "vec4 color = vec4(0.0);\n" + "float total = 0.0;\n" + "float offset = random(v3offset);\n" + "for (float t = -nSamples; t <= nSamples; t++) {\n" + "float percent = (t + offset - 0.5) / nSamples;\n" + "float weight = 1.0 - abs(percent);\n" + "color += texture2D(uTexture, vTexCoord + uDelta * percent) * weight;\n" + "total += weight;\n" + "}\n" + "gl_FragColor = color / total;\n" + "}",
    blur: 0,
    mainParameter: "blur",
    applyTo: function applyTo(t) {
      if (t.webgl) {
        this.aspectRatio = t.sourceWidth / t.sourceHeight;
        t.passes++;

        this._setupFrameBuffer(t);

        this.horizontal = true;
        this.applyToWebGL(t);

        this._swapTextures(t);

        this._setupFrameBuffer(t);

        this.horizontal = false;
        this.applyToWebGL(t);

        this._swapTextures(t);
      } else {
        this.applyTo2d(t);
      }
    },
    applyTo2d: function applyTo2d(t) {
      t.imageData = this.simpleBlur(t);
    },
    simpleBlur: function simpleBlur(t) {
      var e = t.filterBackend.resources,
          i,
          r,
          n = t.imageData.width,
          s = t.imageData.height;

      if (!e.blurLayer1) {
        e.blurLayer1 = p.util.createCanvasElement();
        e.blurLayer2 = p.util.createCanvasElement();
      }

      i = e.blurLayer1;
      r = e.blurLayer2;

      if (i.width !== n || i.height !== s) {
        r.width = i.width = n;
        r.height = i.height = s;
      }

      var o = i.getContext("2d"),
          a = r.getContext("2d"),
          c = 15,
          l,
          h,
          f,
          u,
          d = this.blur * .06 * .5;
      o.putImageData(t.imageData, 0, 0);
      a.clearRect(0, 0, n, s);

      for (u = -c; u <= c; u++) {
        l = (Math.random() - .5) / 4;
        h = u / c;
        f = d * h * n + l;
        a.globalAlpha = 1 - Math.abs(h);
        a.drawImage(i, f, l);
        o.drawImage(r, 0, 0);
        a.globalAlpha = 1;
        a.clearRect(0, 0, r.width, r.height);
      }

      for (u = -c; u <= c; u++) {
        l = (Math.random() - .5) / 4;
        h = u / c;
        f = d * h * s + l;
        a.globalAlpha = 1 - Math.abs(h);
        a.drawImage(i, l, f);
        o.drawImage(r, 0, 0);
        a.globalAlpha = 1;
        a.clearRect(0, 0, r.width, r.height);
      }

      t.ctx.drawImage(i, 0, 0);
      var g = t.ctx.getImageData(0, 0, i.width, i.height);
      o.globalAlpha = 1;
      o.clearRect(0, 0, i.width, i.height);
      return g;
    },
    getUniformLocations: function getUniformLocations(t, e) {
      return {
        delta: t.getUniformLocation(e, "uDelta")
      };
    },
    sendUniformData: function sendUniformData(t, e) {
      var i = this.chooseRightDelta();
      t.uniform2fv(e.delta, i);
    },
    chooseRightDelta: function chooseRightDelta() {
      var t = 1,
          e = [0, 0],
          i;

      if (this.horizontal) {
        if (this.aspectRatio > 1) {
          t = 1 / this.aspectRatio;
        }
      } else {
        if (this.aspectRatio < 1) {
          t = this.aspectRatio;
        }
      }

      i = t * this.blur * .12;

      if (this.horizontal) {
        e[0] = i;
      } else {
        e[1] = i;
      }

      return e;
    }
  });
  e.Blur.fromObject = p.Image.filters.BaseFilter.fromObject;
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var e = t.fabric || (t.fabric = {}),
      i = e.Image.filters,
      r = e.util.createClass;
  i.Gamma = r(i.BaseFilter, {
    type: "Gamma",
    fragmentSource: "precision highp float;\n" + "uniform sampler2D uTexture;\n" + "uniform vec3 uGamma;\n" + "varying vec2 vTexCoord;\n" + "void main() {\n" + "vec4 color = texture2D(uTexture, vTexCoord);\n" + "vec3 correction = (1.0 / uGamma);\n" + "color.r = pow(color.r, correction.r);\n" + "color.g = pow(color.g, correction.g);\n" + "color.b = pow(color.b, correction.b);\n" + "gl_FragColor = color;\n" + "gl_FragColor.rgb *= color.a;\n" + "}",
    gamma: [1, 1, 1],
    mainParameter: "gamma",
    initialize: function initialize(t) {
      this.gamma = [1, 1, 1];
      i.BaseFilter.prototype.initialize.call(this, t);
    },
    applyTo2d: function applyTo2d(t) {
      var e = t.imageData,
          i = e.data,
          r = this.gamma,
          n = i.length,
          s = 1 / r[0],
          o = 1 / r[1],
          a = 1 / r[2],
          c;

      if (!this.rVals) {
        this.rVals = new Uint8Array(256);
        this.gVals = new Uint8Array(256);
        this.bVals = new Uint8Array(256);
      }

      for (c = 0, n = 256; c < n; c++) {
        this.rVals[c] = Math.pow(c / 255, s) * 255;
        this.gVals[c] = Math.pow(c / 255, o) * 255;
        this.bVals[c] = Math.pow(c / 255, a) * 255;
      }

      for (c = 0, n = i.length; c < n; c += 4) {
        i[c] = this.rVals[i[c]];
        i[c + 1] = this.gVals[i[c + 1]];
        i[c + 2] = this.bVals[i[c + 2]];
      }
    },
    getUniformLocations: function getUniformLocations(t, e) {
      return {
        uGamma: t.getUniformLocation(e, "uGamma")
      };
    },
    sendUniformData: function sendUniformData(t, e) {
      t.uniform3fv(e.uGamma, this.gamma);
    }
  });
  e.Image.filters.Gamma.fromObject = e.Image.filters.BaseFilter.fromObject;
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var s = t.fabric || (t.fabric = {}),
      e = s.Image.filters,
      i = s.util.createClass;
  e.Composed = i(e.BaseFilter, {
    type: "Composed",
    subFilters: [],
    initialize: function initialize(t) {
      this.callSuper("initialize", t);
      this.subFilters = this.subFilters.slice(0);
    },
    applyTo: function applyTo(e) {
      e.passes += this.subFilters.length - 1;
      this.subFilters.forEach(function (t) {
        t.applyTo(e);
      });
    },
    toObject: function toObject() {
      return s.util.object.extend(this.callSuper("toObject"), {
        subFilters: this.subFilters.map(function (t) {
          return t.toObject();
        })
      });
    },
    isNeutralState: function isNeutralState() {
      return !this.subFilters.some(function (t) {
        return !t.isNeutralState();
      });
    }
  });

  s.Image.filters.Composed.fromObject = function (t, e) {
    var i = t.subFilters || [],
        r = i.map(function (t) {
      return new s.Image.filters[t.type](t);
    }),
        n = new s.Image.filters.Composed({
      subFilters: r
    });
    e && e(n);
    return n;
  };
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var o = t.fabric || (t.fabric = {}),
      e = o.Image.filters,
      i = o.util.createClass;
  e.HueRotation = i(e.ColorMatrix, {
    type: "HueRotation",
    rotation: 0,
    mainParameter: "rotation",
    calculateMatrix: function calculateMatrix() {
      var t = this.rotation * Math.PI,
          e = o.util.cos(t),
          i = o.util.sin(t),
          r = 1 / 3,
          n = Math.sqrt(r) * i,
          s = 1 - e;
      this.matrix = [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0];
      this.matrix[0] = e + s / 3;
      this.matrix[1] = r * s - n;
      this.matrix[2] = r * s + n;
      this.matrix[5] = r * s + n;
      this.matrix[6] = e + r * s;
      this.matrix[7] = r * s - n;
      this.matrix[10] = r * s - n;
      this.matrix[11] = r * s + n;
      this.matrix[12] = e + r * s;
    },
    isNeutralState: function isNeutralState(t) {
      this.calculateMatrix();
      return e.BaseFilter.prototype.isNeutralState.call(this, t);
    },
    applyTo: function applyTo(t) {
      this.calculateMatrix();
      e.BaseFilter.prototype.applyTo.call(this, t);
    }
  });
  o.Image.filters.HueRotation.fromObject = o.Image.filters.BaseFilter.fromObject;
})(typeof exports !== "undefined" ? exports : void 0);

(function (t) {
  "use strict";

  var o = t.fabric || (t.fabric = {}),
      r = o.util.object.clone;

  if (o.Text) {
    o.warn("fabric.Text is already defined");
    return;
  }

  o.Text = o.util.createClass(o.Object, {
    _dimensionAffectingProps: ["fontSize", "fontWeight", "fontFamily", "fontStyle", "lineHeight", "text", "charSpacing", "textAlign", "styles"],
    _reNewline: /\r?\n/,
    _reSpacesAndTabs: /[ \t\r]/g,
    _reSpaceAndTab: /[ \t\r]/,
    _reWords: /\S+/g,
    type: "text",
    fontSize: 40,
    fontWeight: "normal",
    fontFamily: "Times New Roman",
    underline: false,
    overline: false,
    linethrough: false,
    textAlign: "left",
    fontStyle: "normal",
    lineHeight: 1.16,
    superscript: {
      size: .6,
      baseline: -.35
    },
    subscript: {
      size: .6,
      baseline: .11
    },
    textBackgroundColor: "",
    stateProperties: o.Object.prototype.stateProperties.concat("fontFamily", "fontWeight", "fontSize", "text", "underline", "overline", "linethrough", "textAlign", "fontStyle", "lineHeight", "textBackgroundColor", "charSpacing", "styles"),
    cacheProperties: o.Object.prototype.cacheProperties.concat("fontFamily", "fontWeight", "fontSize", "text", "underline", "overline", "linethrough", "textAlign", "fontStyle", "lineHeight", "textBackgroundColor", "charSpacing", "styles"),
    stroke: null,
    shadow: null,
    _fontSizeFraction: .222,
    offsets: {
      underline: .1,
      linethrough: -.315,
      overline: -.88
    },
    _fontSizeMult: 1.13,
    charSpacing: 0,
    styles: null,
    _measuringContext: null,
    deltaY: 0,
    _styleProperties: ["stroke", "strokeWidth", "fill", "fontFamily", "fontSize", "fontWeight", "fontStyle", "underline", "overline", "linethrough", "deltaY", "textBackgroundColor"],
    __charBounds: [],
    CACHE_FONT_SIZE: 400,
    MIN_TEXT_WIDTH: 2,
    initialize: function initialize(t, e) {
      this.styles = e ? e.styles || {} : {};
      this.text = t;
      this.__skipDimension = true;
      this.callSuper("initialize", e);
      this.__skipDimension = false;
      this.initDimensions();
      this.setCoords();
      this.setupState({
        propertySet: "_dimensionAffectingProps"
      });
    },
    getMeasuringContext: function getMeasuringContext() {
      if (!o._measuringContext) {
        o._measuringContext = this.canvas && this.canvas.contextCache || o.util.createCanvasElement().getContext("2d");
      }

      return o._measuringContext;
    },
    _splitText: function _splitText() {
      var t = this._splitTextIntoLines(this.text);

      this.textLines = t.lines;
      this._textLines = t.graphemeLines;
      this._unwrappedTextLines = t._unwrappedLines;
      this._text = t.graphemeText;
      return t;
    },
    initDimensions: function initDimensions() {
      if (this.__skipDimension) {
        return;
      }

      this._splitText();

      this._clearCache();

      this.width = this.calcTextWidth() || this.cursorWidth || this.MIN_TEXT_WIDTH;

      if (this.textAlign.indexOf("justify") !== -1) {
        this.enlargeSpaces();
      }

      this.height = this.calcTextHeight();
      this.saveState({
        propertySet: "_dimensionAffectingProps"
      });
    },
    enlargeSpaces: function enlargeSpaces() {
      var t, e, i, r, n, s, o;

      for (var a = 0, c = this._textLines.length; a < c; a++) {
        if (this.textAlign !== "justify" && (a === c - 1 || this.isEndOfWrapping(a))) {
          continue;
        }

        r = 0;
        n = this._textLines[a];
        e = this.getLineWidth(a);

        if (e < this.width && (o = this.textLines[a].match(this._reSpacesAndTabs))) {
          i = o.length;
          t = (this.width - e) / i;

          for (var l = 0, h = n.length; l <= h; l++) {
            s = this.__charBounds[a][l];

            if (this._reSpaceAndTab.test(n[l])) {
              s.width += t;
              s.kernedWidth += t;
              s.left += r;
              r += t;
            } else {
              s.left += r;
            }
          }
        }
      }
    },
    isEndOfWrapping: function isEndOfWrapping(t) {
      return t === this._textLines.length - 1;
    },
    missingNewlineOffset: function missingNewlineOffset() {
      return 1;
    },
    toString: function toString() {
      return "#<fabric.Text (" + this.complexity() + '): { "text": "' + this.text + '", "fontFamily": "' + this.fontFamily + '" }>';
    },
    _getCacheCanvasDimensions: function _getCacheCanvasDimensions() {
      var t = this.callSuper("_getCacheCanvasDimensions");
      var e = this.fontSize;
      t.width += e * t.zoomX;
      t.height += e * t.zoomY;
      return t;
    },
    _render: function _render(t) {
      this._setTextStyles(t);

      this._renderTextLinesBackground(t);

      this._renderTextDecoration(t, "underline");

      this._renderText(t);

      this._renderTextDecoration(t, "overline");

      this._renderTextDecoration(t, "linethrough");
    },
    _renderText: function _renderText(t) {
      if (this.paintFirst === "stroke") {
        this._renderTextStroke(t);

        this._renderTextFill(t);
      } else {
        this._renderTextFill(t);

        this._renderTextStroke(t);
      }
    },
    _setTextStyles: function _setTextStyles(t, e, i) {
      t.textBaseline = "alphabetic";
      t.font = this._getFontDeclaration(e, i);
    },
    calcTextWidth: function calcTextWidth() {
      var t = this.getLineWidth(0);

      for (var e = 1, i = this._textLines.length; e < i; e++) {
        var r = this.getLineWidth(e);

        if (r > t) {
          t = r;
        }
      }

      return t;
    },
    _renderTextLine: function _renderTextLine(t, e, i, r, n, s) {
      this._renderChars(t, e, i, r, n, s);
    },
    _renderTextLinesBackground: function _renderTextLinesBackground(t) {
      if (!this.textBackgroundColor && !this.styleHas("textBackgroundColor")) {
        return;
      }

      var e = 0,
          i,
          r,
          n = t.fillStyle,
          s,
          o,
          a = this._getLeftOffset(),
          c = this._getTopOffset(),
          l = 0,
          h = 0,
          f,
          u;

      for (var d = 0, g = this._textLines.length; d < g; d++) {
        i = this.getHeightOfLine(d);

        if (!this.textBackgroundColor && !this.styleHas("textBackgroundColor", d)) {
          e += i;
          continue;
        }

        s = this._textLines[d];
        r = this._getLineLeftOffset(d);
        h = 0;
        l = 0;
        o = this.getValueOfPropertyAt(d, 0, "textBackgroundColor");

        for (var p = 0, v = s.length; p < v; p++) {
          f = this.__charBounds[d][p];
          u = this.getValueOfPropertyAt(d, p, "textBackgroundColor");

          if (u !== o) {
            t.fillStyle = o;
            o && t.fillRect(a + r + l, c + e, h, i / this.lineHeight);
            l = f.left;
            h = f.width;
            o = u;
          } else {
            h += f.kernedWidth;
          }
        }

        if (u) {
          t.fillStyle = u;
          t.fillRect(a + r + l, c + e, h, i / this.lineHeight);
        }

        e += i;
      }

      t.fillStyle = n;

      this._removeShadow(t);
    },
    getFontCache: function getFontCache(t) {
      var e = t.fontFamily.toLowerCase();

      if (!o.charWidthsCache[e]) {
        o.charWidthsCache[e] = {};
      }

      var i = o.charWidthsCache[e],
          r = t.fontStyle.toLowerCase() + "_" + (t.fontWeight + "").toLowerCase();

      if (!i[r]) {
        i[r] = {};
      }

      return i[r];
    },
    _applyCharStyles: function _applyCharStyles(t, e, i, r, n) {
      this._setFillStyles(e, n);

      this._setStrokeStyles(e, n);

      e.font = this._getFontDeclaration(n);
    },
    _measureChar: function _measureChar(t, e, i, r) {
      var n = this.getFontCache(e),
          s = this._getFontDeclaration(e),
          o = this._getFontDeclaration(r),
          a = i + t,
          c = s === o,
          l,
          h,
          f,
          u = e.fontSize / this.CACHE_FONT_SIZE,
          d;

      if (i && n[i] !== undefined) {
        f = n[i];
      }

      if (n[t] !== undefined) {
        d = l = n[t];
      }

      if (c && n[a] !== undefined) {
        h = n[a];
        d = h - f;
      }

      if (l === undefined || f === undefined || h === undefined) {
        var g = this.getMeasuringContext();

        this._setTextStyles(g, e, true);
      }

      if (l === undefined) {
        d = l = g.measureText(t).width;
        n[t] = l;
      }

      if (f === undefined && c && i) {
        f = g.measureText(i).width;
        n[i] = f;
      }

      if (c && h === undefined) {
        h = g.measureText(a).width;
        n[a] = h;
        d = h - f;
      }

      return {
        width: l * u,
        kernedWidth: d * u
      };
    },
    getHeightOfChar: function getHeightOfChar(t, e) {
      return this.getValueOfPropertyAt(t, e, "fontSize");
    },
    measureLine: function measureLine(t) {
      var e = this._measureLine(t);

      if (this.charSpacing !== 0) {
        e.width -= this._getWidthOfCharSpacing();
      }

      if (e.width < 0) {
        e.width = 0;
      }

      return e;
    },
    _measureLine: function _measureLine(t) {
      var e = 0,
          i,
          r,
          n = this._textLines[t],
          s,
          o,
          a = 0,
          c = new Array(n.length);
      this.__charBounds[t] = c;

      for (i = 0; i < n.length; i++) {
        r = n[i];
        o = this._getGraphemeBox(r, t, i, s);
        c[i] = o;
        e += o.kernedWidth;
        s = r;
      }

      c[i] = {
        left: o ? o.left + o.width : 0,
        width: 0,
        kernedWidth: 0,
        height: this.fontSize
      };
      return {
        width: e,
        numOfSpaces: a
      };
    },
    _getGraphemeBox: function _getGraphemeBox(t, e, i, r, n) {
      var s = this.getCompleteStyleDeclaration(e, i),
          o = r ? this.getCompleteStyleDeclaration(e, i - 1) : {},
          a = this._measureChar(t, s, r, o),
          c = a.kernedWidth,
          l = a.width,
          h;

      if (this.charSpacing !== 0) {
        h = this._getWidthOfCharSpacing();
        l += h;
        c += h;
      }

      var f = {
        width: l,
        left: 0,
        height: s.fontSize,
        kernedWidth: c,
        deltaY: s.deltaY
      };

      if (i > 0 && !n) {
        var u = this.__charBounds[e][i - 1];
        f.left = u.left + u.width + a.kernedWidth - a.width;
      }

      return f;
    },
    getHeightOfLine: function getHeightOfLine(t) {
      if (this.__lineHeights[t]) {
        return this.__lineHeights[t];
      }

      var e = this._textLines[t],
          i = this.getHeightOfChar(t, 0);

      for (var r = 1, n = e.length; r < n; r++) {
        i = Math.max(this.getHeightOfChar(t, r), i);
      }

      return this.__lineHeights[t] = i * this.lineHeight * this._fontSizeMult;
    },
    calcTextHeight: function calcTextHeight() {
      var t,
          e = 0;

      for (var i = 0, r = this._textLines.length; i < r; i++) {
        t = this.getHeightOfLine(i);
        e += i === r - 1 ? t / this.lineHeight : t;
      }

      return e;
    },
    _getLeftOffset: function _getLeftOffset() {
      return -this.width / 2;
    },
    _getTopOffset: function _getTopOffset() {
      return -this.height / 2;
    },
    _applyPatternGradientTransform: function _applyPatternGradientTransform(t, e) {
      if (!e || !e.toLive) {
        return {
          offsetX: 0,
          offsetY: 0
        };
      }

      var i = -this.width / 2 + e.offsetX || 0,
          r = -this.height / 2 + e.offsetY || 0;
      t.transform(1, 0, 0, 1, i, r);
      return {
        offsetX: i,
        offsetY: r
      };
    },
    _renderTextCommon: function _renderTextCommon(t, e) {
      t.save();

      var i = 0,
          r = this._getLeftOffset(),
          n = this._getTopOffset(),
          s = this._applyPatternGradientTransform(t, e === "fillText" ? this.fill : this.stroke);

      for (var o = 0, a = this._textLines.length; o < a; o++) {
        var c = this.getHeightOfLine(o),
            l = c / this.lineHeight,
            h = this._getLineLeftOffset(o);

        this._renderTextLine(e, t, this._textLines[o], r + h - s.offsetX, n + i + l - s.offsetY, o);

        i += c;
      }

      t.restore();
    },
    _renderTextFill: function _renderTextFill(t) {
      if (!this.fill && !this.styleHas("fill")) {
        return;
      }

      this._renderTextCommon(t, "fillText");
    },
    _renderTextStroke: function _renderTextStroke(t) {
      if ((!this.stroke || this.strokeWidth === 0) && this.isEmptyStyles()) {
        return;
      }

      if (this.shadow && !this.shadow.affectStroke) {
        this._removeShadow(t);
      }

      t.save();

      this._setLineDash(t, this.strokeDashArray);

      t.beginPath();

      this._renderTextCommon(t, "strokeText");

      t.closePath();
      t.restore();
    },
    _renderChars: function _renderChars(t, e, i, r, n, s) {
      var o = this.getHeightOfLine(s),
          a = this.textAlign.indexOf("justify") !== -1,
          c,
          l,
          h = "",
          f,
          u = 0,
          d,
          g = !a && this.charSpacing === 0 && this.isEmptyStyles(s);
      e.save();
      n -= o * this._fontSizeFraction / this.lineHeight;

      if (g) {
        this._renderChar(t, e, s, 0, this.textLines[s], r, n, o);

        e.restore();
        return;
      }

      for (var p = 0, v = i.length - 1; p <= v; p++) {
        d = p === v || this.charSpacing;
        h += i[p];
        f = this.__charBounds[s][p];

        if (u === 0) {
          r += f.kernedWidth - f.width;
          u += f.width;
        } else {
          u += f.kernedWidth;
        }

        if (a && !d) {
          if (this._reSpaceAndTab.test(i[p])) {
            d = true;
          }
        }

        if (!d) {
          c = c || this.getCompleteStyleDeclaration(s, p);
          l = this.getCompleteStyleDeclaration(s, p + 1);
          d = this._hasStyleChanged(c, l);
        }

        if (d) {
          this._renderChar(t, e, s, p, h, r, n, o);

          h = "";
          c = l;
          r += u;
          u = 0;
        }
      }

      e.restore();
    },
    _renderChar: function _renderChar(t, e, i, r, n, s, o) {
      var a = this._getStyleDeclaration(i, r),
          c = this.getCompleteStyleDeclaration(i, r),
          l = t === "fillText" && c.fill,
          h = t === "strokeText" && c.stroke && c.strokeWidth;

      if (!h && !l) {
        return;
      }

      a && e.save();

      this._applyCharStyles(t, e, i, r, c);

      if (a && a.textBackgroundColor) {
        this._removeShadow(e);
      }

      if (a && a.deltaY) {
        o += a.deltaY;
      }

      l && e.fillText(n, s, o);
      h && e.strokeText(n, s, o);
      a && e.restore();
    },
    setSuperscript: function setSuperscript(t, e) {
      return this._setScript(t, e, this.superscript);
    },
    setSubscript: function setSubscript(t, e) {
      return this._setScript(t, e, this.subscript);
    },
    _setScript: function _setScript(t, e, i) {
      var r = this.get2DCursorLocation(t, true),
          n = this.getValueOfPropertyAt(r.lineIndex, r.charIndex, "fontSize"),
          s = this.getValueOfPropertyAt(r.lineIndex, r.charIndex, "deltaY"),
          o = {
        fontSize: n * i.size,
        deltaY: s + n * i.baseline
      };
      this.setSelectionStyles(o, t, e);
      return this;
    },
    _hasStyleChanged: function _hasStyleChanged(t, e) {
      return t.fill !== e.fill || t.stroke !== e.stroke || t.strokeWidth !== e.strokeWidth || t.fontSize !== e.fontSize || t.fontFamily !== e.fontFamily || t.fontWeight !== e.fontWeight || t.fontStyle !== e.fontStyle || t.deltaY !== e.deltaY;
    },
    _hasStyleChangedForSvg: function _hasStyleChangedForSvg(t, e) {
      return this._hasStyleChanged(t, e) || t.overline !== e.overline || t.underline !== e.underline || t.linethrough !== e.linethrough;
    },
    _getLineLeftOffset: function _getLineLeftOffset(t) {
      var e = this.getLineWidth(t);

      if (this.textAlign === "center") {
        return (this.width - e) / 2;
      }

      if (this.textAlign === "right") {
        return this.width - e;
      }

      if (this.textAlign === "justify-center" && this.isEndOfWrapping(t)) {
        return (this.width - e) / 2;
      }

      if (this.textAlign === "justify-right" && this.isEndOfWrapping(t)) {
        return this.width - e;
      }

      return 0;
    },
    _clearCache: function _clearCache() {
      this.__lineWidths = [];
      this.__lineHeights = [];
      this.__charBounds = [];
    },
    _shouldClearDimensionCache: function _shouldClearDimensionCache() {
      var t = this._forceClearCache;
      t || (t = this.hasStateChanged("_dimensionAffectingProps"));

      if (t) {
        this.dirty = true;
        this._forceClearCache = false;
      }

      return t;
    },
    getLineWidth: function getLineWidth(t) {
      if (this.__lineWidths[t]) {
        return this.__lineWidths[t];
      }

      var e,
          i = this._textLines[t],
          r;

      if (i === "") {
        e = 0;
      } else {
        r = this.measureLine(t);
        e = r.width;
      }

      this.__lineWidths[t] = e;
      return e;
    },
    _getWidthOfCharSpacing: function _getWidthOfCharSpacing() {
      if (this.charSpacing !== 0) {
        return this.fontSize * this.charSpacing / 1e3;
      }

      return 0;
    },
    getValueOfPropertyAt: function getValueOfPropertyAt(t, e, i) {
      var r = this._getStyleDeclaration(t, e);

      if (r && typeof r[i] !== "undefined") {
        return r[i];
      }

      return this[i];
    },
    _renderTextDecoration: function _renderTextDecoration(t, e) {
      if (!this[e] && !this.styleHas(e)) {
        return;
      }

      var i,
          r,
          n,
          s,
          o,
          a,
          c,
          l,
          h = this._getLeftOffset(),
          f = this._getTopOffset(),
          u,
          d,
          g,
          p,
          v,
          m,
          b,
          y,
          _ = this._getWidthOfCharSpacing();

      for (var x = 0, C = this._textLines.length; x < C; x++) {
        i = this.getHeightOfLine(x);

        if (!this[e] && !this.styleHas(e, x)) {
          f += i;
          continue;
        }

        c = this._textLines[x];
        m = i / this.lineHeight;
        s = this._getLineLeftOffset(x);
        d = 0;
        g = 0;
        l = this.getValueOfPropertyAt(x, 0, e);
        y = this.getValueOfPropertyAt(x, 0, "fill");
        u = f + m * (1 - this._fontSizeFraction);
        r = this.getHeightOfChar(x, 0);
        o = this.getValueOfPropertyAt(x, 0, "deltaY");

        for (var w = 0, S = c.length; w < S; w++) {
          p = this.__charBounds[x][w];
          v = this.getValueOfPropertyAt(x, w, e);
          b = this.getValueOfPropertyAt(x, w, "fill");
          n = this.getHeightOfChar(x, w);
          a = this.getValueOfPropertyAt(x, w, "deltaY");

          if ((v !== l || b !== y || n !== r || a !== o) && g > 0) {
            t.fillStyle = y;
            l && y && t.fillRect(h + s + d, u + this.offsets[e] * r + o, g, this.fontSize / 15);
            d = p.left;
            g = p.width;
            l = v;
            y = b;
            r = n;
            o = a;
          } else {
            g += p.kernedWidth;
          }
        }

        t.fillStyle = b;
        v && b && t.fillRect(h + s + d, u + this.offsets[e] * r + o, g - _, this.fontSize / 15);
        f += i;
      }

      this._removeShadow(t);
    },
    _getFontDeclaration: function _getFontDeclaration(t, e) {
      var i = t || this,
          r = this.fontFamily,
          n = o.Text.genericFonts.indexOf(r.toLowerCase()) > -1;
      var s = r === undefined || r.indexOf("'") > -1 || r.indexOf(",") > -1 || r.indexOf('"') > -1 || n ? i.fontFamily : '"' + i.fontFamily + '"';
      return [o.isLikelyNode ? i.fontWeight : i.fontStyle, o.isLikelyNode ? i.fontStyle : i.fontWeight, e ? this.CACHE_FONT_SIZE + "px" : i.fontSize + "px", s].join(" ");
    },
    render: function render(t) {
      if (!this.visible) {
        return;
      }

      if (this.canvas && this.canvas.skipOffscreen && !this.group && !this.isOnScreen()) {
        return;
      }

      if (this._shouldClearDimensionCache()) {
        this.initDimensions();
      }

      this.callSuper("render", t);
    },
    _splitTextIntoLines: function _splitTextIntoLines(t) {
      var e = t.split(this._reNewline),
          i = new Array(e.length),
          r = ["\n"],
          n = [];

      for (var s = 0; s < e.length; s++) {
        i[s] = o.util.string.graphemeSplit(e[s]);
        n = n.concat(i[s], r);
      }

      n.pop();
      return {
        _unwrappedLines: i,
        lines: e,
        graphemeText: n,
        graphemeLines: i
      };
    },
    toObject: function toObject(t) {
      var e = ["text", "fontSize", "fontWeight", "fontFamily", "fontStyle", "lineHeight", "underline", "overline", "linethrough", "textAlign", "textBackgroundColor", "charSpacing"].concat(t);
      var i = this.callSuper("toObject", e);
      i.styles = r(this.styles, true);
      return i;
    },
    set: function set(t, e) {
      this.callSuper("set", t, e);
      var i = false;

      if ((0, _typeof2["default"])(t) === "object") {
        for (var r in t) {
          i = i || this._dimensionAffectingProps.indexOf(r) !== -1;
        }
      } else {
        i = this._dimensionAffectingProps.indexOf(t) !== -1;
      }

      if (i) {
        this.initDimensions();
        this.setCoords();
      }

      return this;
    },
    complexity: function complexity() {
      return 1;
    }
  });

  o.Text.fromObject = function (t, e) {
    return o.Object._fromObject("Text", t, e, "text");
  };

  o.Text.genericFonts = ["sans-serif", "serif", "cursive", "fantasy", "monospace"];
  o.util.createAccessors && o.util.createAccessors(o.Text);
})(typeof exports !== "undefined" ? exports : void 0);

(function () {
  fabric.util.object.extend(fabric.Text.prototype, {
    isEmptyStyles: function isEmptyStyles(t) {
      if (!this.styles) {
        return true;
      }

      if (typeof t !== "undefined" && !this.styles[t]) {
        return true;
      }

      var e = typeof t === "undefined" ? this.styles : {
        line: this.styles[t]
      };

      for (var i in e) {
        for (var r in e[i]) {
          for (var n in e[i][r]) {
            return false;
          }
        }
      }

      return true;
    },
    styleHas: function styleHas(t, e) {
      if (!this.styles || !t || t === "") {
        return false;
      }

      if (typeof e !== "undefined" && !this.styles[e]) {
        return false;
      }

      var i = typeof e === "undefined" ? this.styles : {
        0: this.styles[e]
      };

      for (var r in i) {
        for (var n in i[r]) {
          if (typeof i[r][n][t] !== "undefined") {
            return true;
          }
        }
      }

      return false;
    },
    cleanStyle: function cleanStyle(t) {
      if (!this.styles || !t || t === "") {
        return false;
      }

      var e = this.styles,
          i = 0,
          r,
          n,
          s = true,
          o = 0,
          a;

      for (var c in e) {
        r = 0;

        for (var l in e[c]) {
          var a = e[c][l],
              h = a.hasOwnProperty(t);
          i++;

          if (h) {
            if (!n) {
              n = a[t];
            } else if (a[t] !== n) {
              s = false;
            }

            if (a[t] === this[t]) {
              delete a[t];
            }
          } else {
            s = false;
          }

          if (Object.keys(a).length !== 0) {
            r++;
          } else {
            delete e[c][l];
          }
        }

        if (r === 0) {
          delete e[c];
        }
      }

      for (var f = 0; f < this._textLines.length; f++) {
        o += this._textLines[f].length;
      }

      if (s && i === o) {
        this[t] = n;
        this.removeStyle(t);
      }
    },
    removeStyle: function removeStyle(t) {
      if (!this.styles || !t || t === "") {
        return;
      }

      var e = this.styles,
          i,
          r,
          n;

      for (r in e) {
        i = e[r];

        for (n in i) {
          delete i[n][t];

          if (Object.keys(i[n]).length === 0) {
            delete i[n];
          }
        }

        if (Object.keys(i).length === 0) {
          delete e[r];
        }
      }
    },
    _extendStyles: function _extendStyles(t, e) {
      var i = this.get2DCursorLocation(t);

      if (!this._getLineStyle(i.lineIndex)) {
        this._setLineStyle(i.lineIndex);
      }

      if (!this._getStyleDeclaration(i.lineIndex, i.charIndex)) {
        this._setStyleDeclaration(i.lineIndex, i.charIndex, {});
      }

      fabric.util.object.extend(this._getStyleDeclaration(i.lineIndex, i.charIndex), e);
    },
    get2DCursorLocation: function get2DCursorLocation(t, e) {
      if (typeof t === "undefined") {
        t = this.selectionStart;
      }

      var i = e ? this._unwrappedTextLines : this._textLines,
          r = i.length;

      for (var n = 0; n < r; n++) {
        if (t <= i[n].length) {
          return {
            lineIndex: n,
            charIndex: t
          };
        }

        t -= i[n].length + this.missingNewlineOffset(n);
      }

      return {
        lineIndex: n - 1,
        charIndex: i[n - 1].length < t ? i[n - 1].length : t
      };
    },
    getSelectionStyles: function getSelectionStyles(t, e, i) {
      if (typeof t === "undefined") {
        t = this.selectionStart || 0;
      }

      if (typeof e === "undefined") {
        e = this.selectionEnd || t;
      }

      var r = [];

      for (var n = t; n < e; n++) {
        r.push(this.getStyleAtPosition(n, i));
      }

      return r;
    },
    getStyleAtPosition: function getStyleAtPosition(t, e) {
      var i = this.get2DCursorLocation(t),
          r = e ? this.getCompleteStyleDeclaration(i.lineIndex, i.charIndex) : this._getStyleDeclaration(i.lineIndex, i.charIndex);
      return r || {};
    },
    setSelectionStyles: function setSelectionStyles(t, e, i) {
      if (typeof e === "undefined") {
        e = this.selectionStart || 0;
      }

      if (typeof i === "undefined") {
        i = this.selectionEnd || e;
      }

      for (var r = e; r < i; r++) {
        this._extendStyles(r, t);
      }

      this._forceClearCache = true;
      return this;
    },
    _getStyleDeclaration: function _getStyleDeclaration(t, e) {
      var i = this.styles && this.styles[t];

      if (!i) {
        return null;
      }

      return i[e];
    },
    getCompleteStyleDeclaration: function getCompleteStyleDeclaration(t, e) {
      var i = this._getStyleDeclaration(t, e) || {},
          r = {},
          n;

      for (var s = 0; s < this._styleProperties.length; s++) {
        n = this._styleProperties[s];
        r[n] = typeof i[n] === "undefined" ? this[n] : i[n];
      }

      return r;
    },
    _setStyleDeclaration: function _setStyleDeclaration(t, e, i) {
      this.styles[t][e] = i;
    },
    _deleteStyleDeclaration: function _deleteStyleDeclaration(t, e) {
      delete this.styles[t][e];
    },
    _getLineStyle: function _getLineStyle(t) {
      return !!this.styles[t];
    },
    _setLineStyle: function _setLineStyle(t) {
      this.styles[t] = {};
    },
    _deleteLineStyle: function _deleteLineStyle(t) {
      delete this.styles[t];
    }
  });
})();

(function () {
  function n(t) {
    if (t.textDecoration) {
      t.textDecoration.indexOf("underline") > -1 && (t.underline = true);
      t.textDecoration.indexOf("line-through") > -1 && (t.linethrough = true);
      t.textDecoration.indexOf("overline") > -1 && (t.overline = true);
      delete t.textDecoration;
    }
  }

  fabric.IText = fabric.util.createClass(fabric.Text, fabric.Observable, {
    type: "i-text",
    selectionStart: 0,
    selectionEnd: 0,
    selectionColor: "rgba(17,119,255,0.3)",
    isEditing: false,
    editable: true,
    editingBorderColor: "rgba(102,153,255,0.25)",
    cursorWidth: 2,
    cursorColor: "#333",
    cursorDelay: 1e3,
    cursorDuration: 600,
    caching: true,
    _reSpace: /\s|\n/,
    _currentCursorOpacity: 0,
    _selectionDirection: null,
    _abortCursorAnimation: false,
    __widthOfSpace: [],
    inCompositionMode: false,
    initialize: function initialize(t, e) {
      this.callSuper("initialize", t, e);
      this.initBehavior();
    },
    setSelectionStart: function setSelectionStart(t) {
      t = Math.max(t, 0);

      this._updateAndFire("selectionStart", t);
    },
    setSelectionEnd: function setSelectionEnd(t) {
      t = Math.min(t, this.text.length);

      this._updateAndFire("selectionEnd", t);
    },
    _updateAndFire: function _updateAndFire(t, e) {
      if (this[t] !== e) {
        this._fireSelectionChanged();

        this[t] = e;
      }

      this._updateTextarea();
    },
    _fireSelectionChanged: function _fireSelectionChanged() {
      this.fire("selection:changed");
      this.canvas && this.canvas.fire("text:selection:changed", {
        target: this
      });
    },
    initDimensions: function initDimensions() {
      this.isEditing && this.initDelayedCursor();
      this.clearContextTop();
      this.callSuper("initDimensions");
    },
    render: function render(t) {
      this.clearContextTop();
      this.callSuper("render", t);
      this.cursorOffsetCache = {};
      this.renderCursorOrSelection();
    },
    _render: function _render(t) {
      this.callSuper("_render", t);
    },
    clearContextTop: function clearContextTop(t) {
      if (!this.isEditing || !this.canvas || !this.canvas.contextTop) {
        return;
      }

      var e = this.canvas.contextTop,
          i = this.canvas.viewportTransform;
      e.save();
      e.transform(i[0], i[1], i[2], i[3], i[4], i[5]);
      this.transform(e);
      this.transformMatrix && e.transform.apply(e, this.transformMatrix);

      this._clearTextArea(e);

      t || e.restore();
    },
    renderCursorOrSelection: function renderCursorOrSelection() {
      if (!this.isEditing || !this.canvas || !this.canvas.contextTop) {
        return;
      }

      var t = this._getCursorBoundaries(),
          e = this.canvas.contextTop;

      this.clearContextTop(true);

      if (this.selectionStart === this.selectionEnd) {
        this.renderCursor(t, e);
      } else {
        this.renderSelection(t, e);
      }

      e.restore();
    },
    _clearTextArea: function _clearTextArea(t) {
      var e = this.width + 4,
          i = this.height + 4;
      t.clearRect(-e / 2, -i / 2, e, i);
    },
    _getCursorBoundaries: function _getCursorBoundaries(t) {
      if (typeof t === "undefined") {
        t = this.selectionStart;
      }

      var e = this._getLeftOffset(),
          i = this._getTopOffset(),
          r = this._getCursorBoundariesOffsets(t);

      return {
        left: e,
        top: i,
        leftOffset: r.left,
        topOffset: r.top
      };
    },
    _getCursorBoundariesOffsets: function _getCursorBoundariesOffsets(t) {
      if (this.cursorOffsetCache && "top" in this.cursorOffsetCache) {
        return this.cursorOffsetCache;
      }

      var e,
          i,
          r,
          n = 0,
          s = 0,
          o,
          a = this.get2DCursorLocation(t);
      r = a.charIndex;
      i = a.lineIndex;

      for (var c = 0; c < i; c++) {
        n += this.getHeightOfLine(c);
      }

      e = this._getLineLeftOffset(i);
      var l = this.__charBounds[i][r];
      l && (s = l.left);

      if (this.charSpacing !== 0 && r === this._textLines[i].length) {
        s -= this._getWidthOfCharSpacing();
      }

      o = {
        top: n,
        left: e + (s > 0 ? s : 0)
      };
      this.cursorOffsetCache = o;
      return this.cursorOffsetCache;
    },
    renderCursor: function renderCursor(t, e) {
      var i = this.get2DCursorLocation(),
          r = i.lineIndex,
          n = i.charIndex > 0 ? i.charIndex - 1 : 0,
          s = this.getValueOfPropertyAt(r, n, "fontSize"),
          o = this.scaleX * this.canvas.getZoom(),
          a = this.cursorWidth / o,
          c = t.topOffset,
          l = this.getValueOfPropertyAt(r, n, "deltaY");
      c += (1 - this._fontSizeFraction) * this.getHeightOfLine(r) / this.lineHeight - s * (1 - this._fontSizeFraction);

      if (this.inCompositionMode) {
        this.renderSelection(t, e);
      }

      e.fillStyle = this.getValueOfPropertyAt(r, n, "fill");
      e.globalAlpha = this.__isMousedown ? 1 : this._currentCursorOpacity;
      e.fillRect(t.left + t.leftOffset - a / 2, c + t.top + l, a, s);
    },
    renderSelection: function renderSelection(t, e) {
      var i = this.inCompositionMode ? this.hiddenTextarea.selectionStart : this.selectionStart,
          r = this.inCompositionMode ? this.hiddenTextarea.selectionEnd : this.selectionEnd,
          n = this.textAlign.indexOf("justify") !== -1,
          s = this.get2DCursorLocation(i),
          o = this.get2DCursorLocation(r),
          a = s.lineIndex,
          c = o.lineIndex,
          l = s.charIndex < 0 ? 0 : s.charIndex,
          h = o.charIndex < 0 ? 0 : o.charIndex;

      for (var f = a; f <= c; f++) {
        var u = this._getLineLeftOffset(f) || 0,
            d = this.getHeightOfLine(f),
            g = 0,
            p = 0,
            v = 0;

        if (f === a) {
          p = this.__charBounds[a][l].left;
        }

        if (f >= a && f < c) {
          v = n && !this.isEndOfWrapping(f) ? this.width : this.getLineWidth(f) || 5;
        } else if (f === c) {
          if (h === 0) {
            v = this.__charBounds[c][h].left;
          } else {
            var m = this._getWidthOfCharSpacing();

            v = this.__charBounds[c][h - 1].left + this.__charBounds[c][h - 1].width - m;
          }
        }

        g = d;

        if (this.lineHeight < 1 || f === c && this.lineHeight > 1) {
          d /= this.lineHeight;
        }

        if (this.inCompositionMode) {
          e.fillStyle = this.compositionColor || "black";
          e.fillRect(t.left + u + p, t.top + t.topOffset + d, v - p, 1);
        } else {
          e.fillStyle = this.selectionColor;
          e.fillRect(t.left + u + p, t.top + t.topOffset, v - p, d);
        }

        t.topOffset += g;
      }
    },
    getCurrentCharFontSize: function getCurrentCharFontSize() {
      var t = this._getCurrentCharIndex();

      return this.getValueOfPropertyAt(t.l, t.c, "fontSize");
    },
    getCurrentCharColor: function getCurrentCharColor() {
      var t = this._getCurrentCharIndex();

      return this.getValueOfPropertyAt(t.l, t.c, "fill");
    },
    _getCurrentCharIndex: function _getCurrentCharIndex() {
      var t = this.get2DCursorLocation(this.selectionStart, true),
          e = t.charIndex > 0 ? t.charIndex - 1 : 0;
      return {
        l: t.lineIndex,
        c: e
      };
    }
  });

  fabric.IText.fromObject = function (t, e) {
    n(t);

    if (t.styles) {
      for (var i in t.styles) {
        for (var r in t.styles[i]) {
          n(t.styles[i][r]);
        }
      }
    }

    fabric.Object._fromObject("IText", t, e, "text");
  };
})();

(function () {
  var l = fabric.util.object.clone;
  fabric.util.object.extend(fabric.IText.prototype, {
    initBehavior: function initBehavior() {
      this.initAddedHandler();
      this.initRemovedHandler();
      this.initCursorSelectionHandlers();
      this.initDoubleClickSimulation();
      this.mouseMoveHandler = this.mouseMoveHandler.bind(this);
    },
    onDeselect: function onDeselect() {
      this.isEditing && this.exitEditing();
      this.selected = false;
    },
    initAddedHandler: function initAddedHandler() {
      var e = this;
      this.on("added", function () {
        var t = e.canvas;

        if (t) {
          if (!t._hasITextHandlers) {
            t._hasITextHandlers = true;

            e._initCanvasHandlers(t);
          }

          t._iTextInstances = t._iTextInstances || [];

          t._iTextInstances.push(e);
        }
      });
    },
    initRemovedHandler: function initRemovedHandler() {
      var e = this;
      this.on("removed", function () {
        var t = e.canvas;

        if (t) {
          t._iTextInstances = t._iTextInstances || [];
          fabric.util.removeFromArray(t._iTextInstances, e);

          if (t._iTextInstances.length === 0) {
            t._hasITextHandlers = false;

            e._removeCanvasHandlers(t);
          }
        }
      });
    },
    _initCanvasHandlers: function _initCanvasHandlers(t) {
      t._mouseUpITextHandler = function () {
        if (t._iTextInstances) {
          t._iTextInstances.forEach(function (t) {
            t.__isMousedown = false;
          });
        }
      };

      t.on("mouse:up", t._mouseUpITextHandler);
    },
    _removeCanvasHandlers: function _removeCanvasHandlers(t) {
      t.off("mouse:up", t._mouseUpITextHandler);
    },
    _tick: function _tick() {
      this._currentTickState = this._animateCursor(this, 1, this.cursorDuration, "_onTickComplete");
    },
    _animateCursor: function _animateCursor(t, e, i, r) {
      var n;
      n = {
        isAborted: false,
        abort: function abort() {
          this.isAborted = true;
        }
      };
      t.animate("_currentCursorOpacity", e, {
        duration: i,
        onComplete: function onComplete() {
          if (!n.isAborted) {
            t[r]();
          }
        },
        onChange: function onChange() {
          if (t.canvas && t.selectionStart === t.selectionEnd) {
            t.renderCursorOrSelection();
          }
        },
        abort: function abort() {
          return n.isAborted;
        }
      });
      return n;
    },
    _onTickComplete: function _onTickComplete() {
      var t = this;

      if (this._cursorTimeout1) {
        clearTimeout(this._cursorTimeout1);
      }

      this._cursorTimeout1 = setTimeout(function () {
        t._currentTickCompleteState = t._animateCursor(t, 0, this.cursorDuration / 2, "_tick");
      }, 100);
    },
    initDelayedCursor: function initDelayedCursor(t) {
      var e = this,
          i = t ? 0 : this.cursorDelay;
      this.abortCursorAnimation();
      this._currentCursorOpacity = 1;
      this._cursorTimeout2 = setTimeout(function () {
        e._tick();
      }, i);
    },
    abortCursorAnimation: function abortCursorAnimation() {
      var t = this._currentTickState || this._currentTickCompleteState,
          e = this.canvas;
      this._currentTickState && this._currentTickState.abort();
      this._currentTickCompleteState && this._currentTickCompleteState.abort();
      clearTimeout(this._cursorTimeout1);
      clearTimeout(this._cursorTimeout2);
      this._currentCursorOpacity = 0;

      if (t && e) {
        e.clearContext(e.contextTop || e.contextContainer);
      }
    },
    selectAll: function selectAll() {
      this.selectionStart = 0;
      this.selectionEnd = this._text.length;

      this._fireSelectionChanged();

      this._updateTextarea();

      return this;
    },
    getSelectedText: function getSelectedText() {
      return this._text.slice(this.selectionStart, this.selectionEnd).join("");
    },
    findWordBoundaryLeft: function findWordBoundaryLeft(t) {
      var e = 0,
          i = t - 1;

      if (this._reSpace.test(this._text[i])) {
        while (this._reSpace.test(this._text[i])) {
          e++;
          i--;
        }
      }

      while (/\S/.test(this._text[i]) && i > -1) {
        e++;
        i--;
      }

      return t - e;
    },
    findWordBoundaryRight: function findWordBoundaryRight(t) {
      var e = 0,
          i = t;

      if (this._reSpace.test(this._text[i])) {
        while (this._reSpace.test(this._text[i])) {
          e++;
          i++;
        }
      }

      while (/\S/.test(this._text[i]) && i < this._text.length) {
        e++;
        i++;
      }

      return t + e;
    },
    findLineBoundaryLeft: function findLineBoundaryLeft(t) {
      var e = 0,
          i = t - 1;

      while (!/\n/.test(this._text[i]) && i > -1) {
        e++;
        i--;
      }

      return t - e;
    },
    findLineBoundaryRight: function findLineBoundaryRight(t) {
      var e = 0,
          i = t;

      while (!/\n/.test(this._text[i]) && i < this._text.length) {
        e++;
        i++;
      }

      return t + e;
    },
    searchWordBoundary: function searchWordBoundary(t, e) {
      var i = this._text,
          r = this._reSpace.test(i[t]) ? t - 1 : t,
          n = i[r],
          s = fabric.reNonWord;

      while (!s.test(n) && r > 0 && r < i.length) {
        r += e;
        n = i[r];
      }

      if (s.test(n)) {
        r += e === 1 ? 0 : 1;
      }

      return r;
    },
    selectWord: function selectWord(t) {
      t = t || this.selectionStart;
      var e = this.searchWordBoundary(t, -1),
          i = this.searchWordBoundary(t, 1);
      this.selectionStart = e;
      this.selectionEnd = i;

      this._fireSelectionChanged();

      this._updateTextarea();

      this.renderCursorOrSelection();
    },
    selectLine: function selectLine(t) {
      t = t || this.selectionStart;
      var e = this.findLineBoundaryLeft(t),
          i = this.findLineBoundaryRight(t);
      this.selectionStart = e;
      this.selectionEnd = i;

      this._fireSelectionChanged();

      this._updateTextarea();

      return this;
    },
    enterEditing: function enterEditing(t) {
      if (this.isEditing || !this.editable) {
        return;
      }

      if (this.canvas) {
        this.canvas.calcOffset();
        this.exitEditingOnOthers(this.canvas);
      }

      this.isEditing = true;
      this.initHiddenTextarea(t);
      this.hiddenTextarea.focus();
      this.hiddenTextarea.value = this.text;

      this._updateTextarea();

      this._saveEditingProps();

      this._setEditingProps();

      this._textBeforeEdit = this.text;

      this._tick();

      this.fire("editing:entered");

      this._fireSelectionChanged();

      if (!this.canvas) {
        return this;
      }

      this.canvas.fire("text:editing:entered", {
        target: this
      });
      this.initMouseMoveHandler();
      this.canvas.requestRenderAll();
      return this;
    },
    exitEditingOnOthers: function exitEditingOnOthers(t) {
      if (t._iTextInstances) {
        t._iTextInstances.forEach(function (t) {
          t.selected = false;

          if (t.isEditing) {
            t.exitEditing();
          }
        });
      }
    },
    initMouseMoveHandler: function initMouseMoveHandler() {
      this.canvas.on("mouse:move", this.mouseMoveHandler);
    },
    mouseMoveHandler: function mouseMoveHandler(t) {
      if (!this.__isMousedown || !this.isEditing) {
        return;
      }

      var e = this.getSelectionStartFromPointer(t.e),
          i = this.selectionStart,
          r = this.selectionEnd;

      if ((e !== this.__selectionStartOnMouseDown || i === r) && (i === e || r === e)) {
        return;
      }

      if (e > this.__selectionStartOnMouseDown) {
        this.selectionStart = this.__selectionStartOnMouseDown;
        this.selectionEnd = e;
      } else {
        this.selectionStart = e;
        this.selectionEnd = this.__selectionStartOnMouseDown;
      }

      if (this.selectionStart !== i || this.selectionEnd !== r) {
        this.restartCursorIfNeeded();

        this._fireSelectionChanged();

        this._updateTextarea();

        this.renderCursorOrSelection();
      }
    },
    _setEditingProps: function _setEditingProps() {
      this.hoverCursor = "text";

      if (this.canvas) {
        this.canvas.defaultCursor = this.canvas.moveCursor = "text";
      }

      this.borderColor = this.editingBorderColor;
      this.hasControls = this.selectable = false;
      this.lockMovementX = this.lockMovementY = true;
    },
    fromStringToGraphemeSelection: function fromStringToGraphemeSelection(t, e, i) {
      var r = i.slice(0, t),
          n = fabric.util.string.graphemeSplit(r).length;

      if (t === e) {
        return {
          selectionStart: n,
          selectionEnd: n
        };
      }

      var s = i.slice(t, e),
          o = fabric.util.string.graphemeSplit(s).length;
      return {
        selectionStart: n,
        selectionEnd: n + o
      };
    },
    fromGraphemeToStringSelection: function fromGraphemeToStringSelection(t, e, i) {
      var r = i.slice(0, t),
          n = r.join("").length;

      if (t === e) {
        return {
          selectionStart: n,
          selectionEnd: n
        };
      }

      var s = i.slice(t, e),
          o = s.join("").length;
      return {
        selectionStart: n,
        selectionEnd: n + o
      };
    },
    _updateTextarea: function _updateTextarea() {
      this.cursorOffsetCache = {};

      if (!this.hiddenTextarea) {
        return;
      }

      if (!this.inCompositionMode) {
        var t = this.fromGraphemeToStringSelection(this.selectionStart, this.selectionEnd, this._text);
        this.hiddenTextarea.selectionStart = t.selectionStart;
        this.hiddenTextarea.selectionEnd = t.selectionEnd;
      }

      this.updateTextareaPosition();
    },
    updateFromTextArea: function updateFromTextArea() {
      if (!this.hiddenTextarea) {
        return;
      }

      this.cursorOffsetCache = {};
      this.text = this.hiddenTextarea.value;

      if (this._shouldClearDimensionCache()) {
        this.initDimensions();
        this.setCoords();
      }

      var t = this.fromStringToGraphemeSelection(this.hiddenTextarea.selectionStart, this.hiddenTextarea.selectionEnd, this.hiddenTextarea.value);
      this.selectionEnd = this.selectionStart = t.selectionEnd;

      if (!this.inCompositionMode) {
        this.selectionStart = t.selectionStart;
      }

      this.updateTextareaPosition();
    },
    updateTextareaPosition: function updateTextareaPosition() {
      if (this.selectionStart === this.selectionEnd) {
        var t = this._calcTextareaPosition();

        this.hiddenTextarea.style.left = t.left;
        this.hiddenTextarea.style.top = t.top;
      }
    },
    _calcTextareaPosition: function _calcTextareaPosition() {
      if (!this.canvas) {
        return {
          x: 1,
          y: 1
        };
      }

      var t = this.inCompositionMode ? this.compositionStart : this.selectionStart,
          e = this._getCursorBoundaries(t),
          i = this.get2DCursorLocation(t),
          r = i.lineIndex,
          n = i.charIndex,
          s = this.getValueOfPropertyAt(r, n, "fontSize") * this.lineHeight,
          o = e.leftOffset,
          a = this.calcTransformMatrix(),
          c = {
        x: e.left + o,
        y: e.top + e.topOffset + s
      },
          l = this.canvas.getRetinaScaling(),
          h = this.canvas.upperCanvasEl,
          f = h.width / l,
          u = h.height / l,
          d = f - s,
          g = u - s,
          p = h.clientWidth / f,
          v = h.clientHeight / u;

      c = fabric.util.transformPoint(c, a);
      c = fabric.util.transformPoint(c, this.canvas.viewportTransform);
      c.x *= p;
      c.y *= v;

      if (c.x < 0) {
        c.x = 0;
      }

      if (c.x > d) {
        c.x = d;
      }

      if (c.y < 0) {
        c.y = 0;
      }

      if (c.y > g) {
        c.y = g;
      }

      c.x += this.canvas._offset.left;
      c.y += this.canvas._offset.top;
      return {
        left: c.x + "px",
        top: c.y + "px",
        fontSize: s + "px",
        charHeight: s
      };
    },
    _saveEditingProps: function _saveEditingProps() {
      this._savedProps = {
        hasControls: this.hasControls,
        borderColor: this.borderColor,
        lockMovementX: this.lockMovementX,
        lockMovementY: this.lockMovementY,
        hoverCursor: this.hoverCursor,
        selectable: this.selectable,
        defaultCursor: this.canvas && this.canvas.defaultCursor,
        moveCursor: this.canvas && this.canvas.moveCursor
      };
    },
    _restoreEditingProps: function _restoreEditingProps() {
      if (!this._savedProps) {
        return;
      }

      this.hoverCursor = this._savedProps.hoverCursor;
      this.hasControls = this._savedProps.hasControls;
      this.borderColor = this._savedProps.borderColor;
      this.selectable = this._savedProps.selectable;
      this.lockMovementX = this._savedProps.lockMovementX;
      this.lockMovementY = this._savedProps.lockMovementY;

      if (this.canvas) {
        this.canvas.defaultCursor = this._savedProps.defaultCursor;
        this.canvas.moveCursor = this._savedProps.moveCursor;
      }
    },
    exitEditing: function exitEditing() {
      var t = this._textBeforeEdit !== this.text;
      var e = this.hiddenTextarea;
      this.selected = false;
      this.isEditing = false;
      this.selectionEnd = this.selectionStart;

      if (e) {
        e.blur && e.blur();
        e.parentNode && e.parentNode.removeChild(e);
      }

      this.hiddenTextarea = null;
      this.abortCursorAnimation();

      this._restoreEditingProps();

      this._currentCursorOpacity = 0;

      if (this._shouldClearDimensionCache()) {
        this.initDimensions();
        this.setCoords();
      }

      this.fire("editing:exited");
      t && this.fire("modified");

      if (this.canvas) {
        this.canvas.off("mouse:move", this.mouseMoveHandler);
        this.canvas.fire("text:editing:exited", {
          target: this
        });
        t && this.canvas.fire("object:modified", {
          target: this
        });
      }

      return this;
    },
    _removeExtraneousStyles: function _removeExtraneousStyles() {
      for (var t in this.styles) {
        if (!this._textLines[t]) {
          delete this.styles[t];
        }
      }
    },
    removeStyleFromTo: function removeStyleFromTo(t, e) {
      var i = this.get2DCursorLocation(t, true),
          r = this.get2DCursorLocation(e, true),
          n = i.lineIndex,
          s = i.charIndex,
          o = r.lineIndex,
          a = r.charIndex,
          c,
          l;

      if (n !== o) {
        if (this.styles[n]) {
          for (c = s; c < this._unwrappedTextLines[n].length; c++) {
            delete this.styles[n][c];
          }
        }

        if (this.styles[o]) {
          for (c = a; c < this._unwrappedTextLines[o].length; c++) {
            l = this.styles[o][c];

            if (l) {
              this.styles[n] || (this.styles[n] = {});
              this.styles[n][s + c - a] = l;
            }
          }
        }

        for (c = n + 1; c <= o; c++) {
          delete this.styles[c];
        }

        this.shiftLineStyles(o, n - o);
      } else {
        if (this.styles[n]) {
          l = this.styles[n];
          var h = a - s,
              f,
              u;

          for (c = s; c < a; c++) {
            delete l[c];
          }

          for (u in this.styles[n]) {
            f = parseInt(u, 10);

            if (f >= a) {
              l[f - h] = l[u];
              delete l[u];
            }
          }
        }
      }
    },
    shiftLineStyles: function shiftLineStyles(t, e) {
      var i = l(this.styles);

      for (var r in this.styles) {
        var n = parseInt(r, 10);

        if (n > t) {
          this.styles[n + e] = i[n];

          if (!i[n - e]) {
            delete this.styles[n];
          }
        }
      }
    },
    restartCursorIfNeeded: function restartCursorIfNeeded() {
      if (!this._currentTickState || this._currentTickState.isAborted || !this._currentTickCompleteState || this._currentTickCompleteState.isAborted) {
        this.initDelayedCursor();
      }
    },
    insertNewlineStyleObject: function insertNewlineStyleObject(t, e, i, r) {
      var n,
          s = {},
          o = false;
      i || (i = 1);
      this.shiftLineStyles(t, i);

      if (this.styles[t]) {
        n = this.styles[t][e === 0 ? e : e - 1];
      }

      for (var a in this.styles[t]) {
        var c = parseInt(a, 10);

        if (c >= e) {
          o = true;
          s[c - e] = this.styles[t][a];
          delete this.styles[t][a];
        }
      }

      if (o) {
        this.styles[t + i] = s;
      } else {
        delete this.styles[t + i];
      }

      while (i > 1) {
        i--;

        if (r && r[i]) {
          this.styles[t + i] = {
            0: l(r[i])
          };
        } else if (n) {
          this.styles[t + i] = {
            0: l(n)
          };
        } else {
          delete this.styles[t + i];
        }
      }

      this._forceClearCache = true;
    },
    insertCharStyleObject: function insertCharStyleObject(t, e, i, r) {
      if (!this.styles) {
        this.styles = {};
      }

      var n = this.styles[t],
          s = n ? l(n) : {};
      i || (i = 1);

      for (var o in s) {
        var a = parseInt(o, 10);

        if (a >= e) {
          n[a + i] = s[a];

          if (!s[a - i]) {
            delete n[a];
          }
        }
      }

      this._forceClearCache = true;

      if (r) {
        while (i--) {
          if (!Object.keys(r[i]).length) {
            continue;
          }

          if (!this.styles[t]) {
            this.styles[t] = {};
          }

          this.styles[t][e + i] = l(r[i]);
        }

        return;
      }

      if (!n) {
        return;
      }

      var c = n[e ? e - 1 : 1];

      while (c && i--) {
        this.styles[t][e + i] = l(c);
      }
    },
    insertNewStyleBlock: function insertNewStyleBlock(t, e, i) {
      var r = this.get2DCursorLocation(e, true),
          n = [0],
          s = 0;

      for (var o = 0; o < t.length; o++) {
        if (t[o] === "\n") {
          s++;
          n[s] = 0;
        } else {
          n[s]++;
        }
      }

      if (n[0] > 0) {
        this.insertCharStyleObject(r.lineIndex, r.charIndex, n[0], i);
        i = i && i.slice(n[0] + 1);
      }

      s && this.insertNewlineStyleObject(r.lineIndex, r.charIndex + n[0], s);

      for (var o = 1; o < s; o++) {
        if (n[o] > 0) {
          this.insertCharStyleObject(r.lineIndex + o, 0, n[o], i);
        } else if (i) {
          this.styles[r.lineIndex + o][0] = i[0];
        }

        i = i && i.slice(n[o] + 1);
      }

      if (n[o] > 0) {
        this.insertCharStyleObject(r.lineIndex + o, 0, n[o], i);
      }
    },
    setSelectionStartEndWithShift: function setSelectionStartEndWithShift(t, e, i) {
      if (i <= t) {
        if (e === t) {
          this._selectionDirection = "left";
        } else if (this._selectionDirection === "right") {
          this._selectionDirection = "left";
          this.selectionEnd = t;
        }

        this.selectionStart = i;
      } else if (i > t && i < e) {
        if (this._selectionDirection === "right") {
          this.selectionEnd = i;
        } else {
          this.selectionStart = i;
        }
      } else {
        if (e === t) {
          this._selectionDirection = "right";
        } else if (this._selectionDirection === "left") {
          this._selectionDirection = "right";
          this.selectionStart = e;
        }

        this.selectionEnd = i;
      }
    },
    setSelectionInBoundaries: function setSelectionInBoundaries() {
      var t = this.text.length;

      if (this.selectionStart > t) {
        this.selectionStart = t;
      } else if (this.selectionStart < 0) {
        this.selectionStart = 0;
      }

      if (this.selectionEnd > t) {
        this.selectionEnd = t;
      } else if (this.selectionEnd < 0) {
        this.selectionEnd = 0;
      }
    }
  });
})();

fabric.util.object.extend(fabric.IText.prototype, {
  initDoubleClickSimulation: function initDoubleClickSimulation() {
    this.__lastClickTime = +new Date();
    this.__lastLastClickTime = +new Date();
    this.__lastPointer = {};
    this.on("mousedown", this.onMouseDown);
  },
  onMouseDown: function onMouseDown(t) {
    if (!this.canvas) {
      return;
    }

    this.__newClickTime = +new Date();
    var e = t.pointer;

    if (this.isTripleClick(e)) {
      this.fire("tripleclick", t);

      this._stopEvent(t.e);
    }

    this.__lastLastClickTime = this.__lastClickTime;
    this.__lastClickTime = this.__newClickTime;
    this.__lastPointer = e;
    this.__lastIsEditing = this.isEditing;
    this.__lastSelected = this.selected;
  },
  isTripleClick: function isTripleClick(t) {
    return this.__newClickTime - this.__lastClickTime < 500 && this.__lastClickTime - this.__lastLastClickTime < 500 && this.__lastPointer.x === t.x && this.__lastPointer.y === t.y;
  },
  _stopEvent: function _stopEvent(t) {
    t.preventDefault && t.preventDefault();
    t.stopPropagation && t.stopPropagation();
  },
  initCursorSelectionHandlers: function initCursorSelectionHandlers() {
    this.initMousedownHandler();
    this.initMouseupHandler();
    this.initClicks();
  },
  doubleClickHandler: function doubleClickHandler(t) {
    if (!this.isEditing) {
      return;
    }

    this.selectWord(this.getSelectionStartFromPointer(t.e));
  },
  tripleClickHandler: function tripleClickHandler(t) {
    if (!this.isEditing) {
      return;
    }

    this.selectLine(this.getSelectionStartFromPointer(t.e));
  },
  initClicks: function initClicks() {
    this.on("mousedblclick", this.doubleClickHandler);
    this.on("tripleclick", this.tripleClickHandler);
  },
  _mouseDownHandler: function _mouseDownHandler(t) {
    if (!this.canvas || !this.editable || t.e.button && t.e.button !== 1) {
      return;
    }

    this.__isMousedown = true;

    if (this.selected) {
      this.setCursorByClick(t.e);
    }

    if (this.isEditing) {
      this.__selectionStartOnMouseDown = this.selectionStart;

      if (this.selectionStart === this.selectionEnd) {
        this.abortCursorAnimation();
      }

      this.renderCursorOrSelection();
    }
  },
  _mouseDownHandlerBefore: function _mouseDownHandlerBefore(t) {
    if (!this.canvas || !this.editable || t.e.button && t.e.button !== 1) {
      return;
    }

    this.selected = this === this.canvas._activeObject;
  },
  initMousedownHandler: function initMousedownHandler() {
    this.on("mousedown", this._mouseDownHandler);
    this.on("mousedown:before", this._mouseDownHandlerBefore);
  },
  initMouseupHandler: function initMouseupHandler() {
    this.on("mouseup", this.mouseUpHandler);
  },
  mouseUpHandler: function mouseUpHandler(t) {
    this.__isMousedown = false;

    if (!this.editable || this.group || t.transform && t.transform.actionPerformed || t.e.button && t.e.button !== 1) {
      return;
    }

    if (this.canvas) {
      var e = this.canvas._activeObject;

      if (e && e !== this) {
        return;
      }
    }

    if (this.__lastSelected && !this.__corner) {
      this.selected = false;
      this.__lastSelected = false;
      this.enterEditing(t.e);

      if (this.selectionStart === this.selectionEnd) {
        this.initDelayedCursor(true);
      } else {
        this.renderCursorOrSelection();
      }
    } else {
      this.selected = true;
    }
  },
  setCursorByClick: function setCursorByClick(t) {
    var e = this.getSelectionStartFromPointer(t),
        i = this.selectionStart,
        r = this.selectionEnd;

    if (t.shiftKey) {
      this.setSelectionStartEndWithShift(i, r, e);
    } else {
      this.selectionStart = e;
      this.selectionEnd = e;
    }

    if (this.isEditing) {
      this._fireSelectionChanged();

      this._updateTextarea();
    }
  },
  getSelectionStartFromPointer: function getSelectionStartFromPointer(t) {
    var e = this.getLocalPointer(t),
        i = 0,
        r = 0,
        n = 0,
        s = 0,
        o = 0,
        a,
        c;

    for (var l = 0, h = this._textLines.length; l < h; l++) {
      if (n <= e.y) {
        n += this.getHeightOfLine(l) * this.scaleY;
        o = l;

        if (l > 0) {
          s += this._textLines[l - 1].length + this.missingNewlineOffset(l - 1);
        }
      } else {
        break;
      }
    }

    a = this._getLineLeftOffset(o);
    r = a * this.scaleX;
    c = this._textLines[o];

    for (var f = 0, u = c.length; f < u; f++) {
      i = r;
      r += this.__charBounds[o][f].kernedWidth * this.scaleX;

      if (r <= e.x) {
        s++;
      } else {
        break;
      }
    }

    return this._getNewSelectionStartFromOffset(e, i, r, s, u);
  },
  _getNewSelectionStartFromOffset: function _getNewSelectionStartFromOffset(t, e, i, r, n) {
    var s = t.x - e,
        o = i - t.x,
        a = o > s || o < 0 ? 0 : 1,
        c = r + a;

    if (this.flipX) {
      c = n - c;
    }

    if (c > this._text.length) {
      c = this._text.length;
    }

    return c;
  }
});
fabric.util.object.extend(fabric.IText.prototype, {
  initHiddenTextarea: function initHiddenTextarea() {
    this.hiddenTextarea = fabric.document.createElement("textarea");
    this.hiddenTextarea.setAttribute("autocapitalize", "off");
    this.hiddenTextarea.setAttribute("autocorrect", "off");
    this.hiddenTextarea.setAttribute("autocomplete", "off");
    this.hiddenTextarea.setAttribute("spellcheck", "false");
    this.hiddenTextarea.setAttribute("data-fabric-hiddentextarea", "");
    this.hiddenTextarea.setAttribute("wrap", "off");

    var t = this._calcTextareaPosition();

    this.hiddenTextarea.style.cssText = "position: absolute; top: " + t.top + "; left: " + t.left + "; z-index: -999; opacity: 0; width: 1px; height: 1px; font-size: 1px;" + " paddingｰtop: " + t.fontSize + ";";
    fabric.document.body.appendChild(this.hiddenTextarea);
    fabric.util.addListener(this.hiddenTextarea, "keydown", this.onKeyDown.bind(this));
    fabric.util.addListener(this.hiddenTextarea, "keyup", this.onKeyUp.bind(this));
    fabric.util.addListener(this.hiddenTextarea, "input", this.onInput.bind(this));
    fabric.util.addListener(this.hiddenTextarea, "copy", this.copy.bind(this));
    fabric.util.addListener(this.hiddenTextarea, "cut", this.copy.bind(this));
    fabric.util.addListener(this.hiddenTextarea, "paste", this.paste.bind(this));
    fabric.util.addListener(this.hiddenTextarea, "compositionstart", this.onCompositionStart.bind(this));
    fabric.util.addListener(this.hiddenTextarea, "compositionupdate", this.onCompositionUpdate.bind(this));
    fabric.util.addListener(this.hiddenTextarea, "compositionend", this.onCompositionEnd.bind(this));

    if (!this._clickHandlerInitialized && this.canvas) {
      fabric.util.addListener(this.canvas.upperCanvasEl, "click", this.onClick.bind(this));
      this._clickHandlerInitialized = true;
    }
  },
  keysMap: {
    9: "exitEditing",
    27: "exitEditing",
    33: "moveCursorUp",
    34: "moveCursorDown",
    35: "moveCursorRight",
    36: "moveCursorLeft",
    37: "moveCursorLeft",
    38: "moveCursorUp",
    39: "moveCursorRight",
    40: "moveCursorDown"
  },
  ctrlKeysMapUp: {
    67: "copy",
    88: "cut"
  },
  ctrlKeysMapDown: {
    65: "selectAll"
  },
  onClick: function onClick() {
    this.hiddenTextarea && this.hiddenTextarea.focus();
  },
  onKeyDown: function onKeyDown(t) {
    if (!this.isEditing || this.inCompositionMode) {
      return;
    }

    if (t.keyCode in this.keysMap) {
      this[this.keysMap[t.keyCode]](t);
    } else if (t.keyCode in this.ctrlKeysMapDown && (t.ctrlKey || t.metaKey)) {
      this[this.ctrlKeysMapDown[t.keyCode]](t);
    } else {
      return;
    }

    t.stopImmediatePropagation();
    t.preventDefault();

    if (t.keyCode >= 33 && t.keyCode <= 40) {
      this.clearContextTop();
      this.renderCursorOrSelection();
    } else {
      this.canvas && this.canvas.requestRenderAll();
    }
  },
  onKeyUp: function onKeyUp(t) {
    if (!this.isEditing || this._copyDone || this.inCompositionMode) {
      this._copyDone = false;
      return;
    }

    if (t.keyCode in this.ctrlKeysMapUp && (t.ctrlKey || t.metaKey)) {
      this[this.ctrlKeysMapUp[t.keyCode]](t);
    } else {
      return;
    }

    t.stopImmediatePropagation();
    t.preventDefault();
    this.canvas && this.canvas.requestRenderAll();
  },
  onInput: function onInput(t) {
    var e = this.fromPaste;
    this.fromPaste = false;
    t && t.stopPropagation();

    if (!this.isEditing) {
      return;
    }

    var i = this._splitTextIntoLines(this.hiddenTextarea.value).graphemeText,
        r = this._text.length,
        n = i.length,
        s,
        o,
        a = n - r;

    if (this.hiddenTextarea.value === "") {
      this.styles = {};
      this.updateFromTextArea();
      this.fire("changed");

      if (this.canvas) {
        this.canvas.fire("text:changed", {
          target: this
        });
        this.canvas.requestRenderAll();
      }

      return;
    }

    var c = this.fromStringToGraphemeSelection(this.hiddenTextarea.selectionStart, this.hiddenTextarea.selectionEnd, this.hiddenTextarea.value);
    var l = this.selectionStart > c.selectionStart;

    if (this.selectionStart !== this.selectionEnd) {
      s = this._text.slice(this.selectionStart, this.selectionEnd);
      a += this.selectionEnd - this.selectionStart;
    } else if (n < r) {
      if (l) {
        s = this._text.slice(this.selectionEnd + a, this.selectionEnd);
      } else {
        s = this._text.slice(this.selectionStart, this.selectionStart - a);
      }
    }

    var h;
    o = i.slice(c.selectionEnd - a, c.selectionEnd);

    if (s && s.length) {
      if (o.length) {
        h = this.getSelectionStyles(this.selectionStart, this.selectionEnd, true);
      }

      if (this.selectionStart !== this.selectionEnd) {
        this.removeStyleFromTo(this.selectionStart, this.selectionEnd);
      } else if (l) {
        this.removeStyleFromTo(this.selectionEnd - s.length, this.selectionEnd);
      } else {
        this.removeStyleFromTo(this.selectionEnd, this.selectionEnd + s.length);
      }
    }

    if (o.length) {
      if (e && o.join("") === fabric.copiedText && !fabric.disableStyleCopyPaste) {
        this.insertNewStyleBlock(o, this.selectionStart, fabric.copiedTextStyle);
      } else {
        this.insertNewStyleBlock(o, this.selectionStart, h);
      }
    }

    this.updateFromTextArea();
    this.fire("changed");

    if (this.canvas) {
      this.canvas.fire("text:changed", {
        target: this
      });
      this.canvas.requestRenderAll();
    }
  },
  onCompositionStart: function onCompositionStart() {
    this.inCompositionMode = true;
  },
  onCompositionEnd: function onCompositionEnd() {
    this.inCompositionMode = false;
  },
  onCompositionUpdate: function onCompositionUpdate(t) {
    this.compositionStart = t.target.selectionStart;
    this.compositionEnd = t.target.selectionEnd;
    this.updateTextareaPosition();
  },
  copy: function copy() {
    if (this.selectionStart === this.selectionEnd) {
      return;
    }

    fabric.copiedText = this.getSelectedText();

    if (!fabric.disableStyleCopyPaste) {
      fabric.copiedTextStyle = this.getSelectionStyles(this.selectionStart, this.selectionEnd, true);
    } else {
      fabric.copiedTextStyle = null;
    }

    this._copyDone = true;
  },
  paste: function paste() {
    this.fromPaste = true;
  },
  _getClipboardData: function _getClipboardData(t) {
    return t && t.clipboardData || fabric.window.clipboardData;
  },
  _getWidthBeforeCursor: function _getWidthBeforeCursor(t, e) {
    var i = this._getLineLeftOffset(t),
        r;

    if (e > 0) {
      r = this.__charBounds[t][e - 1];
      i += r.left + r.width;
    }

    return i;
  },
  getDownCursorOffset: function getDownCursorOffset(t, e) {
    var i = this._getSelectionForOffset(t, e),
        r = this.get2DCursorLocation(i),
        n = r.lineIndex;

    if (n === this._textLines.length - 1 || t.metaKey || t.keyCode === 34) {
      return this._text.length - i;
    }

    var s = r.charIndex,
        o = this._getWidthBeforeCursor(n, s),
        a = this._getIndexOnLine(n + 1, o),
        c = this._textLines[n].slice(s);

    return c.length + a + 1 + this.missingNewlineOffset(n);
  },
  _getSelectionForOffset: function _getSelectionForOffset(t, e) {
    if (t.shiftKey && this.selectionStart !== this.selectionEnd && e) {
      return this.selectionEnd;
    } else {
      return this.selectionStart;
    }
  },
  getUpCursorOffset: function getUpCursorOffset(t, e) {
    var i = this._getSelectionForOffset(t, e),
        r = this.get2DCursorLocation(i),
        n = r.lineIndex;

    if (n === 0 || t.metaKey || t.keyCode === 33) {
      return -i;
    }

    var s = r.charIndex,
        o = this._getWidthBeforeCursor(n, s),
        a = this._getIndexOnLine(n - 1, o),
        c = this._textLines[n].slice(0, s),
        l = this.missingNewlineOffset(n - 1);

    return -this._textLines[n - 1].length + a - c.length + (1 - l);
  },
  _getIndexOnLine: function _getIndexOnLine(t, e) {
    var i = this._textLines[t],
        r = this._getLineLeftOffset(t),
        n = r,
        s = 0,
        o,
        a;

    for (var c = 0, l = i.length; c < l; c++) {
      o = this.__charBounds[t][c].width;
      n += o;

      if (n > e) {
        a = true;
        var h = n - o,
            f = n,
            u = Math.abs(h - e),
            d = Math.abs(f - e);
        s = d < u ? c : c - 1;
        break;
      }
    }

    if (!a) {
      s = i.length - 1;
    }

    return s;
  },
  moveCursorDown: function moveCursorDown(t) {
    if (this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length) {
      return;
    }

    this._moveCursorUpOrDown("Down", t);
  },
  moveCursorUp: function moveCursorUp(t) {
    if (this.selectionStart === 0 && this.selectionEnd === 0) {
      return;
    }

    this._moveCursorUpOrDown("Up", t);
  },
  _moveCursorUpOrDown: function _moveCursorUpOrDown(t, e) {
    var i = "get" + t + "CursorOffset",
        r = this[i](e, this._selectionDirection === "right");

    if (e.shiftKey) {
      this.moveCursorWithShift(r);
    } else {
      this.moveCursorWithoutShift(r);
    }

    if (r !== 0) {
      this.setSelectionInBoundaries();
      this.abortCursorAnimation();
      this._currentCursorOpacity = 1;
      this.initDelayedCursor();

      this._fireSelectionChanged();

      this._updateTextarea();
    }
  },
  moveCursorWithShift: function moveCursorWithShift(t) {
    var e = this._selectionDirection === "left" ? this.selectionStart + t : this.selectionEnd + t;
    this.setSelectionStartEndWithShift(this.selectionStart, this.selectionEnd, e);
    return t !== 0;
  },
  moveCursorWithoutShift: function moveCursorWithoutShift(t) {
    if (t < 0) {
      this.selectionStart += t;
      this.selectionEnd = this.selectionStart;
    } else {
      this.selectionEnd += t;
      this.selectionStart = this.selectionEnd;
    }

    return t !== 0;
  },
  moveCursorLeft: function moveCursorLeft(t) {
    if (this.selectionStart === 0 && this.selectionEnd === 0) {
      return;
    }

    this._moveCursorLeftOrRight("Left", t);
  },
  _move: function _move(t, e, i) {
    var r;

    if (t.altKey) {
      r = this["findWordBoundary" + i](this[e]);
    } else if (t.metaKey || t.keyCode === 35 || t.keyCode === 36) {
      r = this["findLineBoundary" + i](this[e]);
    } else {
      this[e] += i === "Left" ? -1 : 1;
      return true;
    }

    if ((0, _typeof2["default"])(r) !== undefined && this[e] !== r) {
      this[e] = r;
      return true;
    }
  },
  _moveLeft: function _moveLeft(t, e) {
    return this._move(t, e, "Left");
  },
  _moveRight: function _moveRight(t, e) {
    return this._move(t, e, "Right");
  },
  moveCursorLeftWithoutShift: function moveCursorLeftWithoutShift(t) {
    var e = true;
    this._selectionDirection = "left";

    if (this.selectionEnd === this.selectionStart && this.selectionStart !== 0) {
      e = this._moveLeft(t, "selectionStart");
    }

    this.selectionEnd = this.selectionStart;
    return e;
  },
  moveCursorLeftWithShift: function moveCursorLeftWithShift(t) {
    if (this._selectionDirection === "right" && this.selectionStart !== this.selectionEnd) {
      return this._moveLeft(t, "selectionEnd");
    } else if (this.selectionStart !== 0) {
      this._selectionDirection = "left";
      return this._moveLeft(t, "selectionStart");
    }
  },
  moveCursorRight: function moveCursorRight(t) {
    if (this.selectionStart >= this._text.length && this.selectionEnd >= this._text.length) {
      return;
    }

    this._moveCursorLeftOrRight("Right", t);
  },
  _moveCursorLeftOrRight: function _moveCursorLeftOrRight(t, e) {
    var i = "moveCursor" + t + "With";
    this._currentCursorOpacity = 1;

    if (e.shiftKey) {
      i += "Shift";
    } else {
      i += "outShift";
    }

    if (this[i](e)) {
      this.abortCursorAnimation();
      this.initDelayedCursor();

      this._fireSelectionChanged();

      this._updateTextarea();
    }
  },
  moveCursorRightWithShift: function moveCursorRightWithShift(t) {
    if (this._selectionDirection === "left" && this.selectionStart !== this.selectionEnd) {
      return this._moveRight(t, "selectionStart");
    } else if (this.selectionEnd !== this._text.length) {
      this._selectionDirection = "right";
      return this._moveRight(t, "selectionEnd");
    }
  },
  moveCursorRightWithoutShift: function moveCursorRightWithoutShift(t) {
    var e = true;
    this._selectionDirection = "right";

    if (this.selectionStart === this.selectionEnd) {
      e = this._moveRight(t, "selectionStart");
      this.selectionEnd = this.selectionStart;
    } else {
      this.selectionStart = this.selectionEnd;
    }

    return e;
  },
  removeChars: function removeChars(t, e) {
    if (typeof e === "undefined") {
      e = t + 1;
    }

    this.removeStyleFromTo(t, e);

    this._text.splice(t, e - t);

    this.text = this._text.join("");
    this.set("dirty", true);

    if (this._shouldClearDimensionCache()) {
      this.initDimensions();
      this.setCoords();
    }

    this._removeExtraneousStyles();
  },
  insertChars: function insertChars(t, e, i, r) {
    if (typeof r === "undefined") {
      r = i;
    }

    if (r > i) {
      this.removeStyleFromTo(i, r);
    }

    var n = fabric.util.string.graphemeSplit(t);
    this.insertNewStyleBlock(n, i, e);
    this._text = [].concat(this._text.slice(0, i), n, this._text.slice(r));
    this.text = this._text.join("");
    this.set("dirty", true);

    if (this._shouldClearDimensionCache()) {
      this.initDimensions();
      this.setCoords();
    }

    this._removeExtraneousStyles();
  }
});

(function (t) {
  "use strict";

  var b = t.fabric || (t.fabric = {});
  b.Textbox = b.util.createClass(b.IText, b.Observable, {
    type: "textbox",
    minWidth: 20,
    dynamicMinWidth: 2,
    __cachedLines: null,
    lockScalingFlip: true,
    noScaleCache: false,
    _dimensionAffectingProps: b.Text.prototype._dimensionAffectingProps.concat("width"),
    _wordJoiners: /[ \t\r]/,
    splitByGrapheme: false,
    initDimensions: function initDimensions() {
      if (this.__skipDimension) {
        return;
      }

      this.isEditing && this.initDelayedCursor();
      this.clearContextTop();

      this._clearCache();

      this.dynamicMinWidth = 0;
      this._styleMap = this._generateStyleMap(this._splitText());

      if (this.dynamicMinWidth > this.width) {
        this._set("width", this.dynamicMinWidth);
      }

      if (this.textAlign.indexOf("justify") !== -1) {
        this.enlargeSpaces();
      }

      this.height = this.calcTextHeight();
      this.saveState({
        propertySet: "_dimensionAffectingProps"
      });
    },
    _generateStyleMap: function _generateStyleMap(t) {
      var e = 0,
          i = 0,
          r = 0,
          n = {};

      for (var s = 0; s < t.graphemeLines.length; s++) {
        if (t.graphemeText[r] === "\n" && s > 0) {
          i = 0;
          r++;
          e++;
        } else if (!this.splitByGrapheme && this._reSpaceAndTab.test(t.graphemeText[r]) && s > 0) {
          i++;
          r++;
        }

        n[s] = {
          line: e,
          offset: i
        };
        r += t.graphemeLines[s].length;
        i += t.graphemeLines[s].length;
      }

      return n;
    },
    styleHas: function styleHas(t, e) {
      if (this._styleMap && !this.isWrapping) {
        var i = this._styleMap[e];

        if (i) {
          e = i.line;
        }
      }

      return b.Text.prototype.styleHas.call(this, t, e);
    },
    isEmptyStyles: function isEmptyStyles(t) {
      if (!this.styles) {
        return true;
      }

      var e = 0,
          i = t + 1,
          r,
          n,
          s = false,
          o = this._styleMap[t],
          a = this._styleMap[t + 1];

      if (o) {
        t = o.line;
        e = o.offset;
      }

      if (a) {
        i = a.line;
        s = i === t;
        r = a.offset;
      }

      n = typeof t === "undefined" ? this.styles : {
        line: this.styles[t]
      };

      for (var c in n) {
        for (var l in n[c]) {
          if (l >= e && (!s || l < r)) {
            for (var h in n[c][l]) {
              return false;
            }
          }
        }
      }

      return true;
    },
    _getStyleDeclaration: function _getStyleDeclaration(t, e) {
      if (this._styleMap && !this.isWrapping) {
        var i = this._styleMap[t];

        if (!i) {
          return null;
        }

        t = i.line;
        e = i.offset + e;
      }

      return this.callSuper("_getStyleDeclaration", t, e);
    },
    _setStyleDeclaration: function _setStyleDeclaration(t, e, i) {
      var r = this._styleMap[t];
      t = r.line;
      e = r.offset + e;
      this.styles[t][e] = i;
    },
    _deleteStyleDeclaration: function _deleteStyleDeclaration(t, e) {
      var i = this._styleMap[t];
      t = i.line;
      e = i.offset + e;
      delete this.styles[t][e];
    },
    _getLineStyle: function _getLineStyle(t) {
      var e = this._styleMap[t];
      return !!this.styles[e.line];
    },
    _setLineStyle: function _setLineStyle(t) {
      var e = this._styleMap[t];
      this.styles[e.line] = {};
    },
    _wrapText: function _wrapText(t, e) {
      var i = [],
          r;
      this.isWrapping = true;

      for (r = 0; r < t.length; r++) {
        i = i.concat(this._wrapLine(t[r], r, e));
      }

      this.isWrapping = false;
      return i;
    },
    _measureWord: function _measureWord(t, e, i) {
      var r = 0,
          n,
          s = true;
      i = i || 0;

      for (var o = 0, a = t.length; o < a; o++) {
        var c = this._getGraphemeBox(t[o], e, o + i, n, s);

        r += c.kernedWidth;
        n = t[o];
      }

      return r;
    },
    _wrapLine: function _wrapLine(t, e, i, r) {
      var n = 0,
          s = this.splitByGrapheme,
          o = [],
          a = [],
          c = s ? b.util.string.graphemeSplit(t) : t.split(this._wordJoiners),
          l = "",
          h = 0,
          f = s ? "" : " ",
          u = 0,
          d = 0,
          g = 0,
          p = true,
          v = s ? 0 : this._getWidthOfCharSpacing(),
          r = r || 0;

      if (c.length === 0) {
        c.push([]);
      }

      i -= r;

      for (var m = 0; m < c.length; m++) {
        l = s ? c[m] : b.util.string.graphemeSplit(c[m]);
        u = this._measureWord(l, e, h);
        h += l.length;
        n += d + u - v;

        if (n >= i && !p) {
          o.push(a);
          a = [];
          n = u;
          p = true;
        } else {
          n += v;
        }

        if (!p && !s) {
          a.push(f);
        }

        a = a.concat(l);
        d = this._measureWord([f], e, h);
        h++;
        p = false;

        if (u > g) {
          g = u;
        }
      }

      m && o.push(a);

      if (g + r > this.dynamicMinWidth) {
        this.dynamicMinWidth = g - v + r;
      }

      return o;
    },
    isEndOfWrapping: function isEndOfWrapping(t) {
      if (!this._styleMap[t + 1]) {
        return true;
      }

      if (this._styleMap[t + 1].line !== this._styleMap[t].line) {
        return true;
      }

      return false;
    },
    missingNewlineOffset: function missingNewlineOffset(t) {
      if (this.splitByGrapheme) {
        return this.isEndOfWrapping(t) ? 1 : 0;
      }

      return 1;
    },
    _splitTextIntoLines: function _splitTextIntoLines(t) {
      var e = b.Text.prototype._splitTextIntoLines.call(this, t),
          i = this._wrapText(e.lines, this.width),
          r = new Array(i.length);

      for (var n = 0; n < i.length; n++) {
        r[n] = i[n].join("");
      }

      e.lines = r;
      e.graphemeLines = i;
      return e;
    },
    getMinWidth: function getMinWidth() {
      return Math.max(this.minWidth, this.dynamicMinWidth);
    },
    _removeExtraneousStyles: function _removeExtraneousStyles() {
      var t = {};

      for (var e in this._styleMap) {
        if (this._textLines[e]) {
          t[this._styleMap[e].line] = 1;
        }
      }

      for (var e in this.styles) {
        if (!t[e]) {
          delete this.styles[e];
        }
      }
    },
    toObject: function toObject(t) {
      return this.callSuper("toObject", ["minWidth", "splitByGrapheme"].concat(t));
    }
  });

  b.Textbox.fromObject = function (t, e) {
    return b.Object._fromObject("Textbox", t, e, "text");
  };
})(typeof exports !== "undefined" ? exports : void 0);

(function () {
  var d = fabric.Canvas.prototype._setObjectScale;

  fabric.Canvas.prototype._setObjectScale = function (t, e, i, r, n, s, o) {
    var a = e.target,
        c,
        l = t.x * a.scaleX / o.x,
        h = t.y * a.scaleY / o.y;

    if (n === "x" && a instanceof fabric.Textbox) {
      var f = a._getTransformedDimensions().x;

      var u = a.width * (t.x / f);
      e.newScaleX = l;
      e.newScaleY = h;

      if (u >= a.getMinWidth()) {
        c = u !== a.width;
        a.set("width", u);
        return c;
      }
    } else {
      return d.call(fabric.Canvas.prototype, t, e, i, r, n, s, o);
    }
  };

  fabric.util.object.extend(fabric.Textbox.prototype, {
    _removeExtraneousStyles: function _removeExtraneousStyles() {
      for (var t in this._styleMap) {
        if (!this._textLines[t]) {
          delete this.styles[this._styleMap[t].line];
        }
      }
    }
  });
})();